// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb, .carousel-indicators, .dropdown-menu, .dropdown-menu-icons, .media-list, .nav, .pager {
    list-style: none;
}
.tag, hr {
    box-sizing: content-box;
}
hr, img {
    border: 0;
}
body, mark {
    color: #000;
}
body, figure {
    margin: 0;
}
.btn-group>.btn-group, .btn-toolbar .btn, .btn-toolbar .btn-group, .btn-toolbar .input-group, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .dropdown-menu {
    float: left;
}
article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section, summary {
    display: block;
}
audio, canvas, progress, video {
    display: inline-block;
    vertical-align: baseline;
}
audio:not([controls]) {
    display: none;
    height: 0;
}
[hidden], template {
    display: none;
}
a {
    background-color: transparent;
}
a:active, a:hover {
    outline: 0;
}
b, optgroup, strong {
    font-weight: 700;
}
dfn {
    font-style: italic;
}
h1 {
    margin: .67em 0;
}
mark {
    background: #ff0;
}
sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
}
sup {
    top: -.5em;
}
sub {
    bottom: -.25em;
}
svg:not(:root) {
    overflow: hidden;
}
hr {
    height: 0;
}
pre, textarea {
    overflow: auto;
}
code, kbd, pre, samp {
    font-size: 1em;
}
button, input, optgroup, select, textarea {
    color: inherit;
    font: inherit;
    margin: 0;
}
body, table {
    font-size: 13px;
}
button {
    overflow: visible;
}
button, select {
    text-transform: none;
}
button, html input[type=button], input[type=reset], input[type=submit] {
    -webkit-appearance: button;
    cursor: pointer;
}
button[disabled], html input[disabled] {
    cursor: default;
}
button::-moz-focus-inner, input::-moz-focus-inner {
    border: 0;
    padding: 0;
}
input[type=checkbox], input[type=radio] {
    box-sizing: border-box;
    padding: 0;
}
input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button {
    height: auto;
}
input[type=search]::-webkit-search-cancel-button, input[type=search]::-webkit-search-decoration {
    -webkit-appearance: none;
}
#btnEditTrigger {
    padding: 0 10px;
    min-width: auto;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
}
table>tbody>tr>td {
    vertical-align: middle!important;
}
td, th {
    padding: 0;
}
/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print {
    blockquote, img, pre, tr {
    page-break-inside: avoid;
}
*, :after, :before {
    background: 0 0!important;
    color: #000!important;
    box-shadow: none!important;
    text-shadow: none!important;
}
a, a:visited {
    text-decoration: underline;
}
a[href]:after {
    content: " (" attr(href) ")"}
abbr[title]:after {
    content: " (" attr(title) ")"}
a[href^="javascript:"]:after, a[href^="#"]:after {
    content: ""}
blockquote, pre {
    border: 1px solid #999;
}
thead {
    display: table-header-group;
}
img {
    max-width: 100%!important;
}
h2, h3, p {
    orphans: 3;
    widows: 3;
}
h2, h3 {
    page-break-after: avoid;
}
.navbar {
    display: none;
}
.navbar-brand img {
    max-height: 30px;
}
.btn>.caret, .dropup>.btn>.caret {
    border-top-color: #000!important;
}
.label {
    border: 1px solid #000;
}
.table {
    border-collapse: collapse!important;
}
.table td, .table th {
    background-color: #fff!important;
}
.table-bordered td, .table-bordered th {
    border: 1px solid #ddd!important;
}
}
.btn, .btn.active, .btn:active, .form-control, .navbar-toggle {
    background-image: none;
}
.navbar-fixed-bottom .navbar-collapse, .navbar-fixed-top .navbar-collapse, .pre-scrollable {
    max-height: 340px;
}
*, :after, :before {
    box-sizing: border-box;
}
body {
    font-family: "Open Sans", Verdana, sans-serif;
    line-height: 1.42857143;
}
button, input, select, textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
a {
    color: #0962ac;
    text-decoration: none;
}
a:focus, a:hover {
    color: #0962ac;
    text-decoration: underline;
}
a:focus {
    outline: dotted thin;
    outline: -webkit-focus-ring-color auto 5px;
    outline-offset: -2px;
}
img {
    vertical-align: middle;
}
.carousel-inner>.item>a>img, .carousel-inner>.item>img, .img-responsive, .thumbnail a>img, .thumbnail>img {
    display: block;
    max-width: 100%;
    height: auto;
}
.img-rounded {
    border-radius: 6px;
}
.img-thumbnail {
    padding: 4px;
    line-height: 1.42857143;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: all .2s ease-in-out;
    display: inline-block;
    max-width: 100%;
    height: auto;
}
.list-inline, .list-unstyled {
    padding-left: 0;
    list-style: none;
}
.img-circle {
    border-radius: 50%}
hr {
    margin-top: 18px;
    margin-bottom: 18px;
    border-top: 1px solid #e6e6e6;
}
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}
.sr-only-focusable:active, .sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    clip: auto;
}
[role=button] {
    cursor: pointer;
}
.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    font-family: inherit;
    font-weight: 600;
    line-height: 1.1;
    color: inherit;
}
.h1 .small, .h1 small, .h2 .small, .h2 small, .h3 .small, .h3 small, .h4 .small, .h4 small, .h5 .small, .h5 small, .h6 .small, .h6 small, h1 .small, h1 small, h2 .small, h2 small, h3 .small, h3 small, h4 .small, h4 small, h5 .small, h5 small, h6 .small, h6 small {
    font-weight: 400;
    line-height: 1;
    color: grey;
}
dt, kbd kbd, label {
    font-weight: 700;
}
.h1, .h2, .h3, h1, h2, h3 {
    margin-top: 18px;
    margin-bottom: 9px;
}
.h1 .small, .h1 small, .h2 .small, .h2 small, .h3 .small, .h3 small, h1 .small, h1 small, h2 .small, h2 small, h3 .small, h3 small {
    font-size: 65%}
.h4, .h5, .h6, h4, h5, h6 {
    margin-top: 9px;
    margin-bottom: 9px;
}
.h4 .small, .h4 small, .h5 .small, .h5 small, .h6 .small, .h6 small, h4 .small, h4 small, h5 .small, h5 small, h6 .small, h6 small {
    font-size: 75%}
.h1, h1 {
    font-size: 33px;
}
.h2, h2 {
    font-size: 27px;
}
.h3, h3 {
    font-size: 23px;
}
.h4, h4 {
    font-size: 17px;
}
.h5, h5 {
    font-size: 13px;
}
.h6, h6 {
    font-size: 12px;
}
p {
    margin: 0 0 9px;
}
.lead {
    margin-bottom: 18px;
    font-size: 14px;
    line-height: 1.4;
}
address, blockquote .small, blockquote footer, blockquote small, dd, dt, pre {
    line-height: 1.42857143;
}
@media (min-width:768px) {
    .lead {
    font-size: 19.5px;
}
}
.small, small {
    font-size: 92%}
.text-left {
    text-align: left;
}
.text-right {
    text-align: right;
}
.text-center {
    text-align: center;
}
.text-justify {
    text-align: justify;
}
.text-nowrap {
    white-space: nowrap;
}
.text-lowercase {
    text-transform: lowercase;
}
.text-uppercase {
    text-transform: uppercase;
}
.text-capitalize {
    text-transform: capitalize;
}
.text-muted {
    color: grey;
}
.text-primary {
    color: #39f;
}
a.text-primary:focus, a.text-primary:hover {
    color: #007fff;
}
.text-success {
    color: #37A320;
}
a.text-success:focus, a.text-success:hover {
    color: #297818;
}
.text-info {
    color: #39f;
}
a.text-info:focus, a.text-info:hover {
    color: #007fff;
}
.text-warning {
    color: #ed6e00;
}
a.text-warning:focus, a.text-warning:hover {
    color: #ba5600;
}
.text-danger {
    color: #b01c38;
}
a.text-danger:focus, a.text-danger:hover {
    color: #84152a;
}
.bg-primary {
    color: #fff;
    background-color: #39f;
}
a.bg-primary:focus, a.bg-primary:hover {
    background-color: #007fff;
}
.bg-success {
    background-color: #e1f1de;
}
a.bg-success:focus, a.bg-success:hover {
    background-color: #c1e2b9;
}
.bg-info {
    background-color: #e0f0ff;
}
a.bg-info:focus, a.bg-info:hover {
    background-color: #add6ff;
}
.bg-warning {
    background-color: #fce9d9;
}
a.bg-warning:focus, a.bg-warning:hover {
    background-color: #f9cea9;
}
.bg-danger {
    background-color: #f3dde1;
}
a.bg-danger:focus, a.bg-danger:hover {
    background-color: #e6b7c0;
}
pre code, table {
    background-color: transparent;
}
.page-header {
    padding-bottom: 8px;
    margin: 36px 0 18px;
    border-bottom: 1px solid #e6e6e6;
}
dl, ol, ul {
    margin-top: 0;
}
blockquote ol:last-child, blockquote p:last-child, blockquote ul:last-child, ol ol, ol ul, ul ol, ul ul {
    margin-bottom: 0;
}
address, dl {
    margin-bottom: 18px;
}
ol, ul {
    margin-bottom: 9px;
}
.list-inline {
    margin-left: -5px;
}
.list-inline>li {
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
}
dd {
    margin-left: 0;
}
@media (min-width:480px) {
    .dl-horizontal dt {
    float: left;
    width: 160px;
    clear: left;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.dl-horizontal dd {
    margin-left: 180px;
}
}
abbr[data-original-title], abbr[title] {
    cursor: help;
    border-bottom: 1px dotted grey;
}
.initialism {
    font-size: 90%;
    text-transform: uppercase;
}
blockquote {
    padding: 9px 18px;
    margin: 0 0 18px;
    font-size: 16.25px;
    border-left: 5px solid #e6e6e6;
}
blockquote .small, blockquote footer, blockquote small {
    display: block;
    font-size: 80%;
    color: grey;
}
legend, pre {
    display: block;
    color: #404040;
}
blockquote .small:before, blockquote footer:before, blockquote small:before {
    content: '\\2014 \\00A0'}
.blockquote-reverse, blockquote.pull-right {
    padding-right: 15px;
    padding-left: 0;
    border-right: 5px solid #e6e6e6;
    border-left: 0;
    text-align: right;
}
code, kbd {
    padding: 2px 4px;
    font-size: 90%}
caption, th {
    text-align: left;
}
.blockquote-reverse .small:before, .blockquote-reverse footer:before, .blockquote-reverse small:before, blockquote.pull-right .small:before, blockquote.pull-right footer:before, blockquote.pull-right small:before {
    content: ''}
.blockquote-reverse .small:after, .blockquote-reverse footer:after, .blockquote-reverse small:after, blockquote.pull-right .small:after, blockquote.pull-right footer:after, blockquote.pull-right small:after {
    content: '\\00A0 \\2014'}
address {
    font-style: normal;
}
code, kbd, pre, samp {
    font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
}
code {
    color: #c7254e;
    background-color: #f9f2f4;
    border-radius: 4px;
}
kbd {
    color: #fff;
    background-color: #333;
    border-radius: 3px;
    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);
}
kbd kbd {
    padding: 0;
    font-size: 100%;
    box-shadow: none;
}
pre {
    padding: 8.5px;
    margin: 0 0 9px;
    font-size: 12px;
    word-break: break-all;
    word-wrap: break-word;
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 4px;
}
pre code {
    padding: 0;
    font-size: inherit;
    color: inherit;
    white-space: pre-wrap;
    border-radius: 0;
}
.badge, .btn, .dropdown-header, .dropdown-menu>li>a, .input-group-btn, .label {
    white-space: nowrap;
}
.container, .container-fluid {
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
}
.pre-scrollable {
    overflow-y: scroll;
}
@media (min-width:768px) {
    .container {
    width: 750px;
}
}
@media (min-width:992px) {
    .container {
    width: 970px;
}
}
@media (min-width:1200px) {
    .container {
    width: 1170px;
}
}
.row {
    margin-left: -15px;
    margin-right: -15px;
}
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
}
.col-xs-12 {
    width: 100%}
.col-xs-11 {
    width: 91.66666667%}
.col-xs-10 {
    width: 83.33333333%}
.col-xs-9 {
    width: 75%}
.col-xs-8 {
    width: 66.66666667%}
.col-xs-7 {
    width: 58.33333333%}
.col-xs-6 {
    width: 50%}
.col-xs-5 {
    width: 41.66666667%}
.col-xs-4 {
    width: 33.33333333%}
.col-xs-3 {
    width: 25%}
.col-xs-2 {
    width: 16.66666667%}
.col-xs-1 {
    width: 8.33333333%}
.col-xs-pull-12 {
    right: 100%}
.col-xs-pull-11 {
    right: 91.66666667%}
.col-xs-pull-10 {
    right: 83.33333333%}
.col-xs-pull-9 {
    right: 75%}
.col-xs-pull-8 {
    right: 66.66666667%}
.col-xs-pull-7 {
    right: 58.33333333%}
.col-xs-pull-6 {
    right: 50%}
.col-xs-pull-5 {
    right: 41.66666667%}
.col-xs-pull-4 {
    right: 33.33333333%}
.col-xs-pull-3 {
    right: 25%}
.col-xs-pull-2 {
    right: 16.66666667%}
.col-xs-pull-1 {
    right: 8.33333333%}
.col-xs-pull-0 {
    right: auto;
}
.col-xs-push-12 {
    left: 100%}
.col-xs-push-11 {
    left: 91.66666667%}
.col-xs-push-10 {
    left: 83.33333333%}
.col-xs-push-9 {
    left: 75%}
.col-xs-push-8 {
    left: 66.66666667%}
.col-xs-push-7 {
    left: 58.33333333%}
.col-xs-push-6 {
    left: 50%}
.col-xs-push-5 {
    left: 41.66666667%}
.col-xs-push-4 {
    left: 33.33333333%}
.col-xs-push-3 {
    left: 25%}
.col-xs-push-2 {
    left: 16.66666667%}
.col-xs-push-1 {
    left: 8.33333333%}
.col-xs-push-0 {
    left: auto;
}
.col-xs-offset-12 {
    margin-left: 100%}
.col-xs-offset-11 {
    margin-left: 91.66666667%}
.col-xs-offset-10 {
    margin-left: 83.33333333%}
.col-xs-offset-9 {
    margin-left: 75%}
.col-xs-offset-8 {
    margin-left: 66.66666667%}
.col-xs-offset-7 {
    margin-left: 58.33333333%}
.col-xs-offset-6 {
    margin-left: 50%}
.col-xs-offset-5 {
    margin-left: 41.66666667%}
.col-xs-offset-4 {
    margin-left: 33.33333333%}
.col-xs-offset-3 {
    margin-left: 25%}
.col-xs-offset-2 {
    margin-left: 16.66666667%}
.col-xs-offset-1 {
    margin-left: 8.33333333%}
.col-xs-offset-0 {
    margin-left: 0;
}
@media (min-width:768px) {
    .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9 {
        min-width: min-content;
    float: left;
}
.col-sm-12 {
    width: 100%}
.col-sm-11 {
    width: 91.66666667%}
.col-sm-10 {
    width: 83.33333333%}
.col-sm-9 {
    width: 75%}
.col-sm-8 {
    width: 66.66666667%}
.col-sm-7 {
    width: 58.33333333%}
.col-sm-6 {
    width: 50%}
.col-sm-5 {
    width: 41.66666667%}
.col-sm-4 {
    width: 33.33333333%}
.col-sm-3 {
    width: 25%}
.col-sm-2 {
    width: 16.66666667%}
.col-sm-1 {
    width: 8.33333333%}
.col-sm-pull-12 {
    right: 100%}
.col-sm-pull-11 {
    right: 91.66666667%}
.col-sm-pull-10 {
    right: 83.33333333%}
.col-sm-pull-9 {
    right: 75%}
.col-sm-pull-8 {
    right: 66.66666667%}
.col-sm-pull-7 {
    right: 58.33333333%}
.col-sm-pull-6 {
    right: 50%}
.col-sm-pull-5 {
    right: 41.66666667%}
.col-sm-pull-4 {
    right: 33.33333333%}
.col-sm-pull-3 {
    right: 25%}
.col-sm-pull-2 {
    right: 16.66666667%}
.col-sm-pull-1 {
    right: 8.33333333%}
.col-sm-pull-0 {
    right: auto;
}
.col-sm-push-12 {
    left: 100%}
.col-sm-push-11 {
    left: 91.66666667%}
.col-sm-push-10 {
    left: 83.33333333%}
.col-sm-push-9 {
    left: 75%}
.col-sm-push-8 {
    left: 66.66666667%}
.col-sm-push-7 {
    left: 58.33333333%}
.col-sm-push-6 {
    left: 50%}
.col-sm-push-5 {
    left: 41.66666667%}
.col-sm-push-4 {
    left: 33.33333333%}
.col-sm-push-3 {
    left: 25%}
.col-sm-push-2 {
    left: 16.66666667%}
.col-sm-push-1 {
    left: 8.33333333%}
.col-sm-push-0 {
    left: auto;
}
.col-sm-offset-12 {
    margin-left: 100%}
.col-sm-offset-11 {
    margin-left: 91.66666667%}
.col-sm-offset-10 {
    margin-left: 83.33333333%}
.col-sm-offset-9 {
    margin-left: 75%}
.col-sm-offset-8 {
    margin-left: 66.66666667%}
.col-sm-offset-7 {
    margin-left: 58.33333333%}
.col-sm-offset-6 {
    margin-left: 50%}
.col-sm-offset-5 {
    margin-left: 41.66666667%}
.col-sm-offset-4 {
    margin-left: 33.33333333%}
.col-sm-offset-3 {
    margin-left: 25%}
.col-sm-offset-2 {
    margin-left: 16.66666667%}
.col-sm-offset-1 {
    margin-left: 8.33333333%}
.col-sm-offset-0 {
    margin-left: 0;
}
}
@media (min-width:992px) {
    .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9 {
        min-width: min-content;
    float: left;
}
.col-md-12 {
    width: 100%}
.col-md-11 {
    width: 91.66666667%}
.col-md-10 {
    width: 83.33333333%}
.col-md-9 {
    width: 75%}
.col-md-8 {
    width: 66.66666667%}
.col-md-7 {
    width: 58.33333333%}
.col-md-6 {
    width: 50%}
.col-md-5 {
    width: 41.66666667%}
.col-md-4 {
    width: 33.33333333%}
.col-md-3 {
    width: 25%}
.col-md-2 {
    width: 16.66666667%}
.col-md-1 {
    width: 8.33333333%}
.col-md-pull-12 {
    right: 100%}
.col-md-pull-11 {
    right: 91.66666667%}
.col-md-pull-10 {
    right: 83.33333333%}
.col-md-pull-9 {
    right: 75%}
.col-md-pull-8 {
    right: 66.66666667%}
.col-md-pull-7 {
    right: 58.33333333%}
.col-md-pull-6 {
    right: 50%}
.col-md-pull-5 {
    right: 41.66666667%}
.col-md-pull-4 {
    right: 33.33333333%}
.col-md-pull-3 {
    right: 25%}
.col-md-pull-2 {
    right: 16.66666667%}
.col-md-pull-1 {
    right: 8.33333333%}
.col-md-pull-0 {
    right: auto;
}
.col-md-push-12 {
    left: 100%}
.col-md-push-11 {
    left: 91.66666667%}
.col-md-push-10 {
    left: 83.33333333%}
.col-md-push-9 {
    left: 75%}
.col-md-push-8 {
    left: 66.66666667%}
.col-md-push-7 {
    left: 58.33333333%}
.col-md-push-6 {
    left: 50%}
.col-md-push-5 {
    left: 41.66666667%}
.col-md-push-4 {
    left: 33.33333333%}
.col-md-push-3 {
    left: 25%}
.col-md-push-2 {
    left: 16.66666667%}
.col-md-push-1 {
    left: 8.33333333%}
.col-md-push-0 {
    left: auto;
}
.col-md-offset-12 {
    margin-left: 100%}
.col-md-offset-11 {
    margin-left: 91.66666667%}
.col-md-offset-10 {
    margin-left: 83.33333333%}
.col-md-offset-9 {
    margin-left: 75%}
.col-md-offset-8 {
    margin-left: 66.66666667%}
.col-md-offset-7 {
    margin-left: 58.33333333%}
.col-md-offset-6 {
    margin-left: 50%}
.col-md-offset-5 {
    margin-left: 41.66666667%}
.col-md-offset-4 {
    margin-left: 33.33333333%}
.col-md-offset-3 {
    margin-left: 25%}
.col-md-offset-2 {
    margin-left: 16.66666667%}
.col-md-offset-1 {
    margin-left: 8.33333333%}
.col-md-offset-0 {
    margin-left: 0;
}
}
@media (min-width:1200px) {
    .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9 {
        min-width: min-content;
    float: left;
}
.col-lg-12 {
    width: 100%}
.col-lg-11 {
    width: 91.66666667%}
.col-lg-10 {
    width: 83.33333333%}
.col-lg-9 {
    width: 75%}
.col-lg-8 {
    width: 66.66666667%}
.col-lg-7 {
    width: 58.33333333%}
.col-lg-6 {
    width: 50%}
.col-lg-5 {
    width: 41.66666667%}
.col-lg-4 {
    width: 33.33333333%}
.col-lg-3 {
    width: 25%}
.col-lg-2 {
    width: 16.66666667%}
.col-lg-1 {
    width: 8.33333333%}
.col-lg-pull-12 {
    right: 100%}
.col-lg-pull-11 {
    right: 91.66666667%}
.col-lg-pull-10 {
    right: 83.33333333%}
.col-lg-pull-9 {
    right: 75%}
.col-lg-pull-8 {
    right: 66.66666667%}
.col-lg-pull-7 {
    right: 58.33333333%}
.col-lg-pull-6 {
    right: 50%}
.col-lg-pull-5 {
    right: 41.66666667%}
.col-lg-pull-4 {
    right: 33.33333333%}
.col-lg-pull-3 {
    right: 25%}
.col-lg-pull-2 {
    right: 16.66666667%}
.col-lg-pull-1 {
    right: 8.33333333%}
.col-lg-pull-0 {
    right: auto;
}
.col-lg-push-12 {
    left: 100%}
.col-lg-push-11 {
    left: 91.66666667%}
.col-lg-push-10 {
    left: 83.33333333%}
.col-lg-push-9 {
    left: 75%}
.col-lg-push-8 {
    left: 66.66666667%}
.col-lg-push-7 {
    left: 58.33333333%}
.col-lg-push-6 {
    left: 50%}
.col-lg-push-5 {
    left: 41.66666667%}
.col-lg-push-4 {
    left: 33.33333333%}
.col-lg-push-3 {
    left: 25%}
.col-lg-push-2 {
    left: 16.66666667%}
.col-lg-push-1 {
    left: 8.33333333%}
.col-lg-push-0 {
    left: auto;
}
.col-lg-offset-12 {
    margin-left: 100%}
.col-lg-offset-11 {
    margin-left: 91.66666667%}
.col-lg-offset-10 {
    margin-left: 83.33333333%}
.col-lg-offset-9 {
    margin-left: 75%}
.col-lg-offset-8 {
    margin-left: 66.66666667%}
.col-lg-offset-7 {
    margin-left: 58.33333333%}
.col-lg-offset-6 {
    margin-left: 50%}
.col-lg-offset-5 {
    margin-left: 41.66666667%}
.col-lg-offset-4 {
    margin-left: 33.33333333%}
.col-lg-offset-3 {
    margin-left: 25%}
.col-lg-offset-2 {
    margin-left: 16.66666667%}
.col-lg-offset-1 {
    margin-left: 8.33333333%}
.col-lg-offset-0 {
    margin-left: 0;
}
}
caption {
    padding-top: 8px;
    padding-bottom: 8px;
    color: grey;
}
.table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 18px;
}
.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #e6e6e6;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 2px solid #e6e6e6;
}
.btn, .btn-group, .btn-group-vertical, .caret, .checkbox-inline, .navbar-form span, .radio-inline {
    vertical-align: middle;
}
.table>caption+thead>tr:first-child>td, .table>caption+thead>tr:first-child>th, .table>colgroup+thead>tr:first-child>td, .table>colgroup+thead>tr:first-child>th, .table>thead:first-child>tr:first-child>td, .table>thead:first-child>tr:first-child>th {
    border-top: 0;
}
.table>tbody+tbody {
    border-top: 2px solid #e6e6e6;
}
.table .table {
    background-color: #fff;
}
.table-condensed>tbody>tr>td, .table-condensed>tbody>tr>th, .table-condensed>tfoot>tr>td, .table-condensed>tfoot>tr>th, .table-condensed>thead>tr>td, .table-condensed>thead>tr>th {
    padding: 5px;
}
.table-bordered, .table-bordered>tbody>tr>td, .table-bordered>tbody>tr>th, .table-bordered>tfoot>tr>td, .table-bordered>tfoot>tr>th, .table-bordered>thead>tr>td, .table-bordered>thead>tr>th {
    border: 1px solid #e6e6e6;
}
.table-bordered>thead>tr>td, .table-bordered>thead>tr>th {
    border-bottom-width: 2px;
}
.table-striped>tbody>tr:nth-of-type(odd) {
    background-color: #f9f9f9;
}
.table-hover>tbody>tr:hover {
    background-color: rgba(0, 0, 0, .06);
}
table col[class*=col-] {
    position: static;
    float: none;
    display: table-column;
}
table td[class*=col-], table th[class*=col-] {
    position: static;
    float: none;
    display: table-cell;
}
.table>tbody>tr.active>td, .table>tbody>tr.active>th, .table>tbody>tr>td.active, .table>tbody>tr>th.active, .table>tfoot>tr.active>td, .table>tfoot>tr.active>th, .table>tfoot>tr>td.active, .table>tfoot>tr>th.active, .table>thead>tr.active>td, .table>thead>tr.active>th, .table>thead>tr>td.active, .table>thead>tr>th.active {
    background-color: #80bfff;
}
.table-hover>tbody>tr.active:hover>td, .table-hover>tbody>tr.active:hover>th, .table-hover>tbody>tr:hover>.active, .table-hover>tbody>tr>td.active:hover, .table-hover>tbody>tr>th.active:hover {
    background-color: #66b2ff;
}
.table>tbody>tr.success>td, .table>tbody>tr.success>th, .table>tbody>tr>td.success, .table>tbody>tr>th.success, .table>tfoot>tr.success>td, .table>tfoot>tr.success>th, .table>tfoot>tr>td.success, .table>tfoot>tr>th.success, .table>thead>tr.success>td, .table>thead>tr.success>th, .table>thead>tr>td.success, .table>thead>tr>th.success {
    background-color: #e1f1de;
}
.table-hover>tbody>tr.success:hover>td, .table-hover>tbody>tr.success:hover>th, .table-hover>tbody>tr:hover>.success, .table-hover>tbody>tr>td.success:hover, .table-hover>tbody>tr>th.success:hover {
    background-color: #d1eacb;
}
.table>tbody>tr.info>td, .table>tbody>tr.info>th, .table>tbody>tr>td.info, .table>tbody>tr>th.info, .table>tfoot>tr.info>td, .table>tfoot>tr.info>th, .table>tfoot>tr>td.info, .table>tfoot>tr>th.info, .table>thead>tr.info>td, .table>thead>tr.info>th, .table>thead>tr>td.info, .table>thead>tr>th.info {
    background-color: #e0f0ff;
}
.table-hover>tbody>tr.info:hover>td, .table-hover>tbody>tr.info:hover>th, .table-hover>tbody>tr:hover>.info, .table-hover>tbody>tr>td.info:hover, .table-hover>tbody>tr>th.info:hover {
    background-color: #c7e3ff;
}
.table>tbody>tr.warning>td, .table>tbody>tr.warning>th, .table>tbody>tr>td.warning, .table>tbody>tr>th.warning, .table>tfoot>tr.warning>td, .table>tfoot>tr.warning>th, .table>tfoot>tr>td.warning, .table>tfoot>tr>th.warning, .table>thead>tr.warning>td, .table>thead>tr.warning>th, .table>thead>tr>td.warning, .table>thead>tr>th.warning {
    background-color: #fce9d9;
}
.table-hover>tbody>tr.warning:hover>td, .table-hover>tbody>tr.warning:hover>th, .table-hover>tbody>tr:hover>.warning, .table-hover>tbody>tr>td.warning:hover, .table-hover>tbody>tr>th.warning:hover {
    background-color: #fbdcc1;
}
.table>tbody>tr.danger>td, .table>tbody>tr.danger>th, .table>tbody>tr>td.danger, .table>tbody>tr>th.danger, .table>tfoot>tr.danger>td, .table>tfoot>tr.danger>th, .table>tfoot>tr>td.danger, .table>tfoot>tr>th.danger, .table>thead>tr.danger>td, .table>thead>tr.danger>th, .table>thead>tr>td.danger, .table>thead>tr>th.danger {
    background-color: #f3dde1;
}
.table-hover>tbody>tr.danger:hover>td, .table-hover>tbody>tr.danger:hover>th, .table-hover>tbody>tr:hover>.danger, .table-hover>tbody>tr>td.danger:hover, .table-hover>tbody>tr>th.danger:hover {
    background-color: #edcad1;
}
.table-responsive {
    min-height: .01%}
@media screen and (max-width:767px) {
    .table-responsive {
    width: 100%;
    margin-bottom: 13.5px;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #e6e6e6;
}
.table-responsive>.table {
    margin-bottom: 0;
}
.table-responsive>.table>tbody>tr>td, .table-responsive>.table>tbody>tr>th, .table-responsive>.table>tfoot>tr>td, .table-responsive>.table>tfoot>tr>th, .table-responsive>.table>thead>tr>td, .table-responsive>.table>thead>tr>th {
    white-space: nowrap;
}
.table-responsive>.table-bordered {
    border: 0;
}
.table-responsive>.table-bordered>tbody>tr>td:first-child, .table-responsive>.table-bordered>tbody>tr>th:first-child, .table-responsive>.table-bordered>tfoot>tr>td:first-child, .table-responsive>.table-bordered>tfoot>tr>th:first-child, .table-responsive>.table-bordered>thead>tr>td:first-child, .table-responsive>.table-bordered>thead>tr>th:first-child {
    border-left: 0;
}
.table-responsive>.table-bordered>tbody>tr>td:last-child, .table-responsive>.table-bordered>tbody>tr>th:last-child, .table-responsive>.table-bordered>tfoot>tr>td:last-child, .table-responsive>.table-bordered>tfoot>tr>th:last-child, .table-responsive>.table-bordered>thead>tr>td:last-child, .table-responsive>.table-bordered>thead>tr>th:last-child {
    border-right: 0;
}
.table-responsive>.table-bordered>tbody>tr:last-child>td, .table-responsive>.table-bordered>tbody>tr:last-child>th, .table-responsive>.table-bordered>tfoot>tr:last-child>td, .table-responsive>.table-bordered>tfoot>tr:last-child>th {
    border-bottom: 0;
}
}
fieldset, legend {
    padding: 0;
    border: 0;
}
fieldset {
    margin: 0;
    min-width: 0;
}
legend {
    width: 100%;
    margin-bottom: 18px;
    font-size: 19.5px;
    line-height: inherit;
    border-bottom: 1px solid #e5e5e5;
}
.form-control, output {
    font-size: 13px;
    color: #000;
}
label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
}
.checkbox, .form-control, .radio, input[type=file], output {
    display: block;
}
input[type=search] {
    box-sizing: border-box;
    padding-left: 20px;
    -webkit-appearance: none;
}
input[type=checkbox], input[type=radio] {
    margin: 4px 0 0;
    margin-top: 1px\\9;
    line-height: normal;
}
.dropdown-header, .dropdown-menu>li>a, .form-control, output {
    line-height: 1.42857143;
}
input[type=range] {
    display: block;
    width: 100%}
select[multiple], select[size] {
    height: auto;
}
input[type=checkbox]:focus, input[type=file]:focus, input[type=radio]:focus {
    outline: dotted thin;
    outline: -webkit-focus-ring-color auto 5px;
    outline-offset: -2px;
}
output {
    padding-top: 4px;
}
.form-control {
    width: 100%;
    height: 26px;
    padding: 3px 5px;
    background-color: #fff;
    border: 1px solid silver;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
.form-control:focus {
    border-color: #39f;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(51, 153, 255, .6);
}
.form-control::-moz-placeholder {
    color: grey;
    opacity: 1;
}
.form-control:-ms-input-placeholder {
    color: grey;
}
.form-control::-webkit-input-placeholder {
    color: grey;
}
.has-success .checkbox, .has-success .checkbox-inline, .has-success .control-label, .has-success .form-control-feedback, .has-success .help-block, .has-success .radio, .has-success .radio-inline, .has-success.checkbox label, .has-success.checkbox-inline label, .has-success.radio label, .has-success.radio-inline label {
    color: #37A320;
}
.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #e6e6e6;
    opacity: 1;
}
.form-control[disabled], fieldset[disabled] .form-control {
    cursor: not-allowed;
}
textarea.form-control {
    height: auto;
}
@media screen and (-webkit-min-device-pixel-ratio:0) {
    input[type=date].form-control, input[type=datetime-local].form-control, input[type=month].form-control, input[type=time].form-control {
    line-height: 26px;
}
.input-group-sm input[type=date], .input-group-sm input[type=datetime-local], .input-group-sm input[type=month], .input-group-sm input[type=time], input[type=date].input-sm, input[type=datetime-local].input-sm, input[type=month].input-sm, input[type=time].input-sm {
    line-height: 30px;
}
.input-group-lg input[type=date], .input-group-lg input[type=datetime-local], .input-group-lg input[type=month], .input-group-lg input[type=time], input[type=date].input-lg, input[type=datetime-local].input-lg, input[type=month].input-lg, input[type=time].input-lg {
    line-height: 38px;
}
}
.form-group {
    margin-bottom: 15px;
}
.checkbox, .radio {
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
}
.checkbox label, .radio label {
    min-height: 18px;
    padding-left: 20px;
    margin-bottom: 0;
    font-weight: 400;
    cursor: pointer;
}
.checkbox input[type=checkbox], .checkbox-inline input[type=checkbox], .radio input[type=radio], .radio-inline input[type=radio] {
    position: absolute;
    margin-left: -20px;
    margin-top: 4px\\9;
}
.checkbox+.checkbox, .radio+.radio {
    margin-top: -5px;
}
.checkbox-inline, .radio-inline {
    position: relative;
    display: inline-block;
    padding-left: 20px;
    margin-bottom: 0;
    font-weight: 400;
    cursor: pointer;
}
.checkbox-inline+.checkbox-inline, .radio-inline+.radio-inline {
    margin-top: 0;
    margin-left: 10px;
}
.checkbox-inline.disabled, .checkbox.disabled label, .radio-inline.disabled, .radio.disabled label, fieldset[disabled] .checkbox label, fieldset[disabled] .checkbox-inline, fieldset[disabled] .radio label, fieldset[disabled] .radio-inline, fieldset[disabled] input[type=checkbox], fieldset[disabled] input[type=radio], input[type=checkbox].disabled, input[type=checkbox][disabled], input[type=radio].disabled, input[type=radio][disabled] {
    cursor: not-allowed;
}
.form-control-static {
    padding-top: 4px;
    padding-bottom: 4px;
    margin-bottom: 0;
    min-height: 31px;
}
.form-control-static.input-lg, .form-control-static.input-sm {
    padding-left: 0;
    padding-right: 0;
}
.form-group-sm .form-control, .input-sm {
    padding: 5px 10px;
    border-radius: 3px;
    font-size: 12px;
}
.input-sm {
    height: 30px;
    line-height: 1.5;
}
select.input-sm {
    height: 30px;
    line-height: 30px;
}
select[multiple].input-sm, textarea.input-sm {
    height: auto;
}
.form-group-sm .form-control {
    height: 30px;
    line-height: 1.5;
}
.form-group-lg .form-control, .input-lg {
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 15px;
}
.form-group-sm select.form-control {
    height: 30px;
    line-height: 30px;
}
.form-group-sm select[multiple].form-control, .form-group-sm textarea.form-control {
    height: auto;
}
.form-group-sm .form-control-static {
    height: 30px;
    min-height: 30px;
    padding: 6px 10px;
    font-size: 12px;
    line-height: 1.5;
}
.input-lg {
    height: 38px;
    line-height: 1.3333333;
}
select.input-lg {
    height: 38px;
    line-height: 38px;
}
select[multiple].input-lg, textarea.input-lg {
    height: auto;
}
.form-group-lg .form-control {
    height: 38px;
    line-height: 1.3333333;
}
.form-group-lg select.form-control {
    height: 38px;
    line-height: 38px;
}
.form-group-lg select[multiple].form-control, .form-group-lg textarea.form-control {
    height: auto;
}
.form-group-lg .form-control-static {
    height: 38px;
    min-height: 33px;
    padding: 9px 12px;
    font-size: 15px;
    line-height: 1.3333333;
}
.has-feedback {
    position: relative;
}
.has-feedback .form-control {
    padding-right: 32.5px;
}
.form-control-feedback {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    display: block;
    width: 26px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    pointer-events: none;
}
.collapsing, .dropdown, .dropup {
    position: relative;
}
.form-group-lg .form-control+.form-control-feedback, .input-group-lg+.form-control-feedback, .input-lg+.form-control-feedback {
    width: 38px;
    height: 38px;
    line-height: 38px;
}
.form-group-sm .form-control+.form-control-feedback, .input-group-sm+.form-control-feedback, .input-sm+.form-control-feedback {
    width: 30px;
    height: 30px;
    line-height: 30px;
}
.has-success .form-control {
    border-color: #37A320;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
}
.has-success .form-control:focus {
    border-color: #297818;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #66dc4d;
}
.has-success .input-group-addon {
    color: #37A320;
    border-color: #37A320;
    background-color: #e1f1de;
}
.has-success .form-control {
    background-color: #e1f1de;
    color: #000;
}
.has-warning .checkbox, .has-warning .checkbox-inline, .has-warning .control-label, .has-warning .form-control-feedback, .has-warning .help-block, .has-warning .radio, .has-warning .radio-inline, .has-warning.checkbox label, .has-warning.checkbox-inline label, .has-warning.radio label, .has-warning.radio-inline label {
    color: #ed6e00;
}
.has-warning .form-control {
    border-color: #ed6e00;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
}
.has-warning .form-control:focus {
    border-color: #ba5600;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ffa354;
}
.has-warning .input-group-addon {
    color: #ed6e00;
    border-color: #ed6e00;
    background-color: #fce9d9;
}
.has-warning .form-control {
    background-color: #fce9d9;
    color: #000;
}
.has-error .checkbox, .has-error .checkbox-inline, .has-error .control-label, .has-error .form-control-feedback, .has-error .help-block, .has-error .radio, .has-error .radio-inline, .has-error.checkbox label, .has-error.checkbox-inline label, .has-error.radio label, .has-error.radio-inline label {
    color: #b01c38;
}
.has-error .form-control {
    border-color: #b01c38;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
}
.has-error .form-control:focus {
    border-color: #84152a;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #e34f6b;
}
.has-error .input-group-addon {
    color: #b01c38;
    border-color: #b01c38;
    background-color: #f3dde1;
}
.has-error .form-control {
    background-color: #f3dde1;
    color: #000;
}
.has-feedback label~.form-control-feedback {
    top: 23px;
}
.has-feedback label.sr-only~.form-control-feedback {
    top: 0;
}
.help-block {
    display: block;
    margin-top: 5px;
    margin-bottom: 10px;
    color: #404040;
}
@media (min-width:768px) {
    .form-inline .form-control-static, .form-inline .form-group {
    display: inline-block;
}
.form-inline .control-label, .form-inline .form-group {
    margin-bottom: 0;
    vertical-align: middle;
}
.form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
}
.form-inline .input-group {
    display: inline-table;
    vertical-align: middle;
}
.form-inline .input-group .form-control, .form-inline .input-group .input-group-addon, .form-inline .input-group .input-group-btn {
    width: auto;
}
.form-inline .input-group>.form-control {
    width: 100%}
.form-inline .checkbox, .form-inline .radio {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle;
}
.form-inline .checkbox label, .form-inline .radio label {
    padding-left: 0;
}
.form-inline .checkbox input[type=checkbox], .form-inline .radio input[type=radio] {
    position: relative;
    margin-left: 0;
}
.form-inline .has-feedback .form-control-feedback {
    top: 0;
}
.form-horizontal .control-label {
    text-align: right;
    margin-bottom: 0;
    padding-top: 4px;
}
}
.btn-block, input[type=button].btn-block, input[type=reset].btn-block, input[type=submit].btn-block {
    width: 100%}
.form-horizontal .checkbox, .form-horizontal .checkbox-inline, .form-horizontal .radio, .form-horizontal .radio-inline {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 4px;
}
.form-horizontal .checkbox, .form-horizontal .radio {
    min-height: 22px;
}
.form-horizontal .form-group {
    margin-left: -15px;
    margin-right: -15px;
}
.form-horizontal .has-feedback .form-control-feedback {
    right: 15px;
}
@media (min-width:768px) {
    .form-horizontal .form-group-lg .control-label {
    padding-top: 11.67px;
    font-size: 15px;
}
.form-horizontal .form-group-sm .control-label {
    padding-top: 6px;
    font-size: 12px;
}
}
.btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    touch-action: manipulation;
    cursor: pointer;
    border: 1px solid transparent;
}
.btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {
    outline: dotted thin;
    outline: -webkit-focus-ring-color auto 5px;
    outline-offset: -2px;
}
.btn.focus, .btn:focus, .btn:hover {
    color: #333;
    text-decoration: none;
}
.btn.active, .btn:active {
    outline: 0;
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);
}
.btn.disabled, .btn[disabled], fieldset[disabled] .btn {
    cursor: not-allowed;
    opacity: .65;
    filter: alpha(opacity=65);
    box-shadow: none;
}
a.btn.disabled, fieldset[disabled] a.btn {
    pointer-events: none;
}
.btn-link {
    color: #0962ac;
    font-weight: 400;
    border-radius: 0;
}
.btn-link, .btn-link.active, .btn-link:active, .btn-link[disabled], fieldset[disabled] .btn-link {
    background-color: transparent;
    box-shadow: none;
}
.btn-link, .btn-link:active, .btn-link:focus, .btn-link:hover {
    border-color: transparent;
}
.btn-link:focus, .btn-link:hover {
    color: #0962ac;
    text-decoration: underline;
    background-color: transparent;
}
.btn-link[disabled]:focus, .btn-link[disabled]:hover, fieldset[disabled] .btn-link:focus, fieldset[disabled] .btn-link:hover {
    color: grey;
    text-decoration: none;
}
.btn-group-lg>.btn, .btn-lg {
    padding: 8px 12px;
    font-size: 15px;
    line-height: 1.3333333;
    border-radius: 6px;
}
.btn-group-sm>.btn, .btn-sm {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
}
.btn-group-xs>.btn, .btn-xs {
    padding: 1px 5px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
}
.btn-block {
    display: block;
}
.btn-block+.btn-block {
    margin-top: 5px;
}
.fade {
    opacity: 0;
    transition: opacity .15s linear;
}
.fade.in {
    opacity: 1;
}
.collapse {
    display: none;
}
.collapse.in {
    display: block;
}
tr.collapse.in {
    display: table-row;
}
tbody.collapse.in {
    display: table-row-group;
}
.collapsing {
    height: 0;
    overflow: hidden;
    transition-property: height, visibility;
    transition-duration: .35s;
    transition-timing-function: ease;
}
.caret {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 2px;
    border-top: 4px dashed;
    border-top: 4px solid\\9;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
}
.dropdown-toggle:focus {
    outline: 0;
}
.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    min-width: 160px;
    margin: 2px 0 0;
    font-size: 13px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    background-clip: padding-box;
}
.dropdown-menu-right, .dropdown-menu.pull-right {
    left: auto;
    right: 0;
}
.btn-group-vertical>.btn:not(:first-child):not(:last-child), .btn-group>.btn-group:not(:first-child):not(:last-child)>.btn, .btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
    border-radius: 0;
}
.dropdown-menu .divider {
    height: 1px;
    margin: 8px 0;
    overflow: hidden;
    background-color: #e5e5e5;
}
.dropdown-menu>li>a {
    display: block;
    clear: both;
    font-weight: 400;
    color: #404040;
}
.dropdown-menu>li>a:focus, .dropdown-menu>li>a:hover {
    text-decoration: none;
    color: #000;
    background-color: rgba(0, 0, 0, .06);
}
.dropdown-menu>.active>a, .dropdown-menu>.active>a:focus, .dropdown-menu>.active>a:hover {
    color: #000;
    text-decoration: none;
    outline: 0;
    background-color: #b3d9ff;
}
.dropdown-menu>.disabled>a, .dropdown-menu>.disabled>a:focus, .dropdown-menu>.disabled>a:hover {
    color: grey;
}
.dropdown-menu>.disabled>a:focus, .dropdown-menu>.disabled>a:hover {
    text-decoration: none;
    background-color: transparent;
    background-image: none;
    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
    cursor: not-allowed;
}
.open>.dropdown-menu {
    display: block;
}
.open>a {
    outline: 0;
}
.dropdown-menu-left {
    left: 0;
    right: auto;
}
.dropdown-header {
    display: block;
    padding: 3px 20px;
    font-size: 12px;
    color: grey;
}
.dropdown-backdrop {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 990;
}
.nav-justified>.dropdown .dropdown-menu, .nav-tabs.nav-justified>.dropdown .dropdown-menu {
    top: auto;
    left: auto;
}
.pull-right>.dropdown-menu {
    right: 0;
    left: auto;
}
.dropup .caret, .navbar-fixed-bottom .dropdown .caret {
    border-top: 0;
    border-bottom: 4px dashed;
    border-bottom: 4px solid\\9;
    content: ""}
.dropup .dropdown-menu, .navbar-fixed-bottom .dropdown .dropdown-menu {
    top: auto;
    bottom: 100%;
    margin-bottom: 2px;
}
@media (min-width:480px) {
    .navbar-right .dropdown-menu {
    left: auto;
    right: 0;
}
.navbar-right .dropdown-menu-left {
    left: 0;
    right: auto;
}
}
.btn-group, .btn-group-vertical {
    position: relative;
    display: inline-block;
}
.btn-group-vertical>.btn, .btn-group>.btn {
    position: relative;
    float: left;
}
.btn-group-vertical>.btn.active, .btn-group-vertical>.btn:active, .btn-group-vertical>.btn:focus, .btn-group-vertical>.btn:hover, .btn-group>.btn.active, .btn-group>.btn:active, .btn-group>.btn:focus, .btn-group>.btn:hover {
    z-index: 2;
}
.btn-group .btn+.btn, .btn-group .btn+.btn-group, .btn-group .btn-group+.btn, .btn-group .btn-group+.btn-group {
    margin-left: -1px;
}
.btn-toolbar {
    margin-left: -5px;
}
.btn-toolbar>.btn, .btn-toolbar>.btn-group, .btn-toolbar>.input-group {
    margin-left: 5px;
}
.btn .caret, .btn-group>.btn:first-child {
    margin-left: 0;
}
.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.btn-group>.btn:last-child:not(:first-child), .btn-group>.dropdown-toggle:not(:first-child) {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child, .btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.btn-group .dropdown-toggle:active, .btn-group.open .dropdown-toggle {
    outline: 0;
}
.btn-group>.btn+.dropdown-toggle {
    padding-left: 8px;
    padding-right: 8px;
}
.btn-group>.btn-lg+.dropdown-toggle {
    padding-left: 12px;
    padding-right: 12px;
}
.btn-group.open .dropdown-toggle {
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);
}
.btn-group.open .dropdown-toggle.btn-link {
    box-shadow: none;
}
.btn-lg .caret {
    border-width: 5px 5px 0;
}
.dropup .btn-lg .caret {
    border-width: 0 5px 5px;
}
.btn-group-vertical>.btn, .btn-group-vertical>.btn-group, .btn-group-vertical>.btn-group>.btn {
    display: block;
    float: none;
    width: 100%;
    max-width: 100%}
.btn-group-vertical>.btn-group>.btn {
    float: none;
}
.btn-group-vertical>.btn+.btn, .btn-group-vertical>.btn+.btn-group, .btn-group-vertical>.btn-group+.btn, .btn-group-vertical>.btn-group+.btn-group {
    margin-top: -1px;
    margin-left: 0;
}
.btn-group-vertical>.btn:first-child:not(:last-child) {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}
.btn-group-vertical>.btn:last-child:not(:first-child) {
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}
.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn {
    border-radius: 0;
}
.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child, .btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}
.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}
.btn-group-justified {
    display: table;
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
}
.btn-group-justified>.btn, .btn-group-justified>.btn-group {
    float: none;
    display: table-cell;
    width: 1%}
.btn-group-justified>.btn-group .btn {
    width: 100%}
.btn-group-justified>.btn-group .dropdown-menu {
    left: auto;
}
[data-toggle=buttons]>.btn input[type=checkbox], [data-toggle=buttons]>.btn input[type=radio], [data-toggle=buttons]>.btn-group>.btn input[type=checkbox], [data-toggle=buttons]>.btn-group>.btn input[type=radio] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none;
}
.input-group, .input-group-btn, .input-group-btn>.btn, .nav>li, .nav>li>a, .navbar {
    position: relative;
}
.input-group {
    display: table;
    border-collapse: separate;
}
.input-group[class*=col-] {
    float: none;
    padding-left: 0;
    padding-right: 0;
}
.input-group .form-control {
    position: relative;
    z-index: 2;
    float: left;
    width: 100%;
    margin-bottom: 0;
}
.input-group-lg>.form-control, .input-group-lg>.input-group-addon, .input-group-lg>.input-group-btn>.btn {
    height: 38px;
    padding: 8px 12px;
    font-size: 15px;
    line-height: 1.3333333;
    border-radius: 6px;
}
select.input-group-lg>.form-control, select.input-group-lg>.input-group-addon, select.input-group-lg>.input-group-btn>.btn {
    height: 38px;
    line-height: 38px;
}
select[multiple].input-group-lg>.form-control, select[multiple].input-group-lg>.input-group-addon, select[multiple].input-group-lg>.input-group-btn>.btn, textarea.input-group-lg>.form-control, textarea.input-group-lg>.input-group-addon, textarea.input-group-lg>.input-group-btn>.btn {
    height: auto;
}
.input-group-sm>.form-control, .input-group-sm>.input-group-addon, .input-group-sm>.input-group-btn>.btn {
    height: 30px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
}
select.input-group-sm>.form-control, select.input-group-sm>.input-group-addon, select.input-group-sm>.input-group-btn>.btn {
    height: 30px;
    line-height: 30px;
}
select[multiple].input-group-sm>.form-control, select[multiple].input-group-sm>.input-group-addon, select[multiple].input-group-sm>.input-group-btn>.btn, textarea.input-group-sm>.form-control, textarea.input-group-sm>.input-group-addon, textarea.input-group-sm>.input-group-btn>.btn {
    height: auto;
}
.input-group .form-control, .input-group-addon, .input-group-btn {
    display: table-cell;
}
.nav>li, .nav>li>a {
    display: block;
}
.input-group .form-control:not(:first-child):not(:last-child), .input-group-addon:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child) {
    border-radius: 0;
}
.input-group-addon, .input-group-btn {
    width: 1%;
    white-space: nowrap;
    vertical-align: middle;
}
.input-group-addon {
    padding: 3px 5px;
    font-size: 13px;
    font-weight: 400;
    line-height: 1;
    color: #000;
    text-align: center;
    background-color: #e6e6e6;
    border: 1px solid silver;
    border-radius: 4px;
}
.input-group-addon.input-sm {
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 3px;
}
.input-group-addon.input-lg {
    padding: 8px 12px;
    font-size: 15px;
    border-radius: 6px;
}
.input-group-addon input[type=checkbox], .input-group-addon input[type=radio] {
    margin-top: 0;
}
.input-group .form-control:first-child, .input-group-addon:first-child, .input-group-btn:first-child>.btn, .input-group-btn:first-child>.btn-group>.btn, .input-group-btn:first-child>.dropdown-toggle, .input-group-btn:last-child>.btn-group:not(:last-child)>.btn, .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle) {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.input-group-addon:first-child {
    border-right: 0;
}
.input-group .form-control:last-child, .input-group-addon:last-child, .input-group-btn:first-child>.btn-group:not(:first-child)>.btn, .input-group-btn:first-child>.btn:not(:first-child), .input-group-btn:last-child>.btn, .input-group-btn:last-child>.btn-group>.btn, .input-group-btn:last-child>.dropdown-toggle {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.input-group-addon:last-child {
    border-left: 0;
}
.input-group-btn {
    font-size: 0;
}
.input-group-btn>.btn+.btn {
    margin-left: -1px;
}
.input-group-btn>.btn:active, .input-group-btn>.btn:focus, .input-group-btn>.btn:hover {
    z-index: 2;
}
.input-group-btn:first-child>.btn, .input-group-btn:first-child>.btn-group {
    margin-right: -1px;
}
.input-group-btn:last-child>.btn, .input-group-btn:last-child>.btn-group {
    z-index: 2;
    margin-left: -1px;
}
.nav {
    margin-bottom: 0;
    padding-left: 0;
}
.nav>li>a:focus, .nav>li>a:hover {
    text-decoration: none;
    background-color: #dadada;
}
.nav>li.disabled>a {
    color: grey;
}
.nav>li.disabled>a:focus, .nav>li.disabled>a:hover {
    color: grey;
    text-decoration: none;
    background-color: transparent;
    cursor: not-allowed;
}
.nav .open>a, .nav .open>a:focus, .nav .open>a:hover {
    background-color: #dadada;
    border-color: #0962ac;
}
.nav .nav-divider {
    height: 1px;
    margin: 8px 0;
    overflow: hidden;
    background-color: #e5e5e5;
}
.nav>li>a>img {
    max-width: none;
}
.nav-tabs {
    border-bottom: 1px solid silver;
}
.nav-tabs>li {
    float: left;
    margin-bottom: -1px;
}
.nav-tabs>li>a {
    line-height: 1.42857143;
    border: 1px solid transparent;
    border-radius: 4px 4px 0 0;
}
.nav-tabs>li>a:hover {
    border-color: silver;
}
.nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover {
    color: #555;
    background-color: #fff;
    border: 1px solid silver;
    border-bottom-color: transparent;
    cursor: default;
}
.nav-tabs>li>div {
    padding: 4px 15px;
}
.nav-tabs.nav-justified {
    width: 100%;
    border-bottom: 0;
}
.nav-tabs.nav-justified>li {
    float: none;
}
.nav-tabs.nav-justified>li>a {
    text-align: center;
    margin-bottom: 5px;
    margin-right: 0;
    border-radius: 4px;
}
.nav-tabs.nav-justified>.active>a, .nav-tabs.nav-justified>.active>a:focus, .nav-tabs.nav-justified>.active>a:hover {
    border: 1px solid #ddd;
}
@media (min-width:768px) {
    .nav-tabs.nav-justified>li {
    display: table-cell;
    width: 1%}
.nav-tabs.nav-justified>li>a {
    margin-bottom: 0;
    border-bottom: 1px solid #ddd;
    border-radius: 4px 4px 0 0;
}
.nav-tabs.nav-justified>.active>a, .nav-tabs.nav-justified>.active>a:focus, .nav-tabs.nav-justified>.active>a:hover {
    border-bottom-color: #fff;
}
}
.nav-pills>li {
    float: left;
}
.nav-justified>li, .nav-stacked>li {
    float: none;
}
.nav-pills>li>a {
    border-radius: 4px;
}
.nav-pills>li+li {
    margin-left: 2px;
}
.nav-pills>li.active>a, .nav-pills>li.active>a:focus, .nav-pills>li.active>a:hover {
    color: #000;
    background-color: #80bfff;
}
.nav-stacked>li+li {
    margin-top: 2px;
    margin-left: 0;
}
.nav-justified {
    width: 100%}
.nav-justified>li>a {
    text-align: center;
    margin-bottom: 5px;
}
.nav-tabs-justified {
    border-bottom: 0;
}
.nav-tabs-justified>li>a {
    margin-right: 0;
    border-radius: 4px;
}
.nav-tabs-justified>.active>a, .nav-tabs-justified>.active>a:focus, .nav-tabs-justified>.active>a:hover {
    border: 1px solid #ddd;
}
@media (min-width:768px) {
    .nav-justified>li {
    display: table-cell;
    width: 1%}
.nav-justified>li>a {
    margin-bottom: 0;
}
.nav-tabs-justified>li>a {
    border-bottom: 1px solid #ddd;
    border-radius: 4px 4px 0 0;
}
.nav-tabs-justified>.active>a, .nav-tabs-justified>.active>a:focus, .nav-tabs-justified>.active>a:hover {
    border-bottom-color: #fff;
}
}
.tab-content>.tab-pane {
    display: none;
}
.tab-content>.active {
    display: block;
}
.nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}
.navbar {
    min-height: 40px;
    margin-bottom: 18px;
    border: 1px solid transparent;
}
.navbar-collapse {
    overflow-x: visible;
    padding-right: 15px;
    padding-left: 15px;
    border-top: 1px solid transparent;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);
    -webkit-overflow-scrolling: touch;
}
.navbar-collapse.in {
    overflow-y: auto;
}
@media (min-width:480px) {
    .navbar {
    border-radius: 4px;
}
.navbar-header {
    float: left;
}
.navbar-collapse {
    width: auto;
    border-top: 0;
    box-shadow: none;
}
.navbar-collapse.collapse {
    display: block!important;
    height: auto!important;
    padding-bottom: 0;
    overflow: visible!important;
}
.navbar-collapse.in {
    overflow-y: visible;
}
.navbar-fixed-bottom .navbar-collapse, .navbar-fixed-top .navbar-collapse, .navbar-static-top .navbar-collapse {
    padding-left: 0;
    padding-right: 0;
}
}
.carousel-inner, .embed-responsive, .modal, .modal-open, .progress {
    overflow: hidden;
}
@media (max-device-width:480px) and (orientation:landscape) {
    .navbar-fixed-bottom .navbar-collapse, .navbar-fixed-top .navbar-collapse {
    max-height: 200px;
}
}
.container-fluid>.navbar-collapse, .container-fluid>.navbar-header, .container>.navbar-collapse, .container>.navbar-header {
    margin-right: -15px;
    margin-left: -15px;
}
.navbar-static-top {
    z-index: 1000;
    border-width: 0 0 1px;
}
.navbar-fixed-bottom, .navbar-fixed-top {
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1030;
}
.navbar-fixed-top {
    top: 0;
    border-width: 0 0 1px;
}
.navbar-fixed-bottom {
    bottom: 0;
    margin-bottom: 0;
    border-width: 1px 0 0;
}
.navbar-brand {
    padding: 0px;
    font-size: 15px;
    line-height: 18px;
    display:block;
}
.navbar-brand:focus, .navbar-brand:hover {
    text-decoration: none;
}
.navbar-brand>img {
    display: block;
}
@media (min-width:480px) {
    .container-fluid>.navbar-collapse, .container-fluid>.navbar-header, .container>.navbar-collapse, .container>.navbar-header {
    margin-right: 0;
    margin-left: 0;
}
.navbar-fixed-bottom, .navbar-fixed-top, .navbar-static-top {
    border-radius: 0;
}
.navbar>.container .navbar-brand, .navbar>.container-fluid .navbar-brand {
    margin-left: -15px;
}
}
.navbar-toggle {
    position: relative;
    float: right;
    margin-right: 15px;
    padding: 9px 10px;
    margin-top: 3px;
    margin-bottom: 3px;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 4px;
}
.navbar-toggle:focus {
    outline: 0;
}
.navbar-toggle .ai-bar {
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
}
.navbar-toggle .ai-bar+.ai-bar {
    margin-top: 4px;
}
.navbar-nav {
    margin: 5.5px -15px;
}
.navbar-nav>li>a {
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 18px;
}
@media (max-width:479px) {
    .navbar-nav .open .dropdown-menu {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
}
.navbar-nav .open .dropdown-menu .dropdown-header, .navbar-nav .open .dropdown-menu>li>a {
    padding: 5px 15px 5px 25px;
}
.navbar-nav .open .dropdown-menu>li>a {
    line-height: 18px;
}
.navbar-nav .open .dropdown-menu>li>a:focus, .navbar-nav .open .dropdown-menu>li>a:hover {
    background-image: none;
}
}
.progress-bar-striped, .progress-striped .progress-bar, .progress-striped .progress-bar-success {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
}
@media (min-width:480px) {
    .navbar-toggle {
    display: none;
}
.navbar-nav {
    float: left;
    margin: 0;
}
.navbar-nav>li {
    float: left;
}
.navbar-nav>li>a {
    padding-top: 11px;
    padding-bottom: 11px;
}
}
.navbar-form {
    padding: 10px 15px;
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);
    margin: 7px -15px;
}
@media (min-width:768px) {
    .navbar-form .form-control-static, .navbar-form .form-group {
    display: inline-block;
}
.navbar-form .control-label, .navbar-form .form-group {
    margin-bottom: 0;
    vertical-align: middle;
}
.navbar-form .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
}
.navbar-form .input-group {
    display: inline-table;
    vertical-align: middle;
}
.navbar-form .input-group .form-control, .navbar-form .input-group .input-group-addon, .navbar-form .input-group .input-group-btn {
    width: auto;
}
.navbar-form .input-group>.form-control {
    width: 100%}
.navbar-form .checkbox, .navbar-form .radio {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle;
}
.navbar-form .checkbox label, .navbar-form .radio label {
    padding-left: 0;
}
.navbar-form .checkbox input[type=checkbox], .navbar-form .radio input[type=radio] {
    position: relative;
    margin-left: 0;
}
.navbar-form .has-feedback .form-control-feedback {
    top: 0;
}
}
.breadcrumb>li, .pagination {
    display: inline-block;
}
.btn .badge, .btn .label {
    top: -1px;
    position: relative;
}
.navbar-form>* {
    margin-right: 5px;
}
@media (max-width:479px) {
    .navbar-form .form-group {
    margin-bottom: 5px;
}
.navbar-form .form-group:last-child {
    margin-bottom: 0;
}
}
@media (min-width:480px) {
    .navbar-form {
    width: auto;
    border: 0;
    margin-left: 0;
    margin-right: 0;
    padding-top: 0;
    padding-bottom: 0;
    box-shadow: none;
}
.navbar-text {
    float: left;
    margin-left: 15px;
    margin-right: 15px;
}
.navbar-left {
    float: left!important;
}
.navbar-right {
    float: right!important;
    margin-right: -15px;
}
.navbar-right~.navbar-right {
    margin-right: 0;
}
}
.navbar-nav>li>.dropdown-menu {
    margin-top: 0;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}
.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu {
    margin-bottom: 0;
    border-radius: 4px 4px 0 0;
}
.navbar-btn {
    margin-top: 7px;
    margin-bottom: 7px;
}
.navbar-btn.btn-sm {
    margin-top: 5px;
    margin-bottom: 5px;
}
.navbar-btn.btn-xs {
    margin-top: 9px;
    margin-bottom: 9px;
}
.navbar-text {
    margin-top: 11px;
    margin-bottom: 11px;
}
.navbar-default {
    background-color: #f8f8f8;
    border-color: silver;
    max-height: 40px;
}
.navbar-default .navbar-brand {
    color: #404040;
}
.navbar-default .navbar-brand:focus, .navbar-default .navbar-brand:hover {
    color: #272727;
    background-color: transparent;
}
.navbar-default .navbar-text {
    color: #777;
}
.navbar-default .navbar-nav>li>a {
    color: #404040;
}
.navbar-default .navbar-nav>li>a:focus, .navbar-default .navbar-nav>li>a:hover {
    color: #000;
    background-color: rgba(0, 0, 0, .06);
}
.navbar-default .navbar-nav>.active>a, .navbar-default .navbar-nav>.active>a:focus, .navbar-default .navbar-nav>.active>a:hover {
    color: #000;
    background-color: rgba(0, 0, 0, .18);
}
.navbar-default .navbar-nav>.disabled>a, .navbar-default .navbar-nav>.disabled>a:focus, .navbar-default .navbar-nav>.disabled>a:hover {
    color: #ccc;
    background-color: transparent;
}
.navbar-default .navbar-toggle {
    border-color: grey;
}
.navbar-default .navbar-toggle:focus, .navbar-default .navbar-toggle:hover {
    background-color: #ddd;
}
.navbar-default .navbar-toggle .ai-bar {
    background-color: #888;
}
.navbar-default .navbar-collapse, .navbar-default .navbar-form {
    border-color: silver;
}
.navbar-default .navbar-nav>.open>a, .navbar-default .navbar-nav>.open>a:focus, .navbar-default .navbar-nav>.open>a:hover {
    background-color: rgba(0, 0, 0, .18);
    color: #000;
}
@media (max-width:479px) {
    .navbar-default .navbar-nav .open .dropdown-menu>li>a {
    color: #404040;
}
.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus, .navbar-default .navbar-nav .open .dropdown-menu>li>a:hover {
    color: #000;
    background-color: rgba(0, 0, 0, .06);
}
.navbar-default .navbar-nav .open .dropdown-menu>.active>a, .navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus, .navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover {
    color: #000;
    background-color: rgba(0, 0, 0, .18);
}
.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a, .navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus, .navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover {
    color: #ccc;
    background-color: transparent;
}
}
.navbar-default .navbar-link {
    color: #404040;
}
.navbar-default .navbar-link:hover {
    color: #000;
}
.navbar-default .btn-link {
    color: #404040;
}
.navbar-default .btn-link:focus, .navbar-default .btn-link:hover {
    color: #000;
}
.navbar-default .btn-link[disabled]:focus, .navbar-default .btn-link[disabled]:hover, fieldset[disabled] .navbar-default .btn-link:focus, fieldset[disabled] .navbar-default .btn-link:hover {
    color: #ccc;
}
.navbar-inverse {
    background-color: #222;
    border-color: #404040;
}
.navbar-inverse .navbar-brand {
    color: #e6e6e6;
}
.navbar-inverse .navbar-brand:focus, .navbar-inverse .navbar-brand:hover {
    color: #fff;
    background-color: transparent;
}
.navbar-inverse .navbar-text {
    color: #a6a6a6;
}
.navbar-inverse .navbar-nav>li>a {
    color: #e6e6e6;
}
.navbar-inverse .navbar-nav>li>a:focus, .navbar-inverse .navbar-nav>li>a:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, .09);
}
.navbar-inverse .navbar-nav>.active>a, .navbar-inverse .navbar-nav>.active>a:focus, .navbar-inverse .navbar-nav>.active>a:hover {
    color: #fff;
    background-color: rgba(0, 0, 0, .3);
}
.navbar-inverse .navbar-nav>.disabled>a, .navbar-inverse .navbar-nav>.disabled>a:focus, .navbar-inverse .navbar-nav>.disabled>a:hover {
    color: #444;
    background-color: transparent;
}
.navbar-inverse .navbar-toggle {
    border-color: #000;
}
.navbar-inverse .navbar-toggle:focus, .navbar-inverse .navbar-toggle:hover {
    background-color: #333;
}
.navbar-inverse .navbar-toggle .ai-bar {
    background-color: #fff;
}
.navbar-inverse .navbar-collapse, .navbar-inverse .navbar-form {
    border-color: #101010;
}
.navbar-inverse .navbar-nav>.open>a, .navbar-inverse .navbar-nav>.open>a:focus, .navbar-inverse .navbar-nav>.open>a:hover {
    background-color: rgba(0, 0, 0, .3);
    color: #fff;
}
@media (max-width:479px) {
    .navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header {
    border-color: #404040;
}
.navbar-inverse .navbar-nav .open .dropdown-menu .divider {
    background-color: #404040;
}
.navbar-inverse .navbar-nav .open .dropdown-menu>li>a {
    color: #e6e6e6;
}
.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus, .navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, .09);
}
.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a, .navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus, .navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover {
    color: #fff;
    background-color: rgba(0, 0, 0, .3);
}
.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a, .navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus, .navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover {
    color: #444;
    background-color: transparent;
}
}
.navbar-inverse .navbar-link {
    color: #e6e6e6;
}
.navbar-inverse .navbar-link:hover {
    color: #fff;
}
.navbar-inverse .btn-link {
    color: #e6e6e6;
}
.navbar-inverse .btn-link:focus, .navbar-inverse .btn-link:hover {
    color: #fff;
}
.navbar-inverse .btn-link[disabled]:focus, .navbar-inverse .btn-link[disabled]:hover, fieldset[disabled] .navbar-inverse .btn-link:focus, fieldset[disabled] .navbar-inverse .btn-link:hover {
    color: #444;
}
.breadcrumb {
    padding: 8px 15px;
    margin-bottom: 18px;
    background-color: #f5f5f5;
    border-radius: 4px;
}
.breadcrumb>li+li:before {
    content: "/\\00a0";
    padding: 0 5px;
    color: #ccc;
}
.breadcrumb>.active {
    color: grey;
}
.pagination {
    padding-left: 0;
    margin: 18px 0;
    border-radius: 4px;
}
.pager li, .pagination>li {
    display: inline;
}
.pagination>li>a, .pagination>li>span {
    position: relative;
    float: left;
    padding: 3px 5px;
    line-height: 1.42857143;
    text-decoration: none;
    color: #0962ac;
    background-color: #fff;
    border: 1px solid #ddd;
    margin-left: -1px;
}
.pagination>li:first-child>a, .pagination>li:first-child>span {
    margin-left: 0;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
}
.pagination>li:last-child>a, .pagination>li:last-child>span {
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
}
.pagination>li>a:focus, .pagination>li>a:hover, .pagination>li>span:focus, .pagination>li>span:hover {
    z-index: 3;
    color: #0962ac;
    background-color: #e6e6e6;
    border-color: #ddd;
}
.pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {
    z-index: 2;
    color: #fff;
    background-color: #39f;
    border-color: #39f;
    cursor: default;
}
.pagination>.disabled>a, .pagination>.disabled>a:focus, .pagination>.disabled>a:hover, .pagination>.disabled>span, .pagination>.disabled>span:focus, .pagination>.disabled>span:hover {
    color: grey;
    background-color: #fff;
    border-color: #ddd;
    cursor: not-allowed;
}
.pagination-lg>li>a, .pagination-lg>li>span {
    padding: 8px 12px;
    font-size: 15px;
    line-height: 1.3333333;
}
.pagination-lg>li:first-child>a, .pagination-lg>li:first-child>span {
    border-bottom-left-radius: 6px;
    border-top-left-radius: 6px;
}
.pagination-lg>li:last-child>a, .pagination-lg>li:last-child>span {
    border-bottom-right-radius: 6px;
    border-top-right-radius: 6px;
}
.pagination-sm>li>a, .pagination-sm>li>span {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
}
.badge, .label {
    font-weight: 700;
    line-height: 1;
    text-align: center;
}
.pagination-sm>li:first-child>a, .pagination-sm>li:first-child>span {
    border-bottom-left-radius: 3px;
    border-top-left-radius: 3px;
}
.pagination-sm>li:last-child>a, .pagination-sm>li:last-child>span {
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px;
}
.pager {
    padding-left: 0;
    margin: 18px 0;
    text-align: center;
}
.pager li>a, .pager li>span {
    display: inline-block;
    padding: 5px 14px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 15px;
}
.pager li>a:focus, .pager li>a:hover {
    text-decoration: none;
    background-color: #e6e6e6;
}
.pager .next>a, .pager .next>span {
    float: right;
}
.pager .previous>a, .pager .previous>span {
    float: left;
}
.pager .disabled>a, .pager .disabled>a:focus, .pager .disabled>a:hover, .pager .disabled>span {
    color: grey;
    background-color: #fff;
    cursor: not-allowed;
}
a.badge:focus, a.badge:hover, a.label:focus, a.label:hover {
    color: #fff;
    cursor: pointer;
    text-decoration: none;
}
.label {
    display: inline;
    padding: .2em .6em .3em;
    font-size: 75%;
    color: #fff;
    vertical-align: baseline;
    border-radius: .25em;
}
.label:empty {
    display: none;
}
.label-default {
    background-color: grey;
}
.label-default[href]:focus, .label-default[href]:hover {
    background-color: #676767;
}
.label-primary {
    background-color: #39f;
}
.label-primary[href]:focus, .label-primary[href]:hover {
    background-color: #007fff;
}
.label-success {
    background-color: #37A320;
}
.label-success[href]:focus, .label-success[href]:hover {
    background-color: #297818;
}
.label-info {
    background-color: #39f;
}
.label-info[href]:focus, .label-info[href]:hover {
    background-color: #007fff;
}
.label-warning {
    background-color: #ed6e00;
}
.label-warning[href]:focus, .label-warning[href]:hover {
    background-color: #ba5600;
}
.label-danger {
    background-color: #b01c38;
}
.label-danger[href]:focus, .label-danger[href]:hover {
    background-color: #84152a;
}
.badge {
    display: inline-block;
    min-width: 10px;
    padding: 3px 7px;
    font-size: 12px;
    color: #fff;
    vertical-align: middle;
    background-color: grey;
    border-radius: 10px;
}
.badge:empty {
    display: none;
}
.media-object, .thumbnail {
    display: block;
}
.btn-group-xs>.btn .badge, .btn-xs .badge {
    top: 0;
    padding: 1px 5px;
}
.list-group-item.active>.badge, .nav-pills>.active>a>.badge {
    color: #0962ac;
    background-color: #fff;
}
.jumbotron, .jumbotron .h1, .jumbotron h1 {
    color: inherit;
}
.list-group-item>.badge {
    float: right;
}
.list-group-item>.badge+.badge {
    margin-right: 5px;
}
.nav-pills>li>a>.badge {
    margin-left: 3px;
}
.jumbotron {
    padding-top: 30px;
    padding-bottom: 30px;
    margin-bottom: 30px;
    background-color: #e6e6e6;
}
.jumbotron p {
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 200;
}
.alert, .thumbnail {
    margin-bottom: 18px;
}
.alert .alert-link, .close {
    font-weight: 700;
}
.jumbotron>hr {
    border-top-color: #cdcdcd;
}
.container .jumbotron, .container-fluid .jumbotron {
    border-radius: 6px;
}
.jumbotron .container {
    max-width: 100%}
@media screen and (min-width:768px) {
    .jumbotron {
    padding-top: 48px;
    padding-bottom: 48px;
}
.container .jumbotron, .container-fluid .jumbotron {
    padding-left: 60px;
    padding-right: 60px;
}
.jumbotron .h1, .jumbotron h1 {
    font-size: 59px;
}
}
.thumbnail {
    padding: 4px;
    line-height: 1.42857143;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: border .2s ease-in-out;
}
.thumbnail a>img, .thumbnail>img {
    margin-left: auto;
    margin-right: auto;
}
a.thumbnail.active, a.thumbnail:focus, a.thumbnail:hover {
    border-color: #0962ac;
}
.thumbnail .caption {
    padding: 9px;
    color: #000;
}
.alert {
    padding: 8px;
    border: 1px solid transparent;
    border-radius: 4px;
}
.alert h4 {
    margin-top: 0;
    color: inherit;
}
.alert>p, .alert>ul {
    margin-bottom: 0;
}
.alert>p+p {
    margin-top: 5px;
}
.alert-dismissable, .alert-dismissible {
    padding-right: 28px;
}
.alert-dismissable .close, .alert-dismissible .close {
    position: relative;
    top: -2px;
    right: -21px;
    color: inherit;
}
.modal, .modal-backdrop {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}
.alert-success {
    background-color: #e1f1de;
}
.alert-success hr {
    border-top-color: #308e1c;
}
.alert-success .alert-link {
    color: #272727;
}
.alert-info {
    background-color: #e0f0ff;
    border-color: #39f;
    color: #404040;
}
.alert-warning {
    background-color: #fce9d9;
}
.alert-warning hr {
    border-top-color: #d46200;
}
.alert-warning .alert-link {
    color: #272727;
}
.alert-danger {
    background-color: #f3dde1;
    border-color: #b01c38;
    color: #404040;
}
@keyframes progress-bar-stripes {
    from {
    background-position: 40px 0;
}
to {
    background-position: 0 0;
}
}
.progress {
    height: 18px;
    margin-bottom: 18px;
    background-color: #f5f5f5;
    border-radius: 4px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);
}
.progress-bar {
    float: left;
    width: 0;
    height: 100%;
    font-size: 12px;
    line-height: 18px;
    color: #fff;
    text-align: center;
    background-color: #39f;
    box-shadow: inset 0 -1px 0 #e6e6e6;
    transition: width .6s ease;
}
.carousel-inner>.item>a>img, .carousel-inner>.item>img, .close {
    line-height: 1;
}
.progress-bar-striped, .progress-striped .progress-bar {
    background-size: 40px 40px;
}
.progress-bar.active, .progress.active .progress-bar {
    animation: progress-bar-stripes 2s linear infinite;
}
.progress-bar-success {
    background-color: #37A320;
}
.progress-striped .progress-bar-info, .progress-striped .progress-bar-warning {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
}
.progress-bar-info {
    background-color: #39f;
}
.progress-bar-warning {
    background-color: #ed6e00;
}
.progress-bar-danger {
    background-color: #b01c38;
}
.progress-striped .progress-bar-danger {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
}
.media {
    margin-top: 15px;
}
.media:first-child {
    margin-top: 0;
}
.media, .media-body {
    transform:scale(1.0);
    transform-origin: 0 0;
    overflow: hidden;
}
.media-body {
    width: 10000px;
}
.media-object.img-thumbnail {
    max-width: none;
}
.media-right, .media>.pull-right {
    padding-left: 10px;
}
.media-left, .media>.pull-left {
    padding-right: 10px;
}
.media-body, .media-left, .media-right {
    display: table-cell;
    vertical-align: top;
}
.btn-group-hover, .form-inline span, .media-middle, .tag-icon {
    vertical-align: middle;
}
.media-bottom {
    vertical-align: bottom;
}
.media-heading {
    margin-top: 0;
    margin-bottom: 5px;
}
.media-list {
    padding-left: 0;
}
.list-group {
    margin-bottom: 20px;
    padding-left: 0;
}
.list-group-item {
    position: relative;
    display: block;
    background-color: inherit;
    border: 1px solid #e6e6e6;
}
.list-group-item:first-child {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
}
.list-group-item:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}
a.list-group-item, a.list-group-item .list-group-item-heading, button.list-group-item, button.list-group-item .list-group-item-heading {
    color: #000;
}
a.list-group-item:focus, a.list-group-item:hover, button.list-group-item:focus, button.list-group-item:hover {
    outline: 0;
    text-decoration: none;
    color: #000;
    background-color: rgba(0, 0, 0, .06);
}
button.list-group-item {
    width: 100%;
    text-align: left;
}
.list-group-item.disabled, .list-group-item.disabled:focus, .list-group-item.disabled:hover {
    color: grey;
    cursor: not-allowed;
}
.list-group-item.disabled .list-group-item-heading, .list-group-item.disabled:focus .list-group-item-heading, .list-group-item.disabled:hover .list-group-item-heading {
    color: inherit;
}
.list-group-item.disabled .list-group-item-text, .list-group-item.disabled:focus .list-group-item-text, .list-group-item.disabled:hover .list-group-item-text {
    color: grey;
}
.list-group-item.active, .list-group-item.active:focus, .list-group-item.active:hover {
    z-index: 2;
    color: #000;
    background-color: #b3d9ff;
    border-color: #e6e6e6;
}
.list-group-item.active .list-group-item-heading, .list-group-item.active .list-group-item-heading>.small, .list-group-item.active .list-group-item-heading>small, .list-group-item.active:focus .list-group-item-heading, .list-group-item.active:focus .list-group-item-heading>.small, .list-group-item.active:focus .list-group-item-heading>small, .list-group-item.active:hover .list-group-item-heading, .list-group-item.active:hover .list-group-item-heading>.small, .list-group-item.active:hover .list-group-item-heading>small {
    color: inherit;
}
.list-group-item.active .list-group-item-text, .list-group-item.active:focus .list-group-item-text, .list-group-item.active:hover .list-group-item-text {
    color: #000;
}
.list-group-item-success {
    color: #37A320;
    background-color: #e1f1de;
}
a.list-group-item-success, button.list-group-item-success {
    color: #37A320;
}
a.list-group-item-success .list-group-item-heading, button.list-group-item-success .list-group-item-heading {
    color: inherit;
}
a.list-group-item-success:focus, a.list-group-item-success:hover, button.list-group-item-success:focus, button.list-group-item-success:hover {
    color: #37A320;
    background-color: #d1eacb;
}
a.list-group-item-success.active, a.list-group-item-success.active:focus, a.list-group-item-success.active:hover, button.list-group-item-success.active, button.list-group-item-success.active:focus, button.list-group-item-success.active:hover {
    color: #fff;
    background-color: #37A320;
    border-color: #37A320;
}
.list-group-item-info {
    color: #39f;
    background-color: #e0f0ff;
}
a.list-group-item-info, button.list-group-item-info {
    color: #39f;
}
a.list-group-item-info .list-group-item-heading, button.list-group-item-info .list-group-item-heading {
    color: inherit;
}
a.list-group-item-info:focus, a.list-group-item-info:hover, button.list-group-item-info:focus, button.list-group-item-info:hover {
    color: #39f;
    background-color: #c7e3ff;
}
a.list-group-item-info.active, a.list-group-item-info.active:focus, a.list-group-item-info.active:hover, button.list-group-item-info.active, button.list-group-item-info.active:focus, button.list-group-item-info.active:hover {
    color: #fff;
    background-color: #39f;
    border-color: #39f;
}
.list-group-item-warning {
    color: #ed6e00;
    background-color: #fce9d9;
}
a.list-group-item-warning, button.list-group-item-warning {
    color: #ed6e00;
}
a.list-group-item-warning .list-group-item-heading, button.list-group-item-warning .list-group-item-heading {
    color: inherit;
}
a.list-group-item-warning:focus, a.list-group-item-warning:hover, button.list-group-item-warning:focus, button.list-group-item-warning:hover {
    color: #ed6e00;
    background-color: #fbdcc1;
}
a.list-group-item-warning.active, a.list-group-item-warning.active:focus, a.list-group-item-warning.active:hover, button.list-group-item-warning.active, button.list-group-item-warning.active:focus, button.list-group-item-warning.active:hover {
    color: #fff;
    background-color: #ed6e00;
    border-color: #ed6e00;
}
.list-group-item-danger {
    color: #b01c38;
    background-color: #f3dde1;
}
a.list-group-item-danger, button.list-group-item-danger {
    color: #b01c38;
}
a.list-group-item-danger .list-group-item-heading, button.list-group-item-danger .list-group-item-heading {
    color: inherit;
}
a.list-group-item-danger:focus, a.list-group-item-danger:hover, button.list-group-item-danger:focus, button.list-group-item-danger:hover {
    color: #b01c38;
    background-color: #edcad1;
}
a.list-group-item-danger.active, a.list-group-item-danger.active:focus, a.list-group-item-danger.active:hover, button.list-group-item-danger.active, button.list-group-item-danger.active:focus, button.list-group-item-danger.active:hover {
    color: #fff;
    background-color: #b01c38;
    border-color: #b01c38;
}
.panel-heading>.dropdown .dropdown-toggle, .panel-title, .panel-title>.small, .panel-title>.small>a, .panel-title>a, .panel-title>small, .panel-title>small>a {
    color: inherit;
    width: min-content;
}
.list-group-item-heading {
    margin-top: 0;
    margin-bottom: 5px;
}
.list-group-item-text {
    margin-bottom: 0;
}
.panel {
    margin-bottom: 18px;
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 4px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
}
.panel-title, .panel>.list-group, .panel>.panel-collapse>.list-group, .panel>.panel-collapse>.table, .panel>.table, .panel>.table-responsive>.table {
    margin-bottom: 0;
}
.panel-body {
    padding: 10px;
    min-width: min-content;
}
.panel-heading {
    padding: 10px 15px;
    border-bottom: 1px solid transparent;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
}
.panel-title {
    margin-top: 0;
    font-size: 15px;
}
.panel>.list-group .list-group-item, .panel>.panel-collapse>.list-group .list-group-item {
    border-width: 1px 0;
    border-radius: 0;
}
.panel-group .panel-heading, .panel>.table-bordered>tbody>tr:first-child>td, .panel>.table-bordered>tbody>tr:first-child>th, .panel>.table-bordered>tbody>tr:last-child>td, .panel>.table-bordered>tbody>tr:last-child>th, .panel>.table-bordered>tfoot>tr:last-child>td, .panel>.table-bordered>tfoot>tr:last-child>th, .panel>.table-bordered>thead>tr:first-child>td, .panel>.table-bordered>thead>tr:first-child>th, .panel>.table-responsive>.table-bordered>tbody>tr:first-child>td, .panel>.table-responsive>.table-bordered>tbody>tr:first-child>th, .panel>.table-responsive>.table-bordered>tbody>tr:last-child>td, .panel>.table-responsive>.table-bordered>tbody>tr:last-child>th, .panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td, .panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th, .panel>.table-responsive>.table-bordered>thead>tr:first-child>td, .panel>.table-responsive>.table-bordered>thead>tr:first-child>th {
    border-bottom: 0;
}
.panel>.table-responsive:last-child>.table:last-child, .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child, .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child, .panel>.table:last-child, .panel>.table:last-child>tbody:last-child>tr:last-child, .panel>.table:last-child>tfoot:last-child>tr:last-child {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
}
.panel>.list-group:first-child .list-group-item:first-child, .panel>.panel-collapse>.list-group:first-child .list-group-item:first-child {
    border-top: 0;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
}
.panel>.list-group:last-child .list-group-item:last-child, .panel>.panel-collapse>.list-group:last-child .list-group-item:last-child {
    border-bottom: 0;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
}
.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}
.panel>.table-responsive:first-child>.table:first-child, .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child, .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child, .panel>.table:first-child, .panel>.table:first-child>tbody:first-child>tr:first-child, .panel>.table:first-child>thead:first-child>tr:first-child {
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
}
.list-group+.panel-footer, .panel-heading+.list-group .list-group-item:first-child {
    border-top-width: 0;
}
.panel>.panel-collapse>.table caption, .panel>.table caption, .panel>.table-responsive>.table caption {
    padding-left: 10px;
    padding-right: 10px;
}
.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child, .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child, .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child, .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child, .panel>.table:first-child>tbody:first-child>tr:first-child td:first-child, .panel>.table:first-child>tbody:first-child>tr:first-child th:first-child, .panel>.table:first-child>thead:first-child>tr:first-child td:first-child, .panel>.table:first-child>thead:first-child>tr:first-child th:first-child {
    border-top-left-radius: 3px;
}
.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child, .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child, .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child, .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child, .panel>.table:first-child>tbody:first-child>tr:first-child td:last-child, .panel>.table:first-child>tbody:first-child>tr:first-child th:last-child, .panel>.table:first-child>thead:first-child>tr:first-child td:last-child, .panel>.table:first-child>thead:first-child>tr:first-child th:last-child {
    border-top-right-radius: 3px;
}
.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child, .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child, .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child, .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child, .panel>.table:last-child>tbody:last-child>tr:last-child td:first-child, .panel>.table:last-child>tbody:last-child>tr:last-child th:first-child, .panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child, .panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child {
    border-bottom-left-radius: 3px;
}
.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child, .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child, .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child, .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child, .panel>.table:last-child>tbody:last-child>tr:last-child td:last-child, .panel>.table:last-child>tbody:last-child>tr:last-child th:last-child, .panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child, .panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child {
    border-bottom-right-radius: 3px;
}
.panel>.panel-body+.table, .panel>.panel-body+.table-responsive, .panel>.table+.panel-body, .panel>.table-responsive+.panel-body {
    border-top: 1px solid #e6e6e6;
}
.panel>.table>tbody:first-child>tr:first-child td, .panel>.table>tbody:first-child>tr:first-child th {
    border-top: 0;
}
.panel>.table-bordered, .panel>.table-responsive>.table-bordered {
    border: 0;
}
.panel>.table-bordered>tbody>tr>td:first-child, .panel>.table-bordered>tbody>tr>th:first-child, .panel>.table-bordered>tfoot>tr>td:first-child, .panel>.table-bordered>tfoot>tr>th:first-child, .panel>.table-bordered>thead>tr>td:first-child, .panel>.table-bordered>thead>tr>th:first-child, .panel>.table-responsive>.table-bordered>tbody>tr>td:first-child, .panel>.table-responsive>.table-bordered>tbody>tr>th:first-child, .panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child, .panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child, .panel>.table-responsive>.table-bordered>thead>tr>td:first-child, .panel>.table-responsive>.table-bordered>thead>tr>th:first-child {
    border-left: 0;
}
.panel>.table-bordered>tbody>tr>td:last-child, .panel>.table-bordered>tbody>tr>th:last-child, .panel>.table-bordered>tfoot>tr>td:last-child, .panel>.table-bordered>tfoot>tr>th:last-child, .panel>.table-bordered>thead>tr>td:last-child, .panel>.table-bordered>thead>tr>th:last-child, .panel>.table-responsive>.table-bordered>tbody>tr>td:last-child, .panel>.table-responsive>.table-bordered>tbody>tr>th:last-child, .panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child, .panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child, .panel>.table-responsive>.table-bordered>thead>tr>td:last-child, .panel>.table-responsive>.table-bordered>thead>tr>th:last-child {
    border-right: 0;
}
.panel>.table-responsive {
    border: 0;
    margin-bottom: 0;
}
.panel-group {
    margin-bottom: 18px;
}
.panel-group .panel {
    margin-bottom: 0;
    border-radius: 4px;
}
.panel-group .panel+.panel {
    margin-top: 5px;
}
.panel-group .panel-heading+.panel-collapse>.list-group, .panel-group .panel-heading+.panel-collapse>.panel-body {
    border-top: 1px solid #ddd;
}
.panel-group .panel-footer {
    border-top: 0;
}
.panel-group .panel-footer+.panel-collapse .panel-body {
    border-bottom: 1px solid #ddd;
}
.panel-primary {
    border-color: #39f;
}
.panel-primary>.panel-heading {
    color: #fff;
    background-color: #39f;
    border-color: #39f;
}
.panel-primary>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: #39f;
}
.panel-primary>.panel-heading .badge {
    color: #39f;
    background-color: #fff;
}
.panel-primary>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: #39f;
}
.panel-primary>.panel-heading {
    border-bottom: 1px solid grey;
}
.panel-success {
    border-color: #37A320;
}
.panel-success>.panel-heading {
    color: #37A320;
    background-color: #e1f1de;
    border-color: #37A320;
}
.panel-success>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: #37A320;
}
.panel-success>.panel-heading .badge {
    color: #e1f1de;
    background-color: #37A320;
}
.panel-success>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: #37A320;
}
.panel-success>.panel-heading {
    border-bottom: 1px solid grey;
}
.panel-info {
    border-color: #39f;
}
.panel-info>.panel-heading {
    color: #39f;
    background-color: #e0f0ff;
    border-color: #39f;
}
.panel-info>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: #39f;
}
.panel-info>.panel-heading .badge {
    color: #e0f0ff;
    background-color: #39f;
}
.panel-info>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: #39f;
}
.panel-info>.panel-heading {
    border-bottom: 1px solid grey;
}
.panel-warning {
    border-color: #ed6e00;
}
.panel-warning>.panel-heading {
    color: #ed6e00;
    background-color: #fce9d9;
    border-color: #ed6e00;
}
.panel-warning>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: #ed6e00;
}
.panel-warning>.panel-heading .badge {
    color: #fce9d9;
    background-color: #ed6e00;
}
.panel-warning>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: #ed6e00;
}
.panel-warning>.panel-heading {
    border-bottom: 1px solid grey;
}
.panel-danger {
    border-color: #b01c38;
}
.panel-danger>.panel-heading {
    color: #b01c38;
    background-color: #f3dde1;
    border-color: #b01c38;
}
.panel-danger>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: #b01c38;
}
.panel-danger>.panel-heading .badge {
    color: #f3dde1;
    background-color: #b01c38;
}
.panel-danger>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: #b01c38;
}
.panel-danger>.panel-heading {
    border-bottom: 1px solid grey;
}
.embed-responsive {
    position: relative;
    display: block;
    height: 0;
    padding: 0;
}
.embed-responsive .embed-responsive-item, .embed-responsive embed, .embed-responsive iframe, .embed-responsive object, .embed-responsive video {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    border: 0;
}
.embed-responsive-16by9 {
    padding-bottom: 56.25%}
.embed-responsive-4by3 {
    padding-bottom: 75%}
.well {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);
}
.well blockquote {
    border-color: #e6e6e6;
}
.well-lg {
    padding: 24px;
    border-radius: 6px;
}
.well-sm {
    padding: 9px;
    border-radius: 3px;
}
.close {
    float: right;
    font-size: 19.5px;
    color: #000;
    text-shadow: 0 1px 0 #fff;
}
.popover, .tooltip {
    font-family: "Open Sans", Verdana, sans-serif;
    font-style: normal;
    font-weight: 400;
    letter-spacing: normal;
    line-break: auto;
    text-shadow: none;
    text-transform: none;
    white-space: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    text-decoration: none;
    line-height: 1.42857143;
}
.close:focus, .close:hover {
    color: #000;
    text-decoration: none;
    cursor: pointer;
    opacity: .5;
    filter: alpha(opacity=50);
}
button.close {
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
    -webkit-appearance: none;
}
.modal-content, .popover {
    background-clip: padding-box;
}
.modal {
    display: none;
    position: fixed;
    z-index: 1050;
    -webkit-overflow-scrolling: touch;
    outline: 0;
}
.modal.fade .modal-dialog {
    transform: translate(0, -25%);
    transition: transform .3s ease-out;
}
.modal.in .modal-dialog {
    transform: translate(0, 0);
}
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
}
.modal-dialog {
    position: relative;
    width: auto;
    margin: 10px;
}
.modal-content {
    position: relative;
    background-color: #fff;
    border: 1px solid #999;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: 6px;
    box-shadow: 0 3px 9px rgba(0, 0, 0, .5);
    outline: 0;
}
.modal-backdrop {
    position: fixed;
    z-index: 1040;
    background-color: #000;
}
.modal-backdrop.fade {
    opacity: 0;
    filter: alpha(opacity=0);
}
.modal-backdrop.in {
    opacity: .5;
    filter: alpha(opacity=50);
}
.modal-header {
    border-bottom: 1px solid silver;
    min-height: 11.43px;
}
.modal-title {
    margin: 0;
    line-height: 1.42857143;
}
.modal-body {
    position: relative;
    padding: 10px;
    min-height: 200px;
}
.modal-footer {
    padding: 10px;
    text-align: right;
    border-top: 1px solid silver;
}
.modal-footer .btn+.btn {
    margin-left: 5px;
    margin-bottom: 0;
}
.modal-footer .btn-group .btn+.btn {
    margin-left: -1px;
}
.modal-footer .btn-block+.btn-block {
    margin-left: 0;
}
.modal-scrollbar-measure {
    position: absolute;
    top: -9999px;
    width: 50px;
    height: 50px;
    overflow: scroll;
}
@media (min-width:768px) {
    .modal-dialog {
    width: 600px;
    margin: 30px auto;
}
.modal-content {
    box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
}
.modal-sm {
    width: 400px;
}
}
@media (min-width:992px) {
    .modal-lg {
    width: 900px;
}
}
.tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    text-align: left;
    text-align: start;
    font-size: 12px;
    opacity: 0;
    filter: alpha(opacity=0);
}
.tooltip.in {
    opacity: 1;
    filter: alpha(opacity=100);
}
.tooltip.top {
    margin-top: -3px;
    padding: 5px 0;
}
.tooltip.right {
    margin-left: 3px;
    padding: 0 5px;
}
.tooltip.bottom {
    margin-top: 3px;
    padding: 5px 0;
}
.tooltip.left {
    margin-left: -3px;
    padding: 0 5px;
}
.tooltip-inner {
    max-width: 200px;
    padding: 3px 8px;
    color: #fff;
    text-align: center;
    background-color: #404040;
    border-radius: 4px;
}
.tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
}
.tooltip.top .tooltip-arrow, .tooltip.top-left .tooltip-arrow, .tooltip.top-right .tooltip-arrow {
    bottom: 0;
    border-width: 5px 5px 0;
    border-top-color: #404040;
}
.tooltip.top .tooltip-arrow {
    left: 50%;
    margin-left: -5px;
}
.tooltip.top-left .tooltip-arrow {
    right: 5px;
    margin-bottom: -5px;
}
.tooltip.top-right .tooltip-arrow {
    left: 5px;
    margin-bottom: -5px;
}
.tooltip.right .tooltip-arrow {
    top: 50%;
    left: 0;
    margin-top: -5px;
    border-width: 5px 5px 5px 0;
    border-right-color: #404040;
}
.tooltip.left .tooltip-arrow {
    top: 50%;
    right: 0;
    margin-top: -5px;
    border-width: 5px 0 5px 5px;
    border-left-color: #404040;
}
.tooltip.bottom .tooltip-arrow, .tooltip.bottom-left .tooltip-arrow, .tooltip.bottom-right .tooltip-arrow {
    border-width: 0 5px 5px;
    border-bottom-color: #404040;
    top: 0;
}
.tooltip.bottom .tooltip-arrow {
    left: 50%;
    margin-left: -5px;
}
.tooltip.bottom-left .tooltip-arrow {
    right: 5px;
    margin-top: -5px;
}
.tooltip.bottom-right .tooltip-arrow {
    left: 5px;
    margin-top: -5px;
}
.popover {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1060;
    display: none;
    max-width: 500px;
    padding: 1px;
    text-align: left;
    text-align: start;
    font-size: 13px;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: 6px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
}
.carousel-caption, .carousel-control {
    color: #fff;
    text-align: center;
    text-shadow: 0 1px 2px rgba(0, 0, 0, .6);
}
.popover.top {
    margin-top: -10px;
}
.popover.right {
    margin-left: 10px;
}
.popover.bottom {
    margin-top: 10px;
}
.popover.left {
    margin-left: -10px;
}
.popover-title {
    margin: 0;
    padding: 8px 14px;
    font-size: 13px;
    background-color: #f7f7f7;
    border-bottom: 1px solid #ebebeb;
    border-radius: 5px 5px 0 0;
}
.popover-content {
    padding: 9px 14px;
    overflow-y: auto;
}
.popover>.arrow, .popover>.arrow:after {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
}
.carousel, .carousel-inner {
    position: relative;
}
.popover>.arrow {
    border-width: 11px;
}
.popover>.arrow:after {
    border-width: 10px;
    content: ""}
.popover.top>.arrow {
    left: 50%;
    margin-left: -11px;
    border-bottom-width: 0;
    border-top-color: #999;
    border-top-color: rgba(0, 0, 0, .25);
    bottom: -11px;
}
.popover.top>.arrow:after {
    content: " ";
    bottom: 1px;
    margin-left: -10px;
    border-bottom-width: 0;
    border-top-color: #fff;
}
.popover.left>.arrow:after, .popover.right>.arrow:after {
    content: " ";
    bottom: -10px;
}
.popover.right>.arrow {
    top: 50%;
    left: -11px;
    margin-top: -11px;
    border-left-width: 0;
    border-right-color: #999;
    border-right-color: rgba(0, 0, 0, .25);
}
.popover.right>.arrow:after {
    left: 1px;
    border-left-width: 0;
    border-right-color: #fff;
}
.popover.bottom>.arrow {
    left: 50%;
    margin-left: -11px;
    border-top-width: 0;
    border-bottom-color: #999;
    border-bottom-color: rgba(0, 0, 0, .25);
    top: -11px;
}
.popover.bottom>.arrow:after {
    content: " ";
    top: 1px;
    margin-left: -10px;
    border-top-width: 0;
    border-bottom-color: #fff;
}
.popover.left>.arrow {
    top: 50%;
    right: -11px;
    margin-top: -11px;
    border-right-width: 0;
    border-left-color: #999;
    border-left-color: rgba(0, 0, 0, .25);
}
.popover.left>.arrow:after {
    right: 1px;
    border-right-width: 0;
    border-left-color: #fff;
}
.carousel-inner {
    width: 100%}
.carousel-inner>.item {
    display: none;
    position: relative;
    transition: .6s ease-in-out left;
}
@media all and (transform-3d), (-webkit-transform-3d) {
    .carousel-inner>.item {
    transition: transform .6s ease-in-out;
    backface-visibility: hidden;
    perspective: 1000px;
}
.carousel-inner>.item.active.right, .carousel-inner>.item.next {
    transform: translate3d(100%, 0, 0);
    left: 0;
}
.carousel-inner>.item.active.left, .carousel-inner>.item.prev {
    transform: translate3d(-100%, 0, 0);
    left: 0;
}
.carousel-inner>.item.active, .carousel-inner>.item.next.left, .carousel-inner>.item.prev.right {
    transform: translate3d(0, 0, 0);
    left: 0;
}
}
.carousel-inner>.active, .carousel-inner>.next, .carousel-inner>.prev {
    display: block;
}
.carousel-inner>.active {
    left: 0;
}
.carousel-inner>.next, .carousel-inner>.prev {
    position: absolute;
    top: 0;
    width: 100%}
.carousel-inner>.next {
    left: 100%}
.carousel-inner>.prev {
    left: -100%}
.carousel-inner>.next.left, .carousel-inner>.prev.right {
    left: 0;
}
.carousel-inner>.active.left {
    left: -100%}
.carousel-inner>.active.right {
    left: 100%}
.carousel-control {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 15%;
    opacity: .5;
    filter: alpha(opacity=50);
    font-size: 20px;
}
.carousel-control.left {
    background-image: linear-gradient(to right, rgba(0, 0, 0, .5) 0, rgba(0, 0, 0, .0001) 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);
}
.carousel-control.right {
    left: auto;
    right: 0;
    background-image: linear-gradient(to right, rgba(0, 0, 0, .0001) 0, rgba(0, 0, 0, .5) 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);
}
.carousel-control:focus, .carousel-control:hover {
    outline: 0;
    color: #fff;
    text-decoration: none;
    opacity: .9;
    filter: alpha(opacity=90);
}
.carousel-control .glyphicon-chevron-left, .carousel-control .glyphicon-chevron-right, .carousel-control .ai-next, .carousel-control .ai-prev {
    position: absolute;
    top: 50%;
    margin-top: -10px;
    z-index: 5;
    display: inline-block;
}
.alert-superimposed.top-left, .alert-superimposed.top-right {
    top: 20px;
}
.carousel-control .glyphicon-chevron-left, .carousel-control .ai-prev {
    left: 50%;
    margin-left: -10px;
}
.carousel-control .glyphicon-chevron-right, .carousel-control .ai-next {
    right: 50%;
    margin-right: -10px;
}
.carousel-control .ai-next, .carousel-control .ai-prev {
    width: 20px;
    height: 20px;
    line-height: 1;
    font-family: serif;
}
.carousel-control .ai-prev:before {
    content: '\\2039'}
.carousel-control .ai-next:before {
    content: '\\203a'}
.carousel-indicators {
    position: absolute;
    bottom: 10px;
    left: 50%;
    z-index: 15;
    width: 60%;
    margin-left: -30%;
    padding-left: 0;
    text-align: center;
}
.alert-superimposed.bottom-left, .alert-superimposed.bottom-right {
    bottom: 20px;
}
.carousel-indicators li {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 1px;
    text-indent: -999px;
    border: 1px solid #fff;
    border-radius: 10px;
    cursor: pointer;
    background-color: #000\\9;
    background-color: rgba(0, 0, 0, 0);
}
.carousel-indicators .active {
    margin: 0;
    width: 12px;
    height: 12px;
    background-color: #fff;
}
.carousel-caption {
    position: absolute;
    left: 15%;
    right: 15%;
    bottom: 20px;
    z-index: 10;
    padding-top: 20px;
    padding-bottom: 20px;
}
.carousel-caption .btn, .text-hide {
    text-shadow: none;
}
@media screen and (min-width:768px) {
    .carousel-control .glyphicon-chevron-left, .carousel-control .glyphicon-chevron-right, .carousel-control .ai-next, .carousel-control .ai-prev {
    width: 30px;
    height: 30px;
    margin-top: -15px;
    font-size: 30px;
}
.carousel-control .glyphicon-chevron-left, .carousel-control .ai-prev {
    margin-left: -15px;
}
.carousel-control .glyphicon-chevron-right, .carousel-control .ai-next {
    margin-right: -15px;
}
.carousel-caption {
    left: 20%;
    right: 20%;
    padding-bottom: 30px;
}
.carousel-indicators {
    bottom: 20px;
}
}
.btn-group-vertical>.btn-group:after, .btn-group-vertical>.btn-group:before, .btn-toolbar:after, .btn-toolbar:before, .clearfix:after, .clearfix:before, .container-fluid:after, .container-fluid:before, .container:after, .container:before, .dl-horizontal dd:after, .dl-horizontal dd:before, .form-horizontal .form-group:after, .form-horizontal .form-group:before, .modal-footer:after, .modal-footer:before, .nav:after, .nav:before, .navbar-collapse:after, .navbar-collapse:before, .navbar-header:after, .navbar-header:before, .navbar:after, .navbar:before, .pager:after, .pager:before, .panel-body:after, .panel-body:before, .panel-footer:after, .panel-footer:before, .row-dual-segments:after, .row-dual-segments:before, .row:after, .row:before {
    content: " ";
    display: table;
    min-width: min-content;
}
.btn-group-vertical>.btn-group:after, .btn-toolbar:after, .clearfix:after, .container-fluid:after, .container:after, .dl-horizontal dd:after, .form-horizontal .form-group:after, .modal-footer:after, .nav:after, .navbar-collapse:after, .navbar-header:after, .navbar:after, .pager:after, .panel-body:after, .panel-footer:after, .row-dual-segments:after, .row:after {
    clear: both;
}
.center-block {
    display: block;
    margin-left: auto;
    margin-right: auto;
}
.pull-right {
    float: right!important;
}
.pull-left {
    float: left!important;
}
.hide {
    display: none!important;
}
.show {
    display: block!important;
}
.hidden, .visible-lg, .visible-lg-block, .visible-lg-inline, .visible-lg-inline-block, .visible-md, .visible-md-block, .visible-md-inline, .visible-md-inline-block, .visible-sm, .visible-sm-block, .visible-sm-inline, .visible-sm-inline-block, .visible-xs, .visible-xs-block, .visible-xs-inline, .visible-xs-inline-block {
    display: none!important;
}
.invisible {
    visibility: hidden;
}
.text-hide {
    color: transparent;
    background-color: transparent;
    border: 0;
}
.btn, .modal-title {
    font-size: 13px;
}
.alert-success, .alert-warning {
    padding-left: 35px;
}
.affix {
    position: fixed;
}

@media (max-width:767px) {
    .visible-xs {
    display: block!important;
}
table.visible-xs {
    display: table!important;
}
tr.visible-xs {
    display: table-row!important;
}
td.visible-xs, th.visible-xs {
    display: table-cell!important;
}
.visible-xs-block {
    display: block!important;
}
.visible-xs-inline {
    display: inline!important;
}
.visible-xs-inline-block {
    display: inline-block!important;
}
}
@media (min-width:768px) and (max-width:991px) {
    .visible-sm {
    display: block!important;
}
table.visible-sm {
    display: table!important;
}
tr.visible-sm {
    display: table-row!important;
}
td.visible-sm, th.visible-sm {
    display: table-cell!important;
}
.visible-sm-block {
    display: block!important;
}
.visible-sm-inline {
    display: inline!important;
}
.visible-sm-inline-block {
    display: inline-block!important;
}
}
@media (min-width:992px) and (max-width:1199px) {
    .visible-md {
    display: block!important;
}
table.visible-md {
    display: table!important;
}
tr.visible-md {
    display: table-row!important;
}
td.visible-md, th.visible-md {
    display: table-cell!important;
}
.visible-md-block {
    display: block!important;
}
.visible-md-inline {
    display: inline!important;
}
.visible-md-inline-block {
    display: inline-block!important;
}
}
@media (min-width:1200px) {
    .visible-lg {
    display: block!important;
}
table.visible-lg {
    display: table!important;
}
tr.visible-lg {
    display: table-row!important;
}
td.visible-lg, th.visible-lg {
    display: table-cell!important;
}
.visible-lg-block {
    display: block!important;
}
.visible-lg-inline {
    display: inline!important;
}
.visible-lg-inline-block {
    display: inline-block!important;
}
.hidden-lg {
    display: none!important;
}
}
@media (max-width:767px) {
    .hidden-xs {
    display: none!important;
}
}
@media (min-width:768px) and (max-width:991px) {
    .hidden-sm {
    display: none!important;
}
}
@media (min-width:992px) and (max-width:1199px) {
    .hidden-md {
    display: none!important;
}
}
.visible-print {
    display: none!important;
}
@media print {
    .visible-print {
    display: block!important;
}
table.visible-print {
    display: table!important;
}
tr.visible-print {
    display: table-row!important;
}
td.visible-print, th.visible-print {
    display: table-cell!important;
}
}
.visible-print-block {
    display: none!important;
}
@media print {
    .visible-print-block {
    display: block!important;
}
}
.visible-print-inline {
    display: none!important;
}
@media print {
    .visible-print-inline {
    display: inline!important;
}
}
.visible-print-inline-block {
    display: none!important;
}
@media print {
    .visible-print-inline-block {
    display: inline-block!important;
}
.hidden-print {
    display: none!important;
}
}
.alert-superimposed {
    border-radius: 6px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .25)!important;
    z-index: 1100;
    margin-bottom: 0;
    position: absolute;
    max-width: 750px;
}
.alert-superimposed.bottom-left, .alert-superimposed.top-left {
    left: 0;
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.alert-superimposed.bottom-right, .alert-superimposed.top-right {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    right: 0;
}
.alert>a {
    text-decoration: underline;
}
.alert>.pull-right {
    margin-left: 10px;
}
.alert-success {
    border-color: #37A320;
    color: #404040;
}
.alert-info hr {
    border-top-color: #198cff;
}
.alert-info .alert-link {
    color: #272727;
}
.alert-warning {
    border-color: #ed6e00;
    color: #404040;
}
.close, .close.disabled, .close:disabled {
    background: url(data:image/svg+xml;
    ), 0 0;
}
.alert-danger hr {
    border-top-color: #9a1931;
}
.alert-danger .alert-link {
    color: #272727;
}
.close {
    opacity: 1;
    filter: alpha(opacity=100);
    width: 11px;
    height: 11px;
}
.modal-content {
    overflow: hidden;
}
.modal-header {
    padding: 5px 10px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-size: contain;
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0);
}
.modal-header .close, .modal-header .close:active, .modal-header .close:focus, .modal-header .close:hover {
    background-repeat: no-repeat;
    background-position-y: center;
}
.modal-header .close {
    margin-top: 0;
    height: 18px;
}
.modal-footer {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: #e6e6e6;
}
.modal-footer .btn-link.pull-left {
    margin-left: 0;
    padding-left: 0;
}
.modal-footer .btn-link.pull-right {
    margin-right: 0;
    padding-right: 0;
}
@media (min-width:1200px) {
    .modal-lg {
    width: 1100px;
}
}
.btn {
    padding: 3px 15px;
    line-height: 1.42857143;
    border-radius: 4px;
    min-width: 86px;
    -webkit-user-select: none;
    user-select: none;
}
.btn-group-hover {
    position: relative;
    display: inline-block;
}
.btn-group-hover>.btn {
    position: relative;
    float: left;
}
.btn-group-hover>.btn.active, .btn-group-hover>.btn:active, .btn-group-hover>.btn:focus, .btn-group-hover>.btn:hover {
    z-index: 2;
}
.btn-group-hover .btn+.btn, .btn-group-hover .btn+.btn-group, .btn-group-hover .btn-group+.btn, .btn-group-hover .btn-group+.btn-group {
    margin-left: -1px;
}
.btn-group-hover.btn-group-flat .btn-default {
    box-shadow: none;
    background-color: #fff;
    background-image: none;
    filter: none;
    font-size: 12px;
    min-width: 0;
    padding: 8px;
    white-space: pre-line;
}
.btn-group-hover.btn-group-flat .btn-default:focus, .btn-group-hover.btn-group-flat .btn-default:hover {
    background-color: rgba(0, 0, 0, .06);
}
.btn-group-hover.btn-group-flat .btn-default.active, .btn-group-hover.btn-group-flat .btn-default.active:focus, .btn-group-hover.btn-group-flat .btn-default.active:hover {
    background-color: #b3d9ff;
}
.btn-default, .btn-default.focus, .btn-default:focus {
    background-color: silver;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0);
    border-color: grey;
    color: #333;
    background-repeat: repeat-x;
}
.btn-group-hover:hover .dropdown-menu {
    display: block;
    top: 94%}
.btn-default {
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%);
}
.btn-default.focus, .btn-default:focus {
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%);
}
.btn-default:hover {
    color: #333;
    background-color: #cdcdcd;
    background-image: linear-gradient(to bottom, #fdfdfd 0, #cdcdcd 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffdfdfd', endColorstr='#ffcdcdcd', GradientType=0);
    border-color: #9a9a9a;
}
.btn-default.active, .btn-default.active.focus, .btn-default.active:focus, .btn-default.active:hover, .btn-default:active, .btn-default:active.focus, .btn-default:active:focus, .btn-default:active:hover, .open>.dropdown-toggle.btn-default, .open>.dropdown-toggle.btn-default.focus, .open>.dropdown-toggle.btn-default:focus, .open>.dropdown-toggle.btn-default:hover {
    color: #333;
    background-color: #9a9a9a;
    background-image: linear-gradient(to bottom, #cacaca 0, #9a9a9a 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffcacaca', endColorstr='#ff9a9a9a', GradientType=0);
    border-color: #676767;
}
.btn-default .badge, .btn-default.disabled, .btn-default.disabled.active, .btn-default.disabled.focus, .btn-default.disabled:active, .btn-default.disabled:focus, .btn-default.disabled:hover, .btn-default[disabled], .btn-default[disabled].active, .btn-default[disabled].focus, .btn-default[disabled]:active, .btn-default[disabled]:focus, .btn-default[disabled]:hover, fieldset[disabled] .btn-default, fieldset[disabled] .btn-default.active, fieldset[disabled] .btn-default.focus, fieldset[disabled] .btn-default:active, fieldset[disabled] .btn-default:focus, fieldset[disabled] .btn-default:hover {
    color: #333;
    background-color: silver;
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0);
    border-color: grey;
}
.btn-primary, .btn-primary.focus, .btn-primary:focus {
    background-color: #39f;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3399ff', endColorstr='#ff0962ac', GradientType=0);
    border-color: #0059b3;
    color: #fff;
    background-repeat: repeat-x;
}
.btn-primary {
    background-image: linear-gradient(to bottom, #39f 0, #0962ac 100%);
}
.btn-primary.focus, .btn-primary:focus {
    background-image: linear-gradient(to bottom, #39f 0, #0962ac 100%);
}
.btn-primary:hover {
    color: #fff;
    background-color: #5cadff;
    background-image: linear-gradient(to bottom, #5cadff 0, #3a81bd 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5cadff', endColorstr='#ff3a81bd', GradientType=0);
    border-color: #337ac2;
}
.btn-primary.active, .btn-primary.active.focus, .btn-primary.active:focus, .btn-primary.active:hover, .btn-primary:active, .btn-primary:active.focus, .btn-primary:active:focus, .btn-primary:active:hover, .open>.dropdown-toggle.btn-primary, .open>.dropdown-toggle.btn-primary.focus, .open>.dropdown-toggle.btn-primary:focus, .open>.dropdown-toggle.btn-primary:hover {
    color: #fff;
    background-color: #297acc;
    background-image: linear-gradient(to bottom, #297acc 0, #074e8a 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff297acc', endColorstr='#ff074e8a', GradientType=0);
    border-color: #00478f;
}
.btn-primary .badge, .btn-primary.disabled, .btn-primary.disabled.active, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled:focus, .btn-primary.disabled:hover, .btn-primary[disabled], .btn-primary[disabled].active, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled]:focus, .btn-primary[disabled]:hover, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary.active, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary:hover {
    color: #fff;
    background-color: #39f;
    background-image: linear-gradient(to bottom, #39f 0, #0962ac 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3399ff', endColorstr='#ff0962ac', GradientType=0);
    border-color: #0059b3;
}
.btn-success, .btn-success.focus, .btn-success:focus {
    color: #fff;
    background-color: #37A320;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #37A320 0, #297818 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff37a320', endColorstr='#ff297818', GradientType=0);
    border-color: #13380b;
}
.btn-success:hover {
    color: #fff;
    background-color: #5fb54d;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #5fb54d 0, #539346 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5fb54d', endColorstr='#ff539346', GradientType=0);
    border-color: #42603c;
}
.btn-success.active, .btn-success.active.focus, .btn-success.active:focus, .btn-success.active:hover, .btn-success:active, .btn-success:active.focus, .btn-success:active:focus, .btn-success:active:hover, .open>.dropdown-toggle.btn-success, .open>.dropdown-toggle.btn-success.focus, .open>.dropdown-toggle.btn-success:focus, .open>.dropdown-toggle.btn-success:hover {
    color: #fff;
    background-color: #2c821a;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #2c821a 0, #206013 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff2c821a', endColorstr='#ff206013', GradientType=0);
    border-color: #0f2d09;
}
.btn-success .badge, .btn-success.disabled, .btn-success.disabled.active, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled:focus, .btn-success.disabled:hover, .btn-success[disabled], .btn-success[disabled].active, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled]:focus, .btn-success[disabled]:hover, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success.active, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success:hover {
    color: #fff;
    background-color: #37A320;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #37A320 0, #297818 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff37a320', endColorstr='#ff297818', GradientType=0);
    border-color: #13380b;
}
.btn-info, .btn-info.focus, .btn-info:focus {
    color: #fff;
    background-color: #39f;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #39f 0, #007fff 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3399ff', endColorstr='#ff007fff', GradientType=0);
    border-color: #0059b3;
}
.btn-info:hover {
    color: #fff;
    background-color: #5cadff;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #5cadff 0, #39f 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5cadff', endColorstr='#ff3399ff', GradientType=0);
    border-color: #337ac2;
}
.btn-info.active, .btn-info.active.focus, .btn-info.active:focus, .btn-info.active:hover, .btn-info:active, .btn-info:active.focus, .btn-info:active:focus, .btn-info:active:hover, .open>.dropdown-toggle.btn-info, .open>.dropdown-toggle.btn-info.focus, .open>.dropdown-toggle.btn-info:focus, .open>.dropdown-toggle.btn-info:hover {
    color: #fff;
    background-color: #297acc;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #297acc 0, #06c 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff297acc', endColorstr='#ff0066cc', GradientType=0);
    border-color: #00478f;
}
.btn-info .badge, .btn-info.disabled, .btn-info.disabled.active, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled:focus, .btn-info.disabled:hover, .btn-info[disabled], .btn-info[disabled].active, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled]:focus, .btn-info[disabled]:hover, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info.active, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info:hover {
    color: #fff;
    background-color: #39f;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #39f 0, #007fff 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3399ff', endColorstr='#ff007fff', GradientType=0);
    border-color: #0059b3;
}
.btn-warning, .btn-warning.focus, .btn-warning:focus {
    color: #fff;
    background-color: #ed6e00;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #ed6e00 0, #ba5600 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffed6e00', endColorstr='#ffba5600', GradientType=0);
    border-color: #6e3300;
}
.btn-warning:hover {
    color: #fff;
    background-color: #f18b33;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #f18b33 0, #c87833 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff18b33', endColorstr='#ffc87833', GradientType=0);
    border-color: #8b5c33;
}
.btn-warning.active, .btn-warning.active.focus, .btn-warning.active:focus, .btn-warning.active:hover, .btn-warning:active, .btn-warning:active.focus, .btn-warning:active:focus, .btn-warning:active:hover, .open>.dropdown-toggle.btn-warning, .open>.dropdown-toggle.btn-warning.focus, .open>.dropdown-toggle.btn-warning:focus, .open>.dropdown-toggle.btn-warning:hover {
    color: #fff;
    background-color: #be5800;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #be5800 0, #954500 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffbe5800', endColorstr='#ff954500', GradientType=0);
    border-color: #582900;
}
.btn-warning .badge, .btn-warning.disabled, .btn-warning.disabled.active, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled:focus, .btn-warning.disabled:hover, .btn-warning[disabled], .btn-warning[disabled].active, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled]:focus, .btn-warning[disabled]:hover, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning.active, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning:hover {
    color: #fff;
    background-color: #ed6e00;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #ed6e00 0, #ba5600 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffed6e00', endColorstr='#ffba5600', GradientType=0);
    border-color: #6e3300;
}
.btn-danger, .btn-danger.focus, .btn-danger:focus {
    color: #fff;
    background-color: #b01c38;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #b01c38 0, #84152a 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffb01c38', endColorstr='#ff84152a', GradientType=0);
    border-color: #420b15;
}
.btn-danger:hover {
    color: #fff;
    background-color: #c04960;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #c04960 0, #9d4455 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffc04960', endColorstr='#ff9d4455', GradientType=0);
    border-color: #683b44;
}
.btn-danger.active, .btn-danger.active.focus, .btn-danger.active:focus, .btn-danger.active:hover, .btn-danger:active, .btn-danger:active.focus, .btn-danger:active:focus, .btn-danger:active:hover, .open>.dropdown-toggle.btn-danger, .open>.dropdown-toggle.btn-danger.focus, .open>.dropdown-toggle.btn-danger:focus, .open>.dropdown-toggle.btn-danger:hover {
    color: #fff;
    background-color: #8d162d;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #8d162d 0, #6a1122 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff8d162d', endColorstr='#ff6a1122', GradientType=0);
    border-color: #350811;
}
.btn-danger .badge, .btn-danger.disabled, .btn-danger.disabled.active, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled:focus, .btn-danger.disabled:hover, .btn-danger[disabled], .btn-danger[disabled].active, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled]:focus, .btn-danger[disabled]:hover, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger.active, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger:hover {
    color: #fff;
    background-color: #b01c38;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #b01c38 0, #84152a 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffb01c38', endColorstr='#ff84152a', GradientType=0);
    border-color: #420b15;
}
.btn-default-inverse, .btn-default-inverse.focus, .btn-default-inverse:focus {
    color: #fff;
    background-color: #404040;
    background-image: url(#);
    background-image: linear-gradient(to bottom, grey 0, #404040 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0);
    border-color: #000;
}
.btn-default-inverse:hover {
    color: #fff;
    background-color: #666;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #999 0, #666 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff999999', endColorstr='#ff666666', GradientType=0);
    border-color: #333;
}
.btn-default-inverse.active, .btn-default-inverse.active.focus, .btn-default-inverse.active:focus, .btn-default-inverse.active:hover, .btn-default-inverse:active, .btn-default-inverse:active.focus, .btn-default-inverse:active:focus, .btn-default-inverse:active:hover, .open>.dropdown-toggle.btn-default-inverse, .open>.dropdown-toggle.btn-default-inverse.focus, .open>.dropdown-toggle.btn-default-inverse:focus, .open>.dropdown-toggle.btn-default-inverse:hover {
    color: #fff;
    background-color: #333;
    background-image: url(#);
    background-image: linear-gradient(to bottom, #666 0, #333 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff666666', endColorstr='#ff333333', GradientType=0);
    border-color: #000;
}
.btn-default-inverse .badge, .btn-default-inverse.disabled, .btn-default-inverse.disabled.active, .btn-default-inverse.disabled.focus, .btn-default-inverse.disabled:active, .btn-default-inverse.disabled:focus, .btn-default-inverse.disabled:hover, .btn-default-inverse[disabled], .btn-default-inverse[disabled].active, .btn-default-inverse[disabled].focus, .btn-default-inverse[disabled]:active, .btn-default-inverse[disabled]:focus, .btn-default-inverse[disabled]:hover, fieldset[disabled] .btn-default-inverse, fieldset[disabled] .btn-default-inverse.active, fieldset[disabled] .btn-default-inverse.focus, fieldset[disabled] .btn-default-inverse:active, fieldset[disabled] .btn-default-inverse:focus, fieldset[disabled] .btn-default-inverse:hover {
    color: #fff;
    background-color: #404040;
    background-image: url(#);
    background-image: linear-gradient(to bottom, grey 0, #404040 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0);
    border-color: #000;
}
.btn-link {
    cursor: pointer;
}
.btn-toolbar .btn {
    min-width: initial;
}
.dropdown-menu>li>a {
    padding: 5px 20px;
}
.dropdown-menu, .dropdown-menu-icons {
    padding: 0;
    max-height: 275px;
    overflow-y: auto;
}
.dropdown-icon {
    position: absolute;
    top: 3px;
    left: 10px;
}
.dropdown-menu-icons {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 160px;
    margin: 2px 0 0;
    font-size: 13px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    background-clip: padding-box;
}
.panel-fixed, .panel-fixed>.panel-body {
    top: 0;
    bottom: 0;
}
.line-segment-right-30>*, .line-segment-right-50>*, .line-segment-right-70>*, .line-segment-right>* {
    float: right!important;
}
.dropdown-menu-icons.pull-right {
    right: 0;
    left: auto;
}
.dropdown-menu-icons .divider {
    height: 1px;
    margin: 8px 0;
    overflow: hidden;
    background-color: #e5e5e5;
}
.dropdown-menu-icons>li>a {
    display: block;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #404040;
    white-space: nowrap;
    position: relative;
    padding: 5px 20px 5px 30px;
}
.dropdown-toggle {
    min-width: initial;
}
.form-inline>* {
    margin-right: 5px;
}
.input-narrow {
    width: 85px!important;
}
.input-wide {
    width: 170px!important;
}
.form-control {
    padding-top: 2px;
    overflow: visible;
}
.panel-fixed-footer>.panel-body, .panel-fixed-header-footer>.panel-body, .panel-fixed>.panel-body {
    overflow-y: auto;
    left: 0;
    right: 0;
    position: absolute;
}
.search {
    border-radius: 14px;
    background: url(data:image/svg+xml;
    ), 0 0;
}
.panel-footer {
    padding: 10px;
    border-top: 1px solid silver;
    background-color: #e6e6e6;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    text-align: right;
}
.panel-footer .btn+.btn {
    margin-left: 5px;
    margin-bottom: 0;
}
.panel-footer .btn-group .btn+.btn {
    margin-left: -1px;
}
.panel-footer .btn-block+.btn-block {
    margin-left: 0;
}
.panel-footer .btn-link.pull-left {
    margin-left: 0;
    padding-left: 0;
}
.panel-footer .btn-link.pull-right {
    margin-right: 0;
    padding-right: 0;
}
.panel-footer>span {
    padding-top: 4px;
    padding-bottom: 4px;
}
.panel-gray {
    border-color: silver;
    background: #eee;
}
.panel-fixed {
    position: absolute;
    right: 0;
    left: 0;
    margin-bottom: 0;
}
.panel-fixed>.panel-footer {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
}
.panel-default-header.panel-fixed, .panel-fixed-header {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin-bottom: 0;
}
.panel-default-header.panel-fixed>.panel-body, .panel-fixed-header>.panel-body {
    overflow-y: auto;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 25px;
}
.panel-default-header.panel-fixed>.panel-footer, .panel-fixed-header>.panel-footer {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
}
.panel-fixed-footer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin-bottom: 0;
}
.panel-fixed-footer>.panel-footer {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
}
.panel-fixed-footer>.panel-body {
    top: 0;
    bottom: 47px;
}
.panel-fixed-header-footer, .panel-fixed-header-footer>.panel-footer {
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
}
.panel-fixed-header-footer {
    top: 0;
    margin-bottom: 0;
}
.panel-fixed-header-footer>.panel-body {
    top: 25px;
    bottom: 47px;
}
.side-panel {
    overflow: hidden;
    box-shadow: 0 1px 8px 2px rgba(0, 0, 0, .25);
}
.side-panel.right {
    border-right: none;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}
.side-panel.left {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}
.panel-placeholder>.panel-body>div {
    position: absolute;
    top: 10px;
    right: 10px;
    bottom: 10px;
    left: 10px;
}
.panel-nav-tree {
    border: none;
}
.panel-nav-tree .list-group-item {
    border: none;
    border-radius: 4px;
    cursor: default;
}
.panel-nav-tree .list-group-item.active, .panel-nav-tree .list-group-item.active:focus, .panel-nav-tree .list-group-item.active:hover {
    border: none;
}
.panel-nav-tree .list-group-item:first-child, .panel-nav-tree .list-group-item:last-child {
    border-radius: 4px;
}
.panel-nav-tree .list-group {
    margin-bottom: 0;
}
.panel-tabs {
    background-color: transparent;
    border: none;
    margin-bottom: 0;
}
.panel-default>.panel-heading+.panel-collapse>.panel-body, .panel-inverse>.panel-heading+.panel-collapse>.panel-body {
    border-top-color: silver;
}
.panel-tabs>.panel-body {
    overflow-y: hidden;
    border-left: 1px solid silver;
    border-right: 1px solid silver;
    border-bottom: 1px solid silver;
    background: #fff;
    top: 26px;
}
.panel-text-editor .form-control, .text-editor .form-control {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-style: none;
}
.panel-tabs>.panel-body>.panel {
    margin-bottom: 0;
}
.panel-tabs>.nav-tabs {
    height: 26px;
}
.panel-tabs>.nav-tabs>li:first-child {
    margin-left: 6px;
}
.text-editor {
    margin-bottom: 0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}
.text-editor .form-control {
    height: auto;
}
.panel-text-editor {
    margin-bottom: 0;
    border-radius: 0;
}
.panel-text-editor>.panel-body {
    padding: 0!important;
}
.panel-text-editor .form-control {
    height: 100%}
.panel-default {
    border-color: silver;
}
.panel-default>.panel-heading {
    color: #404040;
    background-color: #f5f5f5;
    border-color: silver;
}
.panel-default>.panel-heading .badge {
    color: #f5f5f5;
    background-color: #404040;
}
.panel-default>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: silver;
}
.panel-default>.panel-heading {
    border-bottom: 1px solid grey;
}
.panel-inverse, .panel-inverse>.panel-heading {
    background-color: #303030;
    border-color: silver;
}
.panel-inverse>.panel-heading {
    color: #fff;
}
.panel-inverse>.panel-heading .badge {
    color: #303030;
    background-color: #fff;
}
.panel-inverse>.panel-footer+.panel-collapse>.panel-body {
    border-bottom-color: silver;
}
.panel-inverse>.panel-heading {
    border-bottom: 1px solid grey;
    background-size: contain;
    background-image: linear-gradient(to bottom, grey 0, #404040 100%);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0);
}
.panel-inverse>.panel-heading>.btn-default, .panel-inverse>.panel-heading>.btn-default.focus, .panel-inverse>.panel-heading>.btn-default:focus {
    color: #fff!important;
    background-color: #404040!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;
    border-color: #000!important;
}
.panel-inverse>.panel-heading>.btn-default:hover {
    color: #fff!important;
    background-color: #666!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, #999 0, #666 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff999999', endColorstr='#ff666666', GradientType=0)!important;
}
.open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default.focus, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default:focus, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default:hover, .panel-inverse>.panel-heading>.btn-default.active, .panel-inverse>.panel-heading>.btn-default.active.focus, .panel-inverse>.panel-heading>.btn-default.active:focus, .panel-inverse>.panel-heading>.btn-default.active:hover, .panel-inverse>.panel-heading>.btn-default:active, .panel-inverse>.panel-heading>.btn-default:active.focus, .panel-inverse>.panel-heading>.btn-default:active:focus, .panel-inverse>.panel-heading>.btn-default:active:hover {
    color: #fff!important;
    background-color: #333!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, #666 0, #333 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff666666', endColorstr='#ff333333', GradientType=0)!important;
    border-color: #000!important;
}
.panel-inverse>.panel-heading>.btn-default .badge, .panel-inverse>.panel-heading>.btn-default.disabled, .panel-inverse>.panel-heading>.btn-default.disabled.active, .panel-inverse>.panel-heading>.btn-default.disabled.focus, .panel-inverse>.panel-heading>.btn-default.disabled:active, .panel-inverse>.panel-heading>.btn-default.disabled:focus, .panel-inverse>.panel-heading>.btn-default.disabled:hover, .panel-inverse>.panel-heading>.btn-default[disabled], .panel-inverse>.panel-heading>.btn-default[disabled].active, .panel-inverse>.panel-heading>.btn-default[disabled].focus, .panel-inverse>.panel-heading>.btn-default[disabled]:active, .panel-inverse>.panel-heading>.btn-default[disabled]:focus, .panel-inverse>.panel-heading>.btn-default[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default.active, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default.focus, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default:active, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default:focus, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default:hover {
    color: #fff!important;
    background-color: #404040!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;
    border-color: #000!important;
}
.panel-inverse>.panel-heading>.btn-default-inverse, .panel-inverse>.panel-heading>.btn-default-inverse.focus, .panel-inverse>.panel-heading>.btn-default-inverse:focus {
    background-color: silver!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;
    color: #333!important;
    background-repeat: repeat-x!important;
}
.panel-inverse>.panel-heading>.btn-default:hover {
    border-color: grey!important;
}
.panel-inverse>.panel-heading>.btn-default-inverse {
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;
    border-color: grey!important;
}
.panel-inverse>.panel-heading>.btn-default-inverse.focus, .panel-inverse>.panel-heading>.btn-default-inverse:focus {
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;
    border-color: grey!important;
}
.panel-inverse>.panel-heading>.btn-default-inverse:hover {
    color: #333!important;
    background-color: #cdcdcd!important;
    background-image: linear-gradient(to bottom, #fdfdfd 0, #cdcdcd 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffdfdfd', endColorstr='#ffcdcdcd', GradientType=0)!important;
}
.open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default-inverse, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default-inverse.focus, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default-inverse:focus, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default-inverse:hover, .panel-inverse>.panel-heading>.btn-default-inverse.active, .panel-inverse>.panel-heading>.btn-default-inverse.active.focus, .panel-inverse>.panel-heading>.btn-default-inverse.active:focus, .panel-inverse>.panel-heading>.btn-default-inverse.active:hover, .panel-inverse>.panel-heading>.btn-default-inverse:active, .panel-inverse>.panel-heading>.btn-default-inverse:active.focus, .panel-inverse>.panel-heading>.btn-default-inverse:active:focus, .panel-inverse>.panel-heading>.btn-default-inverse:active:hover {
    color: #333!important;
    background-color: #9a9a9a!important;
    background-image: linear-gradient(to bottom, #cacaca 0, #9a9a9a 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffcacaca', endColorstr='#ff9a9a9a', GradientType=0)!important;
    border-color: #676767!important;
}
.panel-inverse>.panel-heading>.btn-default-inverse .badge, .panel-inverse>.panel-heading>.btn-default-inverse.disabled, .panel-inverse>.panel-heading>.btn-default-inverse.disabled.active, .panel-inverse>.panel-heading>.btn-default-inverse.disabled.focus, .panel-inverse>.panel-heading>.btn-default-inverse.disabled:active, .panel-inverse>.panel-heading>.btn-default-inverse.disabled:focus, .panel-inverse>.panel-heading>.btn-default-inverse.disabled:hover, .panel-inverse>.panel-heading>.btn-default-inverse[disabled], .panel-inverse>.panel-heading>.btn-default-inverse[disabled].active, .panel-inverse>.panel-heading>.btn-default-inverse[disabled].focus, .panel-inverse>.panel-heading>.btn-default-inverse[disabled]:active, .panel-inverse>.panel-heading>.btn-default-inverse[disabled]:focus, .panel-inverse>.panel-heading>.btn-default-inverse[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse.active, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse.focus, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse:active, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse:focus, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse:hover {
    color: #333!important;
    background-color: silver!important;
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;
    border-color: grey!important;
}
.panel-inverse>.panel-heading>.btn-default-inverse:hover {
    border-color: #fcfcfc!important;
}
.panel-inverse>.panel-body {
    background-color: #303030;
    color: #fff;
}
.panel-inverse>.panel-body>.btn-default, .panel-inverse>.panel-body>.btn-default.focus, .panel-inverse>.panel-body>.btn-default:focus {
    color: #fff!important;
    background-color: #404040!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;
    border-color: #000!important;
}
.panel-inverse>.panel-body>.btn-default:hover {
    color: #fff!important;
    background-color: #666!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, #999 0, #666 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff999999', endColorstr='#ff666666', GradientType=0)!important;
}
.open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default.focus, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default:focus, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default:hover, .panel-inverse>.panel-body>.btn-default.active, .panel-inverse>.panel-body>.btn-default.active.focus, .panel-inverse>.panel-body>.btn-default.active:focus, .panel-inverse>.panel-body>.btn-default.active:hover, .panel-inverse>.panel-body>.btn-default:active, .panel-inverse>.panel-body>.btn-default:active.focus, .panel-inverse>.panel-body>.btn-default:active:focus, .panel-inverse>.panel-body>.btn-default:active:hover {
    color: #fff!important;
    background-color: #333!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, #666 0, #333 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff666666', endColorstr='#ff333333', GradientType=0)!important;
    border-color: #000!important;
}
.panel-inverse>.panel-body>.btn-default .badge, .panel-inverse>.panel-body>.btn-default.disabled, .panel-inverse>.panel-body>.btn-default.disabled.active, .panel-inverse>.panel-body>.btn-default.disabled.focus, .panel-inverse>.panel-body>.btn-default.disabled:active, .panel-inverse>.panel-body>.btn-default.disabled:focus, .panel-inverse>.panel-body>.btn-default.disabled:hover, .panel-inverse>.panel-body>.btn-default[disabled], .panel-inverse>.panel-body>.btn-default[disabled].active, .panel-inverse>.panel-body>.btn-default[disabled].focus, .panel-inverse>.panel-body>.btn-default[disabled]:active, .panel-inverse>.panel-body>.btn-default[disabled]:focus, .panel-inverse>.panel-body>.btn-default[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-body>.btn-default, fieldset[disabled] .panel-inverse>.panel-body>.btn-default.active, fieldset[disabled] .panel-inverse>.panel-body>.btn-default.focus, fieldset[disabled] .panel-inverse>.panel-body>.btn-default:active, fieldset[disabled] .panel-inverse>.panel-body>.btn-default:focus, fieldset[disabled] .panel-inverse>.panel-body>.btn-default:hover {
    color: #fff!important;
    background-color: #404040!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;
    border-color: #000!important;
}
.panel-inverse>.panel-body>.btn-default-inverse, .panel-inverse>.panel-body>.btn-default-inverse.focus, .panel-inverse>.panel-body>.btn-default-inverse:focus {
    background-color: silver!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;
    color: #333!important;
    background-repeat: repeat-x!important;
}
.panel-inverse>.panel-body>.btn-default:hover {
    border-color: grey!important;
}
.panel-inverse>.panel-body>.btn-default-inverse {
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;
    border-color: grey!important;
}
.panel-inverse>.panel-body>.btn-default-inverse.focus, .panel-inverse>.panel-body>.btn-default-inverse:focus {
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;
    border-color: grey!important;
}
.panel-inverse>.panel-body>.btn-default-inverse:hover {
    color: #333!important;
    background-color: #cdcdcd!important;
    background-image: linear-gradient(to bottom, #fdfdfd 0, #cdcdcd 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffdfdfd', endColorstr='#ffcdcdcd', GradientType=0)!important;
}
.open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default-inverse, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default-inverse.focus, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default-inverse:focus, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default-inverse:hover, .panel-inverse>.panel-body>.btn-default-inverse.active, .panel-inverse>.panel-body>.btn-default-inverse.active.focus, .panel-inverse>.panel-body>.btn-default-inverse.active:focus, .panel-inverse>.panel-body>.btn-default-inverse.active:hover, .panel-inverse>.panel-body>.btn-default-inverse:active, .panel-inverse>.panel-body>.btn-default-inverse:active.focus, .panel-inverse>.panel-body>.btn-default-inverse:active:focus, .panel-inverse>.panel-body>.btn-default-inverse:active:hover {
    color: #333!important;
    background-color: #9a9a9a!important;
    background-image: linear-gradient(to bottom, #cacaca 0, #9a9a9a 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffcacaca', endColorstr='#ff9a9a9a', GradientType=0)!important;
    border-color: #676767!important;
}
.panel-inverse>.panel-body>.btn-default-inverse .badge, .panel-inverse>.panel-body>.btn-default-inverse.disabled, .panel-inverse>.panel-body>.btn-default-inverse.disabled.active, .panel-inverse>.panel-body>.btn-default-inverse.disabled.focus, .panel-inverse>.panel-body>.btn-default-inverse.disabled:active, .panel-inverse>.panel-body>.btn-default-inverse.disabled:focus, .panel-inverse>.panel-body>.btn-default-inverse.disabled:hover, .panel-inverse>.panel-body>.btn-default-inverse[disabled], .panel-inverse>.panel-body>.btn-default-inverse[disabled].active, .panel-inverse>.panel-body>.btn-default-inverse[disabled].focus, .panel-inverse>.panel-body>.btn-default-inverse[disabled]:active, .panel-inverse>.panel-body>.btn-default-inverse[disabled]:focus, .panel-inverse>.panel-body>.btn-default-inverse[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse.active, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse.focus, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse:active, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse:focus, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse:hover {
    color: #333!important;
    background-color: silver!important;
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;
    border-color: grey!important;
}
.panel-inverse>.panel-body>.btn-default-inverse:hover {
    border-color: #fcfcfc!important;
}
.panel-inverse>.panel-footer {
    background-color: #303030;
}
.panel-inverse>.panel-footer>.btn-default, .panel-inverse>.panel-footer>.btn-default.focus, .panel-inverse>.panel-footer>.btn-default:focus {
    color: #fff!important;
    background-color: #404040!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;
    border-color: #000!important;
}
.panel-inverse>.panel-footer>.btn-default:hover {
    color: #fff!important;
    background-color: #666!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, #999 0, #666 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff999999', endColorstr='#ff666666', GradientType=0)!important;
}
.open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default.focus, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default:focus, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default:hover, .panel-inverse>.panel-footer>.btn-default.active, .panel-inverse>.panel-footer>.btn-default.active.focus, .panel-inverse>.panel-footer>.btn-default.active:focus, .panel-inverse>.panel-footer>.btn-default.active:hover, .panel-inverse>.panel-footer>.btn-default:active, .panel-inverse>.panel-footer>.btn-default:active.focus, .panel-inverse>.panel-footer>.btn-default:active:focus, .panel-inverse>.panel-footer>.btn-default:active:hover {
    color: #fff!important;
    background-color: #333!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, #666 0, #333 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff666666', endColorstr='#ff333333', GradientType=0)!important;
    border-color: #000!important;
}
.panel-inverse>.panel-footer>.btn-default .badge, .panel-inverse>.panel-footer>.btn-default.disabled, .panel-inverse>.panel-footer>.btn-default.disabled.active, .panel-inverse>.panel-footer>.btn-default.disabled.focus, .panel-inverse>.panel-footer>.btn-default.disabled:active, .panel-inverse>.panel-footer>.btn-default.disabled:focus, .panel-inverse>.panel-footer>.btn-default.disabled:hover, .panel-inverse>.panel-footer>.btn-default[disabled], .panel-inverse>.panel-footer>.btn-default[disabled].active, .panel-inverse>.panel-footer>.btn-default[disabled].focus, .panel-inverse>.panel-footer>.btn-default[disabled]:active, .panel-inverse>.panel-footer>.btn-default[disabled]:focus, .panel-inverse>.panel-footer>.btn-default[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default.active, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default.focus, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default:active, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default:focus, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default:hover {
    color: #fff!important;
    background-color: #404040!important;
    background-image: url(#)!important;
    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;
    border-color: #000!important;
}
.panel-inverse>.panel-footer>.btn-default-inverse, .panel-inverse>.panel-footer>.btn-default-inverse.focus, .panel-inverse>.panel-footer>.btn-default-inverse:focus {
    background-color: silver!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;
    color: #333!important;
    background-repeat: repeat-x!important;
}
.panel-inverse>.panel-footer>.btn-default:hover {
    border-color: grey!important;
}
.panel-inverse>.panel-footer>.btn-default-inverse {
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;
    border-color: grey!important;
}
.panel-inverse>.panel-footer>.btn-default-inverse.focus, .panel-inverse>.panel-footer>.btn-default-inverse:focus {
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;
    border-color: grey!important;
}
.panel-inverse>.panel-footer>.btn-default-inverse:hover {
    color: #333!important;
    background-color: #cdcdcd!important;
    background-image: linear-gradient(to bottom, #fdfdfd 0, #cdcdcd 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffdfdfd', endColorstr='#ffcdcdcd', GradientType=0)!important;
}
.open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default-inverse, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default-inverse.focus, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default-inverse:focus, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default-inverse:hover, .panel-inverse>.panel-footer>.btn-default-inverse.active, .panel-inverse>.panel-footer>.btn-default-inverse.active.focus, .panel-inverse>.panel-footer>.btn-default-inverse.active:focus, .panel-inverse>.panel-footer>.btn-default-inverse.active:hover, .panel-inverse>.panel-footer>.btn-default-inverse:active, .panel-inverse>.panel-footer>.btn-default-inverse:active.focus, .panel-inverse>.panel-footer>.btn-default-inverse:active:focus, .panel-inverse>.panel-footer>.btn-default-inverse:active:hover {
    color: #333!important;
    background-color: #9a9a9a!important;
    background-image: linear-gradient(to bottom, #cacaca 0, #9a9a9a 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffcacaca', endColorstr='#ff9a9a9a', GradientType=0)!important;
    border-color: #676767!important;
}
.panel-inverse>.panel-footer>.btn-default-inverse .badge, .panel-inverse>.panel-footer>.btn-default-inverse.disabled, .panel-inverse>.panel-footer>.btn-default-inverse.disabled.active, .panel-inverse>.panel-footer>.btn-default-inverse.disabled.focus, .panel-inverse>.panel-footer>.btn-default-inverse.disabled:active, .panel-inverse>.panel-footer>.btn-default-inverse.disabled:focus, .panel-inverse>.panel-footer>.btn-default-inverse.disabled:hover, .panel-inverse>.panel-footer>.btn-default-inverse[disabled], .panel-inverse>.panel-footer>.btn-default-inverse[disabled].active, .panel-inverse>.panel-footer>.btn-default-inverse[disabled].focus, .panel-inverse>.panel-footer>.btn-default-inverse[disabled]:active, .panel-inverse>.panel-footer>.btn-default-inverse[disabled]:focus, .panel-inverse>.panel-footer>.btn-default-inverse[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse.active, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse.focus, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse:active, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse:focus, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse:hover {
    color: #333!important;
    background-color: silver!important;
    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;
    background-repeat: repeat-x!important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;
    border-color: grey!important;
}
.panel-inverse>.panel-footer>.btn-default-inverse:hover {
    border-color: #fcfcfc!important;
}
.panel-inverse>.panel-body>.list-group .section {
    background-color: rgba(255, 255, 255, .15);
    color: #fff;
}
.panel-inverse>.panel-body>.list-group .section>a {
    color: #9cf;
}
.panel-inverse>.panel-body>.list-group .list-group-item {
    color: #fff;
    border-color: rgba(255, 255, 255, .15);
}
.panel-inverse>.panel-body>.list-group .list-group-item .list-group-item-heading, .panel-inverse>.panel-body>.list-group .list-group-item .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item p {
    color: #fff;
}
.panel-inverse>.panel-body>.list-group .list-group-item.active, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover {
    color: #fff;
    background-color: #0059b3;
    border-top-color: rgba(255, 255, 255, .15);
    border-bottom-color: rgba(255, 255, 255, .15);
}
.panel-inverse>.panel-body>.list-group .list-group-item.active .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.active .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.active p, .panel-inverse>.panel-body>.list-group .list-group-item.active span, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus p, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus span, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover p, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover span {
    color: #fff;
}
.panel-inverse>.panel-body>.list-group .list-group-item.active .mark, .panel-inverse>.panel-body>.list-group .list-group-item.active mark, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus .mark, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus mark, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover .mark, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover mark {
    background-color: rgba(0, 0, 0, .35);
}
.panel-inverse>.panel-body>.list-group .list-group-item.disabled, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover {
    background-color: inherit;
    color: rgba(255, 255, 255, .4)!important;
}
.panel-inverse>.panel-body>.list-group .list-group-item.disabled .list-group-item-heading, .panel-inverse>.panel-body>.list-group .list-group-item.disabled .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.disabled .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.disabled p, .panel-inverse>.panel-body>.list-group .list-group-item.disabled span, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus .list-group-item-heading, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus p, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus span, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover .list-group-item-heading, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover p, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover span {
    color: rgba(255, 255, 255, .4)!important;
}
.panel-inverse>.panel-body>.list-group .list-group-item.disabled mark, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus mark, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover mark {
    color: rgba(255, 255, 255, .4)!important;
    background-color: rgba(255, 255, 255, .15);
}
.panel-inverse>.panel-body>.list-group mark {
    background-color: #0059b3;
    color: #fff;
}
.panel-inverse>.panel-body>.list-group a.list-group-item, .panel-inverse>.panel-body>.list-group button.list-group-item {
    text-decoration: none;
}
.panel-inverse>.panel-body>.list-group a.list-group-item:focus, .panel-inverse>.panel-body>.list-group a.list-group-item:hover, .panel-inverse>.panel-body>.list-group button.list-group-item:focus, .panel-inverse>.panel-body>.list-group button.list-group-item:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, .09);
}
.panel-inverse>.panel-body>.list-group a.list-group-item:focus .list-group-item-heading, .panel-inverse>.panel-body>.list-group a.list-group-item:focus .list-group-item-text, .panel-inverse>.panel-body>.list-group a.list-group-item:focus .text-muted, .panel-inverse>.panel-body>.list-group a.list-group-item:focus p, .panel-inverse>.panel-body>.list-group a.list-group-item:focus span, .panel-inverse>.panel-body>.list-group a.list-group-item:hover .list-group-item-heading, .panel-inverse>.panel-body>.list-group a.list-group-item:hover .list-group-item-text, .panel-inverse>.panel-body>.list-group a.list-group-item:hover .text-muted, .panel-inverse>.panel-body>.list-group a.list-group-item:hover p, .panel-inverse>.panel-body>.list-group a.list-group-item:hover span, .panel-inverse>.panel-body>.list-group button.list-group-item:focus .list-group-item-heading, .panel-inverse>.panel-body>.list-group button.list-group-item:focus .list-group-item-text, .panel-inverse>.panel-body>.list-group button.list-group-item:focus .text-muted, .panel-inverse>.panel-body>.list-group button.list-group-item:focus p, .panel-inverse>.panel-body>.list-group button.list-group-item:focus span, .panel-inverse>.panel-body>.list-group button.list-group-item:hover .list-group-item-heading, .panel-inverse>.panel-body>.list-group button.list-group-item:hover .list-group-item-text, .panel-inverse>.panel-body>.list-group button.list-group-item:hover .text-muted, .panel-inverse>.panel-body>.list-group button.list-group-item:hover p, .panel-inverse>.panel-body>.list-group button.list-group-item:hover span {
    color: #fff;
}
.panel-inverse>.panel-body>.list-group .section-inverse {
    color: #000;
    background-color: rgba(255, 255, 255, .75);
}
.list-group-item {
    margin-bottom: 0;
    border-top: none;
    padding: 8px 10px;
}
.list-group-item>p {
    margin-bottom: 0;
}
.list-group-item>.pull-right {
    margin-left: 10px;
}
.list-group-item>.pull-left {
    margin-right: 10px;
}
.list-group-item.disabled, .list-group-item.disabled:focus, .list-group-item.disabled:hover {
    background-color: inherit;
    color: rgba(0, 0, 0, .4)!important;
}
.list-group-item.disabled .list-group-item-heading, .list-group-item.disabled .list-group-item-text, .list-group-item.disabled:focus .list-group-item-heading, .list-group-item.disabled:focus .list-group-item-text, .list-group-item.disabled:hover .list-group-item-heading, .list-group-item.disabled:hover .list-group-item-text {
    color: rgba(0, 0, 0, .4)!important;
}
.list-group-item.disabled mark, .list-group-item.disabled:focus mark, .list-group-item.disabled:hover mark {
    color: rgba(0, 0, 0, .4)!important;
    background-color: #e6e6e6;
}
.list-group-item.active .text-muted, .list-group-item.active:focus .text-muted, .list-group-item.active:hover .text-muted, a.list-group-item:focus .text-muted, a.list-group-item:hover .text-muted, button.list-group-item:focus .text-muted, button.list-group-item:hover .text-muted {
    color: #000;
}
.list-group-item.active, .list-group-item.active:focus, .list-group-item.active:hover {
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    margin-top: -1px;
}
.list-group-item.active mark, .list-group-item.active:focus mark, .list-group-item.active:hover mark {
    background-color: rgba(255, 255, 255, .65);
}
.section, .section-inverse {
    border-top: none;
    border-bottom: none;
    padding-top: 3px;
    padding-bottom: 3px;
    padding-right: 10px;
    background-color: #e6e6e6;
}
.section a {
    color: #06c;
    cursor: pointer;
}
.section-inverse {
    color: #fff;
    background-color: rgba(0, 0, 0, .75);
}
.section-inverse a {
    color: #06c;
    cursor: pointer;
}
.indented {
    padding-left: 25px;
}
.line-segment-right, .line-segment-right-30, .line-segment-right-50, .line-segment-right-70 {
    padding-left: 5px;
    float: right!important;
}
.list-group-item-heading {
    font-weight: 700;
}
.list-group-item-text {
    margin-top: 5px;
    line-height: 1.42857143;
}
.list-group-icon {
    position: absolute;
    top: 3px;
    left: 7px;
}
.line-segment-left-30 {
    display: inline-block;
    position: relative;
    width: 30%}
.line-segment-left-30 div, .line-segment-left-30 h1, .line-segment-left-30 h2, .line-segment-left-30 h3, .line-segment-left-30 h4, .line-segment-left-30 h5, .line-segment-left-30 h6, .line-segment-left-30 p, .line-segment-left-30 span, .line-segment-left-30>a {
    white-space: nowrap!important;
    overflow: hidden!important;
    text-overflow: ellipsis!important;
    display: block!important;
}
.line-segment-left-50 {
    display: inline-block;
    position: relative;
    width: 50%}
.line-segment-left-50 div, .line-segment-left-50 h1, .line-segment-left-50 h2, .line-segment-left-50 h3, .line-segment-left-50 h4, .line-segment-left-50 h5, .line-segment-left-50 h6, .line-segment-left-50 p, .line-segment-left-50 span, .line-segment-left-50>a {
    white-space: nowrap!important;
    overflow: hidden!important;
    text-overflow: ellipsis!important;
    display: block!important;
}
.line-segment-left-70 {
    display: inline-block;
    position: relative;
    width: 70%}
.line-segment-left-70 div, .line-segment-left-70 h1, .line-segment-left-70 h2, .line-segment-left-70 h3, .line-segment-left-70 h4, .line-segment-left-70 h5, .line-segment-left-70 h6, .line-segment-left-70 p, .line-segment-left-70 span, .line-segment-left-70>a {
    white-space: nowrap!important;
    overflow: hidden!important;
    text-overflow: ellipsis!important;
    display: block!important;
}
.line-segment-right-30 {
    display: inline-block;
    position: relative;
    width: 30%}
.line-segment-right-30 div, .line-segment-right-30 h1, .line-segment-right-30 h2, .line-segment-right-30 h3, .line-segment-right-30 h4, .line-segment-right-30 h5, .line-segment-right-30 h6, .line-segment-right-30 p, .line-segment-right-30 span, .line-segment-right-30>a {
    white-space: nowrap!important;
    overflow: hidden!important;
    text-overflow: ellipsis!important;
    display: block!important;
}
.line-segment-right-50 {
    display: inline-block;
    position: relative;
    width: 50%}
.line-segment-right-50 div, .line-segment-right-50 h1, .line-segment-right-50 h2, .line-segment-right-50 h3, .line-segment-right-50 h4, .line-segment-right-50 h5, .line-segment-right-50 h6, .line-segment-right-50 p, .line-segment-right-50 span, .line-segment-right-50>a {
    white-space: nowrap!important;
    overflow: hidden!important;
    text-overflow: ellipsis!important;
    display: block!important;
}
.line-segment-right-70 {
    display: inline-block;
    position: relative;
    width: 70%}
.line-segment-right-70 div, .line-segment-right-70 h1, .line-segment-right-70 h2, .line-segment-right-70 h3, .line-segment-right-70 h4, .line-segment-right-70 h5, .line-segment-right-70 h6, .line-segment-right-70 p, .line-segment-right-70 span, .line-segment-right-70>a {
    white-space: nowrap!important;
    overflow: hidden!important;
    text-overflow: ellipsis!important;
    display: block!important;
}
.tag, .tag-icon {
    display: inline-block;
}
.table>thead {
    background-color: #e6e6e6;
}
.mark, mark {
    background-color: #b3d9ff;
    padding: 0 1px;
}
.lead {
    font-weight: 400;
}
.tag {
    background: #e6e6e6;
    color: #404040;
    font-weight: 600;
    height: 18px;
    border-radius: 2px;
    overflow: hidden;
    border: 1px solid #404040;
    pointer-events: inherit;
}
.tag span {
    margin: 0 4px;
}
.tag-icon {
    background-color: #404040;
    color: #fff;
    padding: 0 3px;
    height: 19px;
    width: 19px;
    position: relative;
    text-align: center;
    line-height: 18px;
    margin-right: -1px;
}
.center-vertical, .overlay {
    position: absolute!important;
}
.tag-info {
    background: #e0f0ff;
    color: #042b4b;
    border: 1px solid #39f;
}
.tag-info>.tag-icon {
    background-color: #39f;
}
.tag-success {
    background: #e1f1de;
    color: #1a4e0f;
    border: 1px solid #37A320;
}
.tag-success>.tag-icon {
    background-color: #37A320;
}
.tag-danger {
    background: #f3dde1;
    color: #580e1c;
    border: 1px solid #b01c38;
}
.tag-danger>.tag-icon {
    background-color: #b01c38;
}
.no-padding {
    padding: 0!important;
}
.no-margin {
    margin: 0!important;
}
.floating {
    border-radius: 6px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .25)!important;
}
.no-scroll {
    overflow: hidden!important;
}
.overlay {
    z-index: 980!important;
    background-color: rgba(255, 255, 255, .95);
    top: 0!important;
    right: 0!important;
    bottom: 0!important;
    left: 0!important;
}
#wrapper-sign-in, body.sign-in {
    background-color: #fff;
}
#wrapper-nav-bar, body {
    background-color: #e6e6e6;
}
.center, .overlay>:first-child {
    left: 50%!important;
    margin-right: 0!important;
    text-align: center!important;
    position: absolute!important;
    top: 50%!important;
}
.overlay>:first-child {
    transform: translate(-50%, -50%)!important;
    -ms-transform: translate(-50%, -50%)!important;
}
.truncate, .truncate-children div, .truncate-children h1, .truncate-children h2, .truncate-children h3, .truncate-children h4, .truncate-children h5, .truncate-children h6, .truncate-children p, .truncate-children span, .truncate-children>a {
    white-space: nowrap!important;
    overflow: hidden!important;
    text-overflow: ellipsis!important;
    display: block!important;
}
.center {
    transform: translate(-50%, -50%)!important;
    -ms-transform: translate(-50%, -50%)!important;
}
.center-vertical {
    top: 50%!important;
    transform: translateY(-50%)!important;
    -ms-transform: translateY(-50%)!important;
}
.related-icon {
    display: inline-block;
    margin-left: 5px;
}
.related-icon.pull-left {
    margin-left: 0;
    margin-right: 5px;
}
body.sign-in .ul-icon {
    margin-bottom: 0;
}
main {
    display: grid;
    grid-template-columns: 2fr 5fr;
    position: absolute;
    top: 41px;
    bottom: 0;
    left: 0;
    right: 0;
}
#wrapper-sign-in {
    height: 100%;
    width: 100%;
    margin: auto;
    padding: inherit;
}
#wrapper-nav-bar {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 49px;
    background-image: url('header_background.b2c046bdc6484ebf.png');
    min-width: 600px;
}
#wrapper-nav-tree {
    resize: horizontal;
    overflow: auto;
    min-width: 5%;
    max-width: 99%;
    flex: 1 1 30%;
    position: relative;
}
#wrapper-panel-tabs {
    margin: 12px 0 0;
    flex: 1 1 70%;
    position: relative;
}
#wrapper-panel-packages, #wrapper-panel-rules {
    width: 25%;
    top: 10px;
    left: 10px;
    bottom: 10px;
    position: absolute;
}
#wrapper-panel-package-details {
    position: absolute;
    left: 26.25%;
    bottom: 10px;
    top: 10px;
    min-width: 400px;
}
#wrapper-panel-package-details span+span {
    margin-left: 5px;
}
#wrapper-panel-details tr i, #wrapper-panel-package-details tr i {
    cursor: pointer;
    background-color: #f0f0f0;
    visibility: hidden;
    color: grey;
}
#wrapper-panel-details tr i:hover, #wrapper-panel-package-details tr i:hover {
    color: #000;
}
#wrapper-panel-details tr:hover i, #wrapper-panel-package-details tr:hover i {
    visibility: visible;
}
#wrapper-panel-rule-details {
    position: absolute;
    width: 73%;
    right: 10px;
    bottom: 10px;
    top: 10px;
    min-width: 400px;
}
#wrapper-side-panel {
    position: absolute;
    right: 0;
    bottom: 10px;
    height: 98%;
    width: 20%}
#wrapper-side-panel .list-group {
    margin-bottom: 0;
}
#wrapper-side-panel .list-group-item i {
    cursor: pointer;
    position: absolute;
    top: 3px;
    left: 0;
    background-color: #f0f0f0;
    margin-left: 0;
    width: 26px;
    visibility: hidden;
    color: grey;
}
#msg-config-body, #msg-config-side {
    height: 100%;
    position: absolute;
    top: 0;
}
#wrapper-side-panel .list-group-item:hover i, .container-card:hover .card-info {
    visibility: visible;
}
#wrapper-side-panel .list-group-item i:hover {
    color: #000;
}
#wrapper-panel-details {
    position: absolute;
    left: .5%;
    top: 1%;
    width: 99%;
    height: 98%
}
#wrapper-assign-preview {
    position: absolute;
    top: 33px;
    right: 10px;
    bottom: 10px;
    left: 10px;
}
#wrapper-config-users-rules {
    position: absolute;
    top: 10px;
    right: 0;
    bottom: 0;
    left: 0;
}
#wrapper-navigation {
    position: absolute;
    width: 200px;
    top: 10px;
    bottom: 10px;
}
#wrapper-preview {
    position: absolute;
    left: 220px;
    right: 10px;
    top: 10px;
    bottom: 10px;
}
#config-assign-body, #config-users-body {
    height: 50%;
    min-height: 300px;
}
#wrapper-config-users-preview .panel-body {
    overflow-y: scroll;
    max-height: 500px;
}
#package-review-body {
    height: 500px;
}
#wrapper-msg-config {
    height: 400px;
    width: 100%;
    position: relative;
}
#msg-config-side {
    width: 20%;
    border-right: 1px solid silver;
    background: #404040;
    text-align: center;
    padding: 15px;
    left: 0;
}

#emrTable {
    width: 100%;
    padding: 10px;
    left: auto;
}

#emrHeader {
    background-color: #666666;
    height: 25px;
    width: 100%;
}

#facilitiesTable {
    width: 100%;
    padding: 10px;
    left: auto;
}

#facilitiesHeader {
    background-color: #666666;
    height: 25px;
    width: 100%;
}

#searchFacs, #searchEmrs {
    display: flex;
    justify-content: space-between;
}

.searchButton {
    width: 10%;
    min-width: 35px;
    cursor: pointer;
    height: 25px;
    text-align: center;
}

.inlineDisplay {
    display: inline-block;
}

.grid-row-pub {
   min-width: min-content;
}

.grid-panel-heading-extended {
    min-width: min-content;
}

.grid-panel-heading {
    min-width: min-content;
}


.dropdown-tenant {
    width: 90px;
}

.searchMapping {
    width: 25%;
    min-width: 600px;
    height: 25px;
}

.mappingInput {
    width: 70%;
    height: 20px;
    min-width: 200px;
    resize: none;
}

.mappingSet {
    overflow: auto;
    height: 320px;
}

.existingMappings {
    height: 450px;
}

.colMap {
    height: 75vh;
}

.mappingCard {
    cursor: pointer;
    border: #666666;
    border-style: solid;
    width: 95%;
    margin: 2%;
}

.addButton {
    width: 15%;
    min-width: 30px;
    cursor: pointer;
    height: 25px;
    text-align: center;
}

.linkBtn {
    cursor: pointer;
}

.btn-secondary:hover {
    background-color: #9a9a9a;
}

#emrList:nth-child(even) {
    background: white;
    list-style-type: none;
}

#emrList:nth-child(odd) {
    background: #9a9a9a;
    list-style-type: none;
}

li:hover {
    background: #999999;
}

#facList:nth-child(even) {
    background: white;
    list-style-type: none;
}

#facList:nth-child(odd) {
    background: grey;
    list-style-type: none;
}

.count-packages, .count-user {
    text-align: right;
    display: inline-block;
}
#msg-config-body {
    width: 80%;
    background: #e6e6e6;
    padding: 10px;
    right: 0;
    overflow-y: auto;
}
.container-card {
    cursor: default;
    font-family: Segoe UI;
    background: #fff;
    border: 1px solid silver;
    border-radius: 4px;
    box-shadow: 0 2px 5px 0 #e6e6e6;
    margin-bottom: 5px;
    padding: 10px;
    position: relative;
    width: 240px;
}
.card-info, .refresh-node i, .rule-old .card-close, .rule-old .container-card:hover .card-info {
    visibility: hidden;
}
.container-card:hover .card-close {
    color: grey;
}
.container-card:hover .card-close:hover {
    color: #000;
}
.card-footer {
    background-color: #fcfcfc;
    border-top: 1px solid silver;
    margin: 0 -10px -10px;
    height: 32px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}
.container-card .card-footer .btn-default, .container-card .card-footer .btn-primary {
    cursor: default;
    border: none;
    border-right: 1px solid silver;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    background: #fcfcfc;
    height: 100%;
    width: 117px;
    color: #404040;
    font-weight: 600;
}
.container-card .card-footer .btn-primary {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 0;
}
.container-card .card-footer .btn-default {
    border: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 4px;
    margin-left: -1px;
    background: #fcfcfc;
    color: #404040;
}
.card-options {
    margin-left: 10px;
}
.card-options select {
    margin-top: 10px;
    margin-bottom: 10px;
    width: 210px;
}
.container-card-header {
    display: block;
    font-family: "Segoe UI";
    font-size: 16px;
    color: #ED6E00;
    margin-top: -3px;
    margin-bottom: 5px;
    line-height: 16px;
}
.count-user {
    margin-left: 5px;
    width: 48px;
}
.count-packages {
    width: 30px;
}
.count-rules {
    text-align: right;
    min-width: 45px;
}
.card-close, .card-info {
    top: 10px;
    position: absolute;
    line-height: 12px;
    text-align: center;
    background-color: #fff;
}
.rule-old * {
    color: grey;
}
html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
    font-family: Segoe UI;
    font-size: 13px;
    color: #000;
}
.text-card-body {
    display: inline-block;
    -moz-hyphens: auto;
    font-family: "Segoe UI";
    font-size: 13px;
}
.card-close {
    width: 20px;
    height: 12px;
    right: 6px;
    color: silver;
}
.card-info {
    width: 22px;
    height: 14px;
    right: 29px;
    color: grey;
}
.card-info:hover {
    color: #000;
}
.overlay i+span, .overlay span+i {
    margin-left: 10px;
}
.panel-details-normal {
    width: 73%}
.panel-details-narrow {
    width: 53%}
.vertical-align {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
}
.col-section {
    margin-left: -15px;
    margin-right: -15px;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 5px;
}
.col-divider {
    height: 100%;
    border-left: 1px solid silver;
}
.btn-group.btn-group-flat .btn-default {
    box-shadow: none;
    background-color: #fff;
    background-image: none;
    filter: none;
    font-size: 12px;
    min-width: 0;
    padding: 8px;
    white-space: pre-line;
}
.btn-group.btn-group-flat .btn-default:focus, .btn-group.btn-group-flat .btn-default:hover {
    background-color: rgba(0, 0, 0, .06);
}
.btn-group.btn-group-flat .btn-default.active, .btn-group.btn-group-flat .btn-default.active:focus, .btn-group.btn-group-flat .btn-default.active:hover {
    background-color: #b3d9ff;
}
.btn-group .img-insertion {
    margin-bottom: 3px;
}
.navbar-brand>img {
    max-height: 100%;
}
.col-xs-1 {
    height: 21px;
}
.panel-body-template {
    overflow-y: auto;
    position: absolute;
    top: 25px;
    bottom: 0;
    left: 0;
    right: 0;
}
.table-col-ex {
    width: 5%}
.table-col-2wide {
    width: 50%}
.table-col-2wide-1ex {
    width: 47.5%}
.table-col-2wide-2ex {
    width: 45%}
.table-col-3wide {
    width: 33.333%}
.table-col-3wide-2ex {
    width: 30%}
.btn-capd-editor {
    width: 90%;
    text-align: left;
    font-size: 15px;
}
.refresh-node i {
    position: relative;
    right: 5px;
}
.list-group-item.active .refresh-node i, .list-group-item:hover .refresh-node i {
    visibility: visible;
}
.form-nr input {
    width: 100%!important;
}
`, "",{"version":3,"sources":["webpack://./src/app/css/capd.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;IACI,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,aAAa;AACjB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;AACb;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,aAAa;IACb,SAAS;AACb;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,0BAA0B;IAC1B,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,UAAU;AACd;AACA,oFAAoF,CAAC;IACjF;IACA,wBAAwB;AAC5B;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,4BAA4B;AAChC;IACI,6BAA6B;AACjC;IACI,WAAW;AACf;IACI,sBAAsB;AAC1B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,mCAAmC;AACvC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;AACA;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IAGI,sBAAsB;AAC1B;AACA;IACI,6CAA6C;IAC7C,uBAAuB;AAC3B;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,oBAAoB;IACpB,0CAA0C;IAC1C,oBAAoB;AACxB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,eAAe;IACf,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAGlB,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI;IACA,iBAAiB;AACrB;AACA;AACA;IACI,cAAc;AAClB;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI;IACA,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;AACA;IACI,YAAY;IACZ,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,cAAc;AAClB;AACA;IACI,sBAAsB;AAC1B;IACI,mBAAmB;IACnB,eAAe;IACf,+BAA+B;IAC/B,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;IACI,sBAAsB;AAC1B;IACI,kBAAkB;AACtB;AACA;IACI,8DAA8D;AAClE;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,6CAA6C;AACjD;AACA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI;IACA,YAAY;AAChB;AACA;AACA;IACI;IACA,YAAY;AAChB;AACA;AACA;IACI;IACA,aAAa;AACjB;AACA;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,kBAAkB;AACtB;IACI,WAAW;AACf;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,kBAAkB;AACtB;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,iBAAiB;AACrB;IACI,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,wBAAwB;AAC5B;IACI,cAAc;AAClB;AACA;IACI;QACI,sBAAsB;IAC1B,WAAW;AACf;AACA;IACI,WAAW;AACf;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,kBAAkB;AACtB;IACI,WAAW;AACf;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,kBAAkB;AACtB;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,iBAAiB;AACrB;IACI,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,wBAAwB;AAC5B;IACI,cAAc;AAClB;AACA;AACA;IACI;QACI,sBAAsB;IAC1B,WAAW;AACf;AACA;IACI,WAAW;AACf;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,kBAAkB;AACtB;IACI,WAAW;AACf;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,kBAAkB;AACtB;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,iBAAiB;AACrB;IACI,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,wBAAwB;AAC5B;IACI,cAAc;AAClB;AACA;AACA;IACI;QACI,sBAAsB;IAC1B,WAAW;AACf;AACA;IACI,WAAW;AACf;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,kBAAkB;AACtB;IACI,WAAW;AACf;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,mBAAmB;AACvB;IACI,UAAU;AACd;IACI,mBAAmB;AACvB;IACI,kBAAkB;AACtB;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,kBAAkB;AACtB;IACI,SAAS;AACb;IACI,kBAAkB;AACtB;IACI,iBAAiB;AACrB;IACI,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,yBAAyB;AAC7B;IACI,gBAAgB;AACpB;IACI,yBAAyB;AAC7B;IACI,wBAAwB;AAC5B;IACI,cAAc;AAClB;AACA;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oCAAoC;AACxC;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;IACI;IACA,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,4CAA4C;IAC5C,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,SAAS;IACT,YAAY;AAChB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IAGI,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,WAAW;AACf;IACI,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,0CAA0C;IAC1C,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAElB,+CAA+C;IAG/C,sEAAsE;AAC1E;AACA;IACI,kBAAkB;IAClB,UAAU;IAEV,+EAA+E;AACnF;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI;IACA,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,qBAAqB;IAErB,+CAA+C;AACnD;AACA;IACI,qBAAqB;IAErB,gEAAgE;AACpE;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;IAErB,+CAA+C;AACnD;AACA;IACI,qBAAqB;IAErB,gEAAgE;AACpE;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;IAErB,+CAA+C;AACnD;AACA;IACI,qBAAqB;IAErB,gEAAgE;AACpE;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,SAAS;AACb;AACA;IACI,MAAM;AACV;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI;IACA,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;IACI,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,MAAM;AACV;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;AACA;IACI,WAAW;AACf;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI;IACA,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,oBAAoB;IACpB,0CAA0C;IAC1C,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,UAAU;IAEV,+CAA+C;AACnD;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IAEzB,gBAAgB;AACpB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAE7B,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,0BAA0B;IAC1B,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,UAAU;IAGV,+BAA+B;AACnC;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,gBAAgB;IAEhB,uCAAuC;IAEvC,yBAAyB;IAEzB,gCAAgC;AACpC;AACA;IACI,qBAAqB;IACrB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,mCAAmC;IACnC,kCAAkC;AACtC;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAElB,0CAA0C;IAC1C,4BAA4B;AAChC;AACA;IACI,UAAU;IACV,QAAQ;AACZ;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,sBAAsB;IACtB,iEAAiE;IACjE,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,OAAO;IACP,WAAW;AACf;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;AACA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,YAAY;AAChB;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,QAAQ;IACR,UAAU;AACd;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,WAAW;AACf;IACI,SAAS;IACT,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI;IACA,UAAU;IACV,QAAQ;AACZ;AACA;IACI,OAAO;IACP,WAAW;AACf;AACA;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IAEI,+CAA+C;AACnD;AACA;IAEI,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,eAAe;AACnB;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,SAAS;AACb;IACI,WAAW;AACf;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;AACxB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;AACA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,wBAAwB;IACxB,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI;IACA,mBAAmB;IACnB,SAAS;AACb;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;AACA;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;AACf;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI;IACA,mBAAmB;IACnB,SAAS;AACb;IACI,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;AACA;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,iDAAiD;IACjD,iCAAiC;AACrC;AACA;IACI,gBAAgB;AACpB;AACA;IACI;IACA,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;AACA;IACI,gBAAgB;AACpB;AACA;IACI;IACA,iBAAiB;AACrB;AACA;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,QAAQ;IACR,OAAO;IACP,aAAa;AACjB;AACA;IACI,MAAM;IACN,qBAAqB;AACzB;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI;IACA,eAAe;IACf,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI;IACA,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;AACA;AACA;IAGI,kMAAkM;AACtM;AACA;IACI;IACA,aAAa;AACjB;AACA;IACI,WAAW;IACX,SAAS;AACb;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;AACA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,oCAAoC;IAEpC,kFAAkF;IAClF,iBAAiB;AACrB;AACA;IACI;IACA,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;IACI,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,MAAM;AACV;AACA;AACA;IACI,qBAAqB;AACzB;AACA;IACI,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI;IACA,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;AACA;IACI;IACA,WAAW;IACX,SAAS;IACT,cAAc;IACd,eAAe;IACf,cAAc;IACd,iBAAiB;IAEjB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;AACA;IACI,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,6BAA6B;AACjC;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oCAAoC;IACpC,WAAW;AACf;AACA;IACI;IACA,cAAc;AAClB;AACA;IACI,WAAW;IACX,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,6BAA6B;AACjC;AACA;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,6BAA6B;AACjC;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mCAAmC;IACnC,WAAW;AACf;AACA;IACI;IACA,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,6BAA6B;AACjC;AACA;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,8BAA8B;IAC9B,2BAA2B;AAC/B;AACA;IACI,+BAA+B;IAC/B,4BAA4B;AAChC;AACA;IACI,UAAU;IACV,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;AACA;IACI,+BAA+B;IAC/B,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;AACA;IACI,+BAA+B;IAC/B,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,MAAM;IACN,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;IACI;IACA,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAGlB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,cAAc;AAClB;AACA;IACI,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;AACX;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;AASA;IACI;IACA,2BAA2B;AAC/B;AACA;IACI,wBAAwB;AAC5B;AACA;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAElB,6CAA6C;AACjD;AACA;IACI,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IAEtB,kCAAkC;IAGlC,0BAA0B;AAC9B;AACA;IACI,cAAc;AAClB;AACA;IACI,0BAA0B;AAC9B;AACA;IAGI,kDAAkD;AACtD;AACA;IACI,yBAAyB;AAC7B;AACA;IAGI,kMAAkM;AACtM;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IAGI,kMAAkM;AACtM;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,8BAA8B;AAClC;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;IACV,qBAAqB;IACrB,WAAW;IACX,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAElB,wCAAwC;AAC5C;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,8BAA8B;AAClC;AACA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;AACjB;AACA;IACI,SAAS;AACb;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,aAAa;AACjB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,YAAY;IACZ,WAAW;IACX,SAAS;AACb;AACA;IACI,sBAAsB;AAC1B;IACI,mBAAmB;AACvB;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAElB,8CAA8C;AAClD;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,SAAS;IACT,wBAAwB;AAC5B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,iCAAiC;IACjC,UAAU;AACd;AACA;IAII,6BAA6B;IAI7B,kCAAkC;AACtC;AACA;IAII,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,mCAAmC;IACnC,kBAAkB;IAElB,uCAAuC;IACvC,UAAU;AACd;AACA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,4BAA4B;AAChC;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI;IACA,YAAY;IACZ,iBAAiB;AACrB;AACA;IAEI,wCAAwC;AAC5C;AACA;IACI,YAAY;AAChB;AACA;AACA;IACI;IACA,YAAY;AAChB;AACA;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,wBAAwB;AAC5B;AACA;IACI,UAAU;IACV,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,QAAQ;IACR,OAAO;IACP,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,QAAQ;IACR,QAAQ;IACR,gBAAgB;IAChB,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,MAAM;AACV;AACA;IACI,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,mCAAmC;IACnC,kBAAkB;IAElB,wCAAwC;AAC5C;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,gCAAgC;IAChC,0BAA0B;AAC9B;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;IACI,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,oCAAoC;IACpC,aAAa;AACjB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,wBAAwB;IACxB,sCAAsC;AAC1C;AACA;IACI,SAAS;IACT,oBAAoB;IACpB,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,uCAAuC;IACvC,UAAU;AACd;AACA;IACI,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;IACvB,qCAAqC;AACzC;AACA;IACI,UAAU;IACV,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;IACI,aAAa;IACb,kBAAkB;IAGlB,gCAAgC;AACpC;AACA;IACI;IAIA,qCAAqC;IAGrC,2BAA2B;IAG3B,mBAAmB;AACvB;AACA;IAEI,kCAAkC;IAClC,OAAO;AACX;AACA;IAEI,mCAAmC;IACnC,OAAO;AACX;AACA;IAEI,+BAA+B;IAC/B,OAAO;AACX;AACA;AACA;IACI,cAAc;AAClB;AACA;IACI,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;IACI,UAAU;AACd;IACI,WAAW;AACf;IACI,OAAO;AACX;AACA;IACI,WAAW;AACf;IACI,UAAU;AACd;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;AACA;IAGI,2FAA2F;IAC3F,2BAA2B;IAC3B,sHAAsH;AAC1H;AACA;IACI,UAAU;IACV,QAAQ;IAGR,2FAA2F;IAC3F,2BAA2B;IAC3B,sHAAsH;AAC1H;AACA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;IACI,gBAAgB;AACpB;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,wBAAwB;IACxB,kCAAkC;AACtC;AACA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,iBAAiB;AACrB;AACA;IACI;IACA,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,UAAU;IACV,oBAAoB;AACxB;AACA;IACI,YAAY;AAChB;AACA;AACA;IACI,YAAY;IACZ,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;AACb;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;;AAEA;IACI;IACA,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,+BAA+B;AACnC;AACA;AACA;IACI;IACA,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,+BAA+B;AACnC;AACA;AACA;IACI;IACA,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,+BAA+B;AACnC;AACA;AACA;IACI;IACA,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,+BAA+B;AACnC;AACA;IACI,uBAAuB;AAC3B;AACA;AACA;IACI;IACA,uBAAuB;AAC3B;AACA;AACA;IACI;IACA,uBAAuB;AAC3B;AACA;AACA;IACI;IACA,uBAAuB;AAC3B;AACA;AACA;IACI,uBAAuB;AAC3B;AACA;IACI;IACA,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;AACA;IACI,uBAAuB;AAC3B;AACA;IACI;IACA,wBAAwB;AAC5B;AACA;AACA;IACI,uBAAuB;AAC3B;AACA;IACI;IACA,yBAAyB;AAC7B;AACA;AACA;IACI,uBAAuB;AAC3B;AACA;IACI;IACA,+BAA+B;AACnC;AACA;IACI,uBAAuB;AAC3B;AACA;AACA;IACI,kBAAkB;IAElB,kDAAkD;IAClD,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,6BAA6B;IAC7B,QAAQ;AACZ;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI;UACM;AACV;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;IACV,0BAA0B;IAC1B,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IAGxB,oEAAoE;IACpE,2BAA2B;IAC3B,sHAAsH;AAC1H;AACA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,YAAY;AAChB;AACA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;IACA,aAAa;AACjB;AACA;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;IACxB,sHAAsH;IACtH,kBAAkB;IAClB,WAAW;IACX,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,QAAQ;AACZ;IAGI,oEAAoE;AACxE;AACA;IAGI,oEAAoE;AACxE;AACA;IACI,WAAW;IACX,yBAAyB;IAGzB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IAGzB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,wBAAwB;IAGxB,oEAAoE;IACpE,2BAA2B;IAC3B,sHAAsH;IACtH,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,sHAAsH;IACtH,qBAAqB;IACrB,WAAW;IACX,2BAA2B;AAC/B;AACA;IAGI,kEAAkE;AACtE;AACA;IAGI,kEAAkE;AACtE;AACA;IACI,WAAW;IACX,yBAAyB;IAGzB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IAGzB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,sBAAsB;IAGtB,kEAAkE;IAClE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,wBAAwB;IAGxB,kEAAkE;IAClE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,kEAAkE;IAClE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,kEAAkE;IAClE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,wBAAwB;IAGxB,kEAAkE;IAClE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,qEAAqE;IACrE,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,kEAAkE;IAClE,2BAA2B;IAC3B,sHAAsH;IACtH,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,wBAAwB;IAGxB,+DAA+D;IAC/D,2BAA2B;IAC3B,sHAAsH;IACtH,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,wBAAwB;IAGxB,+DAA+D;IAC/D,2BAA2B;IAC3B,sHAAsH;IACtH,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IAGxB,kEAAkE;IAClE,2BAA2B;IAC3B,sHAAsH;IACtH,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAElB,0CAA0C;IAC1C,4BAA4B;AAChC;AACA;IACI,MAAM;IACN,SAAS;AACb;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,QAAQ;IACR,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,OAAO;IACP,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB;UACM;AACV;AACA;IACI,aAAa;IACb,4BAA4B;IAC5B,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,OAAO;AACX;AACA;IACI,MAAM;IACN,YAAY;AAChB;AACA;IACI,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,MAAM;IACN,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,4CAA4C;AAChD;AACA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;AAClC;AACA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,+BAA+B;AACnC;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,YAAY;AAChB;IACI,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,6BAA6B;IAC7B,wBAAwB;IAGxB,kEAAkE;IAClE,2BAA2B;IAC3B,sHAAsH;AAC1H;AACA;IACI,qBAAqB;IACrB,mCAAmC;IACnC,kCAAkC;IAGlC,4EAA4E;IAC5E,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,kCAAkC;IAGlC,yEAAyE;IACzE,qCAAqC;IACrC,gIAAgI;AACpI;AACA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,kCAAkC;IAGlC,yEAAyE;IACzE,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,mCAAmC;IACnC,kCAAkC;IAGlC,4EAA4E;IAC5E,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,kCAAkC;IAClC,gIAAgI;IAChI,qBAAqB;IACrB,qCAAqC;AACzC;AACA;IACI,4BAA4B;AAChC;AACA;IAGI,8EAA8E;IAC9E,4BAA4B;AAChC;AACA;IAGI,8EAA8E;IAC9E,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,mCAAmC;IAGnC,+EAA+E;IAC/E,qCAAqC;IACrC,gIAAgI;AACpI;AACA;IACI,qBAAqB;IACrB,mCAAmC;IAGnC,+EAA+E;IAC/E,qCAAqC;IACrC,gIAAgI;IAChI,+BAA+B;AACnC;AACA;IACI,qBAAqB;IACrB,kCAAkC;IAGlC,8EAA8E;IAC9E,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,mCAAmC;IACnC,kCAAkC;IAGlC,4EAA4E;IAC5E,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,kCAAkC;IAGlC,yEAAyE;IACzE,qCAAqC;IACrC,gIAAgI;AACpI;AACA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,kCAAkC;IAGlC,yEAAyE;IACzE,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,mCAAmC;IACnC,kCAAkC;IAGlC,4EAA4E;IAC5E,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,kCAAkC;IAClC,gIAAgI;IAChI,qBAAqB;IACrB,qCAAqC;AACzC;AACA;IACI,4BAA4B;AAChC;AACA;IAGI,8EAA8E;IAC9E,4BAA4B;AAChC;AACA;IAGI,8EAA8E;IAC9E,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,mCAAmC;IAGnC,+EAA+E;IAC/E,qCAAqC;IACrC,gIAAgI;AACpI;AACA;IACI,qBAAqB;IACrB,mCAAmC;IAGnC,+EAA+E;IAC/E,qCAAqC;IACrC,gIAAgI;IAChI,+BAA+B;AACnC;AACA;IACI,qBAAqB;IACrB,kCAAkC;IAGlC,8EAA8E;IAC9E,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,mCAAmC;IACnC,kCAAkC;IAGlC,4EAA4E;IAC5E,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,kCAAkC;IAGlC,yEAAyE;IACzE,qCAAqC;IACrC,gIAAgI;AACpI;AACA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,kCAAkC;IAGlC,yEAAyE;IACzE,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,mCAAmC;IACnC,kCAAkC;IAGlC,4EAA4E;IAC5E,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,kCAAkC;IAClC,gIAAgI;IAChI,qBAAqB;IACrB,qCAAqC;AACzC;AACA;IACI,4BAA4B;AAChC;AACA;IAGI,8EAA8E;IAC9E,4BAA4B;AAChC;AACA;IAGI,8EAA8E;IAC9E,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,mCAAmC;IAGnC,+EAA+E;IAC/E,qCAAqC;IACrC,gIAAgI;AACpI;AACA;IACI,qBAAqB;IACrB,mCAAmC;IAGnC,+EAA+E;IAC/E,qCAAqC;IACrC,gIAAgI;IAChI,+BAA+B;AACnC;AACA;IACI,qBAAqB;IACrB,kCAAkC;IAGlC,8EAA8E;IAC9E,qCAAqC;IACrC,gIAAgI;IAChI,4BAA4B;AAChC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,0CAA0C;IAC1C,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,sCAAsC;AAC1C;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,0CAA0C;IAC1C,6CAA6C;AACjD;AACA;IACI,WAAW;AACf;AACA;IACI,oCAAoC;AACxC;AACA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,wCAAwC;IACxC,0CAA0C;AAC9C;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,0CAA0C;AAC9C;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,0CAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;AACpB;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,WAAW;IACX,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;IACjC,wBAAwB;AAC5B;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;IACjC,wBAAwB;AAC5B;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;IACjC,wBAAwB;AAC5B;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;IACjC,wBAAwB;AAC5B;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;IACjC,wBAAwB;AAC5B;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;IACjC,wBAAwB;AAC5B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAElB,kDAAkD;AACtD;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,sBAAsB;IACtB,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,0CAA0C;IAC1C,8CAA8C;AAClD;AACA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;IACjC,wBAAwB;AAC5B;AACA;IACI,0CAA0C;IAC1C,8CAA8C;AAClD;AACA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;AACA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+DAAgD;IAChD,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,SAAS;IACT,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,UAAU;AACd;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;AACV;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;IACV;AACJ;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,SAAS;IACT,YAAY;AAChB;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,OAAO;AACX;;AAEA;IACI,WAAW;IACX,aAAa;IACb,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;GACG,sBAAsB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAGlB,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,qBAAqB;IACrB,YAAY;IACZ,+BAA+B;IAC/B,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;IAC/B,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,wCAAwC;IACxC,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;IACI,UAAU;AACd;IACI,kBAAkB;IAClB,QAAQ;IAGR,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;AACA;IACI,SAAS;AACb;IACI,UAAU;AACd;IACI,YAAY;AAChB;IACI,UAAU;AACd;IACI,cAAc;AAClB;IACI,UAAU;AACd;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB","sourcesContent":[".breadcrumb, .carousel-indicators, .dropdown-menu, .dropdown-menu-icons, .media-list, .nav, .pager {\r\n    list-style: none;\r\n}\r\n.tag, hr {\r\n    box-sizing: content-box;\r\n}\r\nhr, img {\r\n    border: 0;\r\n}\r\nbody, mark {\r\n    color: #000;\r\n}\r\nbody, figure {\r\n    margin: 0;\r\n}\r\n.btn-group>.btn-group, .btn-toolbar .btn, .btn-toolbar .btn-group, .btn-toolbar .input-group, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .dropdown-menu {\r\n    float: left;\r\n}\r\narticle, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section, summary {\r\n    display: block;\r\n}\r\naudio, canvas, progress, video {\r\n    display: inline-block;\r\n    vertical-align: baseline;\r\n}\r\naudio:not([controls]) {\r\n    display: none;\r\n    height: 0;\r\n}\r\n[hidden], template {\r\n    display: none;\r\n}\r\na {\r\n    background-color: transparent;\r\n}\r\na:active, a:hover {\r\n    outline: 0;\r\n}\r\nb, optgroup, strong {\r\n    font-weight: 700;\r\n}\r\ndfn {\r\n    font-style: italic;\r\n}\r\nh1 {\r\n    margin: .67em 0;\r\n}\r\nmark {\r\n    background: #ff0;\r\n}\r\nsub, sup {\r\n    font-size: 75%;\r\n    line-height: 0;\r\n    position: relative;\r\n    vertical-align: baseline;\r\n}\r\nsup {\r\n    top: -.5em;\r\n}\r\nsub {\r\n    bottom: -.25em;\r\n}\r\nsvg:not(:root) {\r\n    overflow: hidden;\r\n}\r\nhr {\r\n    height: 0;\r\n}\r\npre, textarea {\r\n    overflow: auto;\r\n}\r\ncode, kbd, pre, samp {\r\n    font-size: 1em;\r\n}\r\nbutton, input, optgroup, select, textarea {\r\n    color: inherit;\r\n    font: inherit;\r\n    margin: 0;\r\n}\r\nbody, table {\r\n    font-size: 13px;\r\n}\r\nbutton {\r\n    overflow: visible;\r\n}\r\nbutton, select {\r\n    text-transform: none;\r\n}\r\nbutton, html input[type=button], input[type=reset], input[type=submit] {\r\n    -webkit-appearance: button;\r\n    cursor: pointer;\r\n}\r\nbutton[disabled], html input[disabled] {\r\n    cursor: default;\r\n}\r\nbutton::-moz-focus-inner, input::-moz-focus-inner {\r\n    border: 0;\r\n    padding: 0;\r\n}\r\ninput[type=checkbox], input[type=radio] {\r\n    box-sizing: border-box;\r\n    padding: 0;\r\n}\r\ninput[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button {\r\n    height: auto;\r\n}\r\ninput[type=search]::-webkit-search-cancel-button, input[type=search]::-webkit-search-decoration {\r\n    -webkit-appearance: none;\r\n}\r\n#btnEditTrigger {\r\n    padding: 0 10px;\r\n    min-width: auto;\r\n}\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n    table-layout: fixed;\r\n}\r\ntable>tbody>tr>td {\r\n    vertical-align: middle!important;\r\n}\r\ntd, th {\r\n    padding: 0;\r\n}\r\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print {\r\n    blockquote, img, pre, tr {\r\n    page-break-inside: avoid;\r\n}\r\n*, :after, :before {\r\n    background: 0 0!important;\r\n    color: #000!important;\r\n    box-shadow: none!important;\r\n    text-shadow: none!important;\r\n}\r\na, a:visited {\r\n    text-decoration: underline;\r\n}\r\na[href]:after {\r\n    content: \" (\" attr(href) \")\"}\r\nabbr[title]:after {\r\n    content: \" (\" attr(title) \")\"}\r\na[href^=\"javascript:\"]:after, a[href^=\"#\"]:after {\r\n    content: \"\"}\r\nblockquote, pre {\r\n    border: 1px solid #999;\r\n}\r\nthead {\r\n    display: table-header-group;\r\n}\r\nimg {\r\n    max-width: 100%!important;\r\n}\r\nh2, h3, p {\r\n    orphans: 3;\r\n    widows: 3;\r\n}\r\nh2, h3 {\r\n    page-break-after: avoid;\r\n}\r\n.navbar {\r\n    display: none;\r\n}\r\n.navbar-brand img {\r\n    max-height: 30px;\r\n}\r\n.btn>.caret, .dropup>.btn>.caret {\r\n    border-top-color: #000!important;\r\n}\r\n.label {\r\n    border: 1px solid #000;\r\n}\r\n.table {\r\n    border-collapse: collapse!important;\r\n}\r\n.table td, .table th {\r\n    background-color: #fff!important;\r\n}\r\n.table-bordered td, .table-bordered th {\r\n    border: 1px solid #ddd!important;\r\n}\r\n}\r\n.btn, .btn.active, .btn:active, .form-control, .navbar-toggle {\r\n    background-image: none;\r\n}\r\n.navbar-fixed-bottom .navbar-collapse, .navbar-fixed-top .navbar-collapse, .pre-scrollable {\r\n    max-height: 340px;\r\n}\r\n*, :after, :before {\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n}\r\nbody {\r\n    font-family: \"Open Sans\", Verdana, sans-serif;\r\n    line-height: 1.42857143;\r\n}\r\nbutton, input, select, textarea {\r\n    font-family: inherit;\r\n    font-size: inherit;\r\n    line-height: inherit;\r\n}\r\na {\r\n    color: #0962ac;\r\n    text-decoration: none;\r\n}\r\na:focus, a:hover {\r\n    color: #0962ac;\r\n    text-decoration: underline;\r\n}\r\na:focus {\r\n    outline: dotted thin;\r\n    outline: -webkit-focus-ring-color auto 5px;\r\n    outline-offset: -2px;\r\n}\r\nimg {\r\n    vertical-align: middle;\r\n}\r\n.carousel-inner>.item>a>img, .carousel-inner>.item>img, .img-responsive, .thumbnail a>img, .thumbnail>img {\r\n    display: block;\r\n    max-width: 100%;\r\n    height: auto;\r\n}\r\n.img-rounded {\r\n    border-radius: 6px;\r\n}\r\n.img-thumbnail {\r\n    padding: 4px;\r\n    line-height: 1.42857143;\r\n    background-color: #fff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    -webkit-transition: all .2s ease-in-out;\r\n    -o-transition: all .2s ease-in-out;\r\n    transition: all .2s ease-in-out;\r\n    display: inline-block;\r\n    max-width: 100%;\r\n    height: auto;\r\n}\r\n.list-inline, .list-unstyled {\r\n    padding-left: 0;\r\n    list-style: none;\r\n}\r\n.img-circle {\r\n    border-radius: 50%}\r\nhr {\r\n    margin-top: 18px;\r\n    margin-bottom: 18px;\r\n    border-top: 1px solid #e6e6e6;\r\n}\r\n.sr-only {\r\n    position: absolute;\r\n    width: 1px;\r\n    height: 1px;\r\n    margin: -1px;\r\n    padding: 0;\r\n    overflow: hidden;\r\n    clip: rect(0, 0, 0, 0);\r\n    border: 0;\r\n}\r\n.sr-only-focusable:active, .sr-only-focusable:focus {\r\n    position: static;\r\n    width: auto;\r\n    height: auto;\r\n    margin: 0;\r\n    overflow: visible;\r\n    clip: auto;\r\n}\r\n[role=button] {\r\n    cursor: pointer;\r\n}\r\n.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {\r\n    font-family: inherit;\r\n    font-weight: 600;\r\n    line-height: 1.1;\r\n    color: inherit;\r\n}\r\n.h1 .small, .h1 small, .h2 .small, .h2 small, .h3 .small, .h3 small, .h4 .small, .h4 small, .h5 .small, .h5 small, .h6 .small, .h6 small, h1 .small, h1 small, h2 .small, h2 small, h3 .small, h3 small, h4 .small, h4 small, h5 .small, h5 small, h6 .small, h6 small {\r\n    font-weight: 400;\r\n    line-height: 1;\r\n    color: grey;\r\n}\r\ndt, kbd kbd, label {\r\n    font-weight: 700;\r\n}\r\n.h1, .h2, .h3, h1, h2, h3 {\r\n    margin-top: 18px;\r\n    margin-bottom: 9px;\r\n}\r\n.h1 .small, .h1 small, .h2 .small, .h2 small, .h3 .small, .h3 small, h1 .small, h1 small, h2 .small, h2 small, h3 .small, h3 small {\r\n    font-size: 65%}\r\n.h4, .h5, .h6, h4, h5, h6 {\r\n    margin-top: 9px;\r\n    margin-bottom: 9px;\r\n}\r\n.h4 .small, .h4 small, .h5 .small, .h5 small, .h6 .small, .h6 small, h4 .small, h4 small, h5 .small, h5 small, h6 .small, h6 small {\r\n    font-size: 75%}\r\n.h1, h1 {\r\n    font-size: 33px;\r\n}\r\n.h2, h2 {\r\n    font-size: 27px;\r\n}\r\n.h3, h3 {\r\n    font-size: 23px;\r\n}\r\n.h4, h4 {\r\n    font-size: 17px;\r\n}\r\n.h5, h5 {\r\n    font-size: 13px;\r\n}\r\n.h6, h6 {\r\n    font-size: 12px;\r\n}\r\np {\r\n    margin: 0 0 9px;\r\n}\r\n.lead {\r\n    margin-bottom: 18px;\r\n    font-size: 14px;\r\n    line-height: 1.4;\r\n}\r\naddress, blockquote .small, blockquote footer, blockquote small, dd, dt, pre {\r\n    line-height: 1.42857143;\r\n}\r\n@media (min-width:768px) {\r\n    .lead {\r\n    font-size: 19.5px;\r\n}\r\n}\r\n.small, small {\r\n    font-size: 92%}\r\n.text-left {\r\n    text-align: left;\r\n}\r\n.text-right {\r\n    text-align: right;\r\n}\r\n.text-center {\r\n    text-align: center;\r\n}\r\n.text-justify {\r\n    text-align: justify;\r\n}\r\n.text-nowrap {\r\n    white-space: nowrap;\r\n}\r\n.text-lowercase {\r\n    text-transform: lowercase;\r\n}\r\n.text-uppercase {\r\n    text-transform: uppercase;\r\n}\r\n.text-capitalize {\r\n    text-transform: capitalize;\r\n}\r\n.text-muted {\r\n    color: grey;\r\n}\r\n.text-primary {\r\n    color: #39f;\r\n}\r\na.text-primary:focus, a.text-primary:hover {\r\n    color: #007fff;\r\n}\r\n.text-success {\r\n    color: #37A320;\r\n}\r\na.text-success:focus, a.text-success:hover {\r\n    color: #297818;\r\n}\r\n.text-info {\r\n    color: #39f;\r\n}\r\na.text-info:focus, a.text-info:hover {\r\n    color: #007fff;\r\n}\r\n.text-warning {\r\n    color: #ed6e00;\r\n}\r\na.text-warning:focus, a.text-warning:hover {\r\n    color: #ba5600;\r\n}\r\n.text-danger {\r\n    color: #b01c38;\r\n}\r\na.text-danger:focus, a.text-danger:hover {\r\n    color: #84152a;\r\n}\r\n.bg-primary {\r\n    color: #fff;\r\n    background-color: #39f;\r\n}\r\na.bg-primary:focus, a.bg-primary:hover {\r\n    background-color: #007fff;\r\n}\r\n.bg-success {\r\n    background-color: #e1f1de;\r\n}\r\na.bg-success:focus, a.bg-success:hover {\r\n    background-color: #c1e2b9;\r\n}\r\n.bg-info {\r\n    background-color: #e0f0ff;\r\n}\r\na.bg-info:focus, a.bg-info:hover {\r\n    background-color: #add6ff;\r\n}\r\n.bg-warning {\r\n    background-color: #fce9d9;\r\n}\r\na.bg-warning:focus, a.bg-warning:hover {\r\n    background-color: #f9cea9;\r\n}\r\n.bg-danger {\r\n    background-color: #f3dde1;\r\n}\r\na.bg-danger:focus, a.bg-danger:hover {\r\n    background-color: #e6b7c0;\r\n}\r\npre code, table {\r\n    background-color: transparent;\r\n}\r\n.page-header {\r\n    padding-bottom: 8px;\r\n    margin: 36px 0 18px;\r\n    border-bottom: 1px solid #e6e6e6;\r\n}\r\ndl, ol, ul {\r\n    margin-top: 0;\r\n}\r\nblockquote ol:last-child, blockquote p:last-child, blockquote ul:last-child, ol ol, ol ul, ul ol, ul ul {\r\n    margin-bottom: 0;\r\n}\r\naddress, dl {\r\n    margin-bottom: 18px;\r\n}\r\nol, ul {\r\n    margin-bottom: 9px;\r\n}\r\n.list-inline {\r\n    margin-left: -5px;\r\n}\r\n.list-inline>li {\r\n    display: inline-block;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n}\r\ndd {\r\n    margin-left: 0;\r\n}\r\n@media (min-width:480px) {\r\n    .dl-horizontal dt {\r\n    float: left;\r\n    width: 160px;\r\n    clear: left;\r\n    text-align: right;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n.dl-horizontal dd {\r\n    margin-left: 180px;\r\n}\r\n}\r\nabbr[data-original-title], abbr[title] {\r\n    cursor: help;\r\n    border-bottom: 1px dotted grey;\r\n}\r\n.initialism {\r\n    font-size: 90%;\r\n    text-transform: uppercase;\r\n}\r\nblockquote {\r\n    padding: 9px 18px;\r\n    margin: 0 0 18px;\r\n    font-size: 16.25px;\r\n    border-left: 5px solid #e6e6e6;\r\n}\r\nblockquote .small, blockquote footer, blockquote small {\r\n    display: block;\r\n    font-size: 80%;\r\n    color: grey;\r\n}\r\nlegend, pre {\r\n    display: block;\r\n    color: #404040;\r\n}\r\nblockquote .small:before, blockquote footer:before, blockquote small:before {\r\n    content: '\\2014 \\00A0'}\r\n.blockquote-reverse, blockquote.pull-right {\r\n    padding-right: 15px;\r\n    padding-left: 0;\r\n    border-right: 5px solid #e6e6e6;\r\n    border-left: 0;\r\n    text-align: right;\r\n}\r\ncode, kbd {\r\n    padding: 2px 4px;\r\n    font-size: 90%}\r\ncaption, th {\r\n    text-align: left;\r\n}\r\n.blockquote-reverse .small:before, .blockquote-reverse footer:before, .blockquote-reverse small:before, blockquote.pull-right .small:before, blockquote.pull-right footer:before, blockquote.pull-right small:before {\r\n    content: ''}\r\n.blockquote-reverse .small:after, .blockquote-reverse footer:after, .blockquote-reverse small:after, blockquote.pull-right .small:after, blockquote.pull-right footer:after, blockquote.pull-right small:after {\r\n    content: '\\00A0 \\2014'}\r\naddress {\r\n    font-style: normal;\r\n}\r\ncode, kbd, pre, samp {\r\n    font-family: Menlo, Monaco, Consolas, \"Courier New\", monospace;\r\n}\r\ncode {\r\n    color: #c7254e;\r\n    background-color: #f9f2f4;\r\n    border-radius: 4px;\r\n}\r\nkbd {\r\n    color: #fff;\r\n    background-color: #333;\r\n    border-radius: 3px;\r\n    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);\r\n}\r\nkbd kbd {\r\n    padding: 0;\r\n    font-size: 100%;\r\n    box-shadow: none;\r\n}\r\npre {\r\n    padding: 8.5px;\r\n    margin: 0 0 9px;\r\n    font-size: 12px;\r\n    word-break: break-all;\r\n    word-wrap: break-word;\r\n    background-color: #f5f5f5;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n}\r\npre code {\r\n    padding: 0;\r\n    font-size: inherit;\r\n    color: inherit;\r\n    white-space: pre-wrap;\r\n    border-radius: 0;\r\n}\r\n.badge, .btn, .dropdown-header, .dropdown-menu>li>a, .input-group-btn, .label {\r\n    white-space: nowrap;\r\n}\r\n.container, .container-fluid {\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n}\r\n.pre-scrollable {\r\n    overflow-y: scroll;\r\n}\r\n@media (min-width:768px) {\r\n    .container {\r\n    width: 750px;\r\n}\r\n}\r\n@media (min-width:992px) {\r\n    .container {\r\n    width: 970px;\r\n}\r\n}\r\n@media (min-width:1200px) {\r\n    .container {\r\n    width: 1170px;\r\n}\r\n}\r\n.row {\r\n    margin-left: -15px;\r\n    margin-right: -15px;\r\n}\r\n.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {\r\n    position: relative;\r\n    min-height: 1px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n}\r\n.col-xs-12 {\r\n    width: 100%}\r\n.col-xs-11 {\r\n    width: 91.66666667%}\r\n.col-xs-10 {\r\n    width: 83.33333333%}\r\n.col-xs-9 {\r\n    width: 75%}\r\n.col-xs-8 {\r\n    width: 66.66666667%}\r\n.col-xs-7 {\r\n    width: 58.33333333%}\r\n.col-xs-6 {\r\n    width: 50%}\r\n.col-xs-5 {\r\n    width: 41.66666667%}\r\n.col-xs-4 {\r\n    width: 33.33333333%}\r\n.col-xs-3 {\r\n    width: 25%}\r\n.col-xs-2 {\r\n    width: 16.66666667%}\r\n.col-xs-1 {\r\n    width: 8.33333333%}\r\n.col-xs-pull-12 {\r\n    right: 100%}\r\n.col-xs-pull-11 {\r\n    right: 91.66666667%}\r\n.col-xs-pull-10 {\r\n    right: 83.33333333%}\r\n.col-xs-pull-9 {\r\n    right: 75%}\r\n.col-xs-pull-8 {\r\n    right: 66.66666667%}\r\n.col-xs-pull-7 {\r\n    right: 58.33333333%}\r\n.col-xs-pull-6 {\r\n    right: 50%}\r\n.col-xs-pull-5 {\r\n    right: 41.66666667%}\r\n.col-xs-pull-4 {\r\n    right: 33.33333333%}\r\n.col-xs-pull-3 {\r\n    right: 25%}\r\n.col-xs-pull-2 {\r\n    right: 16.66666667%}\r\n.col-xs-pull-1 {\r\n    right: 8.33333333%}\r\n.col-xs-pull-0 {\r\n    right: auto;\r\n}\r\n.col-xs-push-12 {\r\n    left: 100%}\r\n.col-xs-push-11 {\r\n    left: 91.66666667%}\r\n.col-xs-push-10 {\r\n    left: 83.33333333%}\r\n.col-xs-push-9 {\r\n    left: 75%}\r\n.col-xs-push-8 {\r\n    left: 66.66666667%}\r\n.col-xs-push-7 {\r\n    left: 58.33333333%}\r\n.col-xs-push-6 {\r\n    left: 50%}\r\n.col-xs-push-5 {\r\n    left: 41.66666667%}\r\n.col-xs-push-4 {\r\n    left: 33.33333333%}\r\n.col-xs-push-3 {\r\n    left: 25%}\r\n.col-xs-push-2 {\r\n    left: 16.66666667%}\r\n.col-xs-push-1 {\r\n    left: 8.33333333%}\r\n.col-xs-push-0 {\r\n    left: auto;\r\n}\r\n.col-xs-offset-12 {\r\n    margin-left: 100%}\r\n.col-xs-offset-11 {\r\n    margin-left: 91.66666667%}\r\n.col-xs-offset-10 {\r\n    margin-left: 83.33333333%}\r\n.col-xs-offset-9 {\r\n    margin-left: 75%}\r\n.col-xs-offset-8 {\r\n    margin-left: 66.66666667%}\r\n.col-xs-offset-7 {\r\n    margin-left: 58.33333333%}\r\n.col-xs-offset-6 {\r\n    margin-left: 50%}\r\n.col-xs-offset-5 {\r\n    margin-left: 41.66666667%}\r\n.col-xs-offset-4 {\r\n    margin-left: 33.33333333%}\r\n.col-xs-offset-3 {\r\n    margin-left: 25%}\r\n.col-xs-offset-2 {\r\n    margin-left: 16.66666667%}\r\n.col-xs-offset-1 {\r\n    margin-left: 8.33333333%}\r\n.col-xs-offset-0 {\r\n    margin-left: 0;\r\n}\r\n@media (min-width:768px) {\r\n    .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9 {\r\n        min-width: min-content;\r\n    float: left;\r\n}\r\n.col-sm-12 {\r\n    width: 100%}\r\n.col-sm-11 {\r\n    width: 91.66666667%}\r\n.col-sm-10 {\r\n    width: 83.33333333%}\r\n.col-sm-9 {\r\n    width: 75%}\r\n.col-sm-8 {\r\n    width: 66.66666667%}\r\n.col-sm-7 {\r\n    width: 58.33333333%}\r\n.col-sm-6 {\r\n    width: 50%}\r\n.col-sm-5 {\r\n    width: 41.66666667%}\r\n.col-sm-4 {\r\n    width: 33.33333333%}\r\n.col-sm-3 {\r\n    width: 25%}\r\n.col-sm-2 {\r\n    width: 16.66666667%}\r\n.col-sm-1 {\r\n    width: 8.33333333%}\r\n.col-sm-pull-12 {\r\n    right: 100%}\r\n.col-sm-pull-11 {\r\n    right: 91.66666667%}\r\n.col-sm-pull-10 {\r\n    right: 83.33333333%}\r\n.col-sm-pull-9 {\r\n    right: 75%}\r\n.col-sm-pull-8 {\r\n    right: 66.66666667%}\r\n.col-sm-pull-7 {\r\n    right: 58.33333333%}\r\n.col-sm-pull-6 {\r\n    right: 50%}\r\n.col-sm-pull-5 {\r\n    right: 41.66666667%}\r\n.col-sm-pull-4 {\r\n    right: 33.33333333%}\r\n.col-sm-pull-3 {\r\n    right: 25%}\r\n.col-sm-pull-2 {\r\n    right: 16.66666667%}\r\n.col-sm-pull-1 {\r\n    right: 8.33333333%}\r\n.col-sm-pull-0 {\r\n    right: auto;\r\n}\r\n.col-sm-push-12 {\r\n    left: 100%}\r\n.col-sm-push-11 {\r\n    left: 91.66666667%}\r\n.col-sm-push-10 {\r\n    left: 83.33333333%}\r\n.col-sm-push-9 {\r\n    left: 75%}\r\n.col-sm-push-8 {\r\n    left: 66.66666667%}\r\n.col-sm-push-7 {\r\n    left: 58.33333333%}\r\n.col-sm-push-6 {\r\n    left: 50%}\r\n.col-sm-push-5 {\r\n    left: 41.66666667%}\r\n.col-sm-push-4 {\r\n    left: 33.33333333%}\r\n.col-sm-push-3 {\r\n    left: 25%}\r\n.col-sm-push-2 {\r\n    left: 16.66666667%}\r\n.col-sm-push-1 {\r\n    left: 8.33333333%}\r\n.col-sm-push-0 {\r\n    left: auto;\r\n}\r\n.col-sm-offset-12 {\r\n    margin-left: 100%}\r\n.col-sm-offset-11 {\r\n    margin-left: 91.66666667%}\r\n.col-sm-offset-10 {\r\n    margin-left: 83.33333333%}\r\n.col-sm-offset-9 {\r\n    margin-left: 75%}\r\n.col-sm-offset-8 {\r\n    margin-left: 66.66666667%}\r\n.col-sm-offset-7 {\r\n    margin-left: 58.33333333%}\r\n.col-sm-offset-6 {\r\n    margin-left: 50%}\r\n.col-sm-offset-5 {\r\n    margin-left: 41.66666667%}\r\n.col-sm-offset-4 {\r\n    margin-left: 33.33333333%}\r\n.col-sm-offset-3 {\r\n    margin-left: 25%}\r\n.col-sm-offset-2 {\r\n    margin-left: 16.66666667%}\r\n.col-sm-offset-1 {\r\n    margin-left: 8.33333333%}\r\n.col-sm-offset-0 {\r\n    margin-left: 0;\r\n}\r\n}\r\n@media (min-width:992px) {\r\n    .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9 {\r\n        min-width: min-content;\r\n    float: left;\r\n}\r\n.col-md-12 {\r\n    width: 100%}\r\n.col-md-11 {\r\n    width: 91.66666667%}\r\n.col-md-10 {\r\n    width: 83.33333333%}\r\n.col-md-9 {\r\n    width: 75%}\r\n.col-md-8 {\r\n    width: 66.66666667%}\r\n.col-md-7 {\r\n    width: 58.33333333%}\r\n.col-md-6 {\r\n    width: 50%}\r\n.col-md-5 {\r\n    width: 41.66666667%}\r\n.col-md-4 {\r\n    width: 33.33333333%}\r\n.col-md-3 {\r\n    width: 25%}\r\n.col-md-2 {\r\n    width: 16.66666667%}\r\n.col-md-1 {\r\n    width: 8.33333333%}\r\n.col-md-pull-12 {\r\n    right: 100%}\r\n.col-md-pull-11 {\r\n    right: 91.66666667%}\r\n.col-md-pull-10 {\r\n    right: 83.33333333%}\r\n.col-md-pull-9 {\r\n    right: 75%}\r\n.col-md-pull-8 {\r\n    right: 66.66666667%}\r\n.col-md-pull-7 {\r\n    right: 58.33333333%}\r\n.col-md-pull-6 {\r\n    right: 50%}\r\n.col-md-pull-5 {\r\n    right: 41.66666667%}\r\n.col-md-pull-4 {\r\n    right: 33.33333333%}\r\n.col-md-pull-3 {\r\n    right: 25%}\r\n.col-md-pull-2 {\r\n    right: 16.66666667%}\r\n.col-md-pull-1 {\r\n    right: 8.33333333%}\r\n.col-md-pull-0 {\r\n    right: auto;\r\n}\r\n.col-md-push-12 {\r\n    left: 100%}\r\n.col-md-push-11 {\r\n    left: 91.66666667%}\r\n.col-md-push-10 {\r\n    left: 83.33333333%}\r\n.col-md-push-9 {\r\n    left: 75%}\r\n.col-md-push-8 {\r\n    left: 66.66666667%}\r\n.col-md-push-7 {\r\n    left: 58.33333333%}\r\n.col-md-push-6 {\r\n    left: 50%}\r\n.col-md-push-5 {\r\n    left: 41.66666667%}\r\n.col-md-push-4 {\r\n    left: 33.33333333%}\r\n.col-md-push-3 {\r\n    left: 25%}\r\n.col-md-push-2 {\r\n    left: 16.66666667%}\r\n.col-md-push-1 {\r\n    left: 8.33333333%}\r\n.col-md-push-0 {\r\n    left: auto;\r\n}\r\n.col-md-offset-12 {\r\n    margin-left: 100%}\r\n.col-md-offset-11 {\r\n    margin-left: 91.66666667%}\r\n.col-md-offset-10 {\r\n    margin-left: 83.33333333%}\r\n.col-md-offset-9 {\r\n    margin-left: 75%}\r\n.col-md-offset-8 {\r\n    margin-left: 66.66666667%}\r\n.col-md-offset-7 {\r\n    margin-left: 58.33333333%}\r\n.col-md-offset-6 {\r\n    margin-left: 50%}\r\n.col-md-offset-5 {\r\n    margin-left: 41.66666667%}\r\n.col-md-offset-4 {\r\n    margin-left: 33.33333333%}\r\n.col-md-offset-3 {\r\n    margin-left: 25%}\r\n.col-md-offset-2 {\r\n    margin-left: 16.66666667%}\r\n.col-md-offset-1 {\r\n    margin-left: 8.33333333%}\r\n.col-md-offset-0 {\r\n    margin-left: 0;\r\n}\r\n}\r\n@media (min-width:1200px) {\r\n    .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9 {\r\n        min-width: min-content;\r\n    float: left;\r\n}\r\n.col-lg-12 {\r\n    width: 100%}\r\n.col-lg-11 {\r\n    width: 91.66666667%}\r\n.col-lg-10 {\r\n    width: 83.33333333%}\r\n.col-lg-9 {\r\n    width: 75%}\r\n.col-lg-8 {\r\n    width: 66.66666667%}\r\n.col-lg-7 {\r\n    width: 58.33333333%}\r\n.col-lg-6 {\r\n    width: 50%}\r\n.col-lg-5 {\r\n    width: 41.66666667%}\r\n.col-lg-4 {\r\n    width: 33.33333333%}\r\n.col-lg-3 {\r\n    width: 25%}\r\n.col-lg-2 {\r\n    width: 16.66666667%}\r\n.col-lg-1 {\r\n    width: 8.33333333%}\r\n.col-lg-pull-12 {\r\n    right: 100%}\r\n.col-lg-pull-11 {\r\n    right: 91.66666667%}\r\n.col-lg-pull-10 {\r\n    right: 83.33333333%}\r\n.col-lg-pull-9 {\r\n    right: 75%}\r\n.col-lg-pull-8 {\r\n    right: 66.66666667%}\r\n.col-lg-pull-7 {\r\n    right: 58.33333333%}\r\n.col-lg-pull-6 {\r\n    right: 50%}\r\n.col-lg-pull-5 {\r\n    right: 41.66666667%}\r\n.col-lg-pull-4 {\r\n    right: 33.33333333%}\r\n.col-lg-pull-3 {\r\n    right: 25%}\r\n.col-lg-pull-2 {\r\n    right: 16.66666667%}\r\n.col-lg-pull-1 {\r\n    right: 8.33333333%}\r\n.col-lg-pull-0 {\r\n    right: auto;\r\n}\r\n.col-lg-push-12 {\r\n    left: 100%}\r\n.col-lg-push-11 {\r\n    left: 91.66666667%}\r\n.col-lg-push-10 {\r\n    left: 83.33333333%}\r\n.col-lg-push-9 {\r\n    left: 75%}\r\n.col-lg-push-8 {\r\n    left: 66.66666667%}\r\n.col-lg-push-7 {\r\n    left: 58.33333333%}\r\n.col-lg-push-6 {\r\n    left: 50%}\r\n.col-lg-push-5 {\r\n    left: 41.66666667%}\r\n.col-lg-push-4 {\r\n    left: 33.33333333%}\r\n.col-lg-push-3 {\r\n    left: 25%}\r\n.col-lg-push-2 {\r\n    left: 16.66666667%}\r\n.col-lg-push-1 {\r\n    left: 8.33333333%}\r\n.col-lg-push-0 {\r\n    left: auto;\r\n}\r\n.col-lg-offset-12 {\r\n    margin-left: 100%}\r\n.col-lg-offset-11 {\r\n    margin-left: 91.66666667%}\r\n.col-lg-offset-10 {\r\n    margin-left: 83.33333333%}\r\n.col-lg-offset-9 {\r\n    margin-left: 75%}\r\n.col-lg-offset-8 {\r\n    margin-left: 66.66666667%}\r\n.col-lg-offset-7 {\r\n    margin-left: 58.33333333%}\r\n.col-lg-offset-6 {\r\n    margin-left: 50%}\r\n.col-lg-offset-5 {\r\n    margin-left: 41.66666667%}\r\n.col-lg-offset-4 {\r\n    margin-left: 33.33333333%}\r\n.col-lg-offset-3 {\r\n    margin-left: 25%}\r\n.col-lg-offset-2 {\r\n    margin-left: 16.66666667%}\r\n.col-lg-offset-1 {\r\n    margin-left: 8.33333333%}\r\n.col-lg-offset-0 {\r\n    margin-left: 0;\r\n}\r\n}\r\ncaption {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n    color: grey;\r\n}\r\n.table {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    margin-bottom: 18px;\r\n}\r\n.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {\r\n    padding: 8px;\r\n    line-height: 1.42857143;\r\n    vertical-align: top;\r\n    border-top: 1px solid #e6e6e6;\r\n}\r\n.table>thead>tr>th {\r\n    vertical-align: bottom;\r\n    border-bottom: 2px solid #e6e6e6;\r\n}\r\n.btn, .btn-group, .btn-group-vertical, .caret, .checkbox-inline, .navbar-form span, .radio-inline {\r\n    vertical-align: middle;\r\n}\r\n.table>caption+thead>tr:first-child>td, .table>caption+thead>tr:first-child>th, .table>colgroup+thead>tr:first-child>td, .table>colgroup+thead>tr:first-child>th, .table>thead:first-child>tr:first-child>td, .table>thead:first-child>tr:first-child>th {\r\n    border-top: 0;\r\n}\r\n.table>tbody+tbody {\r\n    border-top: 2px solid #e6e6e6;\r\n}\r\n.table .table {\r\n    background-color: #fff;\r\n}\r\n.table-condensed>tbody>tr>td, .table-condensed>tbody>tr>th, .table-condensed>tfoot>tr>td, .table-condensed>tfoot>tr>th, .table-condensed>thead>tr>td, .table-condensed>thead>tr>th {\r\n    padding: 5px;\r\n}\r\n.table-bordered, .table-bordered>tbody>tr>td, .table-bordered>tbody>tr>th, .table-bordered>tfoot>tr>td, .table-bordered>tfoot>tr>th, .table-bordered>thead>tr>td, .table-bordered>thead>tr>th {\r\n    border: 1px solid #e6e6e6;\r\n}\r\n.table-bordered>thead>tr>td, .table-bordered>thead>tr>th {\r\n    border-bottom-width: 2px;\r\n}\r\n.table-striped>tbody>tr:nth-of-type(odd) {\r\n    background-color: #f9f9f9;\r\n}\r\n.table-hover>tbody>tr:hover {\r\n    background-color: rgba(0, 0, 0, .06);\r\n}\r\ntable col[class*=col-] {\r\n    position: static;\r\n    float: none;\r\n    display: table-column;\r\n}\r\ntable td[class*=col-], table th[class*=col-] {\r\n    position: static;\r\n    float: none;\r\n    display: table-cell;\r\n}\r\n.table>tbody>tr.active>td, .table>tbody>tr.active>th, .table>tbody>tr>td.active, .table>tbody>tr>th.active, .table>tfoot>tr.active>td, .table>tfoot>tr.active>th, .table>tfoot>tr>td.active, .table>tfoot>tr>th.active, .table>thead>tr.active>td, .table>thead>tr.active>th, .table>thead>tr>td.active, .table>thead>tr>th.active {\r\n    background-color: #80bfff;\r\n}\r\n.table-hover>tbody>tr.active:hover>td, .table-hover>tbody>tr.active:hover>th, .table-hover>tbody>tr:hover>.active, .table-hover>tbody>tr>td.active:hover, .table-hover>tbody>tr>th.active:hover {\r\n    background-color: #66b2ff;\r\n}\r\n.table>tbody>tr.success>td, .table>tbody>tr.success>th, .table>tbody>tr>td.success, .table>tbody>tr>th.success, .table>tfoot>tr.success>td, .table>tfoot>tr.success>th, .table>tfoot>tr>td.success, .table>tfoot>tr>th.success, .table>thead>tr.success>td, .table>thead>tr.success>th, .table>thead>tr>td.success, .table>thead>tr>th.success {\r\n    background-color: #e1f1de;\r\n}\r\n.table-hover>tbody>tr.success:hover>td, .table-hover>tbody>tr.success:hover>th, .table-hover>tbody>tr:hover>.success, .table-hover>tbody>tr>td.success:hover, .table-hover>tbody>tr>th.success:hover {\r\n    background-color: #d1eacb;\r\n}\r\n.table>tbody>tr.info>td, .table>tbody>tr.info>th, .table>tbody>tr>td.info, .table>tbody>tr>th.info, .table>tfoot>tr.info>td, .table>tfoot>tr.info>th, .table>tfoot>tr>td.info, .table>tfoot>tr>th.info, .table>thead>tr.info>td, .table>thead>tr.info>th, .table>thead>tr>td.info, .table>thead>tr>th.info {\r\n    background-color: #e0f0ff;\r\n}\r\n.table-hover>tbody>tr.info:hover>td, .table-hover>tbody>tr.info:hover>th, .table-hover>tbody>tr:hover>.info, .table-hover>tbody>tr>td.info:hover, .table-hover>tbody>tr>th.info:hover {\r\n    background-color: #c7e3ff;\r\n}\r\n.table>tbody>tr.warning>td, .table>tbody>tr.warning>th, .table>tbody>tr>td.warning, .table>tbody>tr>th.warning, .table>tfoot>tr.warning>td, .table>tfoot>tr.warning>th, .table>tfoot>tr>td.warning, .table>tfoot>tr>th.warning, .table>thead>tr.warning>td, .table>thead>tr.warning>th, .table>thead>tr>td.warning, .table>thead>tr>th.warning {\r\n    background-color: #fce9d9;\r\n}\r\n.table-hover>tbody>tr.warning:hover>td, .table-hover>tbody>tr.warning:hover>th, .table-hover>tbody>tr:hover>.warning, .table-hover>tbody>tr>td.warning:hover, .table-hover>tbody>tr>th.warning:hover {\r\n    background-color: #fbdcc1;\r\n}\r\n.table>tbody>tr.danger>td, .table>tbody>tr.danger>th, .table>tbody>tr>td.danger, .table>tbody>tr>th.danger, .table>tfoot>tr.danger>td, .table>tfoot>tr.danger>th, .table>tfoot>tr>td.danger, .table>tfoot>tr>th.danger, .table>thead>tr.danger>td, .table>thead>tr.danger>th, .table>thead>tr>td.danger, .table>thead>tr>th.danger {\r\n    background-color: #f3dde1;\r\n}\r\n.table-hover>tbody>tr.danger:hover>td, .table-hover>tbody>tr.danger:hover>th, .table-hover>tbody>tr:hover>.danger, .table-hover>tbody>tr>td.danger:hover, .table-hover>tbody>tr>th.danger:hover {\r\n    background-color: #edcad1;\r\n}\r\n.table-responsive {\r\n    min-height: .01%}\r\n@media screen and (max-width:767px) {\r\n    .table-responsive {\r\n    width: 100%;\r\n    margin-bottom: 13.5px;\r\n    overflow-y: hidden;\r\n    -ms-overflow-style: -ms-autohiding-scrollbar;\r\n    border: 1px solid #e6e6e6;\r\n}\r\n.table-responsive>.table {\r\n    margin-bottom: 0;\r\n}\r\n.table-responsive>.table>tbody>tr>td, .table-responsive>.table>tbody>tr>th, .table-responsive>.table>tfoot>tr>td, .table-responsive>.table>tfoot>tr>th, .table-responsive>.table>thead>tr>td, .table-responsive>.table>thead>tr>th {\r\n    white-space: nowrap;\r\n}\r\n.table-responsive>.table-bordered {\r\n    border: 0;\r\n}\r\n.table-responsive>.table-bordered>tbody>tr>td:first-child, .table-responsive>.table-bordered>tbody>tr>th:first-child, .table-responsive>.table-bordered>tfoot>tr>td:first-child, .table-responsive>.table-bordered>tfoot>tr>th:first-child, .table-responsive>.table-bordered>thead>tr>td:first-child, .table-responsive>.table-bordered>thead>tr>th:first-child {\r\n    border-left: 0;\r\n}\r\n.table-responsive>.table-bordered>tbody>tr>td:last-child, .table-responsive>.table-bordered>tbody>tr>th:last-child, .table-responsive>.table-bordered>tfoot>tr>td:last-child, .table-responsive>.table-bordered>tfoot>tr>th:last-child, .table-responsive>.table-bordered>thead>tr>td:last-child, .table-responsive>.table-bordered>thead>tr>th:last-child {\r\n    border-right: 0;\r\n}\r\n.table-responsive>.table-bordered>tbody>tr:last-child>td, .table-responsive>.table-bordered>tbody>tr:last-child>th, .table-responsive>.table-bordered>tfoot>tr:last-child>td, .table-responsive>.table-bordered>tfoot>tr:last-child>th {\r\n    border-bottom: 0;\r\n}\r\n}\r\nfieldset, legend {\r\n    padding: 0;\r\n    border: 0;\r\n}\r\nfieldset {\r\n    margin: 0;\r\n    min-width: 0;\r\n}\r\nlegend {\r\n    width: 100%;\r\n    margin-bottom: 18px;\r\n    font-size: 19.5px;\r\n    line-height: inherit;\r\n    border-bottom: 1px solid #e5e5e5;\r\n}\r\n.form-control, output {\r\n    font-size: 13px;\r\n    color: #000;\r\n}\r\nlabel {\r\n    display: inline-block;\r\n    max-width: 100%;\r\n    margin-bottom: 5px;\r\n}\r\n.checkbox, .form-control, .radio, input[type=file], output {\r\n    display: block;\r\n}\r\ninput[type=search] {\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n    padding-left: 20px;\r\n    -webkit-appearance: none;\r\n}\r\ninput[type=checkbox], input[type=radio] {\r\n    margin: 4px 0 0;\r\n    margin-top: 1px\\9;\r\n    line-height: normal;\r\n}\r\n.dropdown-header, .dropdown-menu>li>a, .form-control, output {\r\n    line-height: 1.42857143;\r\n}\r\ninput[type=range] {\r\n    display: block;\r\n    width: 100%}\r\nselect[multiple], select[size] {\r\n    height: auto;\r\n}\r\ninput[type=checkbox]:focus, input[type=file]:focus, input[type=radio]:focus {\r\n    outline: dotted thin;\r\n    outline: -webkit-focus-ring-color auto 5px;\r\n    outline-offset: -2px;\r\n}\r\noutput {\r\n    padding-top: 4px;\r\n}\r\n.form-control {\r\n    width: 100%;\r\n    height: 26px;\r\n    padding: 3px 5px;\r\n    background-color: #fff;\r\n    border: 1px solid silver;\r\n    border-radius: 4px;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n    -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n    -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n}\r\n.form-control:focus {\r\n    border-color: #39f;\r\n    outline: 0;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(51, 153, 255, .6);\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(51, 153, 255, .6);\r\n}\r\n.form-control::-moz-placeholder {\r\n    color: grey;\r\n    opacity: 1;\r\n}\r\n.form-control:-ms-input-placeholder {\r\n    color: grey;\r\n}\r\n.form-control::-webkit-input-placeholder {\r\n    color: grey;\r\n}\r\n.has-success .checkbox, .has-success .checkbox-inline, .has-success .control-label, .has-success .form-control-feedback, .has-success .help-block, .has-success .radio, .has-success .radio-inline, .has-success.checkbox label, .has-success.checkbox-inline label, .has-success.radio label, .has-success.radio-inline label {\r\n    color: #37A320;\r\n}\r\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\r\n    background-color: #e6e6e6;\r\n    opacity: 1;\r\n}\r\n.form-control[disabled], fieldset[disabled] .form-control {\r\n    cursor: not-allowed;\r\n}\r\ntextarea.form-control {\r\n    height: auto;\r\n}\r\n@media screen and (-webkit-min-device-pixel-ratio:0) {\r\n    input[type=date].form-control, input[type=datetime-local].form-control, input[type=month].form-control, input[type=time].form-control {\r\n    line-height: 26px;\r\n}\r\n.input-group-sm input[type=date], .input-group-sm input[type=datetime-local], .input-group-sm input[type=month], .input-group-sm input[type=time], input[type=date].input-sm, input[type=datetime-local].input-sm, input[type=month].input-sm, input[type=time].input-sm {\r\n    line-height: 30px;\r\n}\r\n.input-group-lg input[type=date], .input-group-lg input[type=datetime-local], .input-group-lg input[type=month], .input-group-lg input[type=time], input[type=date].input-lg, input[type=datetime-local].input-lg, input[type=month].input-lg, input[type=time].input-lg {\r\n    line-height: 38px;\r\n}\r\n}\r\n.form-group {\r\n    margin-bottom: 15px;\r\n}\r\n.checkbox, .radio {\r\n    position: relative;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n}\r\n.checkbox label, .radio label {\r\n    min-height: 18px;\r\n    padding-left: 20px;\r\n    margin-bottom: 0;\r\n    font-weight: 400;\r\n    cursor: pointer;\r\n}\r\n.checkbox input[type=checkbox], .checkbox-inline input[type=checkbox], .radio input[type=radio], .radio-inline input[type=radio] {\r\n    position: absolute;\r\n    margin-left: -20px;\r\n    margin-top: 4px\\9;\r\n}\r\n.checkbox+.checkbox, .radio+.radio {\r\n    margin-top: -5px;\r\n}\r\n.checkbox-inline, .radio-inline {\r\n    position: relative;\r\n    display: inline-block;\r\n    padding-left: 20px;\r\n    margin-bottom: 0;\r\n    font-weight: 400;\r\n    cursor: pointer;\r\n}\r\n.checkbox-inline+.checkbox-inline, .radio-inline+.radio-inline {\r\n    margin-top: 0;\r\n    margin-left: 10px;\r\n}\r\n.checkbox-inline.disabled, .checkbox.disabled label, .radio-inline.disabled, .radio.disabled label, fieldset[disabled] .checkbox label, fieldset[disabled] .checkbox-inline, fieldset[disabled] .radio label, fieldset[disabled] .radio-inline, fieldset[disabled] input[type=checkbox], fieldset[disabled] input[type=radio], input[type=checkbox].disabled, input[type=checkbox][disabled], input[type=radio].disabled, input[type=radio][disabled] {\r\n    cursor: not-allowed;\r\n}\r\n.form-control-static {\r\n    padding-top: 4px;\r\n    padding-bottom: 4px;\r\n    margin-bottom: 0;\r\n    min-height: 31px;\r\n}\r\n.form-control-static.input-lg, .form-control-static.input-sm {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n}\r\n.form-group-sm .form-control, .input-sm {\r\n    padding: 5px 10px;\r\n    border-radius: 3px;\r\n    font-size: 12px;\r\n}\r\n.input-sm {\r\n    height: 30px;\r\n    line-height: 1.5;\r\n}\r\nselect.input-sm {\r\n    height: 30px;\r\n    line-height: 30px;\r\n}\r\nselect[multiple].input-sm, textarea.input-sm {\r\n    height: auto;\r\n}\r\n.form-group-sm .form-control {\r\n    height: 30px;\r\n    line-height: 1.5;\r\n}\r\n.form-group-lg .form-control, .input-lg {\r\n    border-radius: 6px;\r\n    padding: 8px 12px;\r\n    font-size: 15px;\r\n}\r\n.form-group-sm select.form-control {\r\n    height: 30px;\r\n    line-height: 30px;\r\n}\r\n.form-group-sm select[multiple].form-control, .form-group-sm textarea.form-control {\r\n    height: auto;\r\n}\r\n.form-group-sm .form-control-static {\r\n    height: 30px;\r\n    min-height: 30px;\r\n    padding: 6px 10px;\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n}\r\n.input-lg {\r\n    height: 38px;\r\n    line-height: 1.3333333;\r\n}\r\nselect.input-lg {\r\n    height: 38px;\r\n    line-height: 38px;\r\n}\r\nselect[multiple].input-lg, textarea.input-lg {\r\n    height: auto;\r\n}\r\n.form-group-lg .form-control {\r\n    height: 38px;\r\n    line-height: 1.3333333;\r\n}\r\n.form-group-lg select.form-control {\r\n    height: 38px;\r\n    line-height: 38px;\r\n}\r\n.form-group-lg select[multiple].form-control, .form-group-lg textarea.form-control {\r\n    height: auto;\r\n}\r\n.form-group-lg .form-control-static {\r\n    height: 38px;\r\n    min-height: 33px;\r\n    padding: 9px 12px;\r\n    font-size: 15px;\r\n    line-height: 1.3333333;\r\n}\r\n.has-feedback {\r\n    position: relative;\r\n}\r\n.has-feedback .form-control {\r\n    padding-right: 32.5px;\r\n}\r\n.form-control-feedback {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    z-index: 2;\r\n    display: block;\r\n    width: 26px;\r\n    height: 26px;\r\n    line-height: 26px;\r\n    text-align: center;\r\n    pointer-events: none;\r\n}\r\n.collapsing, .dropdown, .dropup {\r\n    position: relative;\r\n}\r\n.form-group-lg .form-control+.form-control-feedback, .input-group-lg+.form-control-feedback, .input-lg+.form-control-feedback {\r\n    width: 38px;\r\n    height: 38px;\r\n    line-height: 38px;\r\n}\r\n.form-group-sm .form-control+.form-control-feedback, .input-group-sm+.form-control-feedback, .input-sm+.form-control-feedback {\r\n    width: 30px;\r\n    height: 30px;\r\n    line-height: 30px;\r\n}\r\n.has-success .form-control {\r\n    border-color: #37A320;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n}\r\n.has-success .form-control:focus {\r\n    border-color: #297818;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #66dc4d;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #66dc4d;\r\n}\r\n.has-success .input-group-addon {\r\n    color: #37A320;\r\n    border-color: #37A320;\r\n    background-color: #e1f1de;\r\n}\r\n.has-success .form-control {\r\n    background-color: #e1f1de;\r\n    color: #000;\r\n}\r\n.has-warning .checkbox, .has-warning .checkbox-inline, .has-warning .control-label, .has-warning .form-control-feedback, .has-warning .help-block, .has-warning .radio, .has-warning .radio-inline, .has-warning.checkbox label, .has-warning.checkbox-inline label, .has-warning.radio label, .has-warning.radio-inline label {\r\n    color: #ed6e00;\r\n}\r\n.has-warning .form-control {\r\n    border-color: #ed6e00;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n}\r\n.has-warning .form-control:focus {\r\n    border-color: #ba5600;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ffa354;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ffa354;\r\n}\r\n.has-warning .input-group-addon {\r\n    color: #ed6e00;\r\n    border-color: #ed6e00;\r\n    background-color: #fce9d9;\r\n}\r\n.has-warning .form-control {\r\n    background-color: #fce9d9;\r\n    color: #000;\r\n}\r\n.has-error .checkbox, .has-error .checkbox-inline, .has-error .control-label, .has-error .form-control-feedback, .has-error .help-block, .has-error .radio, .has-error .radio-inline, .has-error.checkbox label, .has-error.checkbox-inline label, .has-error.radio label, .has-error.radio-inline label {\r\n    color: #b01c38;\r\n}\r\n.has-error .form-control {\r\n    border-color: #b01c38;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n}\r\n.has-error .form-control:focus {\r\n    border-color: #84152a;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #e34f6b;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #e34f6b;\r\n}\r\n.has-error .input-group-addon {\r\n    color: #b01c38;\r\n    border-color: #b01c38;\r\n    background-color: #f3dde1;\r\n}\r\n.has-error .form-control {\r\n    background-color: #f3dde1;\r\n    color: #000;\r\n}\r\n.has-feedback label~.form-control-feedback {\r\n    top: 23px;\r\n}\r\n.has-feedback label.sr-only~.form-control-feedback {\r\n    top: 0;\r\n}\r\n.help-block {\r\n    display: block;\r\n    margin-top: 5px;\r\n    margin-bottom: 10px;\r\n    color: #404040;\r\n}\r\n@media (min-width:768px) {\r\n    .form-inline .form-control-static, .form-inline .form-group {\r\n    display: inline-block;\r\n}\r\n.form-inline .control-label, .form-inline .form-group {\r\n    margin-bottom: 0;\r\n    vertical-align: middle;\r\n}\r\n.form-inline .form-control {\r\n    display: inline-block;\r\n    width: auto;\r\n    vertical-align: middle;\r\n}\r\n.form-inline .input-group {\r\n    display: inline-table;\r\n    vertical-align: middle;\r\n}\r\n.form-inline .input-group .form-control, .form-inline .input-group .input-group-addon, .form-inline .input-group .input-group-btn {\r\n    width: auto;\r\n}\r\n.form-inline .input-group>.form-control {\r\n    width: 100%}\r\n.form-inline .checkbox, .form-inline .radio {\r\n    display: inline-block;\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n    vertical-align: middle;\r\n}\r\n.form-inline .checkbox label, .form-inline .radio label {\r\n    padding-left: 0;\r\n}\r\n.form-inline .checkbox input[type=checkbox], .form-inline .radio input[type=radio] {\r\n    position: relative;\r\n    margin-left: 0;\r\n}\r\n.form-inline .has-feedback .form-control-feedback {\r\n    top: 0;\r\n}\r\n.form-horizontal .control-label {\r\n    text-align: right;\r\n    margin-bottom: 0;\r\n    padding-top: 4px;\r\n}\r\n}\r\n.btn-block, input[type=button].btn-block, input[type=reset].btn-block, input[type=submit].btn-block {\r\n    width: 100%}\r\n.form-horizontal .checkbox, .form-horizontal .checkbox-inline, .form-horizontal .radio, .form-horizontal .radio-inline {\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n    padding-top: 4px;\r\n}\r\n.form-horizontal .checkbox, .form-horizontal .radio {\r\n    min-height: 22px;\r\n}\r\n.form-horizontal .form-group {\r\n    margin-left: -15px;\r\n    margin-right: -15px;\r\n}\r\n.form-horizontal .has-feedback .form-control-feedback {\r\n    right: 15px;\r\n}\r\n@media (min-width:768px) {\r\n    .form-horizontal .form-group-lg .control-label {\r\n    padding-top: 11.67px;\r\n    font-size: 15px;\r\n}\r\n.form-horizontal .form-group-sm .control-label {\r\n    padding-top: 6px;\r\n    font-size: 12px;\r\n}\r\n}\r\n.btn {\r\n    display: inline-block;\r\n    margin-bottom: 0;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    touch-action: manipulation;\r\n    cursor: pointer;\r\n    border: 1px solid transparent;\r\n}\r\n.btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {\r\n    outline: dotted thin;\r\n    outline: -webkit-focus-ring-color auto 5px;\r\n    outline-offset: -2px;\r\n}\r\n.btn.focus, .btn:focus, .btn:hover {\r\n    color: #333;\r\n    text-decoration: none;\r\n}\r\n.btn.active, .btn:active {\r\n    outline: 0;\r\n    -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\r\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\r\n}\r\n.btn.disabled, .btn[disabled], fieldset[disabled] .btn {\r\n    cursor: not-allowed;\r\n    opacity: .65;\r\n    filter: alpha(opacity=65);\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n}\r\na.btn.disabled, fieldset[disabled] a.btn {\r\n    pointer-events: none;\r\n}\r\n.btn-link {\r\n    color: #0962ac;\r\n    font-weight: 400;\r\n    border-radius: 0;\r\n}\r\n.btn-link, .btn-link.active, .btn-link:active, .btn-link[disabled], fieldset[disabled] .btn-link {\r\n    background-color: transparent;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n}\r\n.btn-link, .btn-link:active, .btn-link:focus, .btn-link:hover {\r\n    border-color: transparent;\r\n}\r\n.btn-link:focus, .btn-link:hover {\r\n    color: #0962ac;\r\n    text-decoration: underline;\r\n    background-color: transparent;\r\n}\r\n.btn-link[disabled]:focus, .btn-link[disabled]:hover, fieldset[disabled] .btn-link:focus, fieldset[disabled] .btn-link:hover {\r\n    color: grey;\r\n    text-decoration: none;\r\n}\r\n.btn-group-lg>.btn, .btn-lg {\r\n    padding: 8px 12px;\r\n    font-size: 15px;\r\n    line-height: 1.3333333;\r\n    border-radius: 6px;\r\n}\r\n.btn-group-sm>.btn, .btn-sm {\r\n    padding: 5px 10px;\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n    border-radius: 3px;\r\n}\r\n.btn-group-xs>.btn, .btn-xs {\r\n    padding: 1px 5px;\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n    border-radius: 3px;\r\n}\r\n.btn-block {\r\n    display: block;\r\n}\r\n.btn-block+.btn-block {\r\n    margin-top: 5px;\r\n}\r\n.fade {\r\n    opacity: 0;\r\n    -webkit-transition: opacity .15s linear;\r\n    -o-transition: opacity .15s linear;\r\n    transition: opacity .15s linear;\r\n}\r\n.fade.in {\r\n    opacity: 1;\r\n}\r\n.collapse {\r\n    display: none;\r\n}\r\n.collapse.in {\r\n    display: block;\r\n}\r\ntr.collapse.in {\r\n    display: table-row;\r\n}\r\ntbody.collapse.in {\r\n    display: table-row-group;\r\n}\r\n.collapsing {\r\n    height: 0;\r\n    overflow: hidden;\r\n    -webkit-transition-property: height, visibility;\r\n    transition-property: height, visibility;\r\n    -webkit-transition-duration: .35s;\r\n    transition-duration: .35s;\r\n    -webkit-transition-timing-function: ease;\r\n    transition-timing-function: ease;\r\n}\r\n.caret {\r\n    display: inline-block;\r\n    width: 0;\r\n    height: 0;\r\n    margin-left: 2px;\r\n    border-top: 4px dashed;\r\n    border-top: 4px solid\\9;\r\n    border-right: 4px solid transparent;\r\n    border-left: 4px solid transparent;\r\n}\r\n.dropdown-toggle:focus {\r\n    outline: 0;\r\n}\r\n.dropdown-menu {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    z-index: 1000;\r\n    display: none;\r\n    min-width: 160px;\r\n    margin: 2px 0 0;\r\n    font-size: 13px;\r\n    text-align: left;\r\n    background-color: #fff;\r\n    border: 1px solid #e6e6e6;\r\n    border-radius: 4px;\r\n    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\r\n    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\r\n    background-clip: padding-box;\r\n}\r\n.dropdown-menu-right, .dropdown-menu.pull-right {\r\n    left: auto;\r\n    right: 0;\r\n}\r\n.btn-group-vertical>.btn:not(:first-child):not(:last-child), .btn-group>.btn-group:not(:first-child):not(:last-child)>.btn, .btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\r\n    border-radius: 0;\r\n}\r\n.dropdown-menu .divider {\r\n    height: 1px;\r\n    margin: 8px 0;\r\n    overflow: hidden;\r\n    background-color: #e5e5e5;\r\n}\r\n.dropdown-menu>li>a {\r\n    display: block;\r\n    clear: both;\r\n    font-weight: 400;\r\n    color: #404040;\r\n}\r\n.dropdown-menu>li>a:focus, .dropdown-menu>li>a:hover {\r\n    text-decoration: none;\r\n    color: #000;\r\n    background-color: rgba(0, 0, 0, .06);\r\n}\r\n.dropdown-menu>.active>a, .dropdown-menu>.active>a:focus, .dropdown-menu>.active>a:hover {\r\n    color: #000;\r\n    text-decoration: none;\r\n    outline: 0;\r\n    background-color: #b3d9ff;\r\n}\r\n.dropdown-menu>.disabled>a, .dropdown-menu>.disabled>a:focus, .dropdown-menu>.disabled>a:hover {\r\n    color: grey;\r\n}\r\n.dropdown-menu>.disabled>a:focus, .dropdown-menu>.disabled>a:hover {\r\n    text-decoration: none;\r\n    background-color: transparent;\r\n    background-image: none;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\r\n    cursor: not-allowed;\r\n}\r\n.open>.dropdown-menu {\r\n    display: block;\r\n}\r\n.open>a {\r\n    outline: 0;\r\n}\r\n.dropdown-menu-left {\r\n    left: 0;\r\n    right: auto;\r\n}\r\n.dropdown-header {\r\n    display: block;\r\n    padding: 3px 20px;\r\n    font-size: 12px;\r\n    color: grey;\r\n}\r\n.dropdown-backdrop {\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    top: 0;\r\n    z-index: 990;\r\n}\r\n.nav-justified>.dropdown .dropdown-menu, .nav-tabs.nav-justified>.dropdown .dropdown-menu {\r\n    top: auto;\r\n    left: auto;\r\n}\r\n.pull-right>.dropdown-menu {\r\n    right: 0;\r\n    left: auto;\r\n}\r\n.dropup .caret, .navbar-fixed-bottom .dropdown .caret {\r\n    border-top: 0;\r\n    border-bottom: 4px dashed;\r\n    border-bottom: 4px solid\\9;\r\n    content: \"\"}\r\n.dropup .dropdown-menu, .navbar-fixed-bottom .dropdown .dropdown-menu {\r\n    top: auto;\r\n    bottom: 100%;\r\n    margin-bottom: 2px;\r\n}\r\n@media (min-width:480px) {\r\n    .navbar-right .dropdown-menu {\r\n    left: auto;\r\n    right: 0;\r\n}\r\n.navbar-right .dropdown-menu-left {\r\n    left: 0;\r\n    right: auto;\r\n}\r\n}\r\n.btn-group, .btn-group-vertical {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n.btn-group-vertical>.btn, .btn-group>.btn {\r\n    position: relative;\r\n    float: left;\r\n}\r\n.btn-group-vertical>.btn.active, .btn-group-vertical>.btn:active, .btn-group-vertical>.btn:focus, .btn-group-vertical>.btn:hover, .btn-group>.btn.active, .btn-group>.btn:active, .btn-group>.btn:focus, .btn-group>.btn:hover {\r\n    z-index: 2;\r\n}\r\n.btn-group .btn+.btn, .btn-group .btn+.btn-group, .btn-group .btn-group+.btn, .btn-group .btn-group+.btn-group {\r\n    margin-left: -1px;\r\n}\r\n.btn-toolbar {\r\n    margin-left: -5px;\r\n}\r\n.btn-toolbar>.btn, .btn-toolbar>.btn-group, .btn-toolbar>.input-group {\r\n    margin-left: 5px;\r\n}\r\n.btn .caret, .btn-group>.btn:first-child {\r\n    margin-left: 0;\r\n}\r\n.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {\r\n    border-bottom-right-radius: 0;\r\n    border-top-right-radius: 0;\r\n}\r\n.btn-group>.btn:last-child:not(:first-child), .btn-group>.dropdown-toggle:not(:first-child) {\r\n    border-bottom-left-radius: 0;\r\n    border-top-left-radius: 0;\r\n}\r\n.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child, .btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle {\r\n    border-bottom-right-radius: 0;\r\n    border-top-right-radius: 0;\r\n}\r\n.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child {\r\n    border-bottom-left-radius: 0;\r\n    border-top-left-radius: 0;\r\n}\r\n.btn-group .dropdown-toggle:active, .btn-group.open .dropdown-toggle {\r\n    outline: 0;\r\n}\r\n.btn-group>.btn+.dropdown-toggle {\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n}\r\n.btn-group>.btn-lg+.dropdown-toggle {\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n}\r\n.btn-group.open .dropdown-toggle {\r\n    -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\r\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\r\n}\r\n.btn-group.open .dropdown-toggle.btn-link {\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n}\r\n.btn-lg .caret {\r\n    border-width: 5px 5px 0;\r\n}\r\n.dropup .btn-lg .caret {\r\n    border-width: 0 5px 5px;\r\n}\r\n.btn-group-vertical>.btn, .btn-group-vertical>.btn-group, .btn-group-vertical>.btn-group>.btn {\r\n    display: block;\r\n    float: none;\r\n    width: 100%;\r\n    max-width: 100%}\r\n.btn-group-vertical>.btn-group>.btn {\r\n    float: none;\r\n}\r\n.btn-group-vertical>.btn+.btn, .btn-group-vertical>.btn+.btn-group, .btn-group-vertical>.btn-group+.btn, .btn-group-vertical>.btn-group+.btn-group {\r\n    margin-top: -1px;\r\n    margin-left: 0;\r\n}\r\n.btn-group-vertical>.btn:first-child:not(:last-child) {\r\n    border-top-right-radius: 4px;\r\n    border-bottom-right-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n}\r\n.btn-group-vertical>.btn:last-child:not(:first-child) {\r\n    border-bottom-left-radius: 4px;\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 0;\r\n}\r\n.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn {\r\n    border-radius: 0;\r\n}\r\n.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child, .btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle {\r\n    border-bottom-right-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n}\r\n.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child {\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 0;\r\n}\r\n.btn-group-justified {\r\n    display: table;\r\n    width: 100%;\r\n    table-layout: fixed;\r\n    border-collapse: separate;\r\n}\r\n.btn-group-justified>.btn, .btn-group-justified>.btn-group {\r\n    float: none;\r\n    display: table-cell;\r\n    width: 1%}\r\n.btn-group-justified>.btn-group .btn {\r\n    width: 100%}\r\n.btn-group-justified>.btn-group .dropdown-menu {\r\n    left: auto;\r\n}\r\n[data-toggle=buttons]>.btn input[type=checkbox], [data-toggle=buttons]>.btn input[type=radio], [data-toggle=buttons]>.btn-group>.btn input[type=checkbox], [data-toggle=buttons]>.btn-group>.btn input[type=radio] {\r\n    position: absolute;\r\n    clip: rect(0, 0, 0, 0);\r\n    pointer-events: none;\r\n}\r\n.input-group, .input-group-btn, .input-group-btn>.btn, .nav>li, .nav>li>a, .navbar {\r\n    position: relative;\r\n}\r\n.input-group {\r\n    display: table;\r\n    border-collapse: separate;\r\n}\r\n.input-group[class*=col-] {\r\n    float: none;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n}\r\n.input-group .form-control {\r\n    position: relative;\r\n    z-index: 2;\r\n    float: left;\r\n    width: 100%;\r\n    margin-bottom: 0;\r\n}\r\n.input-group-lg>.form-control, .input-group-lg>.input-group-addon, .input-group-lg>.input-group-btn>.btn {\r\n    height: 38px;\r\n    padding: 8px 12px;\r\n    font-size: 15px;\r\n    line-height: 1.3333333;\r\n    border-radius: 6px;\r\n}\r\nselect.input-group-lg>.form-control, select.input-group-lg>.input-group-addon, select.input-group-lg>.input-group-btn>.btn {\r\n    height: 38px;\r\n    line-height: 38px;\r\n}\r\nselect[multiple].input-group-lg>.form-control, select[multiple].input-group-lg>.input-group-addon, select[multiple].input-group-lg>.input-group-btn>.btn, textarea.input-group-lg>.form-control, textarea.input-group-lg>.input-group-addon, textarea.input-group-lg>.input-group-btn>.btn {\r\n    height: auto;\r\n}\r\n.input-group-sm>.form-control, .input-group-sm>.input-group-addon, .input-group-sm>.input-group-btn>.btn {\r\n    height: 30px;\r\n    padding: 5px 10px;\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n    border-radius: 3px;\r\n}\r\nselect.input-group-sm>.form-control, select.input-group-sm>.input-group-addon, select.input-group-sm>.input-group-btn>.btn {\r\n    height: 30px;\r\n    line-height: 30px;\r\n}\r\nselect[multiple].input-group-sm>.form-control, select[multiple].input-group-sm>.input-group-addon, select[multiple].input-group-sm>.input-group-btn>.btn, textarea.input-group-sm>.form-control, textarea.input-group-sm>.input-group-addon, textarea.input-group-sm>.input-group-btn>.btn {\r\n    height: auto;\r\n}\r\n.input-group .form-control, .input-group-addon, .input-group-btn {\r\n    display: table-cell;\r\n}\r\n.nav>li, .nav>li>a {\r\n    display: block;\r\n}\r\n.input-group .form-control:not(:first-child):not(:last-child), .input-group-addon:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child) {\r\n    border-radius: 0;\r\n}\r\n.input-group-addon, .input-group-btn {\r\n    width: 1%;\r\n    white-space: nowrap;\r\n    vertical-align: middle;\r\n}\r\n.input-group-addon {\r\n    padding: 3px 5px;\r\n    font-size: 13px;\r\n    font-weight: 400;\r\n    line-height: 1;\r\n    color: #000;\r\n    text-align: center;\r\n    background-color: #e6e6e6;\r\n    border: 1px solid silver;\r\n    border-radius: 4px;\r\n}\r\n.input-group-addon.input-sm {\r\n    padding: 5px 10px;\r\n    font-size: 12px;\r\n    border-radius: 3px;\r\n}\r\n.input-group-addon.input-lg {\r\n    padding: 8px 12px;\r\n    font-size: 15px;\r\n    border-radius: 6px;\r\n}\r\n.input-group-addon input[type=checkbox], .input-group-addon input[type=radio] {\r\n    margin-top: 0;\r\n}\r\n.input-group .form-control:first-child, .input-group-addon:first-child, .input-group-btn:first-child>.btn, .input-group-btn:first-child>.btn-group>.btn, .input-group-btn:first-child>.dropdown-toggle, .input-group-btn:last-child>.btn-group:not(:last-child)>.btn, .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle) {\r\n    border-bottom-right-radius: 0;\r\n    border-top-right-radius: 0;\r\n}\r\n.input-group-addon:first-child {\r\n    border-right: 0;\r\n}\r\n.input-group .form-control:last-child, .input-group-addon:last-child, .input-group-btn:first-child>.btn-group:not(:first-child)>.btn, .input-group-btn:first-child>.btn:not(:first-child), .input-group-btn:last-child>.btn, .input-group-btn:last-child>.btn-group>.btn, .input-group-btn:last-child>.dropdown-toggle {\r\n    border-bottom-left-radius: 0;\r\n    border-top-left-radius: 0;\r\n}\r\n.input-group-addon:last-child {\r\n    border-left: 0;\r\n}\r\n.input-group-btn {\r\n    font-size: 0;\r\n}\r\n.input-group-btn>.btn+.btn {\r\n    margin-left: -1px;\r\n}\r\n.input-group-btn>.btn:active, .input-group-btn>.btn:focus, .input-group-btn>.btn:hover {\r\n    z-index: 2;\r\n}\r\n.input-group-btn:first-child>.btn, .input-group-btn:first-child>.btn-group {\r\n    margin-right: -1px;\r\n}\r\n.input-group-btn:last-child>.btn, .input-group-btn:last-child>.btn-group {\r\n    z-index: 2;\r\n    margin-left: -1px;\r\n}\r\n.nav {\r\n    margin-bottom: 0;\r\n    padding-left: 0;\r\n}\r\n.nav>li>a:focus, .nav>li>a:hover {\r\n    text-decoration: none;\r\n    background-color: #dadada;\r\n}\r\n.nav>li.disabled>a {\r\n    color: grey;\r\n}\r\n.nav>li.disabled>a:focus, .nav>li.disabled>a:hover {\r\n    color: grey;\r\n    text-decoration: none;\r\n    background-color: transparent;\r\n    cursor: not-allowed;\r\n}\r\n.nav .open>a, .nav .open>a:focus, .nav .open>a:hover {\r\n    background-color: #dadada;\r\n    border-color: #0962ac;\r\n}\r\n.nav .nav-divider {\r\n    height: 1px;\r\n    margin: 8px 0;\r\n    overflow: hidden;\r\n    background-color: #e5e5e5;\r\n}\r\n.nav>li>a>img {\r\n    max-width: none;\r\n}\r\n.nav-tabs {\r\n    border-bottom: 1px solid silver;\r\n}\r\n.nav-tabs>li {\r\n    float: left;\r\n    margin-bottom: -1px;\r\n}\r\n.nav-tabs>li>a {\r\n    line-height: 1.42857143;\r\n    border: 1px solid transparent;\r\n    border-radius: 4px 4px 0 0;\r\n}\r\n.nav-tabs>li>a:hover {\r\n    border-color: silver;\r\n}\r\n.nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover {\r\n    color: #555;\r\n    background-color: #fff;\r\n    border: 1px solid silver;\r\n    border-bottom-color: transparent;\r\n    cursor: default;\r\n}\r\n.nav-tabs>li>div {\r\n    padding: 4px 15px;\r\n}\r\n.nav-tabs.nav-justified {\r\n    width: 100%;\r\n    border-bottom: 0;\r\n}\r\n.nav-tabs.nav-justified>li {\r\n    float: none;\r\n}\r\n.nav-tabs.nav-justified>li>a {\r\n    text-align: center;\r\n    margin-bottom: 5px;\r\n    margin-right: 0;\r\n    border-radius: 4px;\r\n}\r\n.nav-tabs.nav-justified>.active>a, .nav-tabs.nav-justified>.active>a:focus, .nav-tabs.nav-justified>.active>a:hover {\r\n    border: 1px solid #ddd;\r\n}\r\n@media (min-width:768px) {\r\n    .nav-tabs.nav-justified>li {\r\n    display: table-cell;\r\n    width: 1%}\r\n.nav-tabs.nav-justified>li>a {\r\n    margin-bottom: 0;\r\n    border-bottom: 1px solid #ddd;\r\n    border-radius: 4px 4px 0 0;\r\n}\r\n.nav-tabs.nav-justified>.active>a, .nav-tabs.nav-justified>.active>a:focus, .nav-tabs.nav-justified>.active>a:hover {\r\n    border-bottom-color: #fff;\r\n}\r\n}\r\n.nav-pills>li {\r\n    float: left;\r\n}\r\n.nav-justified>li, .nav-stacked>li {\r\n    float: none;\r\n}\r\n.nav-pills>li>a {\r\n    border-radius: 4px;\r\n}\r\n.nav-pills>li+li {\r\n    margin-left: 2px;\r\n}\r\n.nav-pills>li.active>a, .nav-pills>li.active>a:focus, .nav-pills>li.active>a:hover {\r\n    color: #000;\r\n    background-color: #80bfff;\r\n}\r\n.nav-stacked>li+li {\r\n    margin-top: 2px;\r\n    margin-left: 0;\r\n}\r\n.nav-justified {\r\n    width: 100%}\r\n.nav-justified>li>a {\r\n    text-align: center;\r\n    margin-bottom: 5px;\r\n}\r\n.nav-tabs-justified {\r\n    border-bottom: 0;\r\n}\r\n.nav-tabs-justified>li>a {\r\n    margin-right: 0;\r\n    border-radius: 4px;\r\n}\r\n.nav-tabs-justified>.active>a, .nav-tabs-justified>.active>a:focus, .nav-tabs-justified>.active>a:hover {\r\n    border: 1px solid #ddd;\r\n}\r\n@media (min-width:768px) {\r\n    .nav-justified>li {\r\n    display: table-cell;\r\n    width: 1%}\r\n.nav-justified>li>a {\r\n    margin-bottom: 0;\r\n}\r\n.nav-tabs-justified>li>a {\r\n    border-bottom: 1px solid #ddd;\r\n    border-radius: 4px 4px 0 0;\r\n}\r\n.nav-tabs-justified>.active>a, .nav-tabs-justified>.active>a:focus, .nav-tabs-justified>.active>a:hover {\r\n    border-bottom-color: #fff;\r\n}\r\n}\r\n.tab-content>.tab-pane {\r\n    display: none;\r\n}\r\n.tab-content>.active {\r\n    display: block;\r\n}\r\n.nav-tabs .dropdown-menu {\r\n    margin-top: -1px;\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 0;\r\n}\r\n.navbar {\r\n    min-height: 40px;\r\n    margin-bottom: 18px;\r\n    border: 1px solid transparent;\r\n}\r\n.navbar-collapse {\r\n    overflow-x: visible;\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n    border-top: 1px solid transparent;\r\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n.navbar-collapse.in {\r\n    overflow-y: auto;\r\n}\r\n@media (min-width:480px) {\r\n    .navbar {\r\n    border-radius: 4px;\r\n}\r\n.navbar-header {\r\n    float: left;\r\n}\r\n.navbar-collapse {\r\n    width: auto;\r\n    border-top: 0;\r\n    box-shadow: none;\r\n}\r\n.navbar-collapse.collapse {\r\n    display: block!important;\r\n    height: auto!important;\r\n    padding-bottom: 0;\r\n    overflow: visible!important;\r\n}\r\n.navbar-collapse.in {\r\n    overflow-y: visible;\r\n}\r\n.navbar-fixed-bottom .navbar-collapse, .navbar-fixed-top .navbar-collapse, .navbar-static-top .navbar-collapse {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n}\r\n}\r\n.carousel-inner, .embed-responsive, .modal, .modal-open, .progress {\r\n    overflow: hidden;\r\n}\r\n@media (max-device-width:480px) and (orientation:landscape) {\r\n    .navbar-fixed-bottom .navbar-collapse, .navbar-fixed-top .navbar-collapse {\r\n    max-height: 200px;\r\n}\r\n}\r\n.container-fluid>.navbar-collapse, .container-fluid>.navbar-header, .container>.navbar-collapse, .container>.navbar-header {\r\n    margin-right: -15px;\r\n    margin-left: -15px;\r\n}\r\n.navbar-static-top {\r\n    z-index: 1000;\r\n    border-width: 0 0 1px;\r\n}\r\n.navbar-fixed-bottom, .navbar-fixed-top {\r\n    position: fixed;\r\n    right: 0;\r\n    left: 0;\r\n    z-index: 1030;\r\n}\r\n.navbar-fixed-top {\r\n    top: 0;\r\n    border-width: 0 0 1px;\r\n}\r\n.navbar-fixed-bottom {\r\n    bottom: 0;\r\n    margin-bottom: 0;\r\n    border-width: 1px 0 0;\r\n}\r\n.navbar-brand {\r\n    padding: 0px;\r\n    font-size: 15px;\r\n    line-height: 18px;\r\n    display:block;\r\n}\r\n.navbar-brand:focus, .navbar-brand:hover {\r\n    text-decoration: none;\r\n}\r\n.navbar-brand>img {\r\n    display: block;\r\n}\r\n@media (min-width:480px) {\r\n    .container-fluid>.navbar-collapse, .container-fluid>.navbar-header, .container>.navbar-collapse, .container>.navbar-header {\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n}\r\n.navbar-fixed-bottom, .navbar-fixed-top, .navbar-static-top {\r\n    border-radius: 0;\r\n}\r\n.navbar>.container .navbar-brand, .navbar>.container-fluid .navbar-brand {\r\n    margin-left: -15px;\r\n}\r\n}\r\n.navbar-toggle {\r\n    position: relative;\r\n    float: right;\r\n    margin-right: 15px;\r\n    padding: 9px 10px;\r\n    margin-top: 3px;\r\n    margin-bottom: 3px;\r\n    background-color: transparent;\r\n    border: 1px solid transparent;\r\n    border-radius: 4px;\r\n}\r\n.navbar-toggle:focus {\r\n    outline: 0;\r\n}\r\n.navbar-toggle .ai-bar {\r\n    display: block;\r\n    width: 22px;\r\n    height: 2px;\r\n    border-radius: 1px;\r\n}\r\n.navbar-toggle .ai-bar+.ai-bar {\r\n    margin-top: 4px;\r\n}\r\n.navbar-nav {\r\n    margin: 5.5px -15px;\r\n}\r\n.navbar-nav>li>a {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    line-height: 18px;\r\n}\r\n@media (max-width:479px) {\r\n    .navbar-nav .open .dropdown-menu {\r\n    position: static;\r\n    float: none;\r\n    width: auto;\r\n    margin-top: 0;\r\n    background-color: transparent;\r\n    border: 0;\r\n    box-shadow: none;\r\n}\r\n.navbar-nav .open .dropdown-menu .dropdown-header, .navbar-nav .open .dropdown-menu>li>a {\r\n    padding: 5px 15px 5px 25px;\r\n}\r\n.navbar-nav .open .dropdown-menu>li>a {\r\n    line-height: 18px;\r\n}\r\n.navbar-nav .open .dropdown-menu>li>a:focus, .navbar-nav .open .dropdown-menu>li>a:hover {\r\n    background-image: none;\r\n}\r\n}\r\n.progress-bar-striped, .progress-striped .progress-bar, .progress-striped .progress-bar-success {\r\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n}\r\n@media (min-width:480px) {\r\n    .navbar-toggle {\r\n    display: none;\r\n}\r\n.navbar-nav {\r\n    float: left;\r\n    margin: 0;\r\n}\r\n.navbar-nav>li {\r\n    float: left;\r\n}\r\n.navbar-nav>li>a {\r\n    padding-top: 11px;\r\n    padding-bottom: 11px;\r\n}\r\n}\r\n.navbar-form {\r\n    padding: 10px 15px;\r\n    border-top: 1px solid transparent;\r\n    border-bottom: 1px solid transparent;\r\n    -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);\r\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);\r\n    margin: 7px -15px;\r\n}\r\n@media (min-width:768px) {\r\n    .navbar-form .form-control-static, .navbar-form .form-group {\r\n    display: inline-block;\r\n}\r\n.navbar-form .control-label, .navbar-form .form-group {\r\n    margin-bottom: 0;\r\n    vertical-align: middle;\r\n}\r\n.navbar-form .form-control {\r\n    display: inline-block;\r\n    width: auto;\r\n    vertical-align: middle;\r\n}\r\n.navbar-form .input-group {\r\n    display: inline-table;\r\n    vertical-align: middle;\r\n}\r\n.navbar-form .input-group .form-control, .navbar-form .input-group .input-group-addon, .navbar-form .input-group .input-group-btn {\r\n    width: auto;\r\n}\r\n.navbar-form .input-group>.form-control {\r\n    width: 100%}\r\n.navbar-form .checkbox, .navbar-form .radio {\r\n    display: inline-block;\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n    vertical-align: middle;\r\n}\r\n.navbar-form .checkbox label, .navbar-form .radio label {\r\n    padding-left: 0;\r\n}\r\n.navbar-form .checkbox input[type=checkbox], .navbar-form .radio input[type=radio] {\r\n    position: relative;\r\n    margin-left: 0;\r\n}\r\n.navbar-form .has-feedback .form-control-feedback {\r\n    top: 0;\r\n}\r\n}\r\n.breadcrumb>li, .pagination {\r\n    display: inline-block;\r\n}\r\n.btn .badge, .btn .label {\r\n    top: -1px;\r\n    position: relative;\r\n}\r\n.navbar-form>* {\r\n    margin-right: 5px;\r\n}\r\n@media (max-width:479px) {\r\n    .navbar-form .form-group {\r\n    margin-bottom: 5px;\r\n}\r\n.navbar-form .form-group:last-child {\r\n    margin-bottom: 0;\r\n}\r\n}\r\n@media (min-width:480px) {\r\n    .navbar-form {\r\n    width: auto;\r\n    border: 0;\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n}\r\n.navbar-text {\r\n    float: left;\r\n    margin-left: 15px;\r\n    margin-right: 15px;\r\n}\r\n.navbar-left {\r\n    float: left!important;\r\n}\r\n.navbar-right {\r\n    float: right!important;\r\n    margin-right: -15px;\r\n}\r\n.navbar-right~.navbar-right {\r\n    margin-right: 0;\r\n}\r\n}\r\n.navbar-nav>li>.dropdown-menu {\r\n    margin-top: 0;\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 0;\r\n}\r\n.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu {\r\n    margin-bottom: 0;\r\n    border-radius: 4px 4px 0 0;\r\n}\r\n.navbar-btn {\r\n    margin-top: 7px;\r\n    margin-bottom: 7px;\r\n}\r\n.navbar-btn.btn-sm {\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n}\r\n.navbar-btn.btn-xs {\r\n    margin-top: 9px;\r\n    margin-bottom: 9px;\r\n}\r\n.navbar-text {\r\n    margin-top: 11px;\r\n    margin-bottom: 11px;\r\n}\r\n.navbar-default {\r\n    background-color: #f8f8f8;\r\n    border-color: silver;\r\n    max-height: 40px;\r\n}\r\n.navbar-default .navbar-brand {\r\n    color: #404040;\r\n}\r\n.navbar-default .navbar-brand:focus, .navbar-default .navbar-brand:hover {\r\n    color: #272727;\r\n    background-color: transparent;\r\n}\r\n.navbar-default .navbar-text {\r\n    color: #777;\r\n}\r\n.navbar-default .navbar-nav>li>a {\r\n    color: #404040;\r\n}\r\n.navbar-default .navbar-nav>li>a:focus, .navbar-default .navbar-nav>li>a:hover {\r\n    color: #000;\r\n    background-color: rgba(0, 0, 0, .06);\r\n}\r\n.navbar-default .navbar-nav>.active>a, .navbar-default .navbar-nav>.active>a:focus, .navbar-default .navbar-nav>.active>a:hover {\r\n    color: #000;\r\n    background-color: rgba(0, 0, 0, .18);\r\n}\r\n.navbar-default .navbar-nav>.disabled>a, .navbar-default .navbar-nav>.disabled>a:focus, .navbar-default .navbar-nav>.disabled>a:hover {\r\n    color: #ccc;\r\n    background-color: transparent;\r\n}\r\n.navbar-default .navbar-toggle {\r\n    border-color: grey;\r\n}\r\n.navbar-default .navbar-toggle:focus, .navbar-default .navbar-toggle:hover {\r\n    background-color: #ddd;\r\n}\r\n.navbar-default .navbar-toggle .ai-bar {\r\n    background-color: #888;\r\n}\r\n.navbar-default .navbar-collapse, .navbar-default .navbar-form {\r\n    border-color: silver;\r\n}\r\n.navbar-default .navbar-nav>.open>a, .navbar-default .navbar-nav>.open>a:focus, .navbar-default .navbar-nav>.open>a:hover {\r\n    background-color: rgba(0, 0, 0, .18);\r\n    color: #000;\r\n}\r\n@media (max-width:479px) {\r\n    .navbar-default .navbar-nav .open .dropdown-menu>li>a {\r\n    color: #404040;\r\n}\r\n.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus, .navbar-default .navbar-nav .open .dropdown-menu>li>a:hover {\r\n    color: #000;\r\n    background-color: rgba(0, 0, 0, .06);\r\n}\r\n.navbar-default .navbar-nav .open .dropdown-menu>.active>a, .navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus, .navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover {\r\n    color: #000;\r\n    background-color: rgba(0, 0, 0, .18);\r\n}\r\n.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a, .navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus, .navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover {\r\n    color: #ccc;\r\n    background-color: transparent;\r\n}\r\n}\r\n.navbar-default .navbar-link {\r\n    color: #404040;\r\n}\r\n.navbar-default .navbar-link:hover {\r\n    color: #000;\r\n}\r\n.navbar-default .btn-link {\r\n    color: #404040;\r\n}\r\n.navbar-default .btn-link:focus, .navbar-default .btn-link:hover {\r\n    color: #000;\r\n}\r\n.navbar-default .btn-link[disabled]:focus, .navbar-default .btn-link[disabled]:hover, fieldset[disabled] .navbar-default .btn-link:focus, fieldset[disabled] .navbar-default .btn-link:hover {\r\n    color: #ccc;\r\n}\r\n.navbar-inverse {\r\n    background-color: #222;\r\n    border-color: #404040;\r\n}\r\n.navbar-inverse .navbar-brand {\r\n    color: #e6e6e6;\r\n}\r\n.navbar-inverse .navbar-brand:focus, .navbar-inverse .navbar-brand:hover {\r\n    color: #fff;\r\n    background-color: transparent;\r\n}\r\n.navbar-inverse .navbar-text {\r\n    color: #a6a6a6;\r\n}\r\n.navbar-inverse .navbar-nav>li>a {\r\n    color: #e6e6e6;\r\n}\r\n.navbar-inverse .navbar-nav>li>a:focus, .navbar-inverse .navbar-nav>li>a:hover {\r\n    color: #fff;\r\n    background-color: rgba(255, 255, 255, .09);\r\n}\r\n.navbar-inverse .navbar-nav>.active>a, .navbar-inverse .navbar-nav>.active>a:focus, .navbar-inverse .navbar-nav>.active>a:hover {\r\n    color: #fff;\r\n    background-color: rgba(0, 0, 0, .3);\r\n}\r\n.navbar-inverse .navbar-nav>.disabled>a, .navbar-inverse .navbar-nav>.disabled>a:focus, .navbar-inverse .navbar-nav>.disabled>a:hover {\r\n    color: #444;\r\n    background-color: transparent;\r\n}\r\n.navbar-inverse .navbar-toggle {\r\n    border-color: #000;\r\n}\r\n.navbar-inverse .navbar-toggle:focus, .navbar-inverse .navbar-toggle:hover {\r\n    background-color: #333;\r\n}\r\n.navbar-inverse .navbar-toggle .ai-bar {\r\n    background-color: #fff;\r\n}\r\n.navbar-inverse .navbar-collapse, .navbar-inverse .navbar-form {\r\n    border-color: #101010;\r\n}\r\n.navbar-inverse .navbar-nav>.open>a, .navbar-inverse .navbar-nav>.open>a:focus, .navbar-inverse .navbar-nav>.open>a:hover {\r\n    background-color: rgba(0, 0, 0, .3);\r\n    color: #fff;\r\n}\r\n@media (max-width:479px) {\r\n    .navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header {\r\n    border-color: #404040;\r\n}\r\n.navbar-inverse .navbar-nav .open .dropdown-menu .divider {\r\n    background-color: #404040;\r\n}\r\n.navbar-inverse .navbar-nav .open .dropdown-menu>li>a {\r\n    color: #e6e6e6;\r\n}\r\n.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus, .navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover {\r\n    color: #fff;\r\n    background-color: rgba(255, 255, 255, .09);\r\n}\r\n.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a, .navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus, .navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover {\r\n    color: #fff;\r\n    background-color: rgba(0, 0, 0, .3);\r\n}\r\n.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a, .navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus, .navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover {\r\n    color: #444;\r\n    background-color: transparent;\r\n}\r\n}\r\n.navbar-inverse .navbar-link {\r\n    color: #e6e6e6;\r\n}\r\n.navbar-inverse .navbar-link:hover {\r\n    color: #fff;\r\n}\r\n.navbar-inverse .btn-link {\r\n    color: #e6e6e6;\r\n}\r\n.navbar-inverse .btn-link:focus, .navbar-inverse .btn-link:hover {\r\n    color: #fff;\r\n}\r\n.navbar-inverse .btn-link[disabled]:focus, .navbar-inverse .btn-link[disabled]:hover, fieldset[disabled] .navbar-inverse .btn-link:focus, fieldset[disabled] .navbar-inverse .btn-link:hover {\r\n    color: #444;\r\n}\r\n.breadcrumb {\r\n    padding: 8px 15px;\r\n    margin-bottom: 18px;\r\n    background-color: #f5f5f5;\r\n    border-radius: 4px;\r\n}\r\n.breadcrumb>li+li:before {\r\n    content: \"/\\00a0\";\r\n    padding: 0 5px;\r\n    color: #ccc;\r\n}\r\n.breadcrumb>.active {\r\n    color: grey;\r\n}\r\n.pagination {\r\n    padding-left: 0;\r\n    margin: 18px 0;\r\n    border-radius: 4px;\r\n}\r\n.pager li, .pagination>li {\r\n    display: inline;\r\n}\r\n.pagination>li>a, .pagination>li>span {\r\n    position: relative;\r\n    float: left;\r\n    padding: 3px 5px;\r\n    line-height: 1.42857143;\r\n    text-decoration: none;\r\n    color: #0962ac;\r\n    background-color: #fff;\r\n    border: 1px solid #ddd;\r\n    margin-left: -1px;\r\n}\r\n.pagination>li:first-child>a, .pagination>li:first-child>span {\r\n    margin-left: 0;\r\n    border-bottom-left-radius: 4px;\r\n    border-top-left-radius: 4px;\r\n}\r\n.pagination>li:last-child>a, .pagination>li:last-child>span {\r\n    border-bottom-right-radius: 4px;\r\n    border-top-right-radius: 4px;\r\n}\r\n.pagination>li>a:focus, .pagination>li>a:hover, .pagination>li>span:focus, .pagination>li>span:hover {\r\n    z-index: 3;\r\n    color: #0962ac;\r\n    background-color: #e6e6e6;\r\n    border-color: #ddd;\r\n}\r\n.pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 2;\r\n    color: #fff;\r\n    background-color: #39f;\r\n    border-color: #39f;\r\n    cursor: default;\r\n}\r\n.pagination>.disabled>a, .pagination>.disabled>a:focus, .pagination>.disabled>a:hover, .pagination>.disabled>span, .pagination>.disabled>span:focus, .pagination>.disabled>span:hover {\r\n    color: grey;\r\n    background-color: #fff;\r\n    border-color: #ddd;\r\n    cursor: not-allowed;\r\n}\r\n.pagination-lg>li>a, .pagination-lg>li>span {\r\n    padding: 8px 12px;\r\n    font-size: 15px;\r\n    line-height: 1.3333333;\r\n}\r\n.pagination-lg>li:first-child>a, .pagination-lg>li:first-child>span {\r\n    border-bottom-left-radius: 6px;\r\n    border-top-left-radius: 6px;\r\n}\r\n.pagination-lg>li:last-child>a, .pagination-lg>li:last-child>span {\r\n    border-bottom-right-radius: 6px;\r\n    border-top-right-radius: 6px;\r\n}\r\n.pagination-sm>li>a, .pagination-sm>li>span {\r\n    padding: 5px 10px;\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n}\r\n.badge, .label {\r\n    font-weight: 700;\r\n    line-height: 1;\r\n    text-align: center;\r\n}\r\n.pagination-sm>li:first-child>a, .pagination-sm>li:first-child>span {\r\n    border-bottom-left-radius: 3px;\r\n    border-top-left-radius: 3px;\r\n}\r\n.pagination-sm>li:last-child>a, .pagination-sm>li:last-child>span {\r\n    border-bottom-right-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n}\r\n.pager {\r\n    padding-left: 0;\r\n    margin: 18px 0;\r\n    text-align: center;\r\n}\r\n.pager li>a, .pager li>span {\r\n    display: inline-block;\r\n    padding: 5px 14px;\r\n    background-color: #fff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 15px;\r\n}\r\n.pager li>a:focus, .pager li>a:hover {\r\n    text-decoration: none;\r\n    background-color: #e6e6e6;\r\n}\r\n.pager .next>a, .pager .next>span {\r\n    float: right;\r\n}\r\n.pager .previous>a, .pager .previous>span {\r\n    float: left;\r\n}\r\n.pager .disabled>a, .pager .disabled>a:focus, .pager .disabled>a:hover, .pager .disabled>span {\r\n    color: grey;\r\n    background-color: #fff;\r\n    cursor: not-allowed;\r\n}\r\na.badge:focus, a.badge:hover, a.label:focus, a.label:hover {\r\n    color: #fff;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n}\r\n.label {\r\n    display: inline;\r\n    padding: .2em .6em .3em;\r\n    font-size: 75%;\r\n    color: #fff;\r\n    vertical-align: baseline;\r\n    border-radius: .25em;\r\n}\r\n.label:empty {\r\n    display: none;\r\n}\r\n.label-default {\r\n    background-color: grey;\r\n}\r\n.label-default[href]:focus, .label-default[href]:hover {\r\n    background-color: #676767;\r\n}\r\n.label-primary {\r\n    background-color: #39f;\r\n}\r\n.label-primary[href]:focus, .label-primary[href]:hover {\r\n    background-color: #007fff;\r\n}\r\n.label-success {\r\n    background-color: #37A320;\r\n}\r\n.label-success[href]:focus, .label-success[href]:hover {\r\n    background-color: #297818;\r\n}\r\n.label-info {\r\n    background-color: #39f;\r\n}\r\n.label-info[href]:focus, .label-info[href]:hover {\r\n    background-color: #007fff;\r\n}\r\n.label-warning {\r\n    background-color: #ed6e00;\r\n}\r\n.label-warning[href]:focus, .label-warning[href]:hover {\r\n    background-color: #ba5600;\r\n}\r\n.label-danger {\r\n    background-color: #b01c38;\r\n}\r\n.label-danger[href]:focus, .label-danger[href]:hover {\r\n    background-color: #84152a;\r\n}\r\n.badge {\r\n    display: inline-block;\r\n    min-width: 10px;\r\n    padding: 3px 7px;\r\n    font-size: 12px;\r\n    color: #fff;\r\n    vertical-align: middle;\r\n    background-color: grey;\r\n    border-radius: 10px;\r\n}\r\n.badge:empty {\r\n    display: none;\r\n}\r\n.media-object, .thumbnail {\r\n    display: block;\r\n}\r\n.btn-group-xs>.btn .badge, .btn-xs .badge {\r\n    top: 0;\r\n    padding: 1px 5px;\r\n}\r\n.list-group-item.active>.badge, .nav-pills>.active>a>.badge {\r\n    color: #0962ac;\r\n    background-color: #fff;\r\n}\r\n.jumbotron, .jumbotron .h1, .jumbotron h1 {\r\n    color: inherit;\r\n}\r\n.list-group-item>.badge {\r\n    float: right;\r\n}\r\n.list-group-item>.badge+.badge {\r\n    margin-right: 5px;\r\n}\r\n.nav-pills>li>a>.badge {\r\n    margin-left: 3px;\r\n}\r\n.jumbotron {\r\n    padding-top: 30px;\r\n    padding-bottom: 30px;\r\n    margin-bottom: 30px;\r\n    background-color: #e6e6e6;\r\n}\r\n.jumbotron p {\r\n    margin-bottom: 15px;\r\n    font-size: 20px;\r\n    font-weight: 200;\r\n}\r\n.alert, .thumbnail {\r\n    margin-bottom: 18px;\r\n}\r\n.alert .alert-link, .close {\r\n    font-weight: 700;\r\n}\r\n.jumbotron>hr {\r\n    border-top-color: #cdcdcd;\r\n}\r\n.container .jumbotron, .container-fluid .jumbotron {\r\n    border-radius: 6px;\r\n}\r\n.jumbotron .container {\r\n    max-width: 100%}\r\n@media screen and (min-width:768px) {\r\n    .jumbotron {\r\n    padding-top: 48px;\r\n    padding-bottom: 48px;\r\n}\r\n.container .jumbotron, .container-fluid .jumbotron {\r\n    padding-left: 60px;\r\n    padding-right: 60px;\r\n}\r\n.jumbotron .h1, .jumbotron h1 {\r\n    font-size: 59px;\r\n}\r\n}\r\n.thumbnail {\r\n    padding: 4px;\r\n    line-height: 1.42857143;\r\n    background-color: #fff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    -webkit-transition: border .2s ease-in-out;\r\n    -o-transition: border .2s ease-in-out;\r\n    transition: border .2s ease-in-out;\r\n}\r\n.thumbnail a>img, .thumbnail>img {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\na.thumbnail.active, a.thumbnail:focus, a.thumbnail:hover {\r\n    border-color: #0962ac;\r\n}\r\n.thumbnail .caption {\r\n    padding: 9px;\r\n    color: #000;\r\n}\r\n.alert {\r\n    padding: 8px;\r\n    border: 1px solid transparent;\r\n    border-radius: 4px;\r\n}\r\n.alert h4 {\r\n    margin-top: 0;\r\n    color: inherit;\r\n}\r\n.alert>p, .alert>ul {\r\n    margin-bottom: 0;\r\n}\r\n.alert>p+p {\r\n    margin-top: 5px;\r\n}\r\n.alert-dismissable, .alert-dismissible {\r\n    padding-right: 28px;\r\n}\r\n.alert-dismissable .close, .alert-dismissible .close {\r\n    position: relative;\r\n    top: -2px;\r\n    right: -21px;\r\n    color: inherit;\r\n}\r\n.modal, .modal-backdrop {\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n}\r\n.alert-success {\r\n    background-color: #e1f1de;\r\n}\r\n.alert-success hr {\r\n    border-top-color: #308e1c;\r\n}\r\n.alert-success .alert-link {\r\n    color: #272727;\r\n}\r\n.alert-info {\r\n    background-color: #e0f0ff;\r\n    border-color: #39f;\r\n    color: #404040;\r\n}\r\n.alert-warning {\r\n    background-color: #fce9d9;\r\n}\r\n.alert-warning hr {\r\n    border-top-color: #d46200;\r\n}\r\n.alert-warning .alert-link {\r\n    color: #272727;\r\n}\r\n.alert-danger {\r\n    background-color: #f3dde1;\r\n    border-color: #b01c38;\r\n    color: #404040;\r\n}\r\n@-webkit-keyframes progress-bar-stripes {\r\n    from {\r\n    background-position: 40px 0;\r\n}\r\nto {\r\n    background-position: 0 0;\r\n}\r\n}\r\n@keyframes progress-bar-stripes {\r\n    from {\r\n    background-position: 40px 0;\r\n}\r\nto {\r\n    background-position: 0 0;\r\n}\r\n}\r\n.progress {\r\n    height: 18px;\r\n    margin-bottom: 18px;\r\n    background-color: #f5f5f5;\r\n    border-radius: 4px;\r\n    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\r\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);\r\n}\r\n.progress-bar {\r\n    float: left;\r\n    width: 0;\r\n    height: 100%;\r\n    font-size: 12px;\r\n    line-height: 18px;\r\n    color: #fff;\r\n    text-align: center;\r\n    background-color: #39f;\r\n    -webkit-box-shadow: inset 0 -1px 0 #e6e6e6;\r\n    box-shadow: inset 0 -1px 0 #e6e6e6;\r\n    -webkit-transition: width .6s ease;\r\n    -o-transition: width .6s ease;\r\n    transition: width .6s ease;\r\n}\r\n.carousel-inner>.item>a>img, .carousel-inner>.item>img, .close {\r\n    line-height: 1;\r\n}\r\n.progress-bar-striped, .progress-striped .progress-bar {\r\n    background-size: 40px 40px;\r\n}\r\n.progress-bar.active, .progress.active .progress-bar {\r\n    -webkit-animation: progress-bar-stripes 2s linear infinite;\r\n    -o-animation: progress-bar-stripes 2s linear infinite;\r\n    animation: progress-bar-stripes 2s linear infinite;\r\n}\r\n.progress-bar-success {\r\n    background-color: #37A320;\r\n}\r\n.progress-striped .progress-bar-info, .progress-striped .progress-bar-warning {\r\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n}\r\n.progress-bar-info {\r\n    background-color: #39f;\r\n}\r\n.progress-bar-warning {\r\n    background-color: #ed6e00;\r\n}\r\n.progress-bar-danger {\r\n    background-color: #b01c38;\r\n}\r\n.progress-striped .progress-bar-danger {\r\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n}\r\n.media {\r\n    margin-top: 15px;\r\n}\r\n.media:first-child {\r\n    margin-top: 0;\r\n}\r\n.media, .media-body {\r\n    transform:scale(1.0);\r\n    transform-origin: 0 0;\r\n    overflow: hidden;\r\n}\r\n.media-body {\r\n    width: 10000px;\r\n}\r\n.media-object.img-thumbnail {\r\n    max-width: none;\r\n}\r\n.media-right, .media>.pull-right {\r\n    padding-left: 10px;\r\n}\r\n.media-left, .media>.pull-left {\r\n    padding-right: 10px;\r\n}\r\n.media-body, .media-left, .media-right {\r\n    display: table-cell;\r\n    vertical-align: top;\r\n}\r\n.btn-group-hover, .form-inline span, .media-middle, .tag-icon {\r\n    vertical-align: middle;\r\n}\r\n.media-bottom {\r\n    vertical-align: bottom;\r\n}\r\n.media-heading {\r\n    margin-top: 0;\r\n    margin-bottom: 5px;\r\n}\r\n.media-list {\r\n    padding-left: 0;\r\n}\r\n.list-group {\r\n    margin-bottom: 20px;\r\n    padding-left: 0;\r\n}\r\n.list-group-item {\r\n    position: relative;\r\n    display: block;\r\n    background-color: inherit;\r\n    border: 1px solid #e6e6e6;\r\n}\r\n.list-group-item:first-child {\r\n    border-top-right-radius: 4px;\r\n    border-top-left-radius: 4px;\r\n}\r\n.list-group-item:last-child {\r\n    margin-bottom: 0;\r\n    border-bottom-right-radius: 4px;\r\n    border-bottom-left-radius: 4px;\r\n}\r\na.list-group-item, a.list-group-item .list-group-item-heading, button.list-group-item, button.list-group-item .list-group-item-heading {\r\n    color: #000;\r\n}\r\na.list-group-item:focus, a.list-group-item:hover, button.list-group-item:focus, button.list-group-item:hover {\r\n    outline: 0;\r\n    text-decoration: none;\r\n    color: #000;\r\n    background-color: rgba(0, 0, 0, .06);\r\n}\r\nbutton.list-group-item {\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n.list-group-item.disabled, .list-group-item.disabled:focus, .list-group-item.disabled:hover {\r\n    color: grey;\r\n    cursor: not-allowed;\r\n}\r\n.list-group-item.disabled .list-group-item-heading, .list-group-item.disabled:focus .list-group-item-heading, .list-group-item.disabled:hover .list-group-item-heading {\r\n    color: inherit;\r\n}\r\n.list-group-item.disabled .list-group-item-text, .list-group-item.disabled:focus .list-group-item-text, .list-group-item.disabled:hover .list-group-item-text {\r\n    color: grey;\r\n}\r\n.list-group-item.active, .list-group-item.active:focus, .list-group-item.active:hover {\r\n    z-index: 2;\r\n    color: #000;\r\n    background-color: #b3d9ff;\r\n    border-color: #e6e6e6;\r\n}\r\n.list-group-item.active .list-group-item-heading, .list-group-item.active .list-group-item-heading>.small, .list-group-item.active .list-group-item-heading>small, .list-group-item.active:focus .list-group-item-heading, .list-group-item.active:focus .list-group-item-heading>.small, .list-group-item.active:focus .list-group-item-heading>small, .list-group-item.active:hover .list-group-item-heading, .list-group-item.active:hover .list-group-item-heading>.small, .list-group-item.active:hover .list-group-item-heading>small {\r\n    color: inherit;\r\n}\r\n.list-group-item.active .list-group-item-text, .list-group-item.active:focus .list-group-item-text, .list-group-item.active:hover .list-group-item-text {\r\n    color: #000;\r\n}\r\n.list-group-item-success {\r\n    color: #37A320;\r\n    background-color: #e1f1de;\r\n}\r\na.list-group-item-success, button.list-group-item-success {\r\n    color: #37A320;\r\n}\r\na.list-group-item-success .list-group-item-heading, button.list-group-item-success .list-group-item-heading {\r\n    color: inherit;\r\n}\r\na.list-group-item-success:focus, a.list-group-item-success:hover, button.list-group-item-success:focus, button.list-group-item-success:hover {\r\n    color: #37A320;\r\n    background-color: #d1eacb;\r\n}\r\na.list-group-item-success.active, a.list-group-item-success.active:focus, a.list-group-item-success.active:hover, button.list-group-item-success.active, button.list-group-item-success.active:focus, button.list-group-item-success.active:hover {\r\n    color: #fff;\r\n    background-color: #37A320;\r\n    border-color: #37A320;\r\n}\r\n.list-group-item-info {\r\n    color: #39f;\r\n    background-color: #e0f0ff;\r\n}\r\na.list-group-item-info, button.list-group-item-info {\r\n    color: #39f;\r\n}\r\na.list-group-item-info .list-group-item-heading, button.list-group-item-info .list-group-item-heading {\r\n    color: inherit;\r\n}\r\na.list-group-item-info:focus, a.list-group-item-info:hover, button.list-group-item-info:focus, button.list-group-item-info:hover {\r\n    color: #39f;\r\n    background-color: #c7e3ff;\r\n}\r\na.list-group-item-info.active, a.list-group-item-info.active:focus, a.list-group-item-info.active:hover, button.list-group-item-info.active, button.list-group-item-info.active:focus, button.list-group-item-info.active:hover {\r\n    color: #fff;\r\n    background-color: #39f;\r\n    border-color: #39f;\r\n}\r\n.list-group-item-warning {\r\n    color: #ed6e00;\r\n    background-color: #fce9d9;\r\n}\r\na.list-group-item-warning, button.list-group-item-warning {\r\n    color: #ed6e00;\r\n}\r\na.list-group-item-warning .list-group-item-heading, button.list-group-item-warning .list-group-item-heading {\r\n    color: inherit;\r\n}\r\na.list-group-item-warning:focus, a.list-group-item-warning:hover, button.list-group-item-warning:focus, button.list-group-item-warning:hover {\r\n    color: #ed6e00;\r\n    background-color: #fbdcc1;\r\n}\r\na.list-group-item-warning.active, a.list-group-item-warning.active:focus, a.list-group-item-warning.active:hover, button.list-group-item-warning.active, button.list-group-item-warning.active:focus, button.list-group-item-warning.active:hover {\r\n    color: #fff;\r\n    background-color: #ed6e00;\r\n    border-color: #ed6e00;\r\n}\r\n.list-group-item-danger {\r\n    color: #b01c38;\r\n    background-color: #f3dde1;\r\n}\r\na.list-group-item-danger, button.list-group-item-danger {\r\n    color: #b01c38;\r\n}\r\na.list-group-item-danger .list-group-item-heading, button.list-group-item-danger .list-group-item-heading {\r\n    color: inherit;\r\n}\r\na.list-group-item-danger:focus, a.list-group-item-danger:hover, button.list-group-item-danger:focus, button.list-group-item-danger:hover {\r\n    color: #b01c38;\r\n    background-color: #edcad1;\r\n}\r\na.list-group-item-danger.active, a.list-group-item-danger.active:focus, a.list-group-item-danger.active:hover, button.list-group-item-danger.active, button.list-group-item-danger.active:focus, button.list-group-item-danger.active:hover {\r\n    color: #fff;\r\n    background-color: #b01c38;\r\n    border-color: #b01c38;\r\n}\r\n.panel-heading>.dropdown .dropdown-toggle, .panel-title, .panel-title>.small, .panel-title>.small>a, .panel-title>a, .panel-title>small, .panel-title>small>a {\r\n    color: inherit;\r\n    width: min-content;\r\n}\r\n.list-group-item-heading {\r\n    margin-top: 0;\r\n    margin-bottom: 5px;\r\n}\r\n.list-group-item-text {\r\n    margin-bottom: 0;\r\n}\r\n.panel {\r\n    margin-bottom: 18px;\r\n    background-color: #fff;\r\n    border: 1px solid transparent;\r\n    border-radius: 4px;\r\n    -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);\r\n    box-shadow: 0 1px 1px rgba(0, 0, 0, .05);\r\n}\r\n.panel-title, .panel>.list-group, .panel>.panel-collapse>.list-group, .panel>.panel-collapse>.table, .panel>.table, .panel>.table-responsive>.table {\r\n    margin-bottom: 0;\r\n}\r\n.panel-body {\r\n    padding: 10px;\r\n    min-width: min-content;\r\n}\r\n.panel-heading {\r\n    padding: 10px 15px;\r\n    border-bottom: 1px solid transparent;\r\n    border-top-right-radius: 3px;\r\n    border-top-left-radius: 3px;\r\n}\r\n.panel-title {\r\n    margin-top: 0;\r\n    font-size: 15px;\r\n}\r\n.panel>.list-group .list-group-item, .panel>.panel-collapse>.list-group .list-group-item {\r\n    border-width: 1px 0;\r\n    border-radius: 0;\r\n}\r\n.panel-group .panel-heading, .panel>.table-bordered>tbody>tr:first-child>td, .panel>.table-bordered>tbody>tr:first-child>th, .panel>.table-bordered>tbody>tr:last-child>td, .panel>.table-bordered>tbody>tr:last-child>th, .panel>.table-bordered>tfoot>tr:last-child>td, .panel>.table-bordered>tfoot>tr:last-child>th, .panel>.table-bordered>thead>tr:first-child>td, .panel>.table-bordered>thead>tr:first-child>th, .panel>.table-responsive>.table-bordered>tbody>tr:first-child>td, .panel>.table-responsive>.table-bordered>tbody>tr:first-child>th, .panel>.table-responsive>.table-bordered>tbody>tr:last-child>td, .panel>.table-responsive>.table-bordered>tbody>tr:last-child>th, .panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td, .panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th, .panel>.table-responsive>.table-bordered>thead>tr:first-child>td, .panel>.table-responsive>.table-bordered>thead>tr:first-child>th {\r\n    border-bottom: 0;\r\n}\r\n.panel>.table-responsive:last-child>.table:last-child, .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child, .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child, .panel>.table:last-child, .panel>.table:last-child>tbody:last-child>tr:last-child, .panel>.table:last-child>tfoot:last-child>tr:last-child {\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px;\r\n}\r\n.panel>.list-group:first-child .list-group-item:first-child, .panel>.panel-collapse>.list-group:first-child .list-group-item:first-child {\r\n    border-top: 0;\r\n    border-top-right-radius: 3px;\r\n    border-top-left-radius: 3px;\r\n}\r\n.panel>.list-group:last-child .list-group-item:last-child, .panel>.panel-collapse>.list-group:last-child .list-group-item:last-child {\r\n    border-bottom: 0;\r\n    border-bottom-right-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n}\r\n.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child {\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 0;\r\n}\r\n.panel>.table-responsive:first-child>.table:first-child, .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child, .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child, .panel>.table:first-child, .panel>.table:first-child>tbody:first-child>tr:first-child, .panel>.table:first-child>thead:first-child>tr:first-child {\r\n    border-top-right-radius: 3px;\r\n    border-top-left-radius: 3px;\r\n}\r\n.list-group+.panel-footer, .panel-heading+.list-group .list-group-item:first-child {\r\n    border-top-width: 0;\r\n}\r\n.panel>.panel-collapse>.table caption, .panel>.table caption, .panel>.table-responsive>.table caption {\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n}\r\n.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child, .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child, .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child, .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child, .panel>.table:first-child>tbody:first-child>tr:first-child td:first-child, .panel>.table:first-child>tbody:first-child>tr:first-child th:first-child, .panel>.table:first-child>thead:first-child>tr:first-child td:first-child, .panel>.table:first-child>thead:first-child>tr:first-child th:first-child {\r\n    border-top-left-radius: 3px;\r\n}\r\n.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child, .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child, .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child, .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child, .panel>.table:first-child>tbody:first-child>tr:first-child td:last-child, .panel>.table:first-child>tbody:first-child>tr:first-child th:last-child, .panel>.table:first-child>thead:first-child>tr:first-child td:last-child, .panel>.table:first-child>thead:first-child>tr:first-child th:last-child {\r\n    border-top-right-radius: 3px;\r\n}\r\n.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child, .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child, .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child, .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child, .panel>.table:last-child>tbody:last-child>tr:last-child td:first-child, .panel>.table:last-child>tbody:last-child>tr:last-child th:first-child, .panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child, .panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child {\r\n    border-bottom-left-radius: 3px;\r\n}\r\n.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child, .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child, .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child, .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child, .panel>.table:last-child>tbody:last-child>tr:last-child td:last-child, .panel>.table:last-child>tbody:last-child>tr:last-child th:last-child, .panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child, .panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child {\r\n    border-bottom-right-radius: 3px;\r\n}\r\n.panel>.panel-body+.table, .panel>.panel-body+.table-responsive, .panel>.table+.panel-body, .panel>.table-responsive+.panel-body {\r\n    border-top: 1px solid #e6e6e6;\r\n}\r\n.panel>.table>tbody:first-child>tr:first-child td, .panel>.table>tbody:first-child>tr:first-child th {\r\n    border-top: 0;\r\n}\r\n.panel>.table-bordered, .panel>.table-responsive>.table-bordered {\r\n    border: 0;\r\n}\r\n.panel>.table-bordered>tbody>tr>td:first-child, .panel>.table-bordered>tbody>tr>th:first-child, .panel>.table-bordered>tfoot>tr>td:first-child, .panel>.table-bordered>tfoot>tr>th:first-child, .panel>.table-bordered>thead>tr>td:first-child, .panel>.table-bordered>thead>tr>th:first-child, .panel>.table-responsive>.table-bordered>tbody>tr>td:first-child, .panel>.table-responsive>.table-bordered>tbody>tr>th:first-child, .panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child, .panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child, .panel>.table-responsive>.table-bordered>thead>tr>td:first-child, .panel>.table-responsive>.table-bordered>thead>tr>th:first-child {\r\n    border-left: 0;\r\n}\r\n.panel>.table-bordered>tbody>tr>td:last-child, .panel>.table-bordered>tbody>tr>th:last-child, .panel>.table-bordered>tfoot>tr>td:last-child, .panel>.table-bordered>tfoot>tr>th:last-child, .panel>.table-bordered>thead>tr>td:last-child, .panel>.table-bordered>thead>tr>th:last-child, .panel>.table-responsive>.table-bordered>tbody>tr>td:last-child, .panel>.table-responsive>.table-bordered>tbody>tr>th:last-child, .panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child, .panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child, .panel>.table-responsive>.table-bordered>thead>tr>td:last-child, .panel>.table-responsive>.table-bordered>thead>tr>th:last-child {\r\n    border-right: 0;\r\n}\r\n.panel>.table-responsive {\r\n    border: 0;\r\n    margin-bottom: 0;\r\n}\r\n.panel-group {\r\n    margin-bottom: 18px;\r\n}\r\n.panel-group .panel {\r\n    margin-bottom: 0;\r\n    border-radius: 4px;\r\n}\r\n.panel-group .panel+.panel {\r\n    margin-top: 5px;\r\n}\r\n.panel-group .panel-heading+.panel-collapse>.list-group, .panel-group .panel-heading+.panel-collapse>.panel-body {\r\n    border-top: 1px solid #ddd;\r\n}\r\n.panel-group .panel-footer {\r\n    border-top: 0;\r\n}\r\n.panel-group .panel-footer+.panel-collapse .panel-body {\r\n    border-bottom: 1px solid #ddd;\r\n}\r\n.panel-primary {\r\n    border-color: #39f;\r\n}\r\n.panel-primary>.panel-heading {\r\n    color: #fff;\r\n    background-color: #39f;\r\n    border-color: #39f;\r\n}\r\n.panel-primary>.panel-heading+.panel-collapse>.panel-body {\r\n    border-top-color: #39f;\r\n}\r\n.panel-primary>.panel-heading .badge {\r\n    color: #39f;\r\n    background-color: #fff;\r\n}\r\n.panel-primary>.panel-footer+.panel-collapse>.panel-body {\r\n    border-bottom-color: #39f;\r\n}\r\n.panel-primary>.panel-heading {\r\n    border-bottom: 1px solid grey;\r\n}\r\n.panel-success {\r\n    border-color: #37A320;\r\n}\r\n.panel-success>.panel-heading {\r\n    color: #37A320;\r\n    background-color: #e1f1de;\r\n    border-color: #37A320;\r\n}\r\n.panel-success>.panel-heading+.panel-collapse>.panel-body {\r\n    border-top-color: #37A320;\r\n}\r\n.panel-success>.panel-heading .badge {\r\n    color: #e1f1de;\r\n    background-color: #37A320;\r\n}\r\n.panel-success>.panel-footer+.panel-collapse>.panel-body {\r\n    border-bottom-color: #37A320;\r\n}\r\n.panel-success>.panel-heading {\r\n    border-bottom: 1px solid grey;\r\n}\r\n.panel-info {\r\n    border-color: #39f;\r\n}\r\n.panel-info>.panel-heading {\r\n    color: #39f;\r\n    background-color: #e0f0ff;\r\n    border-color: #39f;\r\n}\r\n.panel-info>.panel-heading+.panel-collapse>.panel-body {\r\n    border-top-color: #39f;\r\n}\r\n.panel-info>.panel-heading .badge {\r\n    color: #e0f0ff;\r\n    background-color: #39f;\r\n}\r\n.panel-info>.panel-footer+.panel-collapse>.panel-body {\r\n    border-bottom-color: #39f;\r\n}\r\n.panel-info>.panel-heading {\r\n    border-bottom: 1px solid grey;\r\n}\r\n.panel-warning {\r\n    border-color: #ed6e00;\r\n}\r\n.panel-warning>.panel-heading {\r\n    color: #ed6e00;\r\n    background-color: #fce9d9;\r\n    border-color: #ed6e00;\r\n}\r\n.panel-warning>.panel-heading+.panel-collapse>.panel-body {\r\n    border-top-color: #ed6e00;\r\n}\r\n.panel-warning>.panel-heading .badge {\r\n    color: #fce9d9;\r\n    background-color: #ed6e00;\r\n}\r\n.panel-warning>.panel-footer+.panel-collapse>.panel-body {\r\n    border-bottom-color: #ed6e00;\r\n}\r\n.panel-warning>.panel-heading {\r\n    border-bottom: 1px solid grey;\r\n}\r\n.panel-danger {\r\n    border-color: #b01c38;\r\n}\r\n.panel-danger>.panel-heading {\r\n    color: #b01c38;\r\n    background-color: #f3dde1;\r\n    border-color: #b01c38;\r\n}\r\n.panel-danger>.panel-heading+.panel-collapse>.panel-body {\r\n    border-top-color: #b01c38;\r\n}\r\n.panel-danger>.panel-heading .badge {\r\n    color: #f3dde1;\r\n    background-color: #b01c38;\r\n}\r\n.panel-danger>.panel-footer+.panel-collapse>.panel-body {\r\n    border-bottom-color: #b01c38;\r\n}\r\n.panel-danger>.panel-heading {\r\n    border-bottom: 1px solid grey;\r\n}\r\n.embed-responsive {\r\n    position: relative;\r\n    display: block;\r\n    height: 0;\r\n    padding: 0;\r\n}\r\n.embed-responsive .embed-responsive-item, .embed-responsive embed, .embed-responsive iframe, .embed-responsive object, .embed-responsive video {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    border: 0;\r\n}\r\n.embed-responsive-16by9 {\r\n    padding-bottom: 56.25%}\r\n.embed-responsive-4by3 {\r\n    padding-bottom: 75%}\r\n.well {\r\n    min-height: 20px;\r\n    padding: 19px;\r\n    margin-bottom: 20px;\r\n    background-color: #f5f5f5;\r\n    border: 1px solid #e3e3e3;\r\n    border-radius: 4px;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .05);\r\n}\r\n.well blockquote {\r\n    border-color: #e6e6e6;\r\n}\r\n.well-lg {\r\n    padding: 24px;\r\n    border-radius: 6px;\r\n}\r\n.well-sm {\r\n    padding: 9px;\r\n    border-radius: 3px;\r\n}\r\n.close {\r\n    float: right;\r\n    font-size: 19.5px;\r\n    color: #000;\r\n    text-shadow: 0 1px 0 #fff;\r\n}\r\n.popover, .tooltip {\r\n    font-family: \"Open Sans\", Verdana, sans-serif;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    letter-spacing: normal;\r\n    line-break: auto;\r\n    text-shadow: none;\r\n    text-transform: none;\r\n    white-space: normal;\r\n    word-break: normal;\r\n    word-spacing: normal;\r\n    word-wrap: normal;\r\n    text-decoration: none;\r\n    line-height: 1.42857143;\r\n}\r\n.close:focus, .close:hover {\r\n    color: #000;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    opacity: .5;\r\n    filter: alpha(opacity=50);\r\n}\r\nbutton.close {\r\n    padding: 0;\r\n    cursor: pointer;\r\n    background: 0 0;\r\n    border: 0;\r\n    -webkit-appearance: none;\r\n}\r\n.modal-content, .popover {\r\n    background-clip: padding-box;\r\n}\r\n.modal {\r\n    display: none;\r\n    position: fixed;\r\n    z-index: 1050;\r\n    -webkit-overflow-scrolling: touch;\r\n    outline: 0;\r\n}\r\n.modal.fade .modal-dialog {\r\n    -webkit-transform: translate(0, -25%);\r\n    -ms-transform: translate(0, -25%);\r\n    -o-transform: translate(0, -25%);\r\n    transform: translate(0, -25%);\r\n    -webkit-transition: -webkit-transform .3s ease-out;\r\n    -moz-transition: -moz-transform .3s ease-out;\r\n    -o-transition: -o-transform .3s ease-out;\r\n    transition: transform .3s ease-out;\r\n}\r\n.modal.in .modal-dialog {\r\n    -webkit-transform: translate(0, 0);\r\n    -ms-transform: translate(0, 0);\r\n    -o-transform: translate(0, 0);\r\n    transform: translate(0, 0);\r\n}\r\n.modal-open .modal {\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}\r\n.modal-dialog {\r\n    position: relative;\r\n    width: auto;\r\n    margin: 10px;\r\n}\r\n.modal-content {\r\n    position: relative;\r\n    background-color: #fff;\r\n    border: 1px solid #999;\r\n    border: 1px solid rgba(0, 0, 0, .2);\r\n    border-radius: 6px;\r\n    -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, .5);\r\n    box-shadow: 0 3px 9px rgba(0, 0, 0, .5);\r\n    outline: 0;\r\n}\r\n.modal-backdrop {\r\n    position: fixed;\r\n    z-index: 1040;\r\n    background-color: #000;\r\n}\r\n.modal-backdrop.fade {\r\n    opacity: 0;\r\n    filter: alpha(opacity=0);\r\n}\r\n.modal-backdrop.in {\r\n    opacity: .5;\r\n    filter: alpha(opacity=50);\r\n}\r\n.modal-header {\r\n    border-bottom: 1px solid silver;\r\n    min-height: 11.43px;\r\n}\r\n.modal-title {\r\n    margin: 0;\r\n    line-height: 1.42857143;\r\n}\r\n.modal-body {\r\n    position: relative;\r\n    padding: 10px;\r\n    min-height: 200px;\r\n}\r\n.modal-footer {\r\n    padding: 10px;\r\n    text-align: right;\r\n    border-top: 1px solid silver;\r\n}\r\n.modal-footer .btn+.btn {\r\n    margin-left: 5px;\r\n    margin-bottom: 0;\r\n}\r\n.modal-footer .btn-group .btn+.btn {\r\n    margin-left: -1px;\r\n}\r\n.modal-footer .btn-block+.btn-block {\r\n    margin-left: 0;\r\n}\r\n.modal-scrollbar-measure {\r\n    position: absolute;\r\n    top: -9999px;\r\n    width: 50px;\r\n    height: 50px;\r\n    overflow: scroll;\r\n}\r\n@media (min-width:768px) {\r\n    .modal-dialog {\r\n    width: 600px;\r\n    margin: 30px auto;\r\n}\r\n.modal-content {\r\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, .5);\r\n    box-shadow: 0 5px 15px rgba(0, 0, 0, .5);\r\n}\r\n.modal-sm {\r\n    width: 400px;\r\n}\r\n}\r\n@media (min-width:992px) {\r\n    .modal-lg {\r\n    width: 900px;\r\n}\r\n}\r\n.tooltip {\r\n    position: absolute;\r\n    z-index: 1070;\r\n    display: block;\r\n    text-align: left;\r\n    text-align: start;\r\n    font-size: 12px;\r\n    opacity: 0;\r\n    filter: alpha(opacity=0);\r\n}\r\n.tooltip.in {\r\n    opacity: 1;\r\n    filter: alpha(opacity=100);\r\n}\r\n.tooltip.top {\r\n    margin-top: -3px;\r\n    padding: 5px 0;\r\n}\r\n.tooltip.right {\r\n    margin-left: 3px;\r\n    padding: 0 5px;\r\n}\r\n.tooltip.bottom {\r\n    margin-top: 3px;\r\n    padding: 5px 0;\r\n}\r\n.tooltip.left {\r\n    margin-left: -3px;\r\n    padding: 0 5px;\r\n}\r\n.tooltip-inner {\r\n    max-width: 200px;\r\n    padding: 3px 8px;\r\n    color: #fff;\r\n    text-align: center;\r\n    background-color: #404040;\r\n    border-radius: 4px;\r\n}\r\n.tooltip-arrow {\r\n    position: absolute;\r\n    width: 0;\r\n    height: 0;\r\n    border-color: transparent;\r\n    border-style: solid;\r\n}\r\n.tooltip.top .tooltip-arrow, .tooltip.top-left .tooltip-arrow, .tooltip.top-right .tooltip-arrow {\r\n    bottom: 0;\r\n    border-width: 5px 5px 0;\r\n    border-top-color: #404040;\r\n}\r\n.tooltip.top .tooltip-arrow {\r\n    left: 50%;\r\n    margin-left: -5px;\r\n}\r\n.tooltip.top-left .tooltip-arrow {\r\n    right: 5px;\r\n    margin-bottom: -5px;\r\n}\r\n.tooltip.top-right .tooltip-arrow {\r\n    left: 5px;\r\n    margin-bottom: -5px;\r\n}\r\n.tooltip.right .tooltip-arrow {\r\n    top: 50%;\r\n    left: 0;\r\n    margin-top: -5px;\r\n    border-width: 5px 5px 5px 0;\r\n    border-right-color: #404040;\r\n}\r\n.tooltip.left .tooltip-arrow {\r\n    top: 50%;\r\n    right: 0;\r\n    margin-top: -5px;\r\n    border-width: 5px 0 5px 5px;\r\n    border-left-color: #404040;\r\n}\r\n.tooltip.bottom .tooltip-arrow, .tooltip.bottom-left .tooltip-arrow, .tooltip.bottom-right .tooltip-arrow {\r\n    border-width: 0 5px 5px;\r\n    border-bottom-color: #404040;\r\n    top: 0;\r\n}\r\n.tooltip.bottom .tooltip-arrow {\r\n    left: 50%;\r\n    margin-left: -5px;\r\n}\r\n.tooltip.bottom-left .tooltip-arrow {\r\n    right: 5px;\r\n    margin-top: -5px;\r\n}\r\n.tooltip.bottom-right .tooltip-arrow {\r\n    left: 5px;\r\n    margin-top: -5px;\r\n}\r\n.popover {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1060;\r\n    display: none;\r\n    max-width: 500px;\r\n    padding: 1px;\r\n    text-align: left;\r\n    text-align: start;\r\n    font-size: 13px;\r\n    background-color: #fff;\r\n    border: 1px solid #ccc;\r\n    border: 1px solid rgba(0, 0, 0, .2);\r\n    border-radius: 6px;\r\n    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, .2);\r\n    box-shadow: 0 5px 10px rgba(0, 0, 0, .2);\r\n}\r\n.carousel-caption, .carousel-control {\r\n    color: #fff;\r\n    text-align: center;\r\n    text-shadow: 0 1px 2px rgba(0, 0, 0, .6);\r\n}\r\n.popover.top {\r\n    margin-top: -10px;\r\n}\r\n.popover.right {\r\n    margin-left: 10px;\r\n}\r\n.popover.bottom {\r\n    margin-top: 10px;\r\n}\r\n.popover.left {\r\n    margin-left: -10px;\r\n}\r\n.popover-title {\r\n    margin: 0;\r\n    padding: 8px 14px;\r\n    font-size: 13px;\r\n    background-color: #f7f7f7;\r\n    border-bottom: 1px solid #ebebeb;\r\n    border-radius: 5px 5px 0 0;\r\n}\r\n.popover-content {\r\n    padding: 9px 14px;\r\n    overflow-y: auto;\r\n}\r\n.popover>.arrow, .popover>.arrow:after {\r\n    position: absolute;\r\n    display: block;\r\n    width: 0;\r\n    height: 0;\r\n    border-color: transparent;\r\n    border-style: solid;\r\n}\r\n.carousel, .carousel-inner {\r\n    position: relative;\r\n}\r\n.popover>.arrow {\r\n    border-width: 11px;\r\n}\r\n.popover>.arrow:after {\r\n    border-width: 10px;\r\n    content: \"\"}\r\n.popover.top>.arrow {\r\n    left: 50%;\r\n    margin-left: -11px;\r\n    border-bottom-width: 0;\r\n    border-top-color: #999;\r\n    border-top-color: rgba(0, 0, 0, .25);\r\n    bottom: -11px;\r\n}\r\n.popover.top>.arrow:after {\r\n    content: \" \";\r\n    bottom: 1px;\r\n    margin-left: -10px;\r\n    border-bottom-width: 0;\r\n    border-top-color: #fff;\r\n}\r\n.popover.left>.arrow:after, .popover.right>.arrow:after {\r\n    content: \" \";\r\n    bottom: -10px;\r\n}\r\n.popover.right>.arrow {\r\n    top: 50%;\r\n    left: -11px;\r\n    margin-top: -11px;\r\n    border-left-width: 0;\r\n    border-right-color: #999;\r\n    border-right-color: rgba(0, 0, 0, .25);\r\n}\r\n.popover.right>.arrow:after {\r\n    left: 1px;\r\n    border-left-width: 0;\r\n    border-right-color: #fff;\r\n}\r\n.popover.bottom>.arrow {\r\n    left: 50%;\r\n    margin-left: -11px;\r\n    border-top-width: 0;\r\n    border-bottom-color: #999;\r\n    border-bottom-color: rgba(0, 0, 0, .25);\r\n    top: -11px;\r\n}\r\n.popover.bottom>.arrow:after {\r\n    content: \" \";\r\n    top: 1px;\r\n    margin-left: -10px;\r\n    border-top-width: 0;\r\n    border-bottom-color: #fff;\r\n}\r\n.popover.left>.arrow {\r\n    top: 50%;\r\n    right: -11px;\r\n    margin-top: -11px;\r\n    border-right-width: 0;\r\n    border-left-color: #999;\r\n    border-left-color: rgba(0, 0, 0, .25);\r\n}\r\n.popover.left>.arrow:after {\r\n    right: 1px;\r\n    border-right-width: 0;\r\n    border-left-color: #fff;\r\n}\r\n.carousel-inner {\r\n    width: 100%}\r\n.carousel-inner>.item {\r\n    display: none;\r\n    position: relative;\r\n    -webkit-transition: .6s ease-in-out left;\r\n    -o-transition: .6s ease-in-out left;\r\n    transition: .6s ease-in-out left;\r\n}\r\n@media all and (transform-3d), (-webkit-transform-3d) {\r\n    .carousel-inner>.item {\r\n    -webkit-transition: -webkit-transform .6s ease-in-out;\r\n    -moz-transition: -moz-transform .6s ease-in-out;\r\n    -o-transition: -o-transform .6s ease-in-out;\r\n    transition: transform .6s ease-in-out;\r\n    -webkit-backface-visibility: hidden;\r\n    -moz-backface-visibility: hidden;\r\n    backface-visibility: hidden;\r\n    -webkit-perspective: 1000px;\r\n    -moz-perspective: 1000px;\r\n    perspective: 1000px;\r\n}\r\n.carousel-inner>.item.active.right, .carousel-inner>.item.next {\r\n    -webkit-transform: translate3d(100%, 0, 0);\r\n    transform: translate3d(100%, 0, 0);\r\n    left: 0;\r\n}\r\n.carousel-inner>.item.active.left, .carousel-inner>.item.prev {\r\n    -webkit-transform: translate3d(-100%, 0, 0);\r\n    transform: translate3d(-100%, 0, 0);\r\n    left: 0;\r\n}\r\n.carousel-inner>.item.active, .carousel-inner>.item.next.left, .carousel-inner>.item.prev.right {\r\n    -webkit-transform: translate3d(0, 0, 0);\r\n    transform: translate3d(0, 0, 0);\r\n    left: 0;\r\n}\r\n}\r\n.carousel-inner>.active, .carousel-inner>.next, .carousel-inner>.prev {\r\n    display: block;\r\n}\r\n.carousel-inner>.active {\r\n    left: 0;\r\n}\r\n.carousel-inner>.next, .carousel-inner>.prev {\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100%}\r\n.carousel-inner>.next {\r\n    left: 100%}\r\n.carousel-inner>.prev {\r\n    left: -100%}\r\n.carousel-inner>.next.left, .carousel-inner>.prev.right {\r\n    left: 0;\r\n}\r\n.carousel-inner>.active.left {\r\n    left: -100%}\r\n.carousel-inner>.active.right {\r\n    left: 100%}\r\n.carousel-control {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    width: 15%;\r\n    opacity: .5;\r\n    filter: alpha(opacity=50);\r\n    font-size: 20px;\r\n}\r\n.carousel-control.left {\r\n    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, .5) 0, rgba(0, 0, 0, .0001) 100%);\r\n    background-image: -o-linear-gradient(left, rgba(0, 0, 0, .5) 0, rgba(0, 0, 0, .0001) 100%);\r\n    background-image: linear-gradient(to right, rgba(0, 0, 0, .5) 0, rgba(0, 0, 0, .0001) 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);\r\n}\r\n.carousel-control.right {\r\n    left: auto;\r\n    right: 0;\r\n    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, .0001) 0, rgba(0, 0, 0, .5) 100%);\r\n    background-image: -o-linear-gradient(left, rgba(0, 0, 0, .0001) 0, rgba(0, 0, 0, .5) 100%);\r\n    background-image: linear-gradient(to right, rgba(0, 0, 0, .0001) 0, rgba(0, 0, 0, .5) 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);\r\n}\r\n.carousel-control:focus, .carousel-control:hover {\r\n    outline: 0;\r\n    color: #fff;\r\n    text-decoration: none;\r\n    opacity: .9;\r\n    filter: alpha(opacity=90);\r\n}\r\n.carousel-control .glyphicon-chevron-left, .carousel-control .glyphicon-chevron-right, .carousel-control .ai-next, .carousel-control .ai-prev {\r\n    position: absolute;\r\n    top: 50%;\r\n    margin-top: -10px;\r\n    z-index: 5;\r\n    display: inline-block;\r\n}\r\n.alert-superimposed.top-left, .alert-superimposed.top-right {\r\n    top: 20px;\r\n}\r\n.carousel-control .glyphicon-chevron-left, .carousel-control .ai-prev {\r\n    left: 50%;\r\n    margin-left: -10px;\r\n}\r\n.carousel-control .glyphicon-chevron-right, .carousel-control .ai-next {\r\n    right: 50%;\r\n    margin-right: -10px;\r\n}\r\n.carousel-control .ai-next, .carousel-control .ai-prev {\r\n    width: 20px;\r\n    height: 20px;\r\n    line-height: 1;\r\n    font-family: serif;\r\n}\r\n.carousel-control .ai-prev:before {\r\n    content: '\\2039'}\r\n.carousel-control .ai-next:before {\r\n    content: '\\203a'}\r\n.carousel-indicators {\r\n    position: absolute;\r\n    bottom: 10px;\r\n    left: 50%;\r\n    z-index: 15;\r\n    width: 60%;\r\n    margin-left: -30%;\r\n    padding-left: 0;\r\n    text-align: center;\r\n}\r\n.alert-superimposed.bottom-left, .alert-superimposed.bottom-right {\r\n    bottom: 20px;\r\n}\r\n.carousel-indicators li {\r\n    display: inline-block;\r\n    width: 10px;\r\n    height: 10px;\r\n    margin: 1px;\r\n    text-indent: -999px;\r\n    border: 1px solid #fff;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    background-color: #000\\9;\r\n    background-color: rgba(0, 0, 0, 0);\r\n}\r\n.carousel-indicators .active {\r\n    margin: 0;\r\n    width: 12px;\r\n    height: 12px;\r\n    background-color: #fff;\r\n}\r\n.carousel-caption {\r\n    position: absolute;\r\n    left: 15%;\r\n    right: 15%;\r\n    bottom: 20px;\r\n    z-index: 10;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n.carousel-caption .btn, .text-hide {\r\n    text-shadow: none;\r\n}\r\n@media screen and (min-width:768px) {\r\n    .carousel-control .glyphicon-chevron-left, .carousel-control .glyphicon-chevron-right, .carousel-control .ai-next, .carousel-control .ai-prev {\r\n    width: 30px;\r\n    height: 30px;\r\n    margin-top: -15px;\r\n    font-size: 30px;\r\n}\r\n.carousel-control .glyphicon-chevron-left, .carousel-control .ai-prev {\r\n    margin-left: -15px;\r\n}\r\n.carousel-control .glyphicon-chevron-right, .carousel-control .ai-next {\r\n    margin-right: -15px;\r\n}\r\n.carousel-caption {\r\n    left: 20%;\r\n    right: 20%;\r\n    padding-bottom: 30px;\r\n}\r\n.carousel-indicators {\r\n    bottom: 20px;\r\n}\r\n}\r\n.btn-group-vertical>.btn-group:after, .btn-group-vertical>.btn-group:before, .btn-toolbar:after, .btn-toolbar:before, .clearfix:after, .clearfix:before, .container-fluid:after, .container-fluid:before, .container:after, .container:before, .dl-horizontal dd:after, .dl-horizontal dd:before, .form-horizontal .form-group:after, .form-horizontal .form-group:before, .modal-footer:after, .modal-footer:before, .nav:after, .nav:before, .navbar-collapse:after, .navbar-collapse:before, .navbar-header:after, .navbar-header:before, .navbar:after, .navbar:before, .pager:after, .pager:before, .panel-body:after, .panel-body:before, .panel-footer:after, .panel-footer:before, .row-dual-segments:after, .row-dual-segments:before, .row:after, .row:before {\r\n    content: \" \";\r\n    display: table;\r\n    min-width: min-content;\r\n}\r\n.btn-group-vertical>.btn-group:after, .btn-toolbar:after, .clearfix:after, .container-fluid:after, .container:after, .dl-horizontal dd:after, .form-horizontal .form-group:after, .modal-footer:after, .nav:after, .navbar-collapse:after, .navbar-header:after, .navbar:after, .pager:after, .panel-body:after, .panel-footer:after, .row-dual-segments:after, .row:after {\r\n    clear: both;\r\n}\r\n.center-block {\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n.pull-right {\r\n    float: right!important;\r\n}\r\n.pull-left {\r\n    float: left!important;\r\n}\r\n.hide {\r\n    display: none!important;\r\n}\r\n.show {\r\n    display: block!important;\r\n}\r\n.hidden, .visible-lg, .visible-lg-block, .visible-lg-inline, .visible-lg-inline-block, .visible-md, .visible-md-block, .visible-md-inline, .visible-md-inline-block, .visible-sm, .visible-sm-block, .visible-sm-inline, .visible-sm-inline-block, .visible-xs, .visible-xs-block, .visible-xs-inline, .visible-xs-inline-block {\r\n    display: none!important;\r\n}\r\n.invisible {\r\n    visibility: hidden;\r\n}\r\n.text-hide {\r\n    color: transparent;\r\n    background-color: transparent;\r\n    border: 0;\r\n}\r\n.btn, .modal-title {\r\n    font-size: 13px;\r\n}\r\n.alert-success, .alert-warning {\r\n    padding-left: 35px;\r\n}\r\n.affix {\r\n    position: fixed;\r\n}\r\n\r\n@media (max-width:767px) {\r\n    .visible-xs {\r\n    display: block!important;\r\n}\r\ntable.visible-xs {\r\n    display: table!important;\r\n}\r\ntr.visible-xs {\r\n    display: table-row!important;\r\n}\r\ntd.visible-xs, th.visible-xs {\r\n    display: table-cell!important;\r\n}\r\n.visible-xs-block {\r\n    display: block!important;\r\n}\r\n.visible-xs-inline {\r\n    display: inline!important;\r\n}\r\n.visible-xs-inline-block {\r\n    display: inline-block!important;\r\n}\r\n}\r\n@media (min-width:768px) and (max-width:991px) {\r\n    .visible-sm {\r\n    display: block!important;\r\n}\r\ntable.visible-sm {\r\n    display: table!important;\r\n}\r\ntr.visible-sm {\r\n    display: table-row!important;\r\n}\r\ntd.visible-sm, th.visible-sm {\r\n    display: table-cell!important;\r\n}\r\n.visible-sm-block {\r\n    display: block!important;\r\n}\r\n.visible-sm-inline {\r\n    display: inline!important;\r\n}\r\n.visible-sm-inline-block {\r\n    display: inline-block!important;\r\n}\r\n}\r\n@media (min-width:992px) and (max-width:1199px) {\r\n    .visible-md {\r\n    display: block!important;\r\n}\r\ntable.visible-md {\r\n    display: table!important;\r\n}\r\ntr.visible-md {\r\n    display: table-row!important;\r\n}\r\ntd.visible-md, th.visible-md {\r\n    display: table-cell!important;\r\n}\r\n.visible-md-block {\r\n    display: block!important;\r\n}\r\n.visible-md-inline {\r\n    display: inline!important;\r\n}\r\n.visible-md-inline-block {\r\n    display: inline-block!important;\r\n}\r\n}\r\n@media (min-width:1200px) {\r\n    .visible-lg {\r\n    display: block!important;\r\n}\r\ntable.visible-lg {\r\n    display: table!important;\r\n}\r\ntr.visible-lg {\r\n    display: table-row!important;\r\n}\r\ntd.visible-lg, th.visible-lg {\r\n    display: table-cell!important;\r\n}\r\n.visible-lg-block {\r\n    display: block!important;\r\n}\r\n.visible-lg-inline {\r\n    display: inline!important;\r\n}\r\n.visible-lg-inline-block {\r\n    display: inline-block!important;\r\n}\r\n.hidden-lg {\r\n    display: none!important;\r\n}\r\n}\r\n@media (max-width:767px) {\r\n    .hidden-xs {\r\n    display: none!important;\r\n}\r\n}\r\n@media (min-width:768px) and (max-width:991px) {\r\n    .hidden-sm {\r\n    display: none!important;\r\n}\r\n}\r\n@media (min-width:992px) and (max-width:1199px) {\r\n    .hidden-md {\r\n    display: none!important;\r\n}\r\n}\r\n.visible-print {\r\n    display: none!important;\r\n}\r\n@media print {\r\n    .visible-print {\r\n    display: block!important;\r\n}\r\ntable.visible-print {\r\n    display: table!important;\r\n}\r\ntr.visible-print {\r\n    display: table-row!important;\r\n}\r\ntd.visible-print, th.visible-print {\r\n    display: table-cell!important;\r\n}\r\n}\r\n.visible-print-block {\r\n    display: none!important;\r\n}\r\n@media print {\r\n    .visible-print-block {\r\n    display: block!important;\r\n}\r\n}\r\n.visible-print-inline {\r\n    display: none!important;\r\n}\r\n@media print {\r\n    .visible-print-inline {\r\n    display: inline!important;\r\n}\r\n}\r\n.visible-print-inline-block {\r\n    display: none!important;\r\n}\r\n@media print {\r\n    .visible-print-inline-block {\r\n    display: inline-block!important;\r\n}\r\n.hidden-print {\r\n    display: none!important;\r\n}\r\n}\r\n.alert-superimposed {\r\n    border-radius: 6px;\r\n    -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .25)!important;\r\n    box-shadow: 0 1px 1px rgba(0, 0, 0, .25)!important;\r\n    z-index: 1100;\r\n    margin-bottom: 0;\r\n    position: absolute;\r\n    max-width: 750px;\r\n}\r\n.alert-superimposed.bottom-left, .alert-superimposed.top-left {\r\n    left: 0;\r\n    border-left: none;\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n}\r\n.alert-superimposed.bottom-right, .alert-superimposed.top-right {\r\n    border-right: none;\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    right: 0;\r\n}\r\n.alert>a {\r\n    text-decoration: underline;\r\n}\r\n.alert>.pull-right {\r\n    margin-left: 10px;\r\n}\r\n.alert-success {\r\n    border-color: #37A320;\r\n    color: #404040;\r\n}\r\n.alert-info hr {\r\n    border-top-color: #198cff;\r\n}\r\n.alert-info .alert-link {\r\n    color: #272727;\r\n}\r\n.alert-warning {\r\n    border-color: #ed6e00;\r\n    color: #404040;\r\n}\r\n.close, .close.disabled, .close:disabled {\r\n    background: url(data:image/svg+xml;\r\n    ), 0 0;\r\n}\r\n.alert-danger hr {\r\n    border-top-color: #9a1931;\r\n}\r\n.alert-danger .alert-link {\r\n    color: #272727;\r\n}\r\n.close {\r\n    opacity: 1;\r\n    filter: alpha(opacity=100);\r\n    width: 11px;\r\n    height: 11px;\r\n}\r\n.modal-content {\r\n    overflow: hidden;\r\n}\r\n.modal-header {\r\n    padding: 5px 10px;\r\n    border-top-left-radius: 6px;\r\n    border-top-right-radius: 6px;\r\n    background-size: contain;\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%);\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%);\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0);\r\n}\r\n.modal-header .close, .modal-header .close:active, .modal-header .close:focus, .modal-header .close:hover {\r\n    background-repeat: no-repeat;\r\n    background-position-y: center;\r\n}\r\n.modal-header .close {\r\n    margin-top: 0;\r\n    height: 18px;\r\n}\r\n.modal-footer {\r\n    border-bottom-left-radius: 6px;\r\n    border-bottom-right-radius: 6px;\r\n    background-color: #e6e6e6;\r\n}\r\n.modal-footer .btn-link.pull-left {\r\n    margin-left: 0;\r\n    padding-left: 0;\r\n}\r\n.modal-footer .btn-link.pull-right {\r\n    margin-right: 0;\r\n    padding-right: 0;\r\n}\r\n@media (min-width:1200px) {\r\n    .modal-lg {\r\n    width: 1100px;\r\n}\r\n}\r\n.btn {\r\n    padding: 3px 15px;\r\n    line-height: 1.42857143;\r\n    border-radius: 4px;\r\n    min-width: 86px;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n.btn-group-hover {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n.btn-group-hover>.btn {\r\n    position: relative;\r\n    float: left;\r\n}\r\n.btn-group-hover>.btn.active, .btn-group-hover>.btn:active, .btn-group-hover>.btn:focus, .btn-group-hover>.btn:hover {\r\n    z-index: 2;\r\n}\r\n.btn-group-hover .btn+.btn, .btn-group-hover .btn+.btn-group, .btn-group-hover .btn-group+.btn, .btn-group-hover .btn-group+.btn-group {\r\n    margin-left: -1px;\r\n}\r\n.btn-group-hover.btn-group-flat .btn-default {\r\n    box-shadow: none;\r\n    background-color: #fff;\r\n    background-image: none;\r\n    filter: none;\r\n    font-size: 12px;\r\n    min-width: 0;\r\n    padding: 8px;\r\n    white-space: pre-line;\r\n}\r\n.btn-group-hover.btn-group-flat .btn-default:focus, .btn-group-hover.btn-group-flat .btn-default:hover {\r\n    background-color: rgba(0, 0, 0, .06);\r\n}\r\n.btn-group-hover.btn-group-flat .btn-default.active, .btn-group-hover.btn-group-flat .btn-default.active:focus, .btn-group-hover.btn-group-flat .btn-default.active:hover {\r\n    background-color: #b3d9ff;\r\n}\r\n.btn-default, .btn-default.focus, .btn-default:focus {\r\n    background-color: silver;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0);\r\n    border-color: grey;\r\n    color: #333;\r\n    background-repeat: repeat-x;\r\n}\r\n.btn-group-hover:hover .dropdown-menu {\r\n    display: block;\r\n    top: 94%}\r\n.btn-default {\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%);\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%);\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%);\r\n}\r\n.btn-default.focus, .btn-default:focus {\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%);\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%);\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%);\r\n}\r\n.btn-default:hover {\r\n    color: #333;\r\n    background-color: #cdcdcd;\r\n    background-image: -webkit-linear-gradient(top, #fdfdfd 0, #cdcdcd 100%);\r\n    background-image: -o-linear-gradient(top, #fdfdfd 0, #cdcdcd 100%);\r\n    background-image: linear-gradient(to bottom, #fdfdfd 0, #cdcdcd 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffdfdfd', endColorstr='#ffcdcdcd', GradientType=0);\r\n    border-color: #9a9a9a;\r\n}\r\n.btn-default.active, .btn-default.active.focus, .btn-default.active:focus, .btn-default.active:hover, .btn-default:active, .btn-default:active.focus, .btn-default:active:focus, .btn-default:active:hover, .open>.dropdown-toggle.btn-default, .open>.dropdown-toggle.btn-default.focus, .open>.dropdown-toggle.btn-default:focus, .open>.dropdown-toggle.btn-default:hover {\r\n    color: #333;\r\n    background-color: #9a9a9a;\r\n    background-image: -webkit-linear-gradient(top, #cacaca 0, #9a9a9a 100%);\r\n    background-image: -o-linear-gradient(top, #cacaca 0, #9a9a9a 100%);\r\n    background-image: linear-gradient(to bottom, #cacaca 0, #9a9a9a 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffcacaca', endColorstr='#ff9a9a9a', GradientType=0);\r\n    border-color: #676767;\r\n}\r\n.btn-default .badge, .btn-default.disabled, .btn-default.disabled.active, .btn-default.disabled.focus, .btn-default.disabled:active, .btn-default.disabled:focus, .btn-default.disabled:hover, .btn-default[disabled], .btn-default[disabled].active, .btn-default[disabled].focus, .btn-default[disabled]:active, .btn-default[disabled]:focus, .btn-default[disabled]:hover, fieldset[disabled] .btn-default, fieldset[disabled] .btn-default.active, fieldset[disabled] .btn-default.focus, fieldset[disabled] .btn-default:active, fieldset[disabled] .btn-default:focus, fieldset[disabled] .btn-default:hover {\r\n    color: #333;\r\n    background-color: silver;\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%);\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%);\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0);\r\n    border-color: grey;\r\n}\r\n.btn-primary, .btn-primary.focus, .btn-primary:focus {\r\n    background-color: #39f;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3399ff', endColorstr='#ff0962ac', GradientType=0);\r\n    border-color: #0059b3;\r\n    color: #fff;\r\n    background-repeat: repeat-x;\r\n}\r\n.btn-primary {\r\n    background-image: -webkit-linear-gradient(top, #39f 0, #0962ac 100%);\r\n    background-image: -o-linear-gradient(top, #39f 0, #0962ac 100%);\r\n    background-image: linear-gradient(to bottom, #39f 0, #0962ac 100%);\r\n}\r\n.btn-primary.focus, .btn-primary:focus {\r\n    background-image: -webkit-linear-gradient(top, #39f 0, #0962ac 100%);\r\n    background-image: -o-linear-gradient(top, #39f 0, #0962ac 100%);\r\n    background-image: linear-gradient(to bottom, #39f 0, #0962ac 100%);\r\n}\r\n.btn-primary:hover {\r\n    color: #fff;\r\n    background-color: #5cadff;\r\n    background-image: -webkit-linear-gradient(top, #5cadff 0, #3a81bd 100%);\r\n    background-image: -o-linear-gradient(top, #5cadff 0, #3a81bd 100%);\r\n    background-image: linear-gradient(to bottom, #5cadff 0, #3a81bd 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5cadff', endColorstr='#ff3a81bd', GradientType=0);\r\n    border-color: #337ac2;\r\n}\r\n.btn-primary.active, .btn-primary.active.focus, .btn-primary.active:focus, .btn-primary.active:hover, .btn-primary:active, .btn-primary:active.focus, .btn-primary:active:focus, .btn-primary:active:hover, .open>.dropdown-toggle.btn-primary, .open>.dropdown-toggle.btn-primary.focus, .open>.dropdown-toggle.btn-primary:focus, .open>.dropdown-toggle.btn-primary:hover {\r\n    color: #fff;\r\n    background-color: #297acc;\r\n    background-image: -webkit-linear-gradient(top, #297acc 0, #074e8a 100%);\r\n    background-image: -o-linear-gradient(top, #297acc 0, #074e8a 100%);\r\n    background-image: linear-gradient(to bottom, #297acc 0, #074e8a 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff297acc', endColorstr='#ff074e8a', GradientType=0);\r\n    border-color: #00478f;\r\n}\r\n.btn-primary .badge, .btn-primary.disabled, .btn-primary.disabled.active, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled:focus, .btn-primary.disabled:hover, .btn-primary[disabled], .btn-primary[disabled].active, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled]:focus, .btn-primary[disabled]:hover, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary.active, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary:hover {\r\n    color: #fff;\r\n    background-color: #39f;\r\n    background-image: -webkit-linear-gradient(top, #39f 0, #0962ac 100%);\r\n    background-image: -o-linear-gradient(top, #39f 0, #0962ac 100%);\r\n    background-image: linear-gradient(to bottom, #39f 0, #0962ac 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3399ff', endColorstr='#ff0962ac', GradientType=0);\r\n    border-color: #0059b3;\r\n}\r\n.btn-success, .btn-success.focus, .btn-success:focus {\r\n    color: #fff;\r\n    background-color: #37A320;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #37A320 0, #297818 100%);\r\n    background-image: -o-linear-gradient(top, #37A320 0, #297818 100%);\r\n    background-image: linear-gradient(to bottom, #37A320 0, #297818 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff37a320', endColorstr='#ff297818', GradientType=0);\r\n    border-color: #13380b;\r\n}\r\n.btn-success:hover {\r\n    color: #fff;\r\n    background-color: #5fb54d;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #5fb54d 0, #539346 100%);\r\n    background-image: -o-linear-gradient(top, #5fb54d 0, #539346 100%);\r\n    background-image: linear-gradient(to bottom, #5fb54d 0, #539346 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5fb54d', endColorstr='#ff539346', GradientType=0);\r\n    border-color: #42603c;\r\n}\r\n.btn-success.active, .btn-success.active.focus, .btn-success.active:focus, .btn-success.active:hover, .btn-success:active, .btn-success:active.focus, .btn-success:active:focus, .btn-success:active:hover, .open>.dropdown-toggle.btn-success, .open>.dropdown-toggle.btn-success.focus, .open>.dropdown-toggle.btn-success:focus, .open>.dropdown-toggle.btn-success:hover {\r\n    color: #fff;\r\n    background-color: #2c821a;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #2c821a 0, #206013 100%);\r\n    background-image: -o-linear-gradient(top, #2c821a 0, #206013 100%);\r\n    background-image: linear-gradient(to bottom, #2c821a 0, #206013 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff2c821a', endColorstr='#ff206013', GradientType=0);\r\n    border-color: #0f2d09;\r\n}\r\n.btn-success .badge, .btn-success.disabled, .btn-success.disabled.active, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled:focus, .btn-success.disabled:hover, .btn-success[disabled], .btn-success[disabled].active, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled]:focus, .btn-success[disabled]:hover, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success.active, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success:hover {\r\n    color: #fff;\r\n    background-color: #37A320;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #37A320 0, #297818 100%);\r\n    background-image: -o-linear-gradient(top, #37A320 0, #297818 100%);\r\n    background-image: linear-gradient(to bottom, #37A320 0, #297818 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff37a320', endColorstr='#ff297818', GradientType=0);\r\n    border-color: #13380b;\r\n}\r\n.btn-info, .btn-info.focus, .btn-info:focus {\r\n    color: #fff;\r\n    background-color: #39f;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #39f 0, #007fff 100%);\r\n    background-image: -o-linear-gradient(top, #39f 0, #007fff 100%);\r\n    background-image: linear-gradient(to bottom, #39f 0, #007fff 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3399ff', endColorstr='#ff007fff', GradientType=0);\r\n    border-color: #0059b3;\r\n}\r\n.btn-info:hover {\r\n    color: #fff;\r\n    background-color: #5cadff;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #5cadff 0, #39f 100%);\r\n    background-image: -o-linear-gradient(top, #5cadff 0, #39f 100%);\r\n    background-image: linear-gradient(to bottom, #5cadff 0, #39f 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5cadff', endColorstr='#ff3399ff', GradientType=0);\r\n    border-color: #337ac2;\r\n}\r\n.btn-info.active, .btn-info.active.focus, .btn-info.active:focus, .btn-info.active:hover, .btn-info:active, .btn-info:active.focus, .btn-info:active:focus, .btn-info:active:hover, .open>.dropdown-toggle.btn-info, .open>.dropdown-toggle.btn-info.focus, .open>.dropdown-toggle.btn-info:focus, .open>.dropdown-toggle.btn-info:hover {\r\n    color: #fff;\r\n    background-color: #297acc;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #297acc 0, #06c 100%);\r\n    background-image: -o-linear-gradient(top, #297acc 0, #06c 100%);\r\n    background-image: linear-gradient(to bottom, #297acc 0, #06c 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff297acc', endColorstr='#ff0066cc', GradientType=0);\r\n    border-color: #00478f;\r\n}\r\n.btn-info .badge, .btn-info.disabled, .btn-info.disabled.active, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled:focus, .btn-info.disabled:hover, .btn-info[disabled], .btn-info[disabled].active, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled]:focus, .btn-info[disabled]:hover, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info.active, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info:hover {\r\n    color: #fff;\r\n    background-color: #39f;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #39f 0, #007fff 100%);\r\n    background-image: -o-linear-gradient(top, #39f 0, #007fff 100%);\r\n    background-image: linear-gradient(to bottom, #39f 0, #007fff 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3399ff', endColorstr='#ff007fff', GradientType=0);\r\n    border-color: #0059b3;\r\n}\r\n.btn-warning, .btn-warning.focus, .btn-warning:focus {\r\n    color: #fff;\r\n    background-color: #ed6e00;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #ed6e00 0, #ba5600 100%);\r\n    background-image: -o-linear-gradient(top, #ed6e00 0, #ba5600 100%);\r\n    background-image: linear-gradient(to bottom, #ed6e00 0, #ba5600 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffed6e00', endColorstr='#ffba5600', GradientType=0);\r\n    border-color: #6e3300;\r\n}\r\n.btn-warning:hover {\r\n    color: #fff;\r\n    background-color: #f18b33;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #f18b33 0, #c87833 100%);\r\n    background-image: -o-linear-gradient(top, #f18b33 0, #c87833 100%);\r\n    background-image: linear-gradient(to bottom, #f18b33 0, #c87833 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff18b33', endColorstr='#ffc87833', GradientType=0);\r\n    border-color: #8b5c33;\r\n}\r\n.btn-warning.active, .btn-warning.active.focus, .btn-warning.active:focus, .btn-warning.active:hover, .btn-warning:active, .btn-warning:active.focus, .btn-warning:active:focus, .btn-warning:active:hover, .open>.dropdown-toggle.btn-warning, .open>.dropdown-toggle.btn-warning.focus, .open>.dropdown-toggle.btn-warning:focus, .open>.dropdown-toggle.btn-warning:hover {\r\n    color: #fff;\r\n    background-color: #be5800;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #be5800 0, #954500 100%);\r\n    background-image: -o-linear-gradient(top, #be5800 0, #954500 100%);\r\n    background-image: linear-gradient(to bottom, #be5800 0, #954500 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffbe5800', endColorstr='#ff954500', GradientType=0);\r\n    border-color: #582900;\r\n}\r\n.btn-warning .badge, .btn-warning.disabled, .btn-warning.disabled.active, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled:focus, .btn-warning.disabled:hover, .btn-warning[disabled], .btn-warning[disabled].active, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled]:focus, .btn-warning[disabled]:hover, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning.active, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning:hover {\r\n    color: #fff;\r\n    background-color: #ed6e00;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #ed6e00 0, #ba5600 100%);\r\n    background-image: -o-linear-gradient(top, #ed6e00 0, #ba5600 100%);\r\n    background-image: linear-gradient(to bottom, #ed6e00 0, #ba5600 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffed6e00', endColorstr='#ffba5600', GradientType=0);\r\n    border-color: #6e3300;\r\n}\r\n.btn-danger, .btn-danger.focus, .btn-danger:focus {\r\n    color: #fff;\r\n    background-color: #b01c38;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #b01c38 0, #84152a 100%);\r\n    background-image: -o-linear-gradient(top, #b01c38 0, #84152a 100%);\r\n    background-image: linear-gradient(to bottom, #b01c38 0, #84152a 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffb01c38', endColorstr='#ff84152a', GradientType=0);\r\n    border-color: #420b15;\r\n}\r\n.btn-danger:hover {\r\n    color: #fff;\r\n    background-color: #c04960;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #c04960 0, #9d4455 100%);\r\n    background-image: -o-linear-gradient(top, #c04960 0, #9d4455 100%);\r\n    background-image: linear-gradient(to bottom, #c04960 0, #9d4455 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffc04960', endColorstr='#ff9d4455', GradientType=0);\r\n    border-color: #683b44;\r\n}\r\n.btn-danger.active, .btn-danger.active.focus, .btn-danger.active:focus, .btn-danger.active:hover, .btn-danger:active, .btn-danger:active.focus, .btn-danger:active:focus, .btn-danger:active:hover, .open>.dropdown-toggle.btn-danger, .open>.dropdown-toggle.btn-danger.focus, .open>.dropdown-toggle.btn-danger:focus, .open>.dropdown-toggle.btn-danger:hover {\r\n    color: #fff;\r\n    background-color: #8d162d;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #8d162d 0, #6a1122 100%);\r\n    background-image: -o-linear-gradient(top, #8d162d 0, #6a1122 100%);\r\n    background-image: linear-gradient(to bottom, #8d162d 0, #6a1122 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff8d162d', endColorstr='#ff6a1122', GradientType=0);\r\n    border-color: #350811;\r\n}\r\n.btn-danger .badge, .btn-danger.disabled, .btn-danger.disabled.active, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled:focus, .btn-danger.disabled:hover, .btn-danger[disabled], .btn-danger[disabled].active, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled]:focus, .btn-danger[disabled]:hover, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger.active, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger:hover {\r\n    color: #fff;\r\n    background-color: #b01c38;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #b01c38 0, #84152a 100%);\r\n    background-image: -o-linear-gradient(top, #b01c38 0, #84152a 100%);\r\n    background-image: linear-gradient(to bottom, #b01c38 0, #84152a 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffb01c38', endColorstr='#ff84152a', GradientType=0);\r\n    border-color: #420b15;\r\n}\r\n.btn-default-inverse, .btn-default-inverse.focus, .btn-default-inverse:focus {\r\n    color: #fff;\r\n    background-color: #404040;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, grey 0, #404040 100%);\r\n    background-image: -o-linear-gradient(top, grey 0, #404040 100%);\r\n    background-image: linear-gradient(to bottom, grey 0, #404040 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0);\r\n    border-color: #000;\r\n}\r\n.btn-default-inverse:hover {\r\n    color: #fff;\r\n    background-color: #666;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #999 0, #666 100%);\r\n    background-image: -o-linear-gradient(top, #999999 0, #666666 100%);\r\n    background-image: linear-gradient(to bottom, #999 0, #666 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff999999', endColorstr='#ff666666', GradientType=0);\r\n    border-color: #333;\r\n}\r\n.btn-default-inverse.active, .btn-default-inverse.active.focus, .btn-default-inverse.active:focus, .btn-default-inverse.active:hover, .btn-default-inverse:active, .btn-default-inverse:active.focus, .btn-default-inverse:active:focus, .btn-default-inverse:active:hover, .open>.dropdown-toggle.btn-default-inverse, .open>.dropdown-toggle.btn-default-inverse.focus, .open>.dropdown-toggle.btn-default-inverse:focus, .open>.dropdown-toggle.btn-default-inverse:hover {\r\n    color: #fff;\r\n    background-color: #333;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, #666 0, #333 100%);\r\n    background-image: -o-linear-gradient(top, #666 0, #333 100%);\r\n    background-image: linear-gradient(to bottom, #666 0, #333 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff666666', endColorstr='#ff333333', GradientType=0);\r\n    border-color: #000;\r\n}\r\n.btn-default-inverse .badge, .btn-default-inverse.disabled, .btn-default-inverse.disabled.active, .btn-default-inverse.disabled.focus, .btn-default-inverse.disabled:active, .btn-default-inverse.disabled:focus, .btn-default-inverse.disabled:hover, .btn-default-inverse[disabled], .btn-default-inverse[disabled].active, .btn-default-inverse[disabled].focus, .btn-default-inverse[disabled]:active, .btn-default-inverse[disabled]:focus, .btn-default-inverse[disabled]:hover, fieldset[disabled] .btn-default-inverse, fieldset[disabled] .btn-default-inverse.active, fieldset[disabled] .btn-default-inverse.focus, fieldset[disabled] .btn-default-inverse:active, fieldset[disabled] .btn-default-inverse:focus, fieldset[disabled] .btn-default-inverse:hover {\r\n    color: #fff;\r\n    background-color: #404040;\r\n    background-image: url(#);\r\n    background-image: -webkit-linear-gradient(top, grey 0, #404040 100%);\r\n    background-image: -o-linear-gradient(top, grey 0, #404040 100%);\r\n    background-image: linear-gradient(to bottom, grey 0, #404040 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0);\r\n    border-color: #000;\r\n}\r\n.btn-link {\r\n    cursor: pointer;\r\n}\r\n.btn-toolbar .btn {\r\n    min-width: initial;\r\n}\r\n.dropdown-menu>li>a {\r\n    padding: 5px 20px;\r\n}\r\n.dropdown-menu, .dropdown-menu-icons {\r\n    padding: 0;\r\n    max-height: 275px;\r\n    overflow-y: auto;\r\n}\r\n.dropdown-icon {\r\n    position: absolute;\r\n    top: 3px;\r\n    left: 10px;\r\n}\r\n.dropdown-menu-icons {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    z-index: 1000;\r\n    display: none;\r\n    float: left;\r\n    min-width: 160px;\r\n    margin: 2px 0 0;\r\n    font-size: 13px;\r\n    text-align: left;\r\n    background-color: #fff;\r\n    border: 1px solid #e6e6e6;\r\n    border-radius: 4px;\r\n    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\r\n    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\r\n    background-clip: padding-box;\r\n}\r\n.panel-fixed, .panel-fixed>.panel-body {\r\n    top: 0;\r\n    bottom: 0;\r\n}\r\n.line-segment-right-30>*, .line-segment-right-50>*, .line-segment-right-70>*, .line-segment-right>* {\r\n    float: right!important;\r\n}\r\n.dropdown-menu-icons.pull-right {\r\n    right: 0;\r\n    left: auto;\r\n}\r\n.dropdown-menu-icons .divider {\r\n    height: 1px;\r\n    margin: 8px 0;\r\n    overflow: hidden;\r\n    background-color: #e5e5e5;\r\n}\r\n.dropdown-menu-icons>li>a {\r\n    display: block;\r\n    clear: both;\r\n    font-weight: 400;\r\n    line-height: 1.42857143;\r\n    color: #404040;\r\n    white-space: nowrap;\r\n    position: relative;\r\n    padding: 5px 20px 5px 30px;\r\n}\r\n.dropdown-toggle {\r\n    min-width: initial;\r\n}\r\n.form-inline>* {\r\n    margin-right: 5px;\r\n}\r\n.input-narrow {\r\n    width: 85px!important;\r\n}\r\n.input-wide {\r\n    width: 170px!important;\r\n}\r\n.form-control {\r\n    padding-top: 2px;\r\n    overflow: visible;\r\n}\r\n.panel-fixed-footer>.panel-body, .panel-fixed-header-footer>.panel-body, .panel-fixed>.panel-body {\r\n    overflow-y: auto;\r\n    left: 0;\r\n    right: 0;\r\n    position: absolute;\r\n}\r\n.search {\r\n    border-radius: 14px;\r\n    background: url(data:image/svg+xml;\r\n    ), 0 0;\r\n}\r\n.panel-footer {\r\n    padding: 10px;\r\n    border-top: 1px solid silver;\r\n    background-color: #e6e6e6;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    text-align: right;\r\n}\r\n.panel-footer .btn+.btn {\r\n    margin-left: 5px;\r\n    margin-bottom: 0;\r\n}\r\n.panel-footer .btn-group .btn+.btn {\r\n    margin-left: -1px;\r\n}\r\n.panel-footer .btn-block+.btn-block {\r\n    margin-left: 0;\r\n}\r\n.panel-footer .btn-link.pull-left {\r\n    margin-left: 0;\r\n    padding-left: 0;\r\n}\r\n.panel-footer .btn-link.pull-right {\r\n    margin-right: 0;\r\n    padding-right: 0;\r\n}\r\n.panel-footer>span {\r\n    padding-top: 4px;\r\n    padding-bottom: 4px;\r\n}\r\n.panel-gray {\r\n    border-color: silver;\r\n    background: #eee;\r\n}\r\n.panel-fixed {\r\n    position: absolute;\r\n    right: 0;\r\n    left: 0;\r\n    margin-bottom: 0;\r\n}\r\n.panel-fixed>.panel-footer {\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 0;\r\n    left: 0;\r\n}\r\n.panel-default-header.panel-fixed, .panel-fixed-header {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    margin-bottom: 0;\r\n}\r\n.panel-default-header.panel-fixed>.panel-body, .panel-fixed-header>.panel-body {\r\n    overflow-y: auto;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    top: 25px;\r\n}\r\n.panel-default-header.panel-fixed>.panel-footer, .panel-fixed-header>.panel-footer {\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 0;\r\n    left: 0;\r\n}\r\n.panel-fixed-footer {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    margin-bottom: 0;\r\n}\r\n.panel-fixed-footer>.panel-footer {\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 0;\r\n    left: 0;\r\n}\r\n.panel-fixed-footer>.panel-body {\r\n    top: 0;\r\n    bottom: 47px;\r\n}\r\n.panel-fixed-header-footer, .panel-fixed-header-footer>.panel-footer {\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    position: absolute;\r\n}\r\n.panel-fixed-header-footer {\r\n    top: 0;\r\n    margin-bottom: 0;\r\n}\r\n.panel-fixed-header-footer>.panel-body {\r\n    top: 25px;\r\n    bottom: 47px;\r\n}\r\n.side-panel {\r\n    overflow: hidden;\r\n    box-shadow: 0 1px 8px 2px rgba(0, 0, 0, .25);\r\n}\r\n.side-panel.right {\r\n    border-right: none;\r\n    border-top-left-radius: 8px;\r\n    border-bottom-left-radius: 8px;\r\n}\r\n.side-panel.left {\r\n    border-top-right-radius: 8px;\r\n    border-bottom-right-radius: 8px;\r\n}\r\n.panel-placeholder>.panel-body>div {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    bottom: 10px;\r\n    left: 10px;\r\n}\r\n.panel-nav-tree {\r\n    border: none;\r\n}\r\n.panel-nav-tree .list-group-item {\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: default;\r\n}\r\n.panel-nav-tree .list-group-item.active, .panel-nav-tree .list-group-item.active:focus, .panel-nav-tree .list-group-item.active:hover {\r\n    border: none;\r\n}\r\n.panel-nav-tree .list-group-item:first-child, .panel-nav-tree .list-group-item:last-child {\r\n    border-radius: 4px;\r\n}\r\n.panel-nav-tree .list-group {\r\n    margin-bottom: 0;\r\n}\r\n.panel-tabs {\r\n    background-color: transparent;\r\n    border: none;\r\n    margin-bottom: 0;\r\n}\r\n.panel-default>.panel-heading+.panel-collapse>.panel-body, .panel-inverse>.panel-heading+.panel-collapse>.panel-body {\r\n    border-top-color: silver;\r\n}\r\n.panel-tabs>.panel-body {\r\n    overflow-y: hidden;\r\n    border-left: 1px solid silver;\r\n    border-right: 1px solid silver;\r\n    border-bottom: 1px solid silver;\r\n    background: #fff;\r\n    top: 26px;\r\n}\r\n.panel-text-editor .form-control, .text-editor .form-control {\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n    border-style: none;\r\n}\r\n.panel-tabs>.panel-body>.panel {\r\n    margin-bottom: 0;\r\n}\r\n.panel-tabs>.nav-tabs {\r\n    height: 26px;\r\n}\r\n.panel-tabs>.nav-tabs>li:first-child {\r\n    margin-left: 6px;\r\n}\r\n.text-editor {\r\n    margin-bottom: 0;\r\n    border-bottom-left-radius: 4px;\r\n    border-bottom-right-radius: 4px;\r\n}\r\n.text-editor .form-control {\r\n    height: auto;\r\n}\r\n.panel-text-editor {\r\n    margin-bottom: 0;\r\n    border-radius: 0;\r\n}\r\n.panel-text-editor>.panel-body {\r\n    padding: 0!important;\r\n}\r\n.panel-text-editor .form-control {\r\n    height: 100%}\r\n.panel-default {\r\n    border-color: silver;\r\n}\r\n.panel-default>.panel-heading {\r\n    color: #404040;\r\n    background-color: #f5f5f5;\r\n    border-color: silver;\r\n}\r\n.panel-default>.panel-heading .badge {\r\n    color: #f5f5f5;\r\n    background-color: #404040;\r\n}\r\n.panel-default>.panel-footer+.panel-collapse>.panel-body {\r\n    border-bottom-color: silver;\r\n}\r\n.panel-default>.panel-heading {\r\n    border-bottom: 1px solid grey;\r\n}\r\n.panel-inverse, .panel-inverse>.panel-heading {\r\n    background-color: #303030;\r\n    border-color: silver;\r\n}\r\n.panel-inverse>.panel-heading {\r\n    color: #fff;\r\n}\r\n.panel-inverse>.panel-heading .badge {\r\n    color: #303030;\r\n    background-color: #fff;\r\n}\r\n.panel-inverse>.panel-footer+.panel-collapse>.panel-body {\r\n    border-bottom-color: silver;\r\n}\r\n.panel-inverse>.panel-heading {\r\n    border-bottom: 1px solid grey;\r\n    background-size: contain;\r\n    background-image: -webkit-linear-gradient(top, grey 0, #404040 100%);\r\n    background-image: -o-linear-gradient(top, grey 0, #404040 100%);\r\n    background-image: linear-gradient(to bottom, grey 0, #404040 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0);\r\n}\r\n.panel-inverse>.panel-heading>.btn-default, .panel-inverse>.panel-heading>.btn-default.focus, .panel-inverse>.panel-heading>.btn-default:focus {\r\n    color: #fff!important;\r\n    background-color: #404040!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: -o-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;\r\n    border-color: #000!important;\r\n}\r\n.panel-inverse>.panel-heading>.btn-default:hover {\r\n    color: #fff!important;\r\n    background-color: #666!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, #999 0, #666 100%)!important;\r\n    background-image: -o-linear-gradient(top, #999 0, #666 100%)!important;\r\n    background-image: linear-gradient(to bottom, #999 0, #666 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff999999', endColorstr='#ff666666', GradientType=0)!important;\r\n}\r\n.open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default.focus, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default:focus, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default:hover, .panel-inverse>.panel-heading>.btn-default.active, .panel-inverse>.panel-heading>.btn-default.active.focus, .panel-inverse>.panel-heading>.btn-default.active:focus, .panel-inverse>.panel-heading>.btn-default.active:hover, .panel-inverse>.panel-heading>.btn-default:active, .panel-inverse>.panel-heading>.btn-default:active.focus, .panel-inverse>.panel-heading>.btn-default:active:focus, .panel-inverse>.panel-heading>.btn-default:active:hover {\r\n    color: #fff!important;\r\n    background-color: #333!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, #666 0, #333 100%)!important;\r\n    background-image: -o-linear-gradient(top, #666 0, #333 100%)!important;\r\n    background-image: linear-gradient(to bottom, #666 0, #333 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff666666', endColorstr='#ff333333', GradientType=0)!important;\r\n    border-color: #000!important;\r\n}\r\n.panel-inverse>.panel-heading>.btn-default .badge, .panel-inverse>.panel-heading>.btn-default.disabled, .panel-inverse>.panel-heading>.btn-default.disabled.active, .panel-inverse>.panel-heading>.btn-default.disabled.focus, .panel-inverse>.panel-heading>.btn-default.disabled:active, .panel-inverse>.panel-heading>.btn-default.disabled:focus, .panel-inverse>.panel-heading>.btn-default.disabled:hover, .panel-inverse>.panel-heading>.btn-default[disabled], .panel-inverse>.panel-heading>.btn-default[disabled].active, .panel-inverse>.panel-heading>.btn-default[disabled].focus, .panel-inverse>.panel-heading>.btn-default[disabled]:active, .panel-inverse>.panel-heading>.btn-default[disabled]:focus, .panel-inverse>.panel-heading>.btn-default[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default.active, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default.focus, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default:active, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default:focus, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default:hover {\r\n    color: #fff!important;\r\n    background-color: #404040!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: -o-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;\r\n    border-color: #000!important;\r\n}\r\n.panel-inverse>.panel-heading>.btn-default-inverse, .panel-inverse>.panel-heading>.btn-default-inverse.focus, .panel-inverse>.panel-heading>.btn-default-inverse:focus {\r\n    background-color: silver!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;\r\n    color: #333!important;\r\n    background-repeat: repeat-x!important;\r\n}\r\n.panel-inverse>.panel-heading>.btn-default:hover {\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-heading>.btn-default-inverse {\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-heading>.btn-default-inverse.focus, .panel-inverse>.panel-heading>.btn-default-inverse:focus {\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-heading>.btn-default-inverse:hover {\r\n    color: #333!important;\r\n    background-color: #cdcdcd!important;\r\n    background-image: -webkit-linear-gradient(top, #fdfdfd 0, #cdcdcd 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fdfdfd 0, #cdcdcd 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fdfdfd 0, #cdcdcd 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffdfdfd', endColorstr='#ffcdcdcd', GradientType=0)!important;\r\n}\r\n.open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default-inverse, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default-inverse.focus, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default-inverse:focus, .open>.dropdown-toggle.panel-inverse>.panel-heading>.btn-default-inverse:hover, .panel-inverse>.panel-heading>.btn-default-inverse.active, .panel-inverse>.panel-heading>.btn-default-inverse.active.focus, .panel-inverse>.panel-heading>.btn-default-inverse.active:focus, .panel-inverse>.panel-heading>.btn-default-inverse.active:hover, .panel-inverse>.panel-heading>.btn-default-inverse:active, .panel-inverse>.panel-heading>.btn-default-inverse:active.focus, .panel-inverse>.panel-heading>.btn-default-inverse:active:focus, .panel-inverse>.panel-heading>.btn-default-inverse:active:hover {\r\n    color: #333!important;\r\n    background-color: #9a9a9a!important;\r\n    background-image: -webkit-linear-gradient(top, #cacaca 0, #9a9a9a 100%)!important;\r\n    background-image: -o-linear-gradient(top, #cacaca 0, #9a9a9a 100%)!important;\r\n    background-image: linear-gradient(to bottom, #cacaca 0, #9a9a9a 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffcacaca', endColorstr='#ff9a9a9a', GradientType=0)!important;\r\n    border-color: #676767!important;\r\n}\r\n.panel-inverse>.panel-heading>.btn-default-inverse .badge, .panel-inverse>.panel-heading>.btn-default-inverse.disabled, .panel-inverse>.panel-heading>.btn-default-inverse.disabled.active, .panel-inverse>.panel-heading>.btn-default-inverse.disabled.focus, .panel-inverse>.panel-heading>.btn-default-inverse.disabled:active, .panel-inverse>.panel-heading>.btn-default-inverse.disabled:focus, .panel-inverse>.panel-heading>.btn-default-inverse.disabled:hover, .panel-inverse>.panel-heading>.btn-default-inverse[disabled], .panel-inverse>.panel-heading>.btn-default-inverse[disabled].active, .panel-inverse>.panel-heading>.btn-default-inverse[disabled].focus, .panel-inverse>.panel-heading>.btn-default-inverse[disabled]:active, .panel-inverse>.panel-heading>.btn-default-inverse[disabled]:focus, .panel-inverse>.panel-heading>.btn-default-inverse[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse.active, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse.focus, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse:active, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse:focus, fieldset[disabled] .panel-inverse>.panel-heading>.btn-default-inverse:hover {\r\n    color: #333!important;\r\n    background-color: silver!important;\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-heading>.btn-default-inverse:hover {\r\n    border-color: #fcfcfc!important;\r\n}\r\n.panel-inverse>.panel-body {\r\n    background-color: #303030;\r\n    color: #fff;\r\n}\r\n.panel-inverse>.panel-body>.btn-default, .panel-inverse>.panel-body>.btn-default.focus, .panel-inverse>.panel-body>.btn-default:focus {\r\n    color: #fff!important;\r\n    background-color: #404040!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: -o-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;\r\n    border-color: #000!important;\r\n}\r\n.panel-inverse>.panel-body>.btn-default:hover {\r\n    color: #fff!important;\r\n    background-color: #666!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, #999 0, #666 100%)!important;\r\n    background-image: -o-linear-gradient(top, #999 0, #666 100%)!important;\r\n    background-image: linear-gradient(to bottom, #999 0, #666 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff999999', endColorstr='#ff666666', GradientType=0)!important;\r\n}\r\n.open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default.focus, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default:focus, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default:hover, .panel-inverse>.panel-body>.btn-default.active, .panel-inverse>.panel-body>.btn-default.active.focus, .panel-inverse>.panel-body>.btn-default.active:focus, .panel-inverse>.panel-body>.btn-default.active:hover, .panel-inverse>.panel-body>.btn-default:active, .panel-inverse>.panel-body>.btn-default:active.focus, .panel-inverse>.panel-body>.btn-default:active:focus, .panel-inverse>.panel-body>.btn-default:active:hover {\r\n    color: #fff!important;\r\n    background-color: #333!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, #666 0, #333 100%)!important;\r\n    background-image: -o-linear-gradient(top, #666 0, #333 100%)!important;\r\n    background-image: linear-gradient(to bottom, #666 0, #333 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff666666', endColorstr='#ff333333', GradientType=0)!important;\r\n    border-color: #000!important;\r\n}\r\n.panel-inverse>.panel-body>.btn-default .badge, .panel-inverse>.panel-body>.btn-default.disabled, .panel-inverse>.panel-body>.btn-default.disabled.active, .panel-inverse>.panel-body>.btn-default.disabled.focus, .panel-inverse>.panel-body>.btn-default.disabled:active, .panel-inverse>.panel-body>.btn-default.disabled:focus, .panel-inverse>.panel-body>.btn-default.disabled:hover, .panel-inverse>.panel-body>.btn-default[disabled], .panel-inverse>.panel-body>.btn-default[disabled].active, .panel-inverse>.panel-body>.btn-default[disabled].focus, .panel-inverse>.panel-body>.btn-default[disabled]:active, .panel-inverse>.panel-body>.btn-default[disabled]:focus, .panel-inverse>.panel-body>.btn-default[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-body>.btn-default, fieldset[disabled] .panel-inverse>.panel-body>.btn-default.active, fieldset[disabled] .panel-inverse>.panel-body>.btn-default.focus, fieldset[disabled] .panel-inverse>.panel-body>.btn-default:active, fieldset[disabled] .panel-inverse>.panel-body>.btn-default:focus, fieldset[disabled] .panel-inverse>.panel-body>.btn-default:hover {\r\n    color: #fff!important;\r\n    background-color: #404040!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: -o-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;\r\n    border-color: #000!important;\r\n}\r\n.panel-inverse>.panel-body>.btn-default-inverse, .panel-inverse>.panel-body>.btn-default-inverse.focus, .panel-inverse>.panel-body>.btn-default-inverse:focus {\r\n    background-color: silver!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;\r\n    color: #333!important;\r\n    background-repeat: repeat-x!important;\r\n}\r\n.panel-inverse>.panel-body>.btn-default:hover {\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-body>.btn-default-inverse {\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-body>.btn-default-inverse.focus, .panel-inverse>.panel-body>.btn-default-inverse:focus {\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-body>.btn-default-inverse:hover {\r\n    color: #333!important;\r\n    background-color: #cdcdcd!important;\r\n    background-image: -webkit-linear-gradient(top, #fdfdfd 0, #cdcdcd 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fdfdfd 0, #cdcdcd 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fdfdfd 0, #cdcdcd 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffdfdfd', endColorstr='#ffcdcdcd', GradientType=0)!important;\r\n}\r\n.open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default-inverse, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default-inverse.focus, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default-inverse:focus, .open>.dropdown-toggle.panel-inverse>.panel-body>.btn-default-inverse:hover, .panel-inverse>.panel-body>.btn-default-inverse.active, .panel-inverse>.panel-body>.btn-default-inverse.active.focus, .panel-inverse>.panel-body>.btn-default-inverse.active:focus, .panel-inverse>.panel-body>.btn-default-inverse.active:hover, .panel-inverse>.panel-body>.btn-default-inverse:active, .panel-inverse>.panel-body>.btn-default-inverse:active.focus, .panel-inverse>.panel-body>.btn-default-inverse:active:focus, .panel-inverse>.panel-body>.btn-default-inverse:active:hover {\r\n    color: #333!important;\r\n    background-color: #9a9a9a!important;\r\n    background-image: -webkit-linear-gradient(top, #cacaca 0, #9a9a9a 100%)!important;\r\n    background-image: -o-linear-gradient(top, #cacaca 0, #9a9a9a 100%)!important;\r\n    background-image: linear-gradient(to bottom, #cacaca 0, #9a9a9a 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffcacaca', endColorstr='#ff9a9a9a', GradientType=0)!important;\r\n    border-color: #676767!important;\r\n}\r\n.panel-inverse>.panel-body>.btn-default-inverse .badge, .panel-inverse>.panel-body>.btn-default-inverse.disabled, .panel-inverse>.panel-body>.btn-default-inverse.disabled.active, .panel-inverse>.panel-body>.btn-default-inverse.disabled.focus, .panel-inverse>.panel-body>.btn-default-inverse.disabled:active, .panel-inverse>.panel-body>.btn-default-inverse.disabled:focus, .panel-inverse>.panel-body>.btn-default-inverse.disabled:hover, .panel-inverse>.panel-body>.btn-default-inverse[disabled], .panel-inverse>.panel-body>.btn-default-inverse[disabled].active, .panel-inverse>.panel-body>.btn-default-inverse[disabled].focus, .panel-inverse>.panel-body>.btn-default-inverse[disabled]:active, .panel-inverse>.panel-body>.btn-default-inverse[disabled]:focus, .panel-inverse>.panel-body>.btn-default-inverse[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse.active, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse.focus, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse:active, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse:focus, fieldset[disabled] .panel-inverse>.panel-body>.btn-default-inverse:hover {\r\n    color: #333!important;\r\n    background-color: silver!important;\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-body>.btn-default-inverse:hover {\r\n    border-color: #fcfcfc!important;\r\n}\r\n.panel-inverse>.panel-footer {\r\n    background-color: #303030;\r\n}\r\n.panel-inverse>.panel-footer>.btn-default, .panel-inverse>.panel-footer>.btn-default.focus, .panel-inverse>.panel-footer>.btn-default:focus {\r\n    color: #fff!important;\r\n    background-color: #404040!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: -o-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;\r\n    border-color: #000!important;\r\n}\r\n.panel-inverse>.panel-footer>.btn-default:hover {\r\n    color: #fff!important;\r\n    background-color: #666!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, #999 0, #666 100%)!important;\r\n    background-image: -o-linear-gradient(top, #999 0, #666 100%)!important;\r\n    background-image: linear-gradient(to bottom, #999 0, #666 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff999999', endColorstr='#ff666666', GradientType=0)!important;\r\n}\r\n.open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default.focus, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default:focus, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default:hover, .panel-inverse>.panel-footer>.btn-default.active, .panel-inverse>.panel-footer>.btn-default.active.focus, .panel-inverse>.panel-footer>.btn-default.active:focus, .panel-inverse>.panel-footer>.btn-default.active:hover, .panel-inverse>.panel-footer>.btn-default:active, .panel-inverse>.panel-footer>.btn-default:active.focus, .panel-inverse>.panel-footer>.btn-default:active:focus, .panel-inverse>.panel-footer>.btn-default:active:hover {\r\n    color: #fff!important;\r\n    background-color: #333!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, #666 0, #333 100%)!important;\r\n    background-image: -o-linear-gradient(top, #666 0, #333 100%)!important;\r\n    background-image: linear-gradient(to bottom, #666 0, #333 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff666666', endColorstr='#ff333333', GradientType=0)!important;\r\n    border-color: #000!important;\r\n}\r\n.panel-inverse>.panel-footer>.btn-default .badge, .panel-inverse>.panel-footer>.btn-default.disabled, .panel-inverse>.panel-footer>.btn-default.disabled.active, .panel-inverse>.panel-footer>.btn-default.disabled.focus, .panel-inverse>.panel-footer>.btn-default.disabled:active, .panel-inverse>.panel-footer>.btn-default.disabled:focus, .panel-inverse>.panel-footer>.btn-default.disabled:hover, .panel-inverse>.panel-footer>.btn-default[disabled], .panel-inverse>.panel-footer>.btn-default[disabled].active, .panel-inverse>.panel-footer>.btn-default[disabled].focus, .panel-inverse>.panel-footer>.btn-default[disabled]:active, .panel-inverse>.panel-footer>.btn-default[disabled]:focus, .panel-inverse>.panel-footer>.btn-default[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default.active, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default.focus, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default:active, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default:focus, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default:hover {\r\n    color: #fff!important;\r\n    background-color: #404040!important;\r\n    background-image: url(#)!important;\r\n    background-image: -webkit-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: -o-linear-gradient(top, grey 0, #404040 100%)!important;\r\n    background-image: linear-gradient(to bottom, grey 0, #404040 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff808080', endColorstr='#ff404040', GradientType=0)!important;\r\n    border-color: #000!important;\r\n}\r\n.panel-inverse>.panel-footer>.btn-default-inverse, .panel-inverse>.panel-footer>.btn-default-inverse.focus, .panel-inverse>.panel-footer>.btn-default-inverse:focus {\r\n    background-color: silver!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;\r\n    color: #333!important;\r\n    background-repeat: repeat-x!important;\r\n}\r\n.panel-inverse>.panel-footer>.btn-default:hover {\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-footer>.btn-default-inverse {\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-footer>.btn-default-inverse.focus, .panel-inverse>.panel-footer>.btn-default-inverse:focus {\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-footer>.btn-default-inverse:hover {\r\n    color: #333!important;\r\n    background-color: #cdcdcd!important;\r\n    background-image: -webkit-linear-gradient(top, #fdfdfd 0, #cdcdcd 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fdfdfd 0, #cdcdcd 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fdfdfd 0, #cdcdcd 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffdfdfd', endColorstr='#ffcdcdcd', GradientType=0)!important;\r\n}\r\n.open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default-inverse, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default-inverse.focus, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default-inverse:focus, .open>.dropdown-toggle.panel-inverse>.panel-footer>.btn-default-inverse:hover, .panel-inverse>.panel-footer>.btn-default-inverse.active, .panel-inverse>.panel-footer>.btn-default-inverse.active.focus, .panel-inverse>.panel-footer>.btn-default-inverse.active:focus, .panel-inverse>.panel-footer>.btn-default-inverse.active:hover, .panel-inverse>.panel-footer>.btn-default-inverse:active, .panel-inverse>.panel-footer>.btn-default-inverse:active.focus, .panel-inverse>.panel-footer>.btn-default-inverse:active:focus, .panel-inverse>.panel-footer>.btn-default-inverse:active:hover {\r\n    color: #333!important;\r\n    background-color: #9a9a9a!important;\r\n    background-image: -webkit-linear-gradient(top, #cacaca 0, #9a9a9a 100%)!important;\r\n    background-image: -o-linear-gradient(top, #cacaca 0, #9a9a9a 100%)!important;\r\n    background-image: linear-gradient(to bottom, #cacaca 0, #9a9a9a 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffcacaca', endColorstr='#ff9a9a9a', GradientType=0)!important;\r\n    border-color: #676767!important;\r\n}\r\n.panel-inverse>.panel-footer>.btn-default-inverse .badge, .panel-inverse>.panel-footer>.btn-default-inverse.disabled, .panel-inverse>.panel-footer>.btn-default-inverse.disabled.active, .panel-inverse>.panel-footer>.btn-default-inverse.disabled.focus, .panel-inverse>.panel-footer>.btn-default-inverse.disabled:active, .panel-inverse>.panel-footer>.btn-default-inverse.disabled:focus, .panel-inverse>.panel-footer>.btn-default-inverse.disabled:hover, .panel-inverse>.panel-footer>.btn-default-inverse[disabled], .panel-inverse>.panel-footer>.btn-default-inverse[disabled].active, .panel-inverse>.panel-footer>.btn-default-inverse[disabled].focus, .panel-inverse>.panel-footer>.btn-default-inverse[disabled]:active, .panel-inverse>.panel-footer>.btn-default-inverse[disabled]:focus, .panel-inverse>.panel-footer>.btn-default-inverse[disabled]:hover, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse.active, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse.focus, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse:active, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse:focus, fieldset[disabled] .panel-inverse>.panel-footer>.btn-default-inverse:hover {\r\n    color: #333!important;\r\n    background-color: silver!important;\r\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: -o-linear-gradient(top, #fcfcfc 0, silver 100%)!important;\r\n    background-image: linear-gradient(to bottom, #fcfcfc 0, silver 100%)!important;\r\n    background-repeat: repeat-x!important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcfcfc', endColorstr='#ffc0c0c0', GradientType=0)!important;\r\n    border-color: grey!important;\r\n}\r\n.panel-inverse>.panel-footer>.btn-default-inverse:hover {\r\n    border-color: #fcfcfc!important;\r\n}\r\n.panel-inverse>.panel-body>.list-group .section {\r\n    background-color: rgba(255, 255, 255, .15);\r\n    color: #fff;\r\n}\r\n.panel-inverse>.panel-body>.list-group .section>a {\r\n    color: #9cf;\r\n}\r\n.panel-inverse>.panel-body>.list-group .list-group-item {\r\n    color: #fff;\r\n    border-color: rgba(255, 255, 255, .15);\r\n}\r\n.panel-inverse>.panel-body>.list-group .list-group-item .list-group-item-heading, .panel-inverse>.panel-body>.list-group .list-group-item .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item p {\r\n    color: #fff;\r\n}\r\n.panel-inverse>.panel-body>.list-group .list-group-item.active, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover {\r\n    color: #fff;\r\n    background-color: #0059b3;\r\n    border-top-color: rgba(255, 255, 255, .15);\r\n    border-bottom-color: rgba(255, 255, 255, .15);\r\n}\r\n.panel-inverse>.panel-body>.list-group .list-group-item.active .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.active .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.active p, .panel-inverse>.panel-body>.list-group .list-group-item.active span, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus p, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus span, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover p, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover span {\r\n    color: #fff;\r\n}\r\n.panel-inverse>.panel-body>.list-group .list-group-item.active .mark, .panel-inverse>.panel-body>.list-group .list-group-item.active mark, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus .mark, .panel-inverse>.panel-body>.list-group .list-group-item.active:focus mark, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover .mark, .panel-inverse>.panel-body>.list-group .list-group-item.active:hover mark {\r\n    background-color: rgba(0, 0, 0, .35);\r\n}\r\n.panel-inverse>.panel-body>.list-group .list-group-item.disabled, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover {\r\n    background-color: inherit;\r\n    color: rgba(255, 255, 255, .4)!important;\r\n}\r\n.panel-inverse>.panel-body>.list-group .list-group-item.disabled .list-group-item-heading, .panel-inverse>.panel-body>.list-group .list-group-item.disabled .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.disabled .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.disabled p, .panel-inverse>.panel-body>.list-group .list-group-item.disabled span, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus .list-group-item-heading, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus p, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus span, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover .list-group-item-heading, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover .list-group-item-text, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover .text-muted, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover p, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover span {\r\n    color: rgba(255, 255, 255, .4)!important;\r\n}\r\n.panel-inverse>.panel-body>.list-group .list-group-item.disabled mark, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:focus mark, .panel-inverse>.panel-body>.list-group .list-group-item.disabled:hover mark {\r\n    color: rgba(255, 255, 255, .4)!important;\r\n    background-color: rgba(255, 255, 255, .15);\r\n}\r\n.panel-inverse>.panel-body>.list-group mark {\r\n    background-color: #0059b3;\r\n    color: #fff;\r\n}\r\n.panel-inverse>.panel-body>.list-group a.list-group-item, .panel-inverse>.panel-body>.list-group button.list-group-item {\r\n    text-decoration: none;\r\n}\r\n.panel-inverse>.panel-body>.list-group a.list-group-item:focus, .panel-inverse>.panel-body>.list-group a.list-group-item:hover, .panel-inverse>.panel-body>.list-group button.list-group-item:focus, .panel-inverse>.panel-body>.list-group button.list-group-item:hover {\r\n    color: #fff;\r\n    background-color: rgba(255, 255, 255, .09);\r\n}\r\n.panel-inverse>.panel-body>.list-group a.list-group-item:focus .list-group-item-heading, .panel-inverse>.panel-body>.list-group a.list-group-item:focus .list-group-item-text, .panel-inverse>.panel-body>.list-group a.list-group-item:focus .text-muted, .panel-inverse>.panel-body>.list-group a.list-group-item:focus p, .panel-inverse>.panel-body>.list-group a.list-group-item:focus span, .panel-inverse>.panel-body>.list-group a.list-group-item:hover .list-group-item-heading, .panel-inverse>.panel-body>.list-group a.list-group-item:hover .list-group-item-text, .panel-inverse>.panel-body>.list-group a.list-group-item:hover .text-muted, .panel-inverse>.panel-body>.list-group a.list-group-item:hover p, .panel-inverse>.panel-body>.list-group a.list-group-item:hover span, .panel-inverse>.panel-body>.list-group button.list-group-item:focus .list-group-item-heading, .panel-inverse>.panel-body>.list-group button.list-group-item:focus .list-group-item-text, .panel-inverse>.panel-body>.list-group button.list-group-item:focus .text-muted, .panel-inverse>.panel-body>.list-group button.list-group-item:focus p, .panel-inverse>.panel-body>.list-group button.list-group-item:focus span, .panel-inverse>.panel-body>.list-group button.list-group-item:hover .list-group-item-heading, .panel-inverse>.panel-body>.list-group button.list-group-item:hover .list-group-item-text, .panel-inverse>.panel-body>.list-group button.list-group-item:hover .text-muted, .panel-inverse>.panel-body>.list-group button.list-group-item:hover p, .panel-inverse>.panel-body>.list-group button.list-group-item:hover span {\r\n    color: #fff;\r\n}\r\n.panel-inverse>.panel-body>.list-group .section-inverse {\r\n    color: #000;\r\n    background-color: rgba(255, 255, 255, .75);\r\n}\r\n.list-group-item {\r\n    margin-bottom: 0;\r\n    border-top: none;\r\n    padding: 8px 10px;\r\n}\r\n.list-group-item>p {\r\n    margin-bottom: 0;\r\n}\r\n.list-group-item>.pull-right {\r\n    margin-left: 10px;\r\n}\r\n.list-group-item>.pull-left {\r\n    margin-right: 10px;\r\n}\r\n.list-group-item.disabled, .list-group-item.disabled:focus, .list-group-item.disabled:hover {\r\n    background-color: inherit;\r\n    color: rgba(0, 0, 0, .4)!important;\r\n}\r\n.list-group-item.disabled .list-group-item-heading, .list-group-item.disabled .list-group-item-text, .list-group-item.disabled:focus .list-group-item-heading, .list-group-item.disabled:focus .list-group-item-text, .list-group-item.disabled:hover .list-group-item-heading, .list-group-item.disabled:hover .list-group-item-text {\r\n    color: rgba(0, 0, 0, .4)!important;\r\n}\r\n.list-group-item.disabled mark, .list-group-item.disabled:focus mark, .list-group-item.disabled:hover mark {\r\n    color: rgba(0, 0, 0, .4)!important;\r\n    background-color: #e6e6e6;\r\n}\r\n.list-group-item.active .text-muted, .list-group-item.active:focus .text-muted, .list-group-item.active:hover .text-muted, a.list-group-item:focus .text-muted, a.list-group-item:hover .text-muted, button.list-group-item:focus .text-muted, button.list-group-item:hover .text-muted {\r\n    color: #000;\r\n}\r\n.list-group-item.active, .list-group-item.active:focus, .list-group-item.active:hover {\r\n    border-top: 1px solid #e6e6e6;\r\n    border-bottom: 1px solid #e6e6e6;\r\n    margin-top: -1px;\r\n}\r\n.list-group-item.active mark, .list-group-item.active:focus mark, .list-group-item.active:hover mark {\r\n    background-color: rgba(255, 255, 255, .65);\r\n}\r\n.section, .section-inverse {\r\n    border-top: none;\r\n    border-bottom: none;\r\n    padding-top: 3px;\r\n    padding-bottom: 3px;\r\n    padding-right: 10px;\r\n    background-color: #e6e6e6;\r\n}\r\n.section a {\r\n    color: #06c;\r\n    cursor: pointer;\r\n}\r\n.section-inverse {\r\n    color: #fff;\r\n    background-color: rgba(0, 0, 0, .75);\r\n}\r\n.section-inverse a {\r\n    color: #06c;\r\n    cursor: pointer;\r\n}\r\n.indented {\r\n    padding-left: 25px;\r\n}\r\n.line-segment-right, .line-segment-right-30, .line-segment-right-50, .line-segment-right-70 {\r\n    padding-left: 5px;\r\n    float: right!important;\r\n}\r\n.list-group-item-heading {\r\n    font-weight: 700;\r\n}\r\n.list-group-item-text {\r\n    margin-top: 5px;\r\n    line-height: 1.42857143;\r\n}\r\n.list-group-icon {\r\n    position: absolute;\r\n    top: 3px;\r\n    left: 7px;\r\n}\r\n.line-segment-left-30 {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 30%}\r\n.line-segment-left-30 div, .line-segment-left-30 h1, .line-segment-left-30 h2, .line-segment-left-30 h3, .line-segment-left-30 h4, .line-segment-left-30 h5, .line-segment-left-30 h6, .line-segment-left-30 p, .line-segment-left-30 span, .line-segment-left-30>a {\r\n    white-space: nowrap!important;\r\n    overflow: hidden!important;\r\n    text-overflow: ellipsis!important;\r\n    display: block!important;\r\n}\r\n.line-segment-left-50 {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 50%}\r\n.line-segment-left-50 div, .line-segment-left-50 h1, .line-segment-left-50 h2, .line-segment-left-50 h3, .line-segment-left-50 h4, .line-segment-left-50 h5, .line-segment-left-50 h6, .line-segment-left-50 p, .line-segment-left-50 span, .line-segment-left-50>a {\r\n    white-space: nowrap!important;\r\n    overflow: hidden!important;\r\n    text-overflow: ellipsis!important;\r\n    display: block!important;\r\n}\r\n.line-segment-left-70 {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 70%}\r\n.line-segment-left-70 div, .line-segment-left-70 h1, .line-segment-left-70 h2, .line-segment-left-70 h3, .line-segment-left-70 h4, .line-segment-left-70 h5, .line-segment-left-70 h6, .line-segment-left-70 p, .line-segment-left-70 span, .line-segment-left-70>a {\r\n    white-space: nowrap!important;\r\n    overflow: hidden!important;\r\n    text-overflow: ellipsis!important;\r\n    display: block!important;\r\n}\r\n.line-segment-right-30 {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 30%}\r\n.line-segment-right-30 div, .line-segment-right-30 h1, .line-segment-right-30 h2, .line-segment-right-30 h3, .line-segment-right-30 h4, .line-segment-right-30 h5, .line-segment-right-30 h6, .line-segment-right-30 p, .line-segment-right-30 span, .line-segment-right-30>a {\r\n    white-space: nowrap!important;\r\n    overflow: hidden!important;\r\n    text-overflow: ellipsis!important;\r\n    display: block!important;\r\n}\r\n.line-segment-right-50 {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 50%}\r\n.line-segment-right-50 div, .line-segment-right-50 h1, .line-segment-right-50 h2, .line-segment-right-50 h3, .line-segment-right-50 h4, .line-segment-right-50 h5, .line-segment-right-50 h6, .line-segment-right-50 p, .line-segment-right-50 span, .line-segment-right-50>a {\r\n    white-space: nowrap!important;\r\n    overflow: hidden!important;\r\n    text-overflow: ellipsis!important;\r\n    display: block!important;\r\n}\r\n.line-segment-right-70 {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 70%}\r\n.line-segment-right-70 div, .line-segment-right-70 h1, .line-segment-right-70 h2, .line-segment-right-70 h3, .line-segment-right-70 h4, .line-segment-right-70 h5, .line-segment-right-70 h6, .line-segment-right-70 p, .line-segment-right-70 span, .line-segment-right-70>a {\r\n    white-space: nowrap!important;\r\n    overflow: hidden!important;\r\n    text-overflow: ellipsis!important;\r\n    display: block!important;\r\n}\r\n.tag, .tag-icon {\r\n    display: inline-block;\r\n}\r\n.table>thead {\r\n    background-color: #e6e6e6;\r\n}\r\n.mark, mark {\r\n    background-color: #b3d9ff;\r\n    padding: 0 1px;\r\n}\r\n.lead {\r\n    font-weight: 400;\r\n}\r\n.tag {\r\n    background: #e6e6e6;\r\n    color: #404040;\r\n    font-weight: 600;\r\n    height: 18px;\r\n    border-radius: 2px;\r\n    overflow: hidden;\r\n    border: 1px solid #404040;\r\n    pointer-events: inherit;\r\n}\r\n.tag span {\r\n    margin: 0 4px;\r\n}\r\n.tag-icon {\r\n    background-color: #404040;\r\n    color: #fff;\r\n    padding: 0 3px;\r\n    height: 19px;\r\n    width: 19px;\r\n    position: relative;\r\n    text-align: center;\r\n    line-height: 18px;\r\n    margin-right: -1px;\r\n}\r\n.center-vertical, .overlay {\r\n    position: absolute!important;\r\n}\r\n.tag-info {\r\n    background: #e0f0ff;\r\n    color: #042b4b;\r\n    border: 1px solid #39f;\r\n}\r\n.tag-info>.tag-icon {\r\n    background-color: #39f;\r\n}\r\n.tag-success {\r\n    background: #e1f1de;\r\n    color: #1a4e0f;\r\n    border: 1px solid #37A320;\r\n}\r\n.tag-success>.tag-icon {\r\n    background-color: #37A320;\r\n}\r\n.tag-danger {\r\n    background: #f3dde1;\r\n    color: #580e1c;\r\n    border: 1px solid #b01c38;\r\n}\r\n.tag-danger>.tag-icon {\r\n    background-color: #b01c38;\r\n}\r\n.no-padding {\r\n    padding: 0!important;\r\n}\r\n.no-margin {\r\n    margin: 0!important;\r\n}\r\n.floating {\r\n    border-radius: 6px;\r\n    -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .25)!important;\r\n    box-shadow: 0 1px 1px rgba(0, 0, 0, .25)!important;\r\n}\r\n.no-scroll {\r\n    overflow: hidden!important;\r\n}\r\n.overlay {\r\n    z-index: 980!important;\r\n    background-color: rgba(255, 255, 255, .95);\r\n    top: 0!important;\r\n    right: 0!important;\r\n    bottom: 0!important;\r\n    left: 0!important;\r\n}\r\n#wrapper-sign-in, body.sign-in {\r\n    background-color: #fff;\r\n}\r\n#wrapper-nav-bar, body {\r\n    background-color: #e6e6e6;\r\n}\r\n.center, .overlay>:first-child {\r\n    left: 50%!important;\r\n    margin-right: 0!important;\r\n    text-align: center!important;\r\n    position: absolute!important;\r\n    top: 50%!important;\r\n}\r\n.overlay>:first-child {\r\n    transform: translate(-50%, -50%)!important;\r\n    -ms-transform: translate(-50%, -50%)!important;\r\n}\r\n.truncate, .truncate-children div, .truncate-children h1, .truncate-children h2, .truncate-children h3, .truncate-children h4, .truncate-children h5, .truncate-children h6, .truncate-children p, .truncate-children span, .truncate-children>a {\r\n    white-space: nowrap!important;\r\n    overflow: hidden!important;\r\n    text-overflow: ellipsis!important;\r\n    display: block!important;\r\n}\r\n.center {\r\n    transform: translate(-50%, -50%)!important;\r\n    -ms-transform: translate(-50%, -50%)!important;\r\n}\r\n.center-vertical {\r\n    top: 50%!important;\r\n    transform: translateY(-50%)!important;\r\n    -ms-transform: translateY(-50%)!important;\r\n}\r\n.related-icon {\r\n    display: inline-block;\r\n    margin-left: 5px;\r\n}\r\n.related-icon.pull-left {\r\n    margin-left: 0;\r\n    margin-right: 5px;\r\n}\r\nbody.sign-in .ul-icon {\r\n    margin-bottom: 0;\r\n}\r\nmain {\r\n    display: grid;\r\n    grid-template-columns: 2fr 5fr;\r\n    position: absolute;\r\n    top: 41px;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n}\r\n#wrapper-sign-in {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: auto;\r\n    padding: inherit;\r\n}\r\n#wrapper-nav-bar {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 49px;\r\n    background-image: url(img/header_background.png);\r\n    min-width: 600px;\r\n}\r\n#wrapper-nav-tree {\r\n    resize: horizontal;\r\n    overflow: auto;\r\n    min-width: 5%;\r\n    max-width: 99%;\r\n    flex: 1 1 30%;\r\n    position: relative;\r\n}\r\n#wrapper-panel-tabs {\r\n    margin: 12px 0 0;\r\n    flex: 1 1 70%;\r\n    position: relative;\r\n}\r\n#wrapper-panel-packages, #wrapper-panel-rules {\r\n    width: 25%;\r\n    top: 10px;\r\n    left: 10px;\r\n    bottom: 10px;\r\n    position: absolute;\r\n}\r\n#wrapper-panel-package-details {\r\n    position: absolute;\r\n    left: 26.25%;\r\n    bottom: 10px;\r\n    top: 10px;\r\n    min-width: 400px;\r\n}\r\n#wrapper-panel-package-details span+span {\r\n    margin-left: 5px;\r\n}\r\n#wrapper-panel-details tr i, #wrapper-panel-package-details tr i {\r\n    cursor: pointer;\r\n    background-color: #f0f0f0;\r\n    visibility: hidden;\r\n    color: grey;\r\n}\r\n#wrapper-panel-details tr i:hover, #wrapper-panel-package-details tr i:hover {\r\n    color: #000;\r\n}\r\n#wrapper-panel-details tr:hover i, #wrapper-panel-package-details tr:hover i {\r\n    visibility: visible;\r\n}\r\n#wrapper-panel-rule-details {\r\n    position: absolute;\r\n    width: 73%;\r\n    right: 10px;\r\n    bottom: 10px;\r\n    top: 10px;\r\n    min-width: 400px;\r\n}\r\n#wrapper-side-panel {\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 10px;\r\n    height: 98%;\r\n    width: 20%}\r\n#wrapper-side-panel .list-group {\r\n    margin-bottom: 0;\r\n}\r\n#wrapper-side-panel .list-group-item i {\r\n    cursor: pointer;\r\n    position: absolute;\r\n    top: 3px;\r\n    left: 0;\r\n    background-color: #f0f0f0;\r\n    margin-left: 0;\r\n    width: 26px;\r\n    visibility: hidden;\r\n    color: grey;\r\n}\r\n#msg-config-body, #msg-config-side {\r\n    height: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n}\r\n#wrapper-side-panel .list-group-item:hover i, .container-card:hover .card-info {\r\n    visibility: visible;\r\n}\r\n#wrapper-side-panel .list-group-item i:hover {\r\n    color: #000;\r\n}\r\n#wrapper-panel-details {\r\n    position: absolute;\r\n    left: .5%;\r\n    top: 1%;\r\n    width: 99%;\r\n    height: 98%\r\n}\r\n#wrapper-assign-preview {\r\n    position: absolute;\r\n    top: 33px;\r\n    right: 10px;\r\n    bottom: 10px;\r\n    left: 10px;\r\n}\r\n#wrapper-config-users-rules {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n}\r\n#wrapper-navigation {\r\n    position: absolute;\r\n    width: 200px;\r\n    top: 10px;\r\n    bottom: 10px;\r\n}\r\n#wrapper-preview {\r\n    position: absolute;\r\n    left: 220px;\r\n    right: 10px;\r\n    top: 10px;\r\n    bottom: 10px;\r\n}\r\n#config-assign-body, #config-users-body {\r\n    height: 50%;\r\n    min-height: 300px;\r\n}\r\n#wrapper-config-users-preview .panel-body {\r\n    overflow-y: scroll;\r\n    max-height: 500px;\r\n}\r\n#package-review-body {\r\n    height: 500px;\r\n}\r\n#wrapper-msg-config {\r\n    height: 400px;\r\n    width: 100%;\r\n    position: relative;\r\n}\r\n#msg-config-side {\r\n    width: 20%;\r\n    border-right: 1px solid silver;\r\n    background: #404040;\r\n    text-align: center;\r\n    padding: 15px;\r\n    left: 0;\r\n}\r\n\r\n#emrTable {\r\n    width: 100%;\r\n    padding: 10px;\r\n    left: auto;\r\n}\r\n\r\n#emrHeader {\r\n    background-color: #666666;\r\n    height: 25px;\r\n    width: 100%;\r\n}\r\n\r\n#facilitiesTable {\r\n    width: 100%;\r\n    padding: 10px;\r\n    left: auto;\r\n}\r\n\r\n#facilitiesHeader {\r\n    background-color: #666666;\r\n    height: 25px;\r\n    width: 100%;\r\n}\r\n\r\n#searchFacs, #searchEmrs {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.searchButton {\r\n    width: 10%;\r\n    min-width: 35px;\r\n    cursor: pointer;\r\n    height: 25px;\r\n    text-align: center;\r\n}\r\n\r\n.inlineDisplay {\r\n    display: inline-block;\r\n}\r\n\r\n.grid-row-pub {\r\n   min-width: min-content;\r\n}\r\n\r\n.grid-panel-heading-extended {\r\n    min-width: min-content;\r\n}\r\n\r\n.grid-panel-heading {\r\n    min-width: min-content;\r\n}\r\n\r\n\r\n.dropdown-tenant {\r\n    width: 90px;\r\n}\r\n\r\n.searchMapping {\r\n    width: 25%;\r\n    min-width: 600px;\r\n    height: 25px;\r\n}\r\n\r\n.mappingInput {\r\n    width: 70%;\r\n    height: 20px;\r\n    min-width: 200px;\r\n    resize: none;\r\n}\r\n\r\n.mappingSet {\r\n    overflow: auto;\r\n    height: 320px;\r\n}\r\n\r\n.existingMappings {\r\n    height: 450px;\r\n}\r\n\r\n.colMap {\r\n    height: 75vh;\r\n}\r\n\r\n.mappingCard {\r\n    cursor: pointer;\r\n    border: #666666;\r\n    border-style: solid;\r\n    width: 95%;\r\n    margin: 2%;\r\n}\r\n\r\n.addButton {\r\n    width: 15%;\r\n    min-width: 30px;\r\n    cursor: pointer;\r\n    height: 25px;\r\n    text-align: center;\r\n}\r\n\r\n.linkBtn {\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-secondary:hover {\r\n    background-color: #9a9a9a;\r\n}\r\n\r\n#emrList:nth-child(even) {\r\n    background: white;\r\n    list-style-type: none;\r\n}\r\n\r\n#emrList:nth-child(odd) {\r\n    background: #9a9a9a;\r\n    list-style-type: none;\r\n}\r\n\r\nli:hover {\r\n    background: #999999;\r\n}\r\n\r\n#facList:nth-child(even) {\r\n    background: white;\r\n    list-style-type: none;\r\n}\r\n\r\n#facList:nth-child(odd) {\r\n    background: grey;\r\n    list-style-type: none;\r\n}\r\n\r\n.count-packages, .count-user {\r\n    text-align: right;\r\n    display: inline-block;\r\n}\r\n#msg-config-body {\r\n    width: 80%;\r\n    background: #e6e6e6;\r\n    padding: 10px;\r\n    right: 0;\r\n    overflow-y: auto;\r\n}\r\n.container-card {\r\n    cursor: default;\r\n    font-family: Segoe UI;\r\n    background: #fff;\r\n    border: 1px solid silver;\r\n    border-radius: 4px;\r\n    -webkit-box-shadow: 0 2px 5px 0 #e6e6e6;\r\n    -moz-box-shadow: 0 2px 5px 0 #e6e6e6;\r\n    box-shadow: 0 2px 5px 0 #e6e6e6;\r\n    margin-bottom: 5px;\r\n    padding: 10px;\r\n    position: relative;\r\n    width: 240px;\r\n}\r\n.card-info, .refresh-node i, .rule-old .card-close, .rule-old .container-card:hover .card-info {\r\n    visibility: hidden;\r\n}\r\n.container-card:hover .card-close {\r\n    color: grey;\r\n}\r\n.container-card:hover .card-close:hover {\r\n    color: #000;\r\n}\r\n.card-footer {\r\n    background-color: #fcfcfc;\r\n    border-top: 1px solid silver;\r\n    margin: 0 -10px -10px;\r\n    height: 32px;\r\n    border-bottom-right-radius: 4px;\r\n    border-bottom-left-radius: 4px;\r\n}\r\n.container-card .card-footer .btn-default, .container-card .card-footer .btn-primary {\r\n    cursor: default;\r\n    border: none;\r\n    border-right: 1px solid silver;\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 0;\r\n    background: #fcfcfc;\r\n    height: 100%;\r\n    width: 117px;\r\n    color: #404040;\r\n    font-weight: 600;\r\n}\r\n.container-card .card-footer .btn-primary {\r\n    border-bottom-left-radius: 4px;\r\n    border-bottom-right-radius: 0;\r\n}\r\n.container-card .card-footer .btn-default {\r\n    border: none;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 4px;\r\n    margin-left: -1px;\r\n    background: #fcfcfc;\r\n    color: #404040;\r\n}\r\n.card-options {\r\n    margin-left: 10px;\r\n}\r\n.card-options select {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    width: 210px;\r\n}\r\n.container-card-header {\r\n    display: block;\r\n    font-family: \"Segoe UI\";\r\n    font-size: 16px;\r\n    color: #ED6E00;\r\n    margin-top: -3px;\r\n    margin-bottom: 5px;\r\n    line-height: 16px;\r\n}\r\n.count-user {\r\n    margin-left: 5px;\r\n    width: 48px;\r\n}\r\n.count-packages {\r\n    width: 30px;\r\n}\r\n.count-rules {\r\n    text-align: right;\r\n    min-width: 45px;\r\n}\r\n.card-close, .card-info {\r\n    top: 10px;\r\n    position: absolute;\r\n    line-height: 12px;\r\n    text-align: center;\r\n    background-color: #fff;\r\n}\r\n.rule-old * {\r\n    color: grey;\r\n}\r\nhtml {\r\n    -ms-text-size-adjust: 100%;\r\n    -webkit-text-size-adjust: 100%;\r\n    -webkit-tap-highlight-color: transparent;\r\n    font-family: Segoe UI;\r\n    font-size: 13px;\r\n    color: #000;\r\n}\r\n.text-card-body {\r\n    display: inline-block;\r\n    -moz-hyphens: auto;\r\n    font-family: \"Segoe UI\";\r\n    font-size: 13px;\r\n}\r\n.card-close {\r\n    width: 20px;\r\n    height: 12px;\r\n    right: 6px;\r\n    color: silver;\r\n}\r\n.card-info {\r\n    width: 22px;\r\n    height: 14px;\r\n    right: 29px;\r\n    color: grey;\r\n}\r\n.card-info:hover {\r\n    color: #000;\r\n}\r\n.overlay i+span, .overlay span+i {\r\n    margin-left: 10px;\r\n}\r\n.panel-details-normal {\r\n    width: 73%}\r\n.panel-details-narrow {\r\n    width: 53%}\r\n.vertical-align {\r\n    position: relative;\r\n    top: 50%;\r\n    -webkit-transform: translateY(-50%);\r\n    -ms-transform: translateY(-50%);\r\n    transform: translateY(-50%);\r\n}\r\n.col-section {\r\n    margin-left: -15px;\r\n    margin-right: -15px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    margin-bottom: 5px;\r\n}\r\n.col-divider {\r\n    height: 100%;\r\n    border-left: 1px solid silver;\r\n}\r\n.btn-group.btn-group-flat .btn-default {\r\n    box-shadow: none;\r\n    background-color: #fff;\r\n    background-image: none;\r\n    filter: none;\r\n    font-size: 12px;\r\n    min-width: 0;\r\n    padding: 8px;\r\n    white-space: pre-line;\r\n}\r\n.btn-group.btn-group-flat .btn-default:focus, .btn-group.btn-group-flat .btn-default:hover {\r\n    background-color: rgba(0, 0, 0, .06);\r\n}\r\n.btn-group.btn-group-flat .btn-default.active, .btn-group.btn-group-flat .btn-default.active:focus, .btn-group.btn-group-flat .btn-default.active:hover {\r\n    background-color: #b3d9ff;\r\n}\r\n.btn-group .img-insertion {\r\n    margin-bottom: 3px;\r\n}\r\n.navbar-brand>img {\r\n    max-height: 100%;\r\n}\r\n.col-xs-1 {\r\n    height: 21px;\r\n}\r\n.panel-body-template {\r\n    overflow-y: auto;\r\n    position: absolute;\r\n    top: 25px;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n}\r\n.table-col-ex {\r\n    width: 5%}\r\n.table-col-2wide {\r\n    width: 50%}\r\n.table-col-2wide-1ex {\r\n    width: 47.5%}\r\n.table-col-2wide-2ex {\r\n    width: 45%}\r\n.table-col-3wide {\r\n    width: 33.333%}\r\n.table-col-3wide-2ex {\r\n    width: 30%}\r\n.btn-capd-editor {\r\n    width: 90%;\r\n    text-align: left;\r\n    font-size: 15px;\r\n}\r\n.refresh-node i {\r\n    position: relative;\r\n    right: 5px;\r\n}\r\n.list-group-item.active .refresh-node i, .list-group-item:hover .refresh-node i {\r\n    visibility: visible;\r\n}\r\n.form-nr input {\r\n    width: 100%!important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
